import * as at from "react";
import Wt, { useCallback as Ut, createContext as Eo, useMemo as Ur, createElement as st, useContext as xa, useLayoutEffect as E0, useRef as Et, useEffect as At, useState as Zt, forwardRef as Gt, Children as Fn, isValidElement as Ao, cloneElement as wa, Fragment as Wf, useReducer as A0 } from "react";
import qf, { flushSync as Yf } from "react-dom";
function ui(e) {
  var t = e.default;
  if (typeof t == "function") {
    var r = function() {
      return t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
var Gf = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function r() {
      for (var n = [], o = 0; o < arguments.length; o++) {
        var s = arguments[o];
        if (!!s) {
          var f = typeof s;
          if (f === "string" || f === "number")
            n.push(s);
          else if (Array.isArray(s)) {
            if (s.length) {
              var l = r.apply(null, s);
              l && n.push(l);
            }
          } else if (f === "object") {
            if (s.toString !== Object.prototype.toString && !s.toString.toString().includes("[native code]")) {
              n.push(s.toString());
              continue;
            }
            for (var h in s)
              t.call(s, h) && s[h] && n.push(h);
          }
        }
      }
      return n.join(" ");
    }
    e.exports ? (r.default = r, e.exports = r) : window.classNames = r;
  })();
})(Gf);
const So = Gf.exports;
function Ve() {
  return Ve = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Ve.apply(this, arguments);
}
function Sn(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(o) {
    if (e?.(o), r === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
function S0(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Qf(...e) {
  return (t) => e.forEach(
    (r) => S0(r, t)
  );
}
function li(...e) {
  return Ut(Qf(...e), e);
}
function T0(e, t = []) {
  let r = [];
  function n(s, f) {
    const l = /* @__PURE__ */ Eo(f), h = r.length;
    r = [
      ...r,
      f
    ];
    function p(g) {
      const { scope: E, children: m, ...A } = g, w = E?.[e][h] || l, S = Ur(
        () => A,
        Object.values(A)
      );
      return /* @__PURE__ */ st(w.Provider, {
        value: S
      }, m);
    }
    function b(g, E) {
      const m = E?.[e][h] || l, A = xa(m);
      if (A)
        return A;
      if (f !== void 0)
        return f;
      throw new Error(`\`${g}\` must be used within \`${s}\``);
    }
    return p.displayName = s + "Provider", [
      p,
      b
    ];
  }
  const o = () => {
    const s = r.map((f) => /* @__PURE__ */ Eo(f));
    return function(l) {
      const h = l?.[e] || s;
      return Ur(
        () => ({
          [`__scope${e}`]: {
            ...l,
            [e]: h
          }
        }),
        [
          l,
          h
        ]
      );
    };
  };
  return o.scopeName = e, [
    n,
    M0(o, ...t)
  ];
}
function M0(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const r = () => {
    const n = e.map(
      (o) => ({
        useScope: o(),
        scopeName: o.scopeName
      })
    );
    return function(s) {
      const f = n.reduce((l, { useScope: h, scopeName: p }) => {
        const g = h(s)[`__scope${p}`];
        return {
          ...l,
          ...g
        };
      }, {});
      return Ur(
        () => ({
          [`__scope${t.scopeName}`]: f
        }),
        [
          f
        ]
      );
    };
  };
  return r.scopeName = t.scopeName, r;
}
const Gs = Boolean(globalThis?.document) ? E0 : () => {
}, I0 = at["useId".toString()] || (() => {
});
let C0 = 0;
function as(e) {
  const [t, r] = at.useState(I0());
  return Gs(() => {
    e || r(
      (n) => n ?? String(C0++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
function $n(e) {
  const t = Et(e);
  return At(() => {
    t.current = e;
  }), Ur(
    () => (...r) => {
      var n;
      return (n = t.current) === null || n === void 0 ? void 0 : n.call(t, ...r);
    },
    []
  );
}
function _0({ prop: e, defaultProp: t, onChange: r = () => {
} }) {
  const [n, o] = O0({
    defaultProp: t,
    onChange: r
  }), s = e !== void 0, f = s ? e : n, l = $n(r), h = Ut((p) => {
    if (s) {
      const g = typeof p == "function" ? p(e) : p;
      g !== e && l(g);
    } else
      o(p);
  }, [
    s,
    e,
    o,
    l
  ]);
  return [
    f,
    h
  ];
}
function O0({ defaultProp: e, onChange: t }) {
  const r = Zt(e), [n] = r, o = Et(n), s = $n(t);
  return At(() => {
    o.current !== n && (s(n), o.current = n);
  }, [
    n,
    o,
    s
  ]), r;
}
function Mn() {
  return Mn = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, Mn.apply(this, arguments);
}
const ma = /* @__PURE__ */ Gt((e, t) => {
  const { children: r, ...n } = e, o = Fn.toArray(r), s = o.find(j0);
  if (s) {
    const f = s.props.children, l = o.map((h) => h === s ? Fn.count(f) > 1 ? Fn.only(null) : /* @__PURE__ */ Ao(f) ? f.props.children : null : h);
    return /* @__PURE__ */ st(Qs, Mn({}, n, {
      ref: t
    }), /* @__PURE__ */ Ao(f) ? /* @__PURE__ */ wa(f, void 0, l) : null);
  }
  return /* @__PURE__ */ st(Qs, Mn({}, n, {
    ref: t
  }), r);
});
ma.displayName = "Slot";
const Qs = /* @__PURE__ */ Gt((e, t) => {
  const { children: r, ...n } = e;
  return /* @__PURE__ */ Ao(r) ? /* @__PURE__ */ wa(r, {
    ...D0(n, r.props),
    ref: Qf(t, r.ref)
  }) : Fn.count(r) > 1 ? Fn.only(null) : null;
});
Qs.displayName = "SlotClone";
const N0 = ({ children: e }) => /* @__PURE__ */ st(Wf, null, e);
function j0(e) {
  return /* @__PURE__ */ Ao(e) && e.type === N0;
}
function D0(e, t) {
  const r = {
    ...t
  };
  for (const n in t) {
    const o = e[n], s = t[n];
    /^on[A-Z]/.test(n) ? o && s ? r[n] = (...l) => {
      s(...l), o(...l);
    } : o && (r[n] = o) : n === "style" ? r[n] = {
      ...o,
      ...s
    } : n === "className" && (r[n] = [
      o,
      s
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...r
  };
}
const L0 = [
  "a",
  "button",
  "div",
  "h2",
  "h3",
  "img",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Gn = L0.reduce((e, t) => {
  const r = /* @__PURE__ */ Gt((n, o) => {
    const { asChild: s, ...f } = n, l = s ? ma : t;
    return At(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ st(l, Mn({}, f, {
      ref: o
    }));
  });
  return r.displayName = `Primitive.${t}`, {
    ...e,
    [t]: r
  };
}, {});
function R0(e, t) {
  e && Yf(
    () => e.dispatchEvent(t)
  );
}
function P0(e, t = globalThis?.document) {
  const r = $n(e);
  At(() => {
    const n = (o) => {
      o.key === "Escape" && r(o);
    };
    return t.addEventListener("keydown", n), () => t.removeEventListener("keydown", n);
  }, [
    r,
    t
  ]);
}
const Vs = "dismissableLayer.update", U0 = "dismissableLayer.pointerDownOutside", B0 = "dismissableLayer.focusOutside";
let bc;
const k0 = /* @__PURE__ */ Eo({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), z0 = /* @__PURE__ */ Gt((e, t) => {
  var r;
  const { disableOutsidePointerEvents: n = !1, onEscapeKeyDown: o, onPointerDownOutside: s, onFocusOutside: f, onInteractOutside: l, onDismiss: h, ...p } = e, b = xa(k0), [g, E] = Zt(null), m = (r = g?.ownerDocument) !== null && r !== void 0 ? r : globalThis?.document, [, A] = Zt({}), w = li(
    t,
    (K) => E(K)
  ), S = Array.from(b.layers), [N] = [
    ...b.layersWithOutsidePointerEventsDisabled
  ].slice(-1), P = S.indexOf(N), C = g ? S.indexOf(g) : -1, B = b.layersWithOutsidePointerEventsDisabled.size > 0, R = C >= P, F = F0((K) => {
    const Me = K.target, ye = [
      ...b.branches
    ].some(
      ($) => $.contains(Me)
    );
    !R || ye || (s?.(K), l?.(K), K.defaultPrevented || h?.());
  }, m), Y = $0((K) => {
    const Me = K.target;
    [
      ...b.branches
    ].some(
      ($) => $.contains(Me)
    ) || (f?.(K), l?.(K), K.defaultPrevented || h?.());
  }, m);
  return P0((K) => {
    C === b.layers.size - 1 && (o?.(K), !K.defaultPrevented && h && (K.preventDefault(), h()));
  }, m), At(() => {
    if (!!g)
      return n && (b.layersWithOutsidePointerEventsDisabled.size === 0 && (bc = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), b.layersWithOutsidePointerEventsDisabled.add(g)), b.layers.add(g), xc(), () => {
        n && b.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = bc);
      };
  }, [
    g,
    m,
    n,
    b
  ]), At(() => () => {
    !g || (b.layers.delete(g), b.layersWithOutsidePointerEventsDisabled.delete(g), xc());
  }, [
    g,
    b
  ]), At(() => {
    const K = () => A({});
    return document.addEventListener(Vs, K), () => document.removeEventListener(Vs, K);
  }, []), /* @__PURE__ */ st(Gn.div, Mn({}, p, {
    ref: w,
    style: {
      pointerEvents: B ? R ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: Sn(e.onFocusCapture, Y.onFocusCapture),
    onBlurCapture: Sn(e.onBlurCapture, Y.onBlurCapture),
    onPointerDownCapture: Sn(e.onPointerDownCapture, F.onPointerDownCapture)
  }));
});
function F0(e, t = globalThis?.document) {
  const r = $n(e), n = Et(!1), o = Et(() => {
  });
  return At(() => {
    const s = (l) => {
      if (l.target && !n.current) {
        let p = function() {
          Vf(U0, r, h, {
            discrete: !0
          });
        };
        const h = {
          originalEvent: l
        };
        l.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = p, t.addEventListener("click", o.current, {
          once: !0
        })) : p();
      }
      n.current = !1;
    }, f = window.setTimeout(() => {
      t.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(f), t.removeEventListener("pointerdown", s), t.removeEventListener("click", o.current);
    };
  }, [
    t,
    r
  ]), {
    onPointerDownCapture: () => n.current = !0
  };
}
function $0(e, t = globalThis?.document) {
  const r = $n(e), n = Et(!1);
  return At(() => {
    const o = (s) => {
      s.target && !n.current && Vf(B0, r, {
        originalEvent: s
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [
    t,
    r
  ]), {
    onFocusCapture: () => n.current = !0,
    onBlurCapture: () => n.current = !1
  };
}
function xc() {
  const e = new CustomEvent(Vs);
  document.dispatchEvent(e);
}
function Vf(e, t, r, { discrete: n }) {
  const o = r.originalEvent.target, s = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: r
  });
  t && o.addEventListener(e, t, {
    once: !0
  }), n ? R0(o, s) : o.dispatchEvent(s);
}
const cs = "focusScope.autoFocusOnMount", fs = "focusScope.autoFocusOnUnmount", wc = {
  bubbles: !1,
  cancelable: !0
}, W0 = /* @__PURE__ */ Gt((e, t) => {
  const { loop: r = !1, trapped: n = !1, onMountAutoFocus: o, onUnmountAutoFocus: s, ...f } = e, [l, h] = Zt(null), p = $n(o), b = $n(s), g = Et(null), E = li(
    t,
    (w) => h(w)
  ), m = Et({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  At(() => {
    if (n) {
      let w = function(N) {
        if (m.paused || !l)
          return;
        const P = N.target;
        l.contains(P) ? g.current = P : Dn(g.current, {
          select: !0
        });
      }, S = function(N) {
        m.paused || !l || l.contains(N.relatedTarget) || Dn(g.current, {
          select: !0
        });
      };
      return document.addEventListener("focusin", w), document.addEventListener("focusout", S), () => {
        document.removeEventListener("focusin", w), document.removeEventListener("focusout", S);
      };
    }
  }, [
    n,
    l,
    m.paused
  ]), At(() => {
    if (l) {
      Ec.add(m);
      const w = document.activeElement;
      if (!l.contains(w)) {
        const N = new CustomEvent(cs, wc);
        l.addEventListener(cs, p), l.dispatchEvent(N), N.defaultPrevented || (q0(H0(Hf(l)), {
          select: !0
        }), document.activeElement === w && Dn(l));
      }
      return () => {
        l.removeEventListener(cs, p), setTimeout(() => {
          const N = new CustomEvent(fs, wc);
          l.addEventListener(fs, b), l.dispatchEvent(N), N.defaultPrevented || Dn(w ?? document.body, {
            select: !0
          }), l.removeEventListener(fs, b), Ec.remove(m);
        }, 0);
      };
    }
  }, [
    l,
    p,
    b,
    m
  ]);
  const A = Ut((w) => {
    if (!r && !n || m.paused)
      return;
    const S = w.key === "Tab" && !w.altKey && !w.ctrlKey && !w.metaKey, N = document.activeElement;
    if (S && N) {
      const P = w.currentTarget, [C, B] = Y0(P);
      C && B ? !w.shiftKey && N === B ? (w.preventDefault(), r && Dn(C, {
        select: !0
      })) : w.shiftKey && N === C && (w.preventDefault(), r && Dn(B, {
        select: !0
      })) : N === P && w.preventDefault();
    }
  }, [
    r,
    n,
    m.paused
  ]);
  return /* @__PURE__ */ st(Gn.div, Mn({
    tabIndex: -1
  }, f, {
    ref: E,
    onKeyDown: A
  }));
});
function q0(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const n of e)
    if (Dn(n, {
      select: t
    }), document.activeElement !== r)
      return;
}
function Y0(e) {
  const t = Hf(e), r = mc(t, e), n = mc(t.reverse(), e);
  return [
    r,
    n
  ];
}
function Hf(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (n) => {
      const o = n.tagName === "INPUT" && n.type === "hidden";
      return n.disabled || n.hidden || o ? NodeFilter.FILTER_SKIP : n.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); )
    t.push(r.currentNode);
  return t;
}
function mc(e, t) {
  for (const r of e)
    if (!G0(r, {
      upTo: t
    }))
      return r;
}
function G0(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function Q0(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Dn(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== r && Q0(e) && t && e.select();
  }
}
const Ec = V0();
function V0() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && r?.pause(), e = Ac(e, t), e.unshift(t);
    },
    remove(t) {
      var r;
      e = Ac(e, t), (r = e[0]) === null || r === void 0 || r.resume();
    }
  };
}
function Ac(e, t) {
  const r = [
    ...e
  ], n = r.indexOf(t);
  return n !== -1 && r.splice(n, 1), r;
}
function H0(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const Z0 = /* @__PURE__ */ Gt((e, t) => {
  var r;
  const { container: n = globalThis == null || (r = globalThis.document) === null || r === void 0 ? void 0 : r.body, ...o } = e;
  return n ? /* @__PURE__ */ qf.createPortal(/* @__PURE__ */ st(Gn.div, Mn({}, o, {
    ref: t
  })), n) : null;
});
function K0(e, t) {
  return A0((r, n) => {
    const o = t[r][n];
    return o ?? r;
  }, e);
}
const $o = (e) => {
  const { present: t, children: r } = e, n = X0(t), o = typeof r == "function" ? r({
    present: n.isPresent
  }) : Fn.only(r), s = li(n.ref, o.ref);
  return typeof r == "function" || n.isPresent ? /* @__PURE__ */ wa(o, {
    ref: s
  }) : null;
};
$o.displayName = "Presence";
function X0(e) {
  const [t, r] = Zt(), n = Et({}), o = Et(e), s = Et("none"), f = e ? "mounted" : "unmounted", [l, h] = K0(f, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return At(() => {
    const p = $i(n.current);
    s.current = l === "mounted" ? p : "none";
  }, [
    l
  ]), Gs(() => {
    const p = n.current, b = o.current;
    if (b !== e) {
      const E = s.current, m = $i(p);
      e ? h("MOUNT") : m === "none" || p?.display === "none" ? h("UNMOUNT") : h(b && E !== m ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [
    e,
    h
  ]), Gs(() => {
    if (t) {
      const p = (g) => {
        const m = $i(n.current).includes(g.animationName);
        g.target === t && m && Yf(
          () => h("ANIMATION_END")
        );
      }, b = (g) => {
        g.target === t && (s.current = $i(n.current));
      };
      return t.addEventListener("animationstart", b), t.addEventListener("animationcancel", p), t.addEventListener("animationend", p), () => {
        t.removeEventListener("animationstart", b), t.removeEventListener("animationcancel", p), t.removeEventListener("animationend", p);
      };
    } else
      h("ANIMATION_END");
  }, [
    t,
    h
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(l),
    ref: Ut((p) => {
      p && (n.current = getComputedStyle(p)), r(p);
    }, [])
  };
}
function $i(e) {
  return e?.animationName || "none";
}
let us = 0;
function J0() {
  At(() => {
    var e, t;
    const r = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = r[0]) !== null && e !== void 0 ? e : Sc()), document.body.insertAdjacentElement("beforeend", (t = r[1]) !== null && t !== void 0 ? t : Sc()), us++, () => {
      us === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (n) => n.remove()
      ), us--;
    };
  }, []);
}
function Sc() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
var Lr = function() {
  return Lr = Object.assign || function(t) {
    for (var r, n = 1, o = arguments.length; n < o; n++) {
      r = arguments[n];
      for (var s in r)
        Object.prototype.hasOwnProperty.call(r, s) && (t[s] = r[s]);
    }
    return t;
  }, Lr.apply(this, arguments);
};
function Zf(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
}
function ed(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, o = t.length, s; n < o; n++)
      (s || !(n in t)) && (s || (s = Array.prototype.slice.call(t, 0, n)), s[n] = t[n]);
  return e.concat(s || Array.prototype.slice.call(t));
}
var oo = "right-scroll-bar-position", so = "width-before-scroll-bar", td = "with-scroll-bars-hidden", rd = "--removed-body-scroll-bar-size";
function nd(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function id(e, t) {
  var r = Zt(function() {
    return {
      value: e,
      callback: t,
      facade: {
        get current() {
          return r.value;
        },
        set current(n) {
          var o = r.value;
          o !== n && (r.value = n, r.callback(n, o));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
function od(e, t) {
  return id(t || null, function(r) {
    return e.forEach(function(n) {
      return nd(n, r);
    });
  });
}
var Wo = { exports: {} }, vi = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Tc;
function sd() {
  if (Tc)
    return vi;
  Tc = 1;
  var e = Wt, t = Symbol.for("react.element"), r = Symbol.for("react.fragment"), n = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, s = { key: !0, ref: !0, __self: !0, __source: !0 };
  function f(l, h, p) {
    var b, g = {}, E = null, m = null;
    p !== void 0 && (E = "" + p), h.key !== void 0 && (E = "" + h.key), h.ref !== void 0 && (m = h.ref);
    for (b in h)
      n.call(h, b) && !s.hasOwnProperty(b) && (g[b] = h[b]);
    if (l && l.defaultProps)
      for (b in h = l.defaultProps, h)
        g[b] === void 0 && (g[b] = h[b]);
    return { $$typeof: t, type: l, key: E, ref: m, props: g, _owner: o.current };
  }
  return vi.Fragment = r, vi.jsx = f, vi.jsxs = f, vi;
}
var bi = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Mc;
function ad() {
  return Mc || (Mc = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Wt, t = Symbol.for("react.element"), r = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), s = Symbol.for("react.profiler"), f = Symbol.for("react.provider"), l = Symbol.for("react.context"), h = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), b = Symbol.for("react.suspense_list"), g = Symbol.for("react.memo"), E = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), A = Symbol.iterator, w = "@@iterator";
    function S(c) {
      if (c === null || typeof c != "object")
        return null;
      var v = A && c[A] || c[w];
      return typeof v == "function" ? v : null;
    }
    var N = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function P(c) {
      {
        for (var v = arguments.length, x = new Array(v > 1 ? v - 1 : 0), I = 1; I < v; I++)
          x[I - 1] = arguments[I];
        C("error", c, x);
      }
    }
    function C(c, v, x) {
      {
        var I = N.ReactDebugCurrentFrame, U = I.getStackAddendum();
        U !== "" && (v += "%s", x = x.concat([U]));
        var Q = x.map(function(W) {
          return String(W);
        });
        Q.unshift("Warning: " + v), Function.prototype.apply.call(console[c], console, Q);
      }
    }
    var B = !1, R = !1, F = !1, Y = !1, K = !1, Me;
    Me = Symbol.for("react.module.reference");
    function ye(c) {
      return !!(typeof c == "string" || typeof c == "function" || c === n || c === s || K || c === o || c === p || c === b || Y || c === m || B || R || F || typeof c == "object" && c !== null && (c.$$typeof === E || c.$$typeof === g || c.$$typeof === f || c.$$typeof === l || c.$$typeof === h || c.$$typeof === Me || c.getModuleId !== void 0));
    }
    function $(c, v, x) {
      var I = c.displayName;
      if (I)
        return I;
      var U = v.displayName || v.name || "";
      return U !== "" ? x + "(" + U + ")" : x;
    }
    function G(c) {
      return c.displayName || "Context";
    }
    function X(c) {
      if (c == null)
        return null;
      if (typeof c.tag == "number" && P("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof c == "function")
        return c.displayName || c.name || null;
      if (typeof c == "string")
        return c;
      switch (c) {
        case n:
          return "Fragment";
        case r:
          return "Portal";
        case s:
          return "Profiler";
        case o:
          return "StrictMode";
        case p:
          return "Suspense";
        case b:
          return "SuspenseList";
      }
      if (typeof c == "object")
        switch (c.$$typeof) {
          case l:
            var v = c;
            return G(v) + ".Consumer";
          case f:
            var x = c;
            return G(x._context) + ".Provider";
          case h:
            return $(c, c.render, "ForwardRef");
          case g:
            var I = c.displayName || null;
            return I !== null ? I : X(c.type) || "Memo";
          case E: {
            var U = c, Q = U._payload, W = U._init;
            try {
              return X(W(Q));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var ge = Object.assign, L = 0, _, q, se, ae, Ee, Se, Be;
    function Re() {
    }
    Re.__reactDisabledLog = !0;
    function Fe() {
      {
        if (L === 0) {
          _ = console.log, q = console.info, se = console.warn, ae = console.error, Ee = console.group, Se = console.groupCollapsed, Be = console.groupEnd;
          var c = {
            configurable: !0,
            enumerable: !0,
            value: Re,
            writable: !0
          };
          Object.defineProperties(console, {
            info: c,
            log: c,
            warn: c,
            error: c,
            group: c,
            groupCollapsed: c,
            groupEnd: c
          });
        }
        L++;
      }
    }
    function be() {
      {
        if (L--, L === 0) {
          var c = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: ge({}, c, {
              value: _
            }),
            info: ge({}, c, {
              value: q
            }),
            warn: ge({}, c, {
              value: se
            }),
            error: ge({}, c, {
              value: ae
            }),
            group: ge({}, c, {
              value: Ee
            }),
            groupCollapsed: ge({}, c, {
              value: Se
            }),
            groupEnd: ge({}, c, {
              value: Be
            })
          });
        }
        L < 0 && P("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var $e = N.ReactCurrentDispatcher, lt;
    function St(c, v, x) {
      {
        if (lt === void 0)
          try {
            throw Error();
          } catch (U) {
            var I = U.stack.trim().match(/\n( *(at )?)/);
            lt = I && I[1] || "";
          }
        return `
` + lt + c;
      }
    }
    var dt = !1, ht;
    {
      var _r = typeof WeakMap == "function" ? WeakMap : Map;
      ht = new _r();
    }
    function ct(c, v) {
      if (!c || dt)
        return "";
      {
        var x = ht.get(c);
        if (x !== void 0)
          return x;
      }
      var I;
      dt = !0;
      var U = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Q;
      Q = $e.current, $e.current = null, Fe();
      try {
        if (v) {
          var W = function() {
            throw Error();
          };
          if (Object.defineProperty(W.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(W, []);
            } catch (ue) {
              I = ue;
            }
            Reflect.construct(c, [], W);
          } else {
            try {
              W.call();
            } catch (ue) {
              I = ue;
            }
            c.call(W.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (ue) {
            I = ue;
          }
          c();
        }
      } catch (ue) {
        if (ue && I && typeof ue.stack == "string") {
          for (var fe = ue.stack.split(`
`), V = I.stack.split(`
`), ne = fe.length - 1, oe = V.length - 1; ne >= 1 && oe >= 0 && fe[ne] !== V[oe]; )
            oe--;
          for (; ne >= 1 && oe >= 0; ne--, oe--)
            if (fe[ne] !== V[oe]) {
              if (ne !== 1 || oe !== 1)
                do
                  if (ne--, oe--, oe < 0 || fe[ne] !== V[oe]) {
                    var le = `
` + fe[ne].replace(" at new ", " at ");
                    return c.displayName && le.includes("<anonymous>") && (le = le.replace("<anonymous>", c.displayName)), typeof c == "function" && ht.set(c, le), le;
                  }
                while (ne >= 1 && oe >= 0);
              break;
            }
        }
      } finally {
        dt = !1, $e.current = Q, be(), Error.prepareStackTrace = U;
      }
      var pe = c ? c.displayName || c.name : "", he = pe ? St(pe) : "";
      return typeof c == "function" && ht.set(c, he), he;
    }
    function Qt(c, v, x) {
      return ct(c, !1);
    }
    function Or(c) {
      var v = c.prototype;
      return !!(v && v.isReactComponent);
    }
    function hr(c, v, x) {
      if (c == null)
        return "";
      if (typeof c == "function")
        return ct(c, Or(c));
      if (typeof c == "string")
        return St(c);
      switch (c) {
        case p:
          return St("Suspense");
        case b:
          return St("SuspenseList");
      }
      if (typeof c == "object")
        switch (c.$$typeof) {
          case h:
            return Qt(c.render);
          case g:
            return hr(c.type, v, x);
          case E: {
            var I = c, U = I._payload, Q = I._init;
            try {
              return hr(Q(U), v, x);
            } catch {
            }
          }
        }
      return "";
    }
    var pr = Object.prototype.hasOwnProperty, en = {}, tn = N.ReactDebugCurrentFrame;
    function gt(c) {
      if (c) {
        var v = c._owner, x = hr(c.type, c._source, v ? v.type : null);
        tn.setExtraStackFrame(x);
      } else
        tn.setExtraStackFrame(null);
    }
    function yr(c, v, x, I, U) {
      {
        var Q = Function.call.bind(pr);
        for (var W in c)
          if (Q(c, W)) {
            var fe = void 0;
            try {
              if (typeof c[W] != "function") {
                var V = Error((I || "React class") + ": " + x + " type `" + W + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof c[W] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw V.name = "Invariant Violation", V;
              }
              fe = c[W](v, W, I, x, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ne) {
              fe = ne;
            }
            fe && !(fe instanceof Error) && (gt(U), P("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", I || "React class", x, W, typeof fe), gt(null)), fe instanceof Error && !(fe.message in en) && (en[fe.message] = !0, gt(U), P("Failed %s type: %s", x, fe.message), gt(null));
          }
      }
    }
    var On = Array.isArray;
    function gr(c) {
      return On(c);
    }
    function $r(c) {
      {
        var v = typeof Symbol == "function" && Symbol.toStringTag, x = v && c[Symbol.toStringTag] || c.constructor.name || "Object";
        return x;
      }
    }
    function vr(c) {
      try {
        return Nr(c), !1;
      } catch {
        return !0;
      }
    }
    function Nr(c) {
      return "" + c;
    }
    function ar(c) {
      if (vr(c))
        return P("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", $r(c)), Nr(c);
    }
    var Xt = N.ReactCurrentOwner, Wr = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, rn, Zn, br;
    br = {};
    function qr(c) {
      if (pr.call(c, "ref")) {
        var v = Object.getOwnPropertyDescriptor(c, "ref").get;
        if (v && v.isReactWarning)
          return !1;
      }
      return c.ref !== void 0;
    }
    function xr(c) {
      if (pr.call(c, "key")) {
        var v = Object.getOwnPropertyDescriptor(c, "key").get;
        if (v && v.isReactWarning)
          return !1;
      }
      return c.key !== void 0;
    }
    function Jt(c, v) {
      if (typeof c.ref == "string" && Xt.current && v && Xt.current.stateNode !== v) {
        var x = X(Xt.current.type);
        br[x] || (P('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', X(Xt.current.type), c.ref), br[x] = !0);
      }
    }
    function Bt(c, v) {
      {
        var x = function() {
          rn || (rn = !0, P("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", v));
        };
        x.isReactWarning = !0, Object.defineProperty(c, "key", {
          get: x,
          configurable: !0
        });
      }
    }
    function er(c, v) {
      {
        var x = function() {
          Zn || (Zn = !0, P("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", v));
        };
        x.isReactWarning = !0, Object.defineProperty(c, "ref", {
          get: x,
          configurable: !0
        });
      }
    }
    var wr = function(c, v, x, I, U, Q, W) {
      var fe = {
        $$typeof: t,
        type: c,
        key: v,
        ref: x,
        props: W,
        _owner: Q
      };
      return fe._store = {}, Object.defineProperty(fe._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(fe, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: I
      }), Object.defineProperty(fe, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: U
      }), Object.freeze && (Object.freeze(fe.props), Object.freeze(fe)), fe;
    };
    function tr(c, v, x, I, U) {
      {
        var Q, W = {}, fe = null, V = null;
        x !== void 0 && (ar(x), fe = "" + x), xr(v) && (ar(v.key), fe = "" + v.key), qr(v) && (V = v.ref, Jt(v, U));
        for (Q in v)
          pr.call(v, Q) && !Wr.hasOwnProperty(Q) && (W[Q] = v[Q]);
        if (c && c.defaultProps) {
          var ne = c.defaultProps;
          for (Q in ne)
            W[Q] === void 0 && (W[Q] = ne[Q]);
        }
        if (fe || V) {
          var oe = typeof c == "function" ? c.displayName || c.name || "Unknown" : c;
          fe && Bt(W, oe), V && er(W, oe);
        }
        return wr(c, fe, V, U, I, Xt.current, W);
      }
    }
    var kt = N.ReactCurrentOwner, jr = N.ReactDebugCurrentFrame;
    function cr(c) {
      if (c) {
        var v = c._owner, x = hr(c.type, c._source, v ? v.type : null);
        jr.setExtraStackFrame(x);
      } else
        jr.setExtraStackFrame(null);
    }
    var Nn;
    Nn = !1;
    function jn(c) {
      return typeof c == "object" && c !== null && c.$$typeof === t;
    }
    function ft() {
      {
        if (kt.current) {
          var c = X(kt.current.type);
          if (c)
            return `

Check the render method of \`` + c + "`.";
        }
        return "";
      }
    }
    function Tt(c) {
      {
        if (c !== void 0) {
          var v = c.fileName.replace(/^.*[\\\/]/, ""), x = c.lineNumber;
          return `

Check your code at ` + v + ":" + x + ".";
        }
        return "";
      }
    }
    var Nt = {};
    function Yr(c) {
      {
        var v = ft();
        if (!v) {
          var x = typeof c == "string" ? c : c.displayName || c.name;
          x && (v = `

Check the top-level render call using <` + x + ">.");
        }
        return v;
      }
    }
    function Dr(c, v) {
      {
        if (!c._store || c._store.validated || c.key != null)
          return;
        c._store.validated = !0;
        var x = Yr(v);
        if (Nt[x])
          return;
        Nt[x] = !0;
        var I = "";
        c && c._owner && c._owner !== kt.current && (I = " It was passed a child from " + X(c._owner.type) + "."), cr(c), P('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', x, I), cr(null);
      }
    }
    function nn(c, v) {
      {
        if (typeof c != "object")
          return;
        if (gr(c))
          for (var x = 0; x < c.length; x++) {
            var I = c[x];
            jn(I) && Dr(I, v);
          }
        else if (jn(c))
          c._store && (c._store.validated = !0);
        else if (c) {
          var U = S(c);
          if (typeof U == "function" && U !== c.entries)
            for (var Q = U.call(c), W; !(W = Q.next()).done; )
              jn(W.value) && Dr(W.value, v);
        }
      }
    }
    function gi(c) {
      {
        var v = c.type;
        if (v == null || typeof v == "string")
          return;
        var x;
        if (typeof v == "function")
          x = v.propTypes;
        else if (typeof v == "object" && (v.$$typeof === h || v.$$typeof === g))
          x = v.propTypes;
        else
          return;
        if (x) {
          var I = X(v);
          yr(x, c.props, "prop", I, c);
        } else if (v.PropTypes !== void 0 && !Nn) {
          Nn = !0;
          var U = X(v);
          P("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", U || "Unknown");
        }
        typeof v.getDefaultProps == "function" && !v.getDefaultProps.isReactClassApproved && P("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function rt(c) {
      {
        for (var v = Object.keys(c.props), x = 0; x < v.length; x++) {
          var I = v[x];
          if (I !== "children" && I !== "key") {
            cr(c), P("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", I), cr(null);
            break;
          }
        }
        c.ref !== null && (cr(c), P("Invalid attribute `ref` supplied to `React.Fragment`."), cr(null));
      }
    }
    function on(c, v, x, I, U, Q) {
      {
        var W = ye(c);
        if (!W) {
          var fe = "";
          (c === void 0 || typeof c == "object" && c !== null && Object.keys(c).length === 0) && (fe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var V = Tt(U);
          V ? fe += V : fe += ft();
          var ne;
          c === null ? ne = "null" : gr(c) ? ne = "array" : c !== void 0 && c.$$typeof === t ? (ne = "<" + (X(c.type) || "Unknown") + " />", fe = " Did you accidentally export a JSX literal instead of a component?") : ne = typeof c, P("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ne, fe);
        }
        var oe = tr(c, v, x, U, Q);
        if (oe == null)
          return oe;
        if (W) {
          var le = v.children;
          if (le !== void 0)
            if (I)
              if (gr(le)) {
                for (var pe = 0; pe < le.length; pe++)
                  nn(le[pe], c);
                Object.freeze && Object.freeze(le);
              } else
                P("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              nn(le, c);
        }
        return c === n ? rt(oe) : gi(oe), oe;
      }
    }
    function a(c, v, x) {
      return on(c, v, x, !0);
    }
    function d(c, v, x) {
      return on(c, v, x, !1);
    }
    var u = d, i = a;
    bi.Fragment = n, bi.jsx = u, bi.jsxs = i;
  }()), bi;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = sd() : e.exports = ad();
})(Wo);
const To = Wo.exports.Fragment, je = Wo.exports.jsx, yt = Wo.exports.jsxs;
function cd(e) {
  return e;
}
function fd(e, t) {
  t === void 0 && (t = cd);
  var r = [], n = !1, o = {
    read: function() {
      if (n)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(s) {
      var f = t(s, n);
      return r.push(f), function() {
        r = r.filter(function(l) {
          return l !== f;
        });
      };
    },
    assignSyncMedium: function(s) {
      for (n = !0; r.length; ) {
        var f = r;
        r = [], f.forEach(s);
      }
      r = {
        push: function(l) {
          return s(l);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(s) {
      n = !0;
      var f = [];
      if (r.length) {
        var l = r;
        r = [], l.forEach(s), f = r;
      }
      var h = function() {
        var b = f;
        f = [], b.forEach(s);
      }, p = function() {
        return Promise.resolve().then(h);
      };
      p(), r = {
        push: function(b) {
          f.push(b), p();
        },
        filter: function(b) {
          return f = f.filter(b), r;
        }
      };
    }
  };
  return o;
}
function ud(e) {
  e === void 0 && (e = {});
  var t = fd(null);
  return t.options = Lr({ async: !0, ssr: !1 }, e), t;
}
var Kf = function(e) {
  var t = e.sideCar, r = Zf(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var n = t.read();
  if (!n)
    throw new Error("Sidecar medium not found");
  return /* @__PURE__ */ je(n, {
    ...Lr({}, r)
  });
};
Kf.isSideCarExport = !0;
function ld(e, t) {
  return e.useMedium(t), Kf;
}
var Xf = ud(), ls = function() {
}, qo = at.forwardRef(function(e, t) {
  var r = at.useRef(null), n = at.useState({
    onScrollCapture: ls,
    onWheelCapture: ls,
    onTouchMoveCapture: ls
  }), o = n[0], s = n[1], f = e.forwardProps, l = e.children, h = e.className, p = e.removeScrollBar, b = e.enabled, g = e.shards, E = e.sideCar, m = e.noIsolation, A = e.inert, w = e.allowPinchZoom, S = e.as, N = S === void 0 ? "div" : S, P = Zf(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), C = E, B = od([r, t]), R = Lr(Lr({}, P), o);
  return /* @__PURE__ */ yt(To, {
    children: [b && /* @__PURE__ */ je(C, {
      sideCar: Xf,
      removeScrollBar: p,
      shards: g,
      noIsolation: m,
      inert: A,
      setCallbacks: s,
      allowPinchZoom: !!w,
      lockRef: r
    }), f ? at.cloneElement(at.Children.only(l), Lr(Lr({}, R), {
      ref: B
    })) : /* @__PURE__ */ je(N, {
      ...Lr({}, R, {
        className: h,
        ref: B
      }),
      children: l
    })]
  });
});
qo.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
qo.classNames = {
  fullWidth: so,
  zeroRight: oo
};
var dd = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function hd() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = dd();
  return t && e.setAttribute("nonce", t), e;
}
function pd(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function yd(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var gd = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = hd()) && (pd(t, r), yd(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, vd = function() {
  var e = gd();
  return function(t, r) {
    at.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, Jf = function() {
  var e = vd(), t = function(r) {
    var n = r.styles, o = r.dynamic;
    return e(n, o), null;
  };
  return t;
}, bd = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, ds = function(e) {
  return parseInt(e || "", 10) || 0;
}, xd = function(e) {
  var t = window.getComputedStyle(document.body);
  process.env.NODE_ENV !== "production" && t.overflowY === "hidden" && console.error("react-remove-scroll-bar: cannot calculate scrollbar size because it is removed (overflow:hidden on body");
  var r = t[e === "padding" ? "paddingLeft" : "marginLeft"], n = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [ds(r), ds(n), ds(o)];
}, wd = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return bd;
  var t = xd(e), r = document.documentElement.clientWidth, n = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, n - r + t[2] - t[0])
  };
}, md = Jf(), Ed = function(e, t, r, n) {
  var o = e.left, s = e.top, f = e.right, l = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(td, ` {
   overflow: hidden `).concat(n, `;
   padding-right: `).concat(l, "px ").concat(n, `;
  }
  body {
    overflow: hidden `).concat(n, `;
    overscroll-behavior: contain;
    `).concat([t && "position: relative ".concat(n, ";"), r === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(f, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(l, "px ").concat(n, `;
    `), r === "padding" && "padding-right: ".concat(l, "px ").concat(n, ";")].filter(Boolean).join(""), `
  }
  
  .`).concat(oo, ` {
    right: `).concat(l, "px ").concat(n, `;
  }
  
  .`).concat(so, ` {
    margin-right: `).concat(l, "px ").concat(n, `;
  }
  
  .`).concat(oo, " .").concat(oo, ` {
    right: 0 `).concat(n, `;
  }
  
  .`).concat(so, " .").concat(so, ` {
    margin-right: 0 `).concat(n, `;
  }
  
  body {
    `).concat(rd, ": ").concat(l, `px;
  }
`);
}, Ad = function(e) {
  var t = e.noRelative, r = e.noImportant, n = e.gapMode, o = n === void 0 ? "margin" : n, s = at.useMemo(function() {
    return wd(o);
  }, [o]);
  return /* @__PURE__ */ je(md, {
    styles: Ed(s, !t, o, r ? "" : "!important")
  });
}, Hs = !1;
if (typeof window < "u")
  try {
    var Wi = Object.defineProperty({}, "passive", {
      get: function() {
        return Hs = !0, !0;
      }
    });
    window.addEventListener("test", Wi, Wi), window.removeEventListener("test", Wi, Wi);
  } catch {
    Hs = !1;
  }
var Kn = Hs ? { passive: !1 } : !1, Sd = function(e) {
  return e.tagName === "TEXTAREA";
}, eu = function(e, t) {
  var r = window.getComputedStyle(e);
  return r[t] !== "hidden" && !(r.overflowY === r.overflowX && !Sd(e) && r[t] === "visible");
}, Td = function(e) {
  return eu(e, "overflowY");
}, Md = function(e) {
  return eu(e, "overflowX");
}, Ic = function(e, t) {
  var r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var n = tu(e, r);
    if (n) {
      var o = ru(e, r), s = o[1], f = o[2];
      if (s > f)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== document.body);
  return !1;
}, Id = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, n = e.clientHeight;
  return [
    t,
    r,
    n
  ];
}, Cd = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, n = e.clientWidth;
  return [
    t,
    r,
    n
  ];
}, tu = function(e, t) {
  return e === "v" ? Td(t) : Md(t);
}, ru = function(e, t) {
  return e === "v" ? Id(t) : Cd(t);
}, _d = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Od = function(e, t, r, n, o) {
  var s = _d(e, window.getComputedStyle(t).direction), f = s * n, l = r.target, h = t.contains(l), p = !1, b = f > 0, g = 0, E = 0;
  do {
    var m = ru(e, l), A = m[0], w = m[1], S = m[2], N = w - S - s * A;
    (A || N) && tu(e, l) && (g += N, E += A), l = l.parentNode;
  } while (!h && l !== document.body || h && (t.contains(l) || t === l));
  return (b && (o && g === 0 || !o && f > g) || !b && (o && E === 0 || !o && -f > E)) && (p = !0), p;
}, qi = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Cc = function(e) {
  return [e.deltaX, e.deltaY];
}, _c = function(e) {
  return e && "current" in e ? e.current : e;
}, Nd = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, jd = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Dd = 0, Xn = [];
function Ld(e) {
  var t = at.useRef([]), r = at.useRef([0, 0]), n = at.useRef(), o = at.useState(Dd++)[0], s = at.useState(function() {
    return Jf();
  })[0], f = at.useRef(e);
  at.useEffect(function() {
    f.current = e;
  }, [e]), at.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var w = ed([e.lockRef.current], (e.shards || []).map(_c), !0).filter(Boolean);
      return w.forEach(function(S) {
        return S.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), w.forEach(function(S) {
          return S.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var l = at.useCallback(function(w, S) {
    if ("touches" in w && w.touches.length === 2)
      return !f.current.allowPinchZoom;
    var N = qi(w), P = r.current, C = "deltaX" in w ? w.deltaX : P[0] - N[0], B = "deltaY" in w ? w.deltaY : P[1] - N[1], R, F = w.target, Y = Math.abs(C) > Math.abs(B) ? "h" : "v";
    if ("touches" in w && Y === "h" && F.type === "range")
      return !1;
    var K = Ic(Y, F);
    if (!K)
      return !0;
    if (K ? R = Y : (R = Y === "v" ? "h" : "v", K = Ic(Y, F)), !K)
      return !1;
    if (!n.current && "changedTouches" in w && (C || B) && (n.current = R), !R)
      return !0;
    var Me = n.current || R;
    return Od(Me, S, w, Me === "h" ? C : B, !0);
  }, []), h = at.useCallback(function(w) {
    var S = w;
    if (!(!Xn.length || Xn[Xn.length - 1] !== s)) {
      var N = "deltaY" in S ? Cc(S) : qi(S), P = t.current.filter(function(R) {
        return R.name === S.type && R.target === S.target && Nd(R.delta, N);
      })[0];
      if (P && P.should) {
        S.cancelable && S.preventDefault();
        return;
      }
      if (!P) {
        var C = (f.current.shards || []).map(_c).filter(Boolean).filter(function(R) {
          return R.contains(S.target);
        }), B = C.length > 0 ? l(S, C[0]) : !f.current.noIsolation;
        B && S.cancelable && S.preventDefault();
      }
    }
  }, []), p = at.useCallback(function(w, S, N, P) {
    var C = {
      name: w,
      delta: S,
      target: N,
      should: P
    };
    t.current.push(C), setTimeout(function() {
      t.current = t.current.filter(function(B) {
        return B !== C;
      });
    }, 1);
  }, []), b = at.useCallback(function(w) {
    r.current = qi(w), n.current = void 0;
  }, []), g = at.useCallback(function(w) {
    p(w.type, Cc(w), w.target, l(w, e.lockRef.current));
  }, []), E = at.useCallback(function(w) {
    p(w.type, qi(w), w.target, l(w, e.lockRef.current));
  }, []);
  at.useEffect(function() {
    return Xn.push(s), e.setCallbacks({
      onScrollCapture: g,
      onWheelCapture: g,
      onTouchMoveCapture: E
    }), document.addEventListener("wheel", h, Kn), document.addEventListener("touchmove", h, Kn), document.addEventListener("touchstart", b, Kn), function() {
      Xn = Xn.filter(function(w) {
        return w !== s;
      }), document.removeEventListener("wheel", h, Kn), document.removeEventListener("touchmove", h, Kn), document.removeEventListener("touchstart", b, Kn);
    };
  }, []);
  var m = e.removeScrollBar, A = e.inert;
  return /* @__PURE__ */ yt(To, {
    children: [A ? /* @__PURE__ */ je(s, {
      styles: jd(o)
    }) : null, m ? /* @__PURE__ */ je(Ad, {
      gapMode: "margin"
    }) : null]
  });
}
const Rd = ld(Xf, Ld);
var nu = at.forwardRef(function(e, t) {
  return /* @__PURE__ */ je(qo, {
    ...Lr({}, e, {
      ref: t,
      sideCar: Rd
    })
  });
});
nu.classNames = qo.classNames;
const Pd = nu;
var Ud = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Jn = /* @__PURE__ */ new WeakMap(), Yi = /* @__PURE__ */ new WeakMap(), Gi = {}, hs = 0, Bd = function(e, t, r, n) {
  var o = Array.isArray(e) ? e : [e];
  Gi[r] || (Gi[r] = /* @__PURE__ */ new WeakMap());
  var s = Gi[r], f = [], l = /* @__PURE__ */ new Set(), h = new Set(o), p = function(g) {
    !g || l.has(g) || (l.add(g), p(g.parentNode));
  };
  o.forEach(p);
  var b = function(g) {
    !g || h.has(g) || Array.prototype.forEach.call(g.children, function(E) {
      if (l.has(E))
        b(E);
      else {
        var m = E.getAttribute(n), A = m !== null && m !== "false", w = (Jn.get(E) || 0) + 1, S = (s.get(E) || 0) + 1;
        Jn.set(E, w), s.set(E, S), f.push(E), w === 1 && A && Yi.set(E, !0), S === 1 && E.setAttribute(r, "true"), A || E.setAttribute(n, "true");
      }
    });
  };
  return b(t), l.clear(), hs++, function() {
    f.forEach(function(g) {
      var E = Jn.get(g) - 1, m = s.get(g) - 1;
      Jn.set(g, E), s.set(g, m), E || (Yi.has(g) || g.removeAttribute(n), Yi.delete(g)), m || g.removeAttribute(r);
    }), hs--, hs || (Jn = /* @__PURE__ */ new WeakMap(), Jn = /* @__PURE__ */ new WeakMap(), Yi = /* @__PURE__ */ new WeakMap(), Gi = {});
  };
}, kd = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var n = Array.from(Array.isArray(e) ? e : [e]), o = t || Ud(e);
  return o ? (n.push.apply(n, Array.from(o.querySelectorAll("[aria-live]"))), Bd(n, o, r, "aria-hidden")) : function() {
    return null;
  };
};
const iu = "Dialog", [ou, N6] = T0(iu), [zd, zr] = ou(iu), Fd = (e) => {
  const { __scopeDialog: t, children: r, open: n, defaultOpen: o, onOpenChange: s, modal: f = !0 } = e, l = Et(null), h = Et(null), [p = !1, b] = _0({
    prop: n,
    defaultProp: o,
    onChange: s
  });
  return /* @__PURE__ */ st(zd, {
    scope: t,
    triggerRef: l,
    contentRef: h,
    contentId: as(),
    titleId: as(),
    descriptionId: as(),
    open: p,
    onOpenChange: b,
    onOpenToggle: Ut(
      () => b(
        (g) => !g
      ),
      [
        b
      ]
    ),
    modal: f
  }, r);
}, $d = "DialogTrigger", Wd = /* @__PURE__ */ Gt((e, t) => {
  const { __scopeDialog: r, ...n } = e, o = zr($d, r), s = li(t, o.triggerRef);
  return /* @__PURE__ */ st(Gn.button, Ve({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": o.open,
    "aria-controls": o.contentId,
    "data-state": Ea(o.open)
  }, n, {
    ref: s,
    onClick: Sn(e.onClick, o.onOpenToggle)
  }));
}), su = "DialogPortal", [qd, au] = ou(su, {
  forceMount: void 0
}), Yd = (e) => {
  const { __scopeDialog: t, forceMount: r, children: n, container: o } = e, s = zr(su, t);
  return /* @__PURE__ */ st(qd, {
    scope: t,
    forceMount: r
  }, Fn.map(
    n,
    (f) => /* @__PURE__ */ st($o, {
      present: r || s.open
    }, /* @__PURE__ */ st(Z0, {
      asChild: !0,
      container: o
    }, f))
  ));
}, Zs = "DialogOverlay", Gd = /* @__PURE__ */ Gt((e, t) => {
  const r = au(Zs, e.__scopeDialog), { forceMount: n = r.forceMount, ...o } = e, s = zr(Zs, e.__scopeDialog);
  return s.modal ? /* @__PURE__ */ st($o, {
    present: n || s.open
  }, /* @__PURE__ */ st(Qd, Ve({}, o, {
    ref: t
  }))) : null;
}), Qd = /* @__PURE__ */ Gt((e, t) => {
  const { __scopeDialog: r, ...n } = e, o = zr(Zs, r);
  return /* @__PURE__ */ st(Pd, {
    as: ma,
    allowPinchZoom: !0,
    shards: [
      o.contentRef
    ]
  }, /* @__PURE__ */ st(Gn.div, Ve({
    "data-state": Ea(o.open)
  }, n, {
    ref: t,
    style: {
      pointerEvents: "auto",
      ...n.style
    }
  })));
}), Mi = "DialogContent", Vd = /* @__PURE__ */ Gt((e, t) => {
  const r = au(Mi, e.__scopeDialog), { forceMount: n = r.forceMount, ...o } = e, s = zr(Mi, e.__scopeDialog);
  return /* @__PURE__ */ st($o, {
    present: n || s.open
  }, s.modal ? /* @__PURE__ */ st(Hd, Ve({}, o, {
    ref: t
  })) : /* @__PURE__ */ st(Zd, Ve({}, o, {
    ref: t
  })));
}), Hd = /* @__PURE__ */ Gt((e, t) => {
  const r = zr(Mi, e.__scopeDialog), n = Et(null), o = li(t, r.contentRef, n);
  return At(() => {
    const s = n.current;
    if (s)
      return kd(s);
  }, []), /* @__PURE__ */ st(cu, Ve({}, e, {
    ref: o,
    trapFocus: r.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: Sn(e.onCloseAutoFocus, (s) => {
      var f;
      s.preventDefault(), (f = r.triggerRef.current) === null || f === void 0 || f.focus();
    }),
    onPointerDownOutside: Sn(e.onPointerDownOutside, (s) => {
      const f = s.detail.originalEvent, l = f.button === 0 && f.ctrlKey === !0;
      (f.button === 2 || l) && s.preventDefault();
    }),
    onFocusOutside: Sn(
      e.onFocusOutside,
      (s) => s.preventDefault()
    )
  }));
}), Zd = /* @__PURE__ */ Gt((e, t) => {
  const r = zr(Mi, e.__scopeDialog), n = Et(!1);
  return /* @__PURE__ */ st(cu, Ve({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (o) => {
      var s;
      if ((s = e.onCloseAutoFocus) === null || s === void 0 || s.call(e, o), !o.defaultPrevented) {
        var f;
        n.current || (f = r.triggerRef.current) === null || f === void 0 || f.focus(), o.preventDefault();
      }
      n.current = !1;
    },
    onInteractOutside: (o) => {
      var s, f;
      (s = e.onInteractOutside) === null || s === void 0 || s.call(e, o), o.defaultPrevented || (n.current = !0);
      const l = o.target;
      ((f = r.triggerRef.current) === null || f === void 0 ? void 0 : f.contains(l)) && o.preventDefault();
    }
  }));
}), cu = /* @__PURE__ */ Gt((e, t) => {
  const { __scopeDialog: r, trapFocus: n, onOpenAutoFocus: o, onCloseAutoFocus: s, ...f } = e, l = zr(Mi, r), h = Et(null), p = li(t, h);
  return J0(), /* @__PURE__ */ st(Wf, null, /* @__PURE__ */ st(W0, {
    asChild: !0,
    loop: !0,
    trapped: n,
    onMountAutoFocus: o,
    onUnmountAutoFocus: s
  }, /* @__PURE__ */ st(z0, Ve({
    role: "dialog",
    id: l.contentId,
    "aria-describedby": l.descriptionId,
    "aria-labelledby": l.titleId,
    "data-state": Ea(l.open)
  }, f, {
    ref: p,
    onDismiss: () => l.onOpenChange(!1)
  }))), !1);
}), Kd = "DialogTitle", Xd = /* @__PURE__ */ Gt((e, t) => {
  const { __scopeDialog: r, ...n } = e, o = zr(Kd, r);
  return /* @__PURE__ */ st(Gn.h2, Ve({
    id: o.titleId
  }, n, {
    ref: t
  }));
}), Jd = "DialogClose", eh = /* @__PURE__ */ Gt((e, t) => {
  const { __scopeDialog: r, ...n } = e, o = zr(Jd, r);
  return /* @__PURE__ */ st(Gn.button, Ve({
    type: "button"
  }, n, {
    ref: t,
    onClick: Sn(
      e.onClick,
      () => o.onOpenChange(!1)
    )
  }));
});
function Ea(e) {
  return e ? "open" : "closed";
}
const th = Fd, rh = Wd, nh = Yd, ih = Gd, oh = Vd, Ii = Xd, sh = eh, ah = (e) => /* @__PURE__ */ yt(th, {
  open: e.open,
  onOpenChange: e.onOpenChange,
  children: [/* @__PURE__ */ je(rh, {
    asChild: !0,
    children: e.trigger
  }), /* @__PURE__ */ je(nh, {
    children: /* @__PURE__ */ je(ih, {
      className: "wkit-dialog__overlay",
      children: /* @__PURE__ */ je(oh, {
        ...e.contentProps,
        className: So("wkit-dialog__content", e.className),
        style: e.style,
        children: e.children
      })
    })
  })]
});
function fu() {
  return /* @__PURE__ */ je("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ je("path", {
      d: "M15.8332 10.0003H4.1665M4.1665 10.0003L9.99984 15.8337M4.1665 10.0003L9.99984 4.16699",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
}
function ch() {
  return /* @__PURE__ */ je("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ je("path", {
      d: "M15 5L5 15M5 5L15 15",
      stroke: "currentColor",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })
  });
}
function fh() {
  return /* @__PURE__ */ yt("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/* @__PURE__ */ je("g", {
      clipPath: "url(#clip0_1790_28273)",
      children: /* @__PURE__ */ je("path", {
        d: "M9.99989 10.9766L14.1249 6.85156L15.3032 8.0299L9.99989 13.3332L4.69656 8.0299L5.87489 6.85156L9.99989 10.9766Z",
        fill: "currentColor"
      })
    }), /* @__PURE__ */ je("defs", {
      children: /* @__PURE__ */ je("clipPath", {
        id: "clip0_1790_28273",
        children: /* @__PURE__ */ je("rect", {
          width: "20",
          height: "20",
          fill: "white",
          transform: "translate(20) rotate(90)"
        })
      })
    })]
  });
}
var Ar = /* @__PURE__ */ ((e) => (e.DISCONNECTED = "disconnected", e.CONNECTED = "connected", e.CONNECTING = "connecting", e))(Ar || {}), uh = Object.defineProperty, lh = (e, t, r) => t in e ? uh(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, Oc = (e, t, r) => (lh(e, typeof t != "symbol" ? t + "" : t, r), r), Sr = /* @__PURE__ */ ((e) => (e.UNKNOWN_ERROR = "UNKNOWN_ERROR", e.KIT__UNKNOWN_ERROR = "KIT.UNKNOWN_ERROR", e.WALLET__UNKNOWN_ERROR = "WALLET.UNKNOWN_ERROR", e.WALLET__CONNECT_ERROR = "WALLET.CONNECT_ERROR", e.WALLET__CONNECT_ERROR__USER_REJECTED = "WALLET.CONNECT_ERROR.USER_REJECTED", e.WALLET__DISCONNECT_ERROR = "WALLET.DISCONNECT_ERROR", e.WALLET__SIGN_TX_ERROR = "WALLET.SIGN_TX_ERROR", e.WALLET__SIGN_MSG_ERROR = "WALLET.SIGN_MSG_ERROR", e.WALLET__LISTEN_TO_EVENT_ERROR = "WALLET.LISTEN_TO_EVENT_ERROR", e.WALLET__METHOD_NOT_IMPLEMENTED_ERROR = "WALLET.METHOD_NOT_IMPLEMENTED_ERROR", e))(Sr || {});
class uu extends Error {
  constructor(t, r = "UNKNOWN_ERROR", n) {
    super(t), Oc(this, "code"), Oc(this, "details"), this.details = n, this.code = r, this.message = this.formatErrorStr(r, t, n);
  }
  formatErrorStr(t, r, n) {
    let o = `[${this.code}] ${r}`;
    return n && (o += " | details: " + JSON.stringify(n)), o;
  }
}
class zt extends uu {
  constructor(t = "kit unknown error", r = "KIT.UNKNOWN_ERROR", n) {
    super(t, r, n);
  }
}
class Ln extends uu {
  constructor(t = "wallet unknown error", r = "WALLET.UNKNOWN_ERROR", n) {
    super(t, r, n);
  }
}
class dh extends Ln {
  constructor(t) {
    super(`wallet does not implement function: ${t}`, "WALLET.METHOD_NOT_IMPLEMENTED_ERROR");
  }
}
function sn(e) {
  return `Failed to call ${e}, missing context provider to run within`;
}
const hh = {
  configuredWallets: [],
  detectedWallets: [],
  allAvailableWallets: [],
  chains: [],
  chain: void 0,
  name: void 0,
  adapter: void 0,
  connecting: !1,
  connected: !1,
  account: void 0,
  status: Ar.DISCONNECTED,
  address: void 0,
  async select() {
    throw new zt(sn("select"));
  },
  on() {
    throw new zt(sn("on"));
  },
  async disconnect() {
    throw new zt(sn("disconnect"));
  },
  getAccounts() {
    throw new zt(sn("getAccounts"));
  },
  async signAndExecuteTransactionBlock() {
    throw new zt(sn("signAndExecuteTransactionBlock"));
  },
  async signTransactionBlock() {
    throw new zt(sn("signTransactionBlock"));
  },
  async signMessage() {
    throw new zt(sn("signMessage"));
  },
  verifySignedMessage() {
    throw new zt(sn("verifySignedMessage"));
  }
}, lu = Eo(hh);
function Pi() {
  return xa(lu);
}
function ph(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var yh = { exports: {} };
const gh = {}, vh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: gh
}, Symbol.toStringTag, { value: "Module" })), bh = /* @__PURE__ */ ui(vh);
(function(e) {
  (function(t) {
    var r = function(a) {
      var d, u = new Float64Array(16);
      if (a)
        for (d = 0; d < a.length; d++)
          u[d] = a[d];
      return u;
    }, n = function() {
      throw new Error("no PRNG");
    }, o = new Uint8Array(16), s = new Uint8Array(32);
    s[0] = 9;
    var f = r(), l = r([1]), h = r([56129, 1]), p = r([30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139, 11119, 27886, 20995]), b = r([61785, 9906, 39828, 60374, 45398, 33411, 5274, 224, 53552, 61171, 33010, 6542, 64743, 22239, 55772, 9222]), g = r([54554, 36645, 11616, 51542, 42930, 38181, 51040, 26924, 56412, 64982, 57905, 49316, 21502, 52590, 14035, 8553]), E = r([26200, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214]), m = r([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);
    function A(a, d, u, i) {
      a[d] = u >> 24 & 255, a[d + 1] = u >> 16 & 255, a[d + 2] = u >> 8 & 255, a[d + 3] = u & 255, a[d + 4] = i >> 24 & 255, a[d + 5] = i >> 16 & 255, a[d + 6] = i >> 8 & 255, a[d + 7] = i & 255;
    }
    function w(a, d, u, i, c) {
      var v, x = 0;
      for (v = 0; v < c; v++)
        x |= a[d + v] ^ u[i + v];
      return (1 & x - 1 >>> 8) - 1;
    }
    function S(a, d, u, i) {
      return w(a, d, u, i, 16);
    }
    function N(a, d, u, i) {
      return w(a, d, u, i, 32);
    }
    function P(a, d, u, i) {
      for (var c = i[0] & 255 | (i[1] & 255) << 8 | (i[2] & 255) << 16 | (i[3] & 255) << 24, v = u[0] & 255 | (u[1] & 255) << 8 | (u[2] & 255) << 16 | (u[3] & 255) << 24, x = u[4] & 255 | (u[5] & 255) << 8 | (u[6] & 255) << 16 | (u[7] & 255) << 24, I = u[8] & 255 | (u[9] & 255) << 8 | (u[10] & 255) << 16 | (u[11] & 255) << 24, U = u[12] & 255 | (u[13] & 255) << 8 | (u[14] & 255) << 16 | (u[15] & 255) << 24, Q = i[4] & 255 | (i[5] & 255) << 8 | (i[6] & 255) << 16 | (i[7] & 255) << 24, W = d[0] & 255 | (d[1] & 255) << 8 | (d[2] & 255) << 16 | (d[3] & 255) << 24, fe = d[4] & 255 | (d[5] & 255) << 8 | (d[6] & 255) << 16 | (d[7] & 255) << 24, V = d[8] & 255 | (d[9] & 255) << 8 | (d[10] & 255) << 16 | (d[11] & 255) << 24, ne = d[12] & 255 | (d[13] & 255) << 8 | (d[14] & 255) << 16 | (d[15] & 255) << 24, oe = i[8] & 255 | (i[9] & 255) << 8 | (i[10] & 255) << 16 | (i[11] & 255) << 24, le = u[16] & 255 | (u[17] & 255) << 8 | (u[18] & 255) << 16 | (u[19] & 255) << 24, pe = u[20] & 255 | (u[21] & 255) << 8 | (u[22] & 255) << 16 | (u[23] & 255) << 24, he = u[24] & 255 | (u[25] & 255) << 8 | (u[26] & 255) << 16 | (u[27] & 255) << 24, ue = u[28] & 255 | (u[29] & 255) << 8 | (u[30] & 255) << 16 | (u[31] & 255) << 24, ve = i[12] & 255 | (i[13] & 255) << 8 | (i[14] & 255) << 16 | (i[15] & 255) << 24, ee = c, ie = v, J = x, te = I, re = U, Z = Q, T = W, M = fe, k = V, j = ne, D = oe, z = le, ce = pe, xe = he, me = ue, we = ve, y, Te = 0; Te < 20; Te += 2)
        y = ee + ce | 0, re ^= y << 7 | y >>> 32 - 7, y = re + ee | 0, k ^= y << 9 | y >>> 32 - 9, y = k + re | 0, ce ^= y << 13 | y >>> 32 - 13, y = ce + k | 0, ee ^= y << 18 | y >>> 32 - 18, y = Z + ie | 0, j ^= y << 7 | y >>> 32 - 7, y = j + Z | 0, xe ^= y << 9 | y >>> 32 - 9, y = xe + j | 0, ie ^= y << 13 | y >>> 32 - 13, y = ie + xe | 0, Z ^= y << 18 | y >>> 32 - 18, y = D + T | 0, me ^= y << 7 | y >>> 32 - 7, y = me + D | 0, J ^= y << 9 | y >>> 32 - 9, y = J + me | 0, T ^= y << 13 | y >>> 32 - 13, y = T + J | 0, D ^= y << 18 | y >>> 32 - 18, y = we + z | 0, te ^= y << 7 | y >>> 32 - 7, y = te + we | 0, M ^= y << 9 | y >>> 32 - 9, y = M + te | 0, z ^= y << 13 | y >>> 32 - 13, y = z + M | 0, we ^= y << 18 | y >>> 32 - 18, y = ee + te | 0, ie ^= y << 7 | y >>> 32 - 7, y = ie + ee | 0, J ^= y << 9 | y >>> 32 - 9, y = J + ie | 0, te ^= y << 13 | y >>> 32 - 13, y = te + J | 0, ee ^= y << 18 | y >>> 32 - 18, y = Z + re | 0, T ^= y << 7 | y >>> 32 - 7, y = T + Z | 0, M ^= y << 9 | y >>> 32 - 9, y = M + T | 0, re ^= y << 13 | y >>> 32 - 13, y = re + M | 0, Z ^= y << 18 | y >>> 32 - 18, y = D + j | 0, z ^= y << 7 | y >>> 32 - 7, y = z + D | 0, k ^= y << 9 | y >>> 32 - 9, y = k + z | 0, j ^= y << 13 | y >>> 32 - 13, y = j + k | 0, D ^= y << 18 | y >>> 32 - 18, y = we + me | 0, ce ^= y << 7 | y >>> 32 - 7, y = ce + we | 0, xe ^= y << 9 | y >>> 32 - 9, y = xe + ce | 0, me ^= y << 13 | y >>> 32 - 13, y = me + xe | 0, we ^= y << 18 | y >>> 32 - 18;
      ee = ee + c | 0, ie = ie + v | 0, J = J + x | 0, te = te + I | 0, re = re + U | 0, Z = Z + Q | 0, T = T + W | 0, M = M + fe | 0, k = k + V | 0, j = j + ne | 0, D = D + oe | 0, z = z + le | 0, ce = ce + pe | 0, xe = xe + he | 0, me = me + ue | 0, we = we + ve | 0, a[0] = ee >>> 0 & 255, a[1] = ee >>> 8 & 255, a[2] = ee >>> 16 & 255, a[3] = ee >>> 24 & 255, a[4] = ie >>> 0 & 255, a[5] = ie >>> 8 & 255, a[6] = ie >>> 16 & 255, a[7] = ie >>> 24 & 255, a[8] = J >>> 0 & 255, a[9] = J >>> 8 & 255, a[10] = J >>> 16 & 255, a[11] = J >>> 24 & 255, a[12] = te >>> 0 & 255, a[13] = te >>> 8 & 255, a[14] = te >>> 16 & 255, a[15] = te >>> 24 & 255, a[16] = re >>> 0 & 255, a[17] = re >>> 8 & 255, a[18] = re >>> 16 & 255, a[19] = re >>> 24 & 255, a[20] = Z >>> 0 & 255, a[21] = Z >>> 8 & 255, a[22] = Z >>> 16 & 255, a[23] = Z >>> 24 & 255, a[24] = T >>> 0 & 255, a[25] = T >>> 8 & 255, a[26] = T >>> 16 & 255, a[27] = T >>> 24 & 255, a[28] = M >>> 0 & 255, a[29] = M >>> 8 & 255, a[30] = M >>> 16 & 255, a[31] = M >>> 24 & 255, a[32] = k >>> 0 & 255, a[33] = k >>> 8 & 255, a[34] = k >>> 16 & 255, a[35] = k >>> 24 & 255, a[36] = j >>> 0 & 255, a[37] = j >>> 8 & 255, a[38] = j >>> 16 & 255, a[39] = j >>> 24 & 255, a[40] = D >>> 0 & 255, a[41] = D >>> 8 & 255, a[42] = D >>> 16 & 255, a[43] = D >>> 24 & 255, a[44] = z >>> 0 & 255, a[45] = z >>> 8 & 255, a[46] = z >>> 16 & 255, a[47] = z >>> 24 & 255, a[48] = ce >>> 0 & 255, a[49] = ce >>> 8 & 255, a[50] = ce >>> 16 & 255, a[51] = ce >>> 24 & 255, a[52] = xe >>> 0 & 255, a[53] = xe >>> 8 & 255, a[54] = xe >>> 16 & 255, a[55] = xe >>> 24 & 255, a[56] = me >>> 0 & 255, a[57] = me >>> 8 & 255, a[58] = me >>> 16 & 255, a[59] = me >>> 24 & 255, a[60] = we >>> 0 & 255, a[61] = we >>> 8 & 255, a[62] = we >>> 16 & 255, a[63] = we >>> 24 & 255;
    }
    function C(a, d, u, i) {
      for (var c = i[0] & 255 | (i[1] & 255) << 8 | (i[2] & 255) << 16 | (i[3] & 255) << 24, v = u[0] & 255 | (u[1] & 255) << 8 | (u[2] & 255) << 16 | (u[3] & 255) << 24, x = u[4] & 255 | (u[5] & 255) << 8 | (u[6] & 255) << 16 | (u[7] & 255) << 24, I = u[8] & 255 | (u[9] & 255) << 8 | (u[10] & 255) << 16 | (u[11] & 255) << 24, U = u[12] & 255 | (u[13] & 255) << 8 | (u[14] & 255) << 16 | (u[15] & 255) << 24, Q = i[4] & 255 | (i[5] & 255) << 8 | (i[6] & 255) << 16 | (i[7] & 255) << 24, W = d[0] & 255 | (d[1] & 255) << 8 | (d[2] & 255) << 16 | (d[3] & 255) << 24, fe = d[4] & 255 | (d[5] & 255) << 8 | (d[6] & 255) << 16 | (d[7] & 255) << 24, V = d[8] & 255 | (d[9] & 255) << 8 | (d[10] & 255) << 16 | (d[11] & 255) << 24, ne = d[12] & 255 | (d[13] & 255) << 8 | (d[14] & 255) << 16 | (d[15] & 255) << 24, oe = i[8] & 255 | (i[9] & 255) << 8 | (i[10] & 255) << 16 | (i[11] & 255) << 24, le = u[16] & 255 | (u[17] & 255) << 8 | (u[18] & 255) << 16 | (u[19] & 255) << 24, pe = u[20] & 255 | (u[21] & 255) << 8 | (u[22] & 255) << 16 | (u[23] & 255) << 24, he = u[24] & 255 | (u[25] & 255) << 8 | (u[26] & 255) << 16 | (u[27] & 255) << 24, ue = u[28] & 255 | (u[29] & 255) << 8 | (u[30] & 255) << 16 | (u[31] & 255) << 24, ve = i[12] & 255 | (i[13] & 255) << 8 | (i[14] & 255) << 16 | (i[15] & 255) << 24, ee = c, ie = v, J = x, te = I, re = U, Z = Q, T = W, M = fe, k = V, j = ne, D = oe, z = le, ce = pe, xe = he, me = ue, we = ve, y, Te = 0; Te < 20; Te += 2)
        y = ee + ce | 0, re ^= y << 7 | y >>> 32 - 7, y = re + ee | 0, k ^= y << 9 | y >>> 32 - 9, y = k + re | 0, ce ^= y << 13 | y >>> 32 - 13, y = ce + k | 0, ee ^= y << 18 | y >>> 32 - 18, y = Z + ie | 0, j ^= y << 7 | y >>> 32 - 7, y = j + Z | 0, xe ^= y << 9 | y >>> 32 - 9, y = xe + j | 0, ie ^= y << 13 | y >>> 32 - 13, y = ie + xe | 0, Z ^= y << 18 | y >>> 32 - 18, y = D + T | 0, me ^= y << 7 | y >>> 32 - 7, y = me + D | 0, J ^= y << 9 | y >>> 32 - 9, y = J + me | 0, T ^= y << 13 | y >>> 32 - 13, y = T + J | 0, D ^= y << 18 | y >>> 32 - 18, y = we + z | 0, te ^= y << 7 | y >>> 32 - 7, y = te + we | 0, M ^= y << 9 | y >>> 32 - 9, y = M + te | 0, z ^= y << 13 | y >>> 32 - 13, y = z + M | 0, we ^= y << 18 | y >>> 32 - 18, y = ee + te | 0, ie ^= y << 7 | y >>> 32 - 7, y = ie + ee | 0, J ^= y << 9 | y >>> 32 - 9, y = J + ie | 0, te ^= y << 13 | y >>> 32 - 13, y = te + J | 0, ee ^= y << 18 | y >>> 32 - 18, y = Z + re | 0, T ^= y << 7 | y >>> 32 - 7, y = T + Z | 0, M ^= y << 9 | y >>> 32 - 9, y = M + T | 0, re ^= y << 13 | y >>> 32 - 13, y = re + M | 0, Z ^= y << 18 | y >>> 32 - 18, y = D + j | 0, z ^= y << 7 | y >>> 32 - 7, y = z + D | 0, k ^= y << 9 | y >>> 32 - 9, y = k + z | 0, j ^= y << 13 | y >>> 32 - 13, y = j + k | 0, D ^= y << 18 | y >>> 32 - 18, y = we + me | 0, ce ^= y << 7 | y >>> 32 - 7, y = ce + we | 0, xe ^= y << 9 | y >>> 32 - 9, y = xe + ce | 0, me ^= y << 13 | y >>> 32 - 13, y = me + xe | 0, we ^= y << 18 | y >>> 32 - 18;
      a[0] = ee >>> 0 & 255, a[1] = ee >>> 8 & 255, a[2] = ee >>> 16 & 255, a[3] = ee >>> 24 & 255, a[4] = Z >>> 0 & 255, a[5] = Z >>> 8 & 255, a[6] = Z >>> 16 & 255, a[7] = Z >>> 24 & 255, a[8] = D >>> 0 & 255, a[9] = D >>> 8 & 255, a[10] = D >>> 16 & 255, a[11] = D >>> 24 & 255, a[12] = we >>> 0 & 255, a[13] = we >>> 8 & 255, a[14] = we >>> 16 & 255, a[15] = we >>> 24 & 255, a[16] = T >>> 0 & 255, a[17] = T >>> 8 & 255, a[18] = T >>> 16 & 255, a[19] = T >>> 24 & 255, a[20] = M >>> 0 & 255, a[21] = M >>> 8 & 255, a[22] = M >>> 16 & 255, a[23] = M >>> 24 & 255, a[24] = k >>> 0 & 255, a[25] = k >>> 8 & 255, a[26] = k >>> 16 & 255, a[27] = k >>> 24 & 255, a[28] = j >>> 0 & 255, a[29] = j >>> 8 & 255, a[30] = j >>> 16 & 255, a[31] = j >>> 24 & 255;
    }
    function B(a, d, u, i) {
      P(a, d, u, i);
    }
    function R(a, d, u, i) {
      C(a, d, u, i);
    }
    var F = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);
    function Y(a, d, u, i, c, v, x) {
      var I = new Uint8Array(16), U = new Uint8Array(64), Q, W;
      for (W = 0; W < 16; W++)
        I[W] = 0;
      for (W = 0; W < 8; W++)
        I[W] = v[W];
      for (; c >= 64; ) {
        for (B(U, I, x, F), W = 0; W < 64; W++)
          a[d + W] = u[i + W] ^ U[W];
        for (Q = 1, W = 8; W < 16; W++)
          Q = Q + (I[W] & 255) | 0, I[W] = Q & 255, Q >>>= 8;
        c -= 64, d += 64, i += 64;
      }
      if (c > 0)
        for (B(U, I, x, F), W = 0; W < c; W++)
          a[d + W] = u[i + W] ^ U[W];
      return 0;
    }
    function K(a, d, u, i, c) {
      var v = new Uint8Array(16), x = new Uint8Array(64), I, U;
      for (U = 0; U < 16; U++)
        v[U] = 0;
      for (U = 0; U < 8; U++)
        v[U] = i[U];
      for (; u >= 64; ) {
        for (B(x, v, c, F), U = 0; U < 64; U++)
          a[d + U] = x[U];
        for (I = 1, U = 8; U < 16; U++)
          I = I + (v[U] & 255) | 0, v[U] = I & 255, I >>>= 8;
        u -= 64, d += 64;
      }
      if (u > 0)
        for (B(x, v, c, F), U = 0; U < u; U++)
          a[d + U] = x[U];
      return 0;
    }
    function Me(a, d, u, i, c) {
      var v = new Uint8Array(32);
      R(v, i, c, F);
      for (var x = new Uint8Array(8), I = 0; I < 8; I++)
        x[I] = i[I + 16];
      return K(a, d, u, x, v);
    }
    function ye(a, d, u, i, c, v, x) {
      var I = new Uint8Array(32);
      R(I, v, x, F);
      for (var U = new Uint8Array(8), Q = 0; Q < 8; Q++)
        U[Q] = v[Q + 16];
      return Y(a, d, u, i, c, U, I);
    }
    var $ = function(a) {
      this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.leftover = 0, this.fin = 0;
      var d, u, i, c, v, x, I, U;
      d = a[0] & 255 | (a[1] & 255) << 8, this.r[0] = d & 8191, u = a[2] & 255 | (a[3] & 255) << 8, this.r[1] = (d >>> 13 | u << 3) & 8191, i = a[4] & 255 | (a[5] & 255) << 8, this.r[2] = (u >>> 10 | i << 6) & 7939, c = a[6] & 255 | (a[7] & 255) << 8, this.r[3] = (i >>> 7 | c << 9) & 8191, v = a[8] & 255 | (a[9] & 255) << 8, this.r[4] = (c >>> 4 | v << 12) & 255, this.r[5] = v >>> 1 & 8190, x = a[10] & 255 | (a[11] & 255) << 8, this.r[6] = (v >>> 14 | x << 2) & 8191, I = a[12] & 255 | (a[13] & 255) << 8, this.r[7] = (x >>> 11 | I << 5) & 8065, U = a[14] & 255 | (a[15] & 255) << 8, this.r[8] = (I >>> 8 | U << 8) & 8191, this.r[9] = U >>> 5 & 127, this.pad[0] = a[16] & 255 | (a[17] & 255) << 8, this.pad[1] = a[18] & 255 | (a[19] & 255) << 8, this.pad[2] = a[20] & 255 | (a[21] & 255) << 8, this.pad[3] = a[22] & 255 | (a[23] & 255) << 8, this.pad[4] = a[24] & 255 | (a[25] & 255) << 8, this.pad[5] = a[26] & 255 | (a[27] & 255) << 8, this.pad[6] = a[28] & 255 | (a[29] & 255) << 8, this.pad[7] = a[30] & 255 | (a[31] & 255) << 8;
    };
    $.prototype.blocks = function(a, d, u) {
      for (var i = this.fin ? 0 : 2048, c, v, x, I, U, Q, W, fe, V, ne, oe, le, pe, he, ue, ve, ee, ie, J, te = this.h[0], re = this.h[1], Z = this.h[2], T = this.h[3], M = this.h[4], k = this.h[5], j = this.h[6], D = this.h[7], z = this.h[8], ce = this.h[9], xe = this.r[0], me = this.r[1], we = this.r[2], y = this.r[3], Te = this.r[4], De = this.r[5], Le = this.r[6], Ae = this.r[7], Oe = this.r[8], Ne = this.r[9]; u >= 16; )
        c = a[d + 0] & 255 | (a[d + 1] & 255) << 8, te += c & 8191, v = a[d + 2] & 255 | (a[d + 3] & 255) << 8, re += (c >>> 13 | v << 3) & 8191, x = a[d + 4] & 255 | (a[d + 5] & 255) << 8, Z += (v >>> 10 | x << 6) & 8191, I = a[d + 6] & 255 | (a[d + 7] & 255) << 8, T += (x >>> 7 | I << 9) & 8191, U = a[d + 8] & 255 | (a[d + 9] & 255) << 8, M += (I >>> 4 | U << 12) & 8191, k += U >>> 1 & 8191, Q = a[d + 10] & 255 | (a[d + 11] & 255) << 8, j += (U >>> 14 | Q << 2) & 8191, W = a[d + 12] & 255 | (a[d + 13] & 255) << 8, D += (Q >>> 11 | W << 5) & 8191, fe = a[d + 14] & 255 | (a[d + 15] & 255) << 8, z += (W >>> 8 | fe << 8) & 8191, ce += fe >>> 5 | i, V = 0, ne = V, ne += te * xe, ne += re * (5 * Ne), ne += Z * (5 * Oe), ne += T * (5 * Ae), ne += M * (5 * Le), V = ne >>> 13, ne &= 8191, ne += k * (5 * De), ne += j * (5 * Te), ne += D * (5 * y), ne += z * (5 * we), ne += ce * (5 * me), V += ne >>> 13, ne &= 8191, oe = V, oe += te * me, oe += re * xe, oe += Z * (5 * Ne), oe += T * (5 * Oe), oe += M * (5 * Ae), V = oe >>> 13, oe &= 8191, oe += k * (5 * Le), oe += j * (5 * De), oe += D * (5 * Te), oe += z * (5 * y), oe += ce * (5 * we), V += oe >>> 13, oe &= 8191, le = V, le += te * we, le += re * me, le += Z * xe, le += T * (5 * Ne), le += M * (5 * Oe), V = le >>> 13, le &= 8191, le += k * (5 * Ae), le += j * (5 * Le), le += D * (5 * De), le += z * (5 * Te), le += ce * (5 * y), V += le >>> 13, le &= 8191, pe = V, pe += te * y, pe += re * we, pe += Z * me, pe += T * xe, pe += M * (5 * Ne), V = pe >>> 13, pe &= 8191, pe += k * (5 * Oe), pe += j * (5 * Ae), pe += D * (5 * Le), pe += z * (5 * De), pe += ce * (5 * Te), V += pe >>> 13, pe &= 8191, he = V, he += te * Te, he += re * y, he += Z * we, he += T * me, he += M * xe, V = he >>> 13, he &= 8191, he += k * (5 * Ne), he += j * (5 * Oe), he += D * (5 * Ae), he += z * (5 * Le), he += ce * (5 * De), V += he >>> 13, he &= 8191, ue = V, ue += te * De, ue += re * Te, ue += Z * y, ue += T * we, ue += M * me, V = ue >>> 13, ue &= 8191, ue += k * xe, ue += j * (5 * Ne), ue += D * (5 * Oe), ue += z * (5 * Ae), ue += ce * (5 * Le), V += ue >>> 13, ue &= 8191, ve = V, ve += te * Le, ve += re * De, ve += Z * Te, ve += T * y, ve += M * we, V = ve >>> 13, ve &= 8191, ve += k * me, ve += j * xe, ve += D * (5 * Ne), ve += z * (5 * Oe), ve += ce * (5 * Ae), V += ve >>> 13, ve &= 8191, ee = V, ee += te * Ae, ee += re * Le, ee += Z * De, ee += T * Te, ee += M * y, V = ee >>> 13, ee &= 8191, ee += k * we, ee += j * me, ee += D * xe, ee += z * (5 * Ne), ee += ce * (5 * Oe), V += ee >>> 13, ee &= 8191, ie = V, ie += te * Oe, ie += re * Ae, ie += Z * Le, ie += T * De, ie += M * Te, V = ie >>> 13, ie &= 8191, ie += k * y, ie += j * we, ie += D * me, ie += z * xe, ie += ce * (5 * Ne), V += ie >>> 13, ie &= 8191, J = V, J += te * Ne, J += re * Oe, J += Z * Ae, J += T * Le, J += M * De, V = J >>> 13, J &= 8191, J += k * Te, J += j * y, J += D * we, J += z * me, J += ce * xe, V += J >>> 13, J &= 8191, V = (V << 2) + V | 0, V = V + ne | 0, ne = V & 8191, V = V >>> 13, oe += V, te = ne, re = oe, Z = le, T = pe, M = he, k = ue, j = ve, D = ee, z = ie, ce = J, d += 16, u -= 16;
      this.h[0] = te, this.h[1] = re, this.h[2] = Z, this.h[3] = T, this.h[4] = M, this.h[5] = k, this.h[6] = j, this.h[7] = D, this.h[8] = z, this.h[9] = ce;
    }, $.prototype.finish = function(a, d) {
      var u = new Uint16Array(10), i, c, v, x;
      if (this.leftover) {
        for (x = this.leftover, this.buffer[x++] = 1; x < 16; x++)
          this.buffer[x] = 0;
        this.fin = 1, this.blocks(this.buffer, 0, 16);
      }
      for (i = this.h[1] >>> 13, this.h[1] &= 8191, x = 2; x < 10; x++)
        this.h[x] += i, i = this.h[x] >>> 13, this.h[x] &= 8191;
      for (this.h[0] += i * 5, i = this.h[0] >>> 13, this.h[0] &= 8191, this.h[1] += i, i = this.h[1] >>> 13, this.h[1] &= 8191, this.h[2] += i, u[0] = this.h[0] + 5, i = u[0] >>> 13, u[0] &= 8191, x = 1; x < 10; x++)
        u[x] = this.h[x] + i, i = u[x] >>> 13, u[x] &= 8191;
      for (u[9] -= 1 << 13, c = (i ^ 1) - 1, x = 0; x < 10; x++)
        u[x] &= c;
      for (c = ~c, x = 0; x < 10; x++)
        this.h[x] = this.h[x] & c | u[x];
      for (this.h[0] = (this.h[0] | this.h[1] << 13) & 65535, this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 65535, this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 65535, this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 65535, this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 65535, this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 65535, this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 65535, this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 65535, v = this.h[0] + this.pad[0], this.h[0] = v & 65535, x = 1; x < 8; x++)
        v = (this.h[x] + this.pad[x] | 0) + (v >>> 16) | 0, this.h[x] = v & 65535;
      a[d + 0] = this.h[0] >>> 0 & 255, a[d + 1] = this.h[0] >>> 8 & 255, a[d + 2] = this.h[1] >>> 0 & 255, a[d + 3] = this.h[1] >>> 8 & 255, a[d + 4] = this.h[2] >>> 0 & 255, a[d + 5] = this.h[2] >>> 8 & 255, a[d + 6] = this.h[3] >>> 0 & 255, a[d + 7] = this.h[3] >>> 8 & 255, a[d + 8] = this.h[4] >>> 0 & 255, a[d + 9] = this.h[4] >>> 8 & 255, a[d + 10] = this.h[5] >>> 0 & 255, a[d + 11] = this.h[5] >>> 8 & 255, a[d + 12] = this.h[6] >>> 0 & 255, a[d + 13] = this.h[6] >>> 8 & 255, a[d + 14] = this.h[7] >>> 0 & 255, a[d + 15] = this.h[7] >>> 8 & 255;
    }, $.prototype.update = function(a, d, u) {
      var i, c;
      if (this.leftover) {
        for (c = 16 - this.leftover, c > u && (c = u), i = 0; i < c; i++)
          this.buffer[this.leftover + i] = a[d + i];
        if (u -= c, d += c, this.leftover += c, this.leftover < 16)
          return;
        this.blocks(this.buffer, 0, 16), this.leftover = 0;
      }
      if (u >= 16 && (c = u - u % 16, this.blocks(a, d, c), d += c, u -= c), u) {
        for (i = 0; i < u; i++)
          this.buffer[this.leftover + i] = a[d + i];
        this.leftover += u;
      }
    };
    function G(a, d, u, i, c, v) {
      var x = new $(v);
      return x.update(u, i, c), x.finish(a, d), 0;
    }
    function X(a, d, u, i, c, v) {
      var x = new Uint8Array(16);
      return G(x, 0, u, i, c, v), S(a, d, x, 0);
    }
    function ge(a, d, u, i, c) {
      var v;
      if (u < 32)
        return -1;
      for (ye(a, 0, d, 0, u, i, c), G(a, 16, a, 32, u - 32, a), v = 0; v < 16; v++)
        a[v] = 0;
      return 0;
    }
    function L(a, d, u, i, c) {
      var v, x = new Uint8Array(32);
      if (u < 32 || (Me(x, 0, 32, i, c), X(d, 16, d, 32, u - 32, x) !== 0))
        return -1;
      for (ye(a, 0, d, 0, u, i, c), v = 0; v < 32; v++)
        a[v] = 0;
      return 0;
    }
    function _(a, d) {
      var u;
      for (u = 0; u < 16; u++)
        a[u] = d[u] | 0;
    }
    function q(a) {
      var d, u, i = 1;
      for (d = 0; d < 16; d++)
        u = a[d] + i + 65535, i = Math.floor(u / 65536), a[d] = u - i * 65536;
      a[0] += i - 1 + 37 * (i - 1);
    }
    function se(a, d, u) {
      for (var i, c = ~(u - 1), v = 0; v < 16; v++)
        i = c & (a[v] ^ d[v]), a[v] ^= i, d[v] ^= i;
    }
    function ae(a, d) {
      var u, i, c, v = r(), x = r();
      for (u = 0; u < 16; u++)
        x[u] = d[u];
      for (q(x), q(x), q(x), i = 0; i < 2; i++) {
        for (v[0] = x[0] - 65517, u = 1; u < 15; u++)
          v[u] = x[u] - 65535 - (v[u - 1] >> 16 & 1), v[u - 1] &= 65535;
        v[15] = x[15] - 32767 - (v[14] >> 16 & 1), c = v[15] >> 16 & 1, v[14] &= 65535, se(x, v, 1 - c);
      }
      for (u = 0; u < 16; u++)
        a[2 * u] = x[u] & 255, a[2 * u + 1] = x[u] >> 8;
    }
    function Ee(a, d) {
      var u = new Uint8Array(32), i = new Uint8Array(32);
      return ae(u, a), ae(i, d), N(u, 0, i, 0);
    }
    function Se(a) {
      var d = new Uint8Array(32);
      return ae(d, a), d[0] & 1;
    }
    function Be(a, d) {
      var u;
      for (u = 0; u < 16; u++)
        a[u] = d[2 * u] + (d[2 * u + 1] << 8);
      a[15] &= 32767;
    }
    function Re(a, d, u) {
      for (var i = 0; i < 16; i++)
        a[i] = d[i] + u[i];
    }
    function Fe(a, d, u) {
      for (var i = 0; i < 16; i++)
        a[i] = d[i] - u[i];
    }
    function be(a, d, u) {
      var i, c, v = 0, x = 0, I = 0, U = 0, Q = 0, W = 0, fe = 0, V = 0, ne = 0, oe = 0, le = 0, pe = 0, he = 0, ue = 0, ve = 0, ee = 0, ie = 0, J = 0, te = 0, re = 0, Z = 0, T = 0, M = 0, k = 0, j = 0, D = 0, z = 0, ce = 0, xe = 0, me = 0, we = 0, y = u[0], Te = u[1], De = u[2], Le = u[3], Ae = u[4], Oe = u[5], Ne = u[6], Ge = u[7], Pe = u[8], We = u[9], qe = u[10], Ye = u[11], He = u[12], Ke = u[13], Xe = u[14], Je = u[15];
      i = d[0], v += i * y, x += i * Te, I += i * De, U += i * Le, Q += i * Ae, W += i * Oe, fe += i * Ne, V += i * Ge, ne += i * Pe, oe += i * We, le += i * qe, pe += i * Ye, he += i * He, ue += i * Ke, ve += i * Xe, ee += i * Je, i = d[1], x += i * y, I += i * Te, U += i * De, Q += i * Le, W += i * Ae, fe += i * Oe, V += i * Ne, ne += i * Ge, oe += i * Pe, le += i * We, pe += i * qe, he += i * Ye, ue += i * He, ve += i * Ke, ee += i * Xe, ie += i * Je, i = d[2], I += i * y, U += i * Te, Q += i * De, W += i * Le, fe += i * Ae, V += i * Oe, ne += i * Ne, oe += i * Ge, le += i * Pe, pe += i * We, he += i * qe, ue += i * Ye, ve += i * He, ee += i * Ke, ie += i * Xe, J += i * Je, i = d[3], U += i * y, Q += i * Te, W += i * De, fe += i * Le, V += i * Ae, ne += i * Oe, oe += i * Ne, le += i * Ge, pe += i * Pe, he += i * We, ue += i * qe, ve += i * Ye, ee += i * He, ie += i * Ke, J += i * Xe, te += i * Je, i = d[4], Q += i * y, W += i * Te, fe += i * De, V += i * Le, ne += i * Ae, oe += i * Oe, le += i * Ne, pe += i * Ge, he += i * Pe, ue += i * We, ve += i * qe, ee += i * Ye, ie += i * He, J += i * Ke, te += i * Xe, re += i * Je, i = d[5], W += i * y, fe += i * Te, V += i * De, ne += i * Le, oe += i * Ae, le += i * Oe, pe += i * Ne, he += i * Ge, ue += i * Pe, ve += i * We, ee += i * qe, ie += i * Ye, J += i * He, te += i * Ke, re += i * Xe, Z += i * Je, i = d[6], fe += i * y, V += i * Te, ne += i * De, oe += i * Le, le += i * Ae, pe += i * Oe, he += i * Ne, ue += i * Ge, ve += i * Pe, ee += i * We, ie += i * qe, J += i * Ye, te += i * He, re += i * Ke, Z += i * Xe, T += i * Je, i = d[7], V += i * y, ne += i * Te, oe += i * De, le += i * Le, pe += i * Ae, he += i * Oe, ue += i * Ne, ve += i * Ge, ee += i * Pe, ie += i * We, J += i * qe, te += i * Ye, re += i * He, Z += i * Ke, T += i * Xe, M += i * Je, i = d[8], ne += i * y, oe += i * Te, le += i * De, pe += i * Le, he += i * Ae, ue += i * Oe, ve += i * Ne, ee += i * Ge, ie += i * Pe, J += i * We, te += i * qe, re += i * Ye, Z += i * He, T += i * Ke, M += i * Xe, k += i * Je, i = d[9], oe += i * y, le += i * Te, pe += i * De, he += i * Le, ue += i * Ae, ve += i * Oe, ee += i * Ne, ie += i * Ge, J += i * Pe, te += i * We, re += i * qe, Z += i * Ye, T += i * He, M += i * Ke, k += i * Xe, j += i * Je, i = d[10], le += i * y, pe += i * Te, he += i * De, ue += i * Le, ve += i * Ae, ee += i * Oe, ie += i * Ne, J += i * Ge, te += i * Pe, re += i * We, Z += i * qe, T += i * Ye, M += i * He, k += i * Ke, j += i * Xe, D += i * Je, i = d[11], pe += i * y, he += i * Te, ue += i * De, ve += i * Le, ee += i * Ae, ie += i * Oe, J += i * Ne, te += i * Ge, re += i * Pe, Z += i * We, T += i * qe, M += i * Ye, k += i * He, j += i * Ke, D += i * Xe, z += i * Je, i = d[12], he += i * y, ue += i * Te, ve += i * De, ee += i * Le, ie += i * Ae, J += i * Oe, te += i * Ne, re += i * Ge, Z += i * Pe, T += i * We, M += i * qe, k += i * Ye, j += i * He, D += i * Ke, z += i * Xe, ce += i * Je, i = d[13], ue += i * y, ve += i * Te, ee += i * De, ie += i * Le, J += i * Ae, te += i * Oe, re += i * Ne, Z += i * Ge, T += i * Pe, M += i * We, k += i * qe, j += i * Ye, D += i * He, z += i * Ke, ce += i * Xe, xe += i * Je, i = d[14], ve += i * y, ee += i * Te, ie += i * De, J += i * Le, te += i * Ae, re += i * Oe, Z += i * Ne, T += i * Ge, M += i * Pe, k += i * We, j += i * qe, D += i * Ye, z += i * He, ce += i * Ke, xe += i * Xe, me += i * Je, i = d[15], ee += i * y, ie += i * Te, J += i * De, te += i * Le, re += i * Ae, Z += i * Oe, T += i * Ne, M += i * Ge, k += i * Pe, j += i * We, D += i * qe, z += i * Ye, ce += i * He, xe += i * Ke, me += i * Xe, we += i * Je, v += 38 * ie, x += 38 * J, I += 38 * te, U += 38 * re, Q += 38 * Z, W += 38 * T, fe += 38 * M, V += 38 * k, ne += 38 * j, oe += 38 * D, le += 38 * z, pe += 38 * ce, he += 38 * xe, ue += 38 * me, ve += 38 * we, c = 1, i = v + c + 65535, c = Math.floor(i / 65536), v = i - c * 65536, i = x + c + 65535, c = Math.floor(i / 65536), x = i - c * 65536, i = I + c + 65535, c = Math.floor(i / 65536), I = i - c * 65536, i = U + c + 65535, c = Math.floor(i / 65536), U = i - c * 65536, i = Q + c + 65535, c = Math.floor(i / 65536), Q = i - c * 65536, i = W + c + 65535, c = Math.floor(i / 65536), W = i - c * 65536, i = fe + c + 65535, c = Math.floor(i / 65536), fe = i - c * 65536, i = V + c + 65535, c = Math.floor(i / 65536), V = i - c * 65536, i = ne + c + 65535, c = Math.floor(i / 65536), ne = i - c * 65536, i = oe + c + 65535, c = Math.floor(i / 65536), oe = i - c * 65536, i = le + c + 65535, c = Math.floor(i / 65536), le = i - c * 65536, i = pe + c + 65535, c = Math.floor(i / 65536), pe = i - c * 65536, i = he + c + 65535, c = Math.floor(i / 65536), he = i - c * 65536, i = ue + c + 65535, c = Math.floor(i / 65536), ue = i - c * 65536, i = ve + c + 65535, c = Math.floor(i / 65536), ve = i - c * 65536, i = ee + c + 65535, c = Math.floor(i / 65536), ee = i - c * 65536, v += c - 1 + 37 * (c - 1), c = 1, i = v + c + 65535, c = Math.floor(i / 65536), v = i - c * 65536, i = x + c + 65535, c = Math.floor(i / 65536), x = i - c * 65536, i = I + c + 65535, c = Math.floor(i / 65536), I = i - c * 65536, i = U + c + 65535, c = Math.floor(i / 65536), U = i - c * 65536, i = Q + c + 65535, c = Math.floor(i / 65536), Q = i - c * 65536, i = W + c + 65535, c = Math.floor(i / 65536), W = i - c * 65536, i = fe + c + 65535, c = Math.floor(i / 65536), fe = i - c * 65536, i = V + c + 65535, c = Math.floor(i / 65536), V = i - c * 65536, i = ne + c + 65535, c = Math.floor(i / 65536), ne = i - c * 65536, i = oe + c + 65535, c = Math.floor(i / 65536), oe = i - c * 65536, i = le + c + 65535, c = Math.floor(i / 65536), le = i - c * 65536, i = pe + c + 65535, c = Math.floor(i / 65536), pe = i - c * 65536, i = he + c + 65535, c = Math.floor(i / 65536), he = i - c * 65536, i = ue + c + 65535, c = Math.floor(i / 65536), ue = i - c * 65536, i = ve + c + 65535, c = Math.floor(i / 65536), ve = i - c * 65536, i = ee + c + 65535, c = Math.floor(i / 65536), ee = i - c * 65536, v += c - 1 + 37 * (c - 1), a[0] = v, a[1] = x, a[2] = I, a[3] = U, a[4] = Q, a[5] = W, a[6] = fe, a[7] = V, a[8] = ne, a[9] = oe, a[10] = le, a[11] = pe, a[12] = he, a[13] = ue, a[14] = ve, a[15] = ee;
    }
    function $e(a, d) {
      be(a, d, d);
    }
    function lt(a, d) {
      var u = r(), i;
      for (i = 0; i < 16; i++)
        u[i] = d[i];
      for (i = 253; i >= 0; i--)
        $e(u, u), i !== 2 && i !== 4 && be(u, u, d);
      for (i = 0; i < 16; i++)
        a[i] = u[i];
    }
    function St(a, d) {
      var u = r(), i;
      for (i = 0; i < 16; i++)
        u[i] = d[i];
      for (i = 250; i >= 0; i--)
        $e(u, u), i !== 1 && be(u, u, d);
      for (i = 0; i < 16; i++)
        a[i] = u[i];
    }
    function dt(a, d, u) {
      var i = new Uint8Array(32), c = new Float64Array(80), v, x, I = r(), U = r(), Q = r(), W = r(), fe = r(), V = r();
      for (x = 0; x < 31; x++)
        i[x] = d[x];
      for (i[31] = d[31] & 127 | 64, i[0] &= 248, Be(c, u), x = 0; x < 16; x++)
        U[x] = c[x], W[x] = I[x] = Q[x] = 0;
      for (I[0] = W[0] = 1, x = 254; x >= 0; --x)
        v = i[x >>> 3] >>> (x & 7) & 1, se(I, U, v), se(Q, W, v), Re(fe, I, Q), Fe(I, I, Q), Re(Q, U, W), Fe(U, U, W), $e(W, fe), $e(V, I), be(I, Q, I), be(Q, U, fe), Re(fe, I, Q), Fe(I, I, Q), $e(U, I), Fe(Q, W, V), be(I, Q, h), Re(I, I, W), be(Q, Q, I), be(I, W, V), be(W, U, c), $e(U, fe), se(I, U, v), se(Q, W, v);
      for (x = 0; x < 16; x++)
        c[x + 16] = I[x], c[x + 32] = Q[x], c[x + 48] = U[x], c[x + 64] = W[x];
      var ne = c.subarray(32), oe = c.subarray(16);
      return lt(ne, ne), be(oe, oe, ne), ae(a, oe), 0;
    }
    function ht(a, d) {
      return dt(a, d, s);
    }
    function _r(a, d) {
      return n(d, 32), ht(a, d);
    }
    function ct(a, d, u) {
      var i = new Uint8Array(32);
      return dt(i, u, d), R(a, o, i, F);
    }
    var Qt = ge, Or = L;
    function hr(a, d, u, i, c, v) {
      var x = new Uint8Array(32);
      return ct(x, c, v), Qt(a, d, u, i, x);
    }
    function pr(a, d, u, i, c, v) {
      var x = new Uint8Array(32);
      return ct(x, c, v), Or(a, d, u, i, x);
    }
    var en = [
      1116352408,
      3609767458,
      1899447441,
      602891725,
      3049323471,
      3964484399,
      3921009573,
      2173295548,
      961987163,
      4081628472,
      1508970993,
      3053834265,
      2453635748,
      2937671579,
      2870763221,
      3664609560,
      3624381080,
      2734883394,
      310598401,
      1164996542,
      607225278,
      1323610764,
      1426881987,
      3590304994,
      1925078388,
      4068182383,
      2162078206,
      991336113,
      2614888103,
      633803317,
      3248222580,
      3479774868,
      3835390401,
      2666613458,
      4022224774,
      944711139,
      264347078,
      2341262773,
      604807628,
      2007800933,
      770255983,
      1495990901,
      1249150122,
      1856431235,
      1555081692,
      3175218132,
      1996064986,
      2198950837,
      2554220882,
      3999719339,
      2821834349,
      766784016,
      2952996808,
      2566594879,
      3210313671,
      3203337956,
      3336571891,
      1034457026,
      3584528711,
      2466948901,
      113926993,
      3758326383,
      338241895,
      168717936,
      666307205,
      1188179964,
      773529912,
      1546045734,
      1294757372,
      1522805485,
      1396182291,
      2643833823,
      1695183700,
      2343527390,
      1986661051,
      1014477480,
      2177026350,
      1206759142,
      2456956037,
      344077627,
      2730485921,
      1290863460,
      2820302411,
      3158454273,
      3259730800,
      3505952657,
      3345764771,
      106217008,
      3516065817,
      3606008344,
      3600352804,
      1432725776,
      4094571909,
      1467031594,
      275423344,
      851169720,
      430227734,
      3100823752,
      506948616,
      1363258195,
      659060556,
      3750685593,
      883997877,
      3785050280,
      958139571,
      3318307427,
      1322822218,
      3812723403,
      1537002063,
      2003034995,
      1747873779,
      3602036899,
      1955562222,
      1575990012,
      2024104815,
      1125592928,
      2227730452,
      2716904306,
      2361852424,
      442776044,
      2428436474,
      593698344,
      2756734187,
      3733110249,
      3204031479,
      2999351573,
      3329325298,
      3815920427,
      3391569614,
      3928383900,
      3515267271,
      566280711,
      3940187606,
      3454069534,
      4118630271,
      4000239992,
      116418474,
      1914138554,
      174292421,
      2731055270,
      289380356,
      3203993006,
      460393269,
      320620315,
      685471733,
      587496836,
      852142971,
      1086792851,
      1017036298,
      365543100,
      1126000580,
      2618297676,
      1288033470,
      3409855158,
      1501505948,
      4234509866,
      1607167915,
      987167468,
      1816402316,
      1246189591
    ];
    function tn(a, d, u, i) {
      for (var c = new Int32Array(16), v = new Int32Array(16), x, I, U, Q, W, fe, V, ne, oe, le, pe, he, ue, ve, ee, ie, J, te, re, Z, T, M, k, j, D, z, ce = a[0], xe = a[1], me = a[2], we = a[3], y = a[4], Te = a[5], De = a[6], Le = a[7], Ae = d[0], Oe = d[1], Ne = d[2], Ge = d[3], Pe = d[4], We = d[5], qe = d[6], Ye = d[7], He = 0; i >= 128; ) {
        for (re = 0; re < 16; re++)
          Z = 8 * re + He, c[re] = u[Z + 0] << 24 | u[Z + 1] << 16 | u[Z + 2] << 8 | u[Z + 3], v[re] = u[Z + 4] << 24 | u[Z + 5] << 16 | u[Z + 6] << 8 | u[Z + 7];
        for (re = 0; re < 80; re++)
          if (x = ce, I = xe, U = me, Q = we, W = y, fe = Te, V = De, ne = Le, oe = Ae, le = Oe, pe = Ne, he = Ge, ue = Pe, ve = We, ee = qe, ie = Ye, T = Le, M = Ye, k = M & 65535, j = M >>> 16, D = T & 65535, z = T >>> 16, T = (y >>> 14 | Pe << 32 - 14) ^ (y >>> 18 | Pe << 32 - 18) ^ (Pe >>> 41 - 32 | y << 32 - (41 - 32)), M = (Pe >>> 14 | y << 32 - 14) ^ (Pe >>> 18 | y << 32 - 18) ^ (y >>> 41 - 32 | Pe << 32 - (41 - 32)), k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, T = y & Te ^ ~y & De, M = Pe & We ^ ~Pe & qe, k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, T = en[re * 2], M = en[re * 2 + 1], k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, T = c[re % 16], M = v[re % 16], k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, j += k >>> 16, D += j >>> 16, z += D >>> 16, J = D & 65535 | z << 16, te = k & 65535 | j << 16, T = J, M = te, k = M & 65535, j = M >>> 16, D = T & 65535, z = T >>> 16, T = (ce >>> 28 | Ae << 32 - 28) ^ (Ae >>> 34 - 32 | ce << 32 - (34 - 32)) ^ (Ae >>> 39 - 32 | ce << 32 - (39 - 32)), M = (Ae >>> 28 | ce << 32 - 28) ^ (ce >>> 34 - 32 | Ae << 32 - (34 - 32)) ^ (ce >>> 39 - 32 | Ae << 32 - (39 - 32)), k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, T = ce & xe ^ ce & me ^ xe & me, M = Ae & Oe ^ Ae & Ne ^ Oe & Ne, k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, j += k >>> 16, D += j >>> 16, z += D >>> 16, ne = D & 65535 | z << 16, ie = k & 65535 | j << 16, T = Q, M = he, k = M & 65535, j = M >>> 16, D = T & 65535, z = T >>> 16, T = J, M = te, k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, j += k >>> 16, D += j >>> 16, z += D >>> 16, Q = D & 65535 | z << 16, he = k & 65535 | j << 16, xe = x, me = I, we = U, y = Q, Te = W, De = fe, Le = V, ce = ne, Oe = oe, Ne = le, Ge = pe, Pe = he, We = ue, qe = ve, Ye = ee, Ae = ie, re % 16 === 15)
            for (Z = 0; Z < 16; Z++)
              T = c[Z], M = v[Z], k = M & 65535, j = M >>> 16, D = T & 65535, z = T >>> 16, T = c[(Z + 9) % 16], M = v[(Z + 9) % 16], k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, J = c[(Z + 1) % 16], te = v[(Z + 1) % 16], T = (J >>> 1 | te << 32 - 1) ^ (J >>> 8 | te << 32 - 8) ^ J >>> 7, M = (te >>> 1 | J << 32 - 1) ^ (te >>> 8 | J << 32 - 8) ^ (te >>> 7 | J << 32 - 7), k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, J = c[(Z + 14) % 16], te = v[(Z + 14) % 16], T = (J >>> 19 | te << 32 - 19) ^ (te >>> 61 - 32 | J << 32 - (61 - 32)) ^ J >>> 6, M = (te >>> 19 | J << 32 - 19) ^ (J >>> 61 - 32 | te << 32 - (61 - 32)) ^ (te >>> 6 | J << 32 - 6), k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, j += k >>> 16, D += j >>> 16, z += D >>> 16, c[Z] = D & 65535 | z << 16, v[Z] = k & 65535 | j << 16;
        T = ce, M = Ae, k = M & 65535, j = M >>> 16, D = T & 65535, z = T >>> 16, T = a[0], M = d[0], k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, j += k >>> 16, D += j >>> 16, z += D >>> 16, a[0] = ce = D & 65535 | z << 16, d[0] = Ae = k & 65535 | j << 16, T = xe, M = Oe, k = M & 65535, j = M >>> 16, D = T & 65535, z = T >>> 16, T = a[1], M = d[1], k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, j += k >>> 16, D += j >>> 16, z += D >>> 16, a[1] = xe = D & 65535 | z << 16, d[1] = Oe = k & 65535 | j << 16, T = me, M = Ne, k = M & 65535, j = M >>> 16, D = T & 65535, z = T >>> 16, T = a[2], M = d[2], k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, j += k >>> 16, D += j >>> 16, z += D >>> 16, a[2] = me = D & 65535 | z << 16, d[2] = Ne = k & 65535 | j << 16, T = we, M = Ge, k = M & 65535, j = M >>> 16, D = T & 65535, z = T >>> 16, T = a[3], M = d[3], k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, j += k >>> 16, D += j >>> 16, z += D >>> 16, a[3] = we = D & 65535 | z << 16, d[3] = Ge = k & 65535 | j << 16, T = y, M = Pe, k = M & 65535, j = M >>> 16, D = T & 65535, z = T >>> 16, T = a[4], M = d[4], k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, j += k >>> 16, D += j >>> 16, z += D >>> 16, a[4] = y = D & 65535 | z << 16, d[4] = Pe = k & 65535 | j << 16, T = Te, M = We, k = M & 65535, j = M >>> 16, D = T & 65535, z = T >>> 16, T = a[5], M = d[5], k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, j += k >>> 16, D += j >>> 16, z += D >>> 16, a[5] = Te = D & 65535 | z << 16, d[5] = We = k & 65535 | j << 16, T = De, M = qe, k = M & 65535, j = M >>> 16, D = T & 65535, z = T >>> 16, T = a[6], M = d[6], k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, j += k >>> 16, D += j >>> 16, z += D >>> 16, a[6] = De = D & 65535 | z << 16, d[6] = qe = k & 65535 | j << 16, T = Le, M = Ye, k = M & 65535, j = M >>> 16, D = T & 65535, z = T >>> 16, T = a[7], M = d[7], k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, j += k >>> 16, D += j >>> 16, z += D >>> 16, a[7] = Le = D & 65535 | z << 16, d[7] = Ye = k & 65535 | j << 16, He += 128, i -= 128;
      }
      return i;
    }
    function gt(a, d, u) {
      var i = new Int32Array(8), c = new Int32Array(8), v = new Uint8Array(256), x, I = u;
      for (i[0] = 1779033703, i[1] = 3144134277, i[2] = 1013904242, i[3] = 2773480762, i[4] = 1359893119, i[5] = 2600822924, i[6] = 528734635, i[7] = 1541459225, c[0] = 4089235720, c[1] = 2227873595, c[2] = 4271175723, c[3] = 1595750129, c[4] = 2917565137, c[5] = 725511199, c[6] = 4215389547, c[7] = 327033209, tn(i, c, d, u), u %= 128, x = 0; x < u; x++)
        v[x] = d[I - u + x];
      for (v[u] = 128, u = 256 - 128 * (u < 112 ? 1 : 0), v[u - 9] = 0, A(v, u - 8, I / 536870912 | 0, I << 3), tn(i, c, v, u), x = 0; x < 8; x++)
        A(a, 8 * x, i[x], c[x]);
      return 0;
    }
    function yr(a, d) {
      var u = r(), i = r(), c = r(), v = r(), x = r(), I = r(), U = r(), Q = r(), W = r();
      Fe(u, a[1], a[0]), Fe(W, d[1], d[0]), be(u, u, W), Re(i, a[0], a[1]), Re(W, d[0], d[1]), be(i, i, W), be(c, a[3], d[3]), be(c, c, b), be(v, a[2], d[2]), Re(v, v, v), Fe(x, i, u), Fe(I, v, c), Re(U, v, c), Re(Q, i, u), be(a[0], x, I), be(a[1], Q, U), be(a[2], U, I), be(a[3], x, Q);
    }
    function On(a, d, u) {
      var i;
      for (i = 0; i < 4; i++)
        se(a[i], d[i], u);
    }
    function gr(a, d) {
      var u = r(), i = r(), c = r();
      lt(c, d[2]), be(u, d[0], c), be(i, d[1], c), ae(a, i), a[31] ^= Se(u) << 7;
    }
    function $r(a, d, u) {
      var i, c;
      for (_(a[0], f), _(a[1], l), _(a[2], l), _(a[3], f), c = 255; c >= 0; --c)
        i = u[c / 8 | 0] >> (c & 7) & 1, On(a, d, i), yr(d, a), yr(a, a), On(a, d, i);
    }
    function vr(a, d) {
      var u = [r(), r(), r(), r()];
      _(u[0], g), _(u[1], E), _(u[2], l), be(u[3], g, E), $r(a, u, d);
    }
    function Nr(a, d, u) {
      var i = new Uint8Array(64), c = [r(), r(), r(), r()], v;
      for (u || n(d, 32), gt(i, d, 32), i[0] &= 248, i[31] &= 127, i[31] |= 64, vr(c, i), gr(a, c), v = 0; v < 32; v++)
        d[v + 32] = a[v];
      return 0;
    }
    var ar = new Float64Array([237, 211, 245, 92, 26, 99, 18, 88, 214, 156, 247, 162, 222, 249, 222, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16]);
    function Xt(a, d) {
      var u, i, c, v;
      for (i = 63; i >= 32; --i) {
        for (u = 0, c = i - 32, v = i - 12; c < v; ++c)
          d[c] += u - 16 * d[i] * ar[c - (i - 32)], u = Math.floor((d[c] + 128) / 256), d[c] -= u * 256;
        d[c] += u, d[i] = 0;
      }
      for (u = 0, c = 0; c < 32; c++)
        d[c] += u - (d[31] >> 4) * ar[c], u = d[c] >> 8, d[c] &= 255;
      for (c = 0; c < 32; c++)
        d[c] -= u * ar[c];
      for (i = 0; i < 32; i++)
        d[i + 1] += d[i] >> 8, a[i] = d[i] & 255;
    }
    function Wr(a) {
      var d = new Float64Array(64), u;
      for (u = 0; u < 64; u++)
        d[u] = a[u];
      for (u = 0; u < 64; u++)
        a[u] = 0;
      Xt(a, d);
    }
    function rn(a, d, u, i) {
      var c = new Uint8Array(64), v = new Uint8Array(64), x = new Uint8Array(64), I, U, Q = new Float64Array(64), W = [r(), r(), r(), r()];
      gt(c, i, 32), c[0] &= 248, c[31] &= 127, c[31] |= 64;
      var fe = u + 64;
      for (I = 0; I < u; I++)
        a[64 + I] = d[I];
      for (I = 0; I < 32; I++)
        a[32 + I] = c[32 + I];
      for (gt(x, a.subarray(32), u + 32), Wr(x), vr(W, x), gr(a, W), I = 32; I < 64; I++)
        a[I] = i[I];
      for (gt(v, a, u + 64), Wr(v), I = 0; I < 64; I++)
        Q[I] = 0;
      for (I = 0; I < 32; I++)
        Q[I] = x[I];
      for (I = 0; I < 32; I++)
        for (U = 0; U < 32; U++)
          Q[I + U] += v[I] * c[U];
      return Xt(a.subarray(32), Q), fe;
    }
    function Zn(a, d) {
      var u = r(), i = r(), c = r(), v = r(), x = r(), I = r(), U = r();
      return _(a[2], l), Be(a[1], d), $e(c, a[1]), be(v, c, p), Fe(c, c, a[2]), Re(v, a[2], v), $e(x, v), $e(I, x), be(U, I, x), be(u, U, c), be(u, u, v), St(u, u), be(u, u, c), be(u, u, v), be(u, u, v), be(a[0], u, v), $e(i, a[0]), be(i, i, v), Ee(i, c) && be(a[0], a[0], m), $e(i, a[0]), be(i, i, v), Ee(i, c) ? -1 : (Se(a[0]) === d[31] >> 7 && Fe(a[0], f, a[0]), be(a[3], a[0], a[1]), 0);
    }
    function br(a, d, u, i) {
      var c, v = new Uint8Array(32), x = new Uint8Array(64), I = [r(), r(), r(), r()], U = [r(), r(), r(), r()];
      if (u < 64 || Zn(U, i))
        return -1;
      for (c = 0; c < u; c++)
        a[c] = d[c];
      for (c = 0; c < 32; c++)
        a[c + 32] = i[c];
      if (gt(x, a, u), Wr(x), $r(I, U, x), vr(U, d.subarray(32)), yr(I, U), gr(v, I), u -= 64, N(d, 0, v, 0)) {
        for (c = 0; c < u; c++)
          a[c] = 0;
        return -1;
      }
      for (c = 0; c < u; c++)
        a[c] = d[c + 64];
      return u;
    }
    var qr = 32, xr = 24, Jt = 32, Bt = 16, er = 32, wr = 32, tr = 32, kt = 32, jr = 32, cr = xr, Nn = Jt, jn = Bt, ft = 64, Tt = 32, Nt = 64, Yr = 32, Dr = 64;
    t.lowlevel = {
      crypto_core_hsalsa20: R,
      crypto_stream_xor: ye,
      crypto_stream: Me,
      crypto_stream_salsa20_xor: Y,
      crypto_stream_salsa20: K,
      crypto_onetimeauth: G,
      crypto_onetimeauth_verify: X,
      crypto_verify_16: S,
      crypto_verify_32: N,
      crypto_secretbox: ge,
      crypto_secretbox_open: L,
      crypto_scalarmult: dt,
      crypto_scalarmult_base: ht,
      crypto_box_beforenm: ct,
      crypto_box_afternm: Qt,
      crypto_box: hr,
      crypto_box_open: pr,
      crypto_box_keypair: _r,
      crypto_hash: gt,
      crypto_sign: rn,
      crypto_sign_keypair: Nr,
      crypto_sign_open: br,
      crypto_secretbox_KEYBYTES: qr,
      crypto_secretbox_NONCEBYTES: xr,
      crypto_secretbox_ZEROBYTES: Jt,
      crypto_secretbox_BOXZEROBYTES: Bt,
      crypto_scalarmult_BYTES: er,
      crypto_scalarmult_SCALARBYTES: wr,
      crypto_box_PUBLICKEYBYTES: tr,
      crypto_box_SECRETKEYBYTES: kt,
      crypto_box_BEFORENMBYTES: jr,
      crypto_box_NONCEBYTES: cr,
      crypto_box_ZEROBYTES: Nn,
      crypto_box_BOXZEROBYTES: jn,
      crypto_sign_BYTES: ft,
      crypto_sign_PUBLICKEYBYTES: Tt,
      crypto_sign_SECRETKEYBYTES: Nt,
      crypto_sign_SEEDBYTES: Yr,
      crypto_hash_BYTES: Dr,
      gf: r,
      D: p,
      L: ar,
      pack25519: ae,
      unpack25519: Be,
      M: be,
      A: Re,
      S: $e,
      Z: Fe,
      pow2523: St,
      add: yr,
      set25519: _,
      modL: Xt,
      scalarmult: $r,
      scalarbase: vr
    };
    function nn(a, d) {
      if (a.length !== qr)
        throw new Error("bad key size");
      if (d.length !== xr)
        throw new Error("bad nonce size");
    }
    function gi(a, d) {
      if (a.length !== tr)
        throw new Error("bad public key size");
      if (d.length !== kt)
        throw new Error("bad secret key size");
    }
    function rt() {
      for (var a = 0; a < arguments.length; a++)
        if (!(arguments[a] instanceof Uint8Array))
          throw new TypeError("unexpected type, use Uint8Array");
    }
    function on(a) {
      for (var d = 0; d < a.length; d++)
        a[d] = 0;
    }
    t.randomBytes = function(a) {
      var d = new Uint8Array(a);
      return n(d, a), d;
    }, t.secretbox = function(a, d, u) {
      rt(a, d, u), nn(u, d);
      for (var i = new Uint8Array(Jt + a.length), c = new Uint8Array(i.length), v = 0; v < a.length; v++)
        i[v + Jt] = a[v];
      return ge(c, i, i.length, d, u), c.subarray(Bt);
    }, t.secretbox.open = function(a, d, u) {
      rt(a, d, u), nn(u, d);
      for (var i = new Uint8Array(Bt + a.length), c = new Uint8Array(i.length), v = 0; v < a.length; v++)
        i[v + Bt] = a[v];
      return i.length < 32 || L(c, i, i.length, d, u) !== 0 ? null : c.subarray(Jt);
    }, t.secretbox.keyLength = qr, t.secretbox.nonceLength = xr, t.secretbox.overheadLength = Bt, t.scalarMult = function(a, d) {
      if (rt(a, d), a.length !== wr)
        throw new Error("bad n size");
      if (d.length !== er)
        throw new Error("bad p size");
      var u = new Uint8Array(er);
      return dt(u, a, d), u;
    }, t.scalarMult.base = function(a) {
      if (rt(a), a.length !== wr)
        throw new Error("bad n size");
      var d = new Uint8Array(er);
      return ht(d, a), d;
    }, t.scalarMult.scalarLength = wr, t.scalarMult.groupElementLength = er, t.box = function(a, d, u, i) {
      var c = t.box.before(u, i);
      return t.secretbox(a, d, c);
    }, t.box.before = function(a, d) {
      rt(a, d), gi(a, d);
      var u = new Uint8Array(jr);
      return ct(u, a, d), u;
    }, t.box.after = t.secretbox, t.box.open = function(a, d, u, i) {
      var c = t.box.before(u, i);
      return t.secretbox.open(a, d, c);
    }, t.box.open.after = t.secretbox.open, t.box.keyPair = function() {
      var a = new Uint8Array(tr), d = new Uint8Array(kt);
      return _r(a, d), { publicKey: a, secretKey: d };
    }, t.box.keyPair.fromSecretKey = function(a) {
      if (rt(a), a.length !== kt)
        throw new Error("bad secret key size");
      var d = new Uint8Array(tr);
      return ht(d, a), { publicKey: d, secretKey: new Uint8Array(a) };
    }, t.box.publicKeyLength = tr, t.box.secretKeyLength = kt, t.box.sharedKeyLength = jr, t.box.nonceLength = cr, t.box.overheadLength = t.secretbox.overheadLength, t.sign = function(a, d) {
      if (rt(a, d), d.length !== Nt)
        throw new Error("bad secret key size");
      var u = new Uint8Array(ft + a.length);
      return rn(u, a, a.length, d), u;
    }, t.sign.open = function(a, d) {
      if (rt(a, d), d.length !== Tt)
        throw new Error("bad public key size");
      var u = new Uint8Array(a.length), i = br(u, a, a.length, d);
      if (i < 0)
        return null;
      for (var c = new Uint8Array(i), v = 0; v < c.length; v++)
        c[v] = u[v];
      return c;
    }, t.sign.detached = function(a, d) {
      for (var u = t.sign(a, d), i = new Uint8Array(ft), c = 0; c < i.length; c++)
        i[c] = u[c];
      return i;
    }, t.sign.detached.verify = function(a, d, u) {
      if (rt(a, d, u), d.length !== ft)
        throw new Error("bad signature size");
      if (u.length !== Tt)
        throw new Error("bad public key size");
      var i = new Uint8Array(ft + a.length), c = new Uint8Array(ft + a.length), v;
      for (v = 0; v < ft; v++)
        i[v] = d[v];
      for (v = 0; v < a.length; v++)
        i[v + ft] = a[v];
      return br(c, i, i.length, u) >= 0;
    }, t.sign.keyPair = function() {
      var a = new Uint8Array(Tt), d = new Uint8Array(Nt);
      return Nr(a, d), { publicKey: a, secretKey: d };
    }, t.sign.keyPair.fromSecretKey = function(a) {
      if (rt(a), a.length !== Nt)
        throw new Error("bad secret key size");
      for (var d = new Uint8Array(Tt), u = 0; u < d.length; u++)
        d[u] = a[32 + u];
      return { publicKey: d, secretKey: new Uint8Array(a) };
    }, t.sign.keyPair.fromSeed = function(a) {
      if (rt(a), a.length !== Yr)
        throw new Error("bad seed size");
      for (var d = new Uint8Array(Tt), u = new Uint8Array(Nt), i = 0; i < 32; i++)
        u[i] = a[i];
      return Nr(d, u, !0), { publicKey: d, secretKey: u };
    }, t.sign.publicKeyLength = Tt, t.sign.secretKeyLength = Nt, t.sign.seedLength = Yr, t.sign.signatureLength = ft, t.hash = function(a) {
      rt(a);
      var d = new Uint8Array(Dr);
      return gt(d, a, a.length), d;
    }, t.hash.hashLength = Dr, t.verify = function(a, d) {
      return rt(a, d), a.length === 0 || d.length === 0 || a.length !== d.length ? !1 : w(a, 0, d, 0, a.length) === 0;
    }, t.setPRNG = function(a) {
      n = a;
    }, function() {
      var a = typeof self < "u" ? self.crypto || self.msCrypto : null;
      if (a && a.getRandomValues) {
        var d = 65536;
        t.setPRNG(function(u, i) {
          var c, v = new Uint8Array(i);
          for (c = 0; c < i; c += d)
            a.getRandomValues(v.subarray(c, c + Math.min(i - c, d)));
          for (c = 0; c < i; c++)
            u[c] = v[c];
          on(v);
        });
      } else
        typeof ph < "u" && (a = bh, a && a.randomBytes && t.setPRNG(function(u, i) {
          var c, v = a.randomBytes(i);
          for (c = 0; c < i; c++)
            u[c] = v[c];
          on(v);
        }));
    }();
  })(e.exports ? e.exports : self.nacl = self.nacl || {});
})(yh);
function xh(e) {
  if (e.length >= 255)
    throw new TypeError("Alphabet too long");
  for (var t = new Uint8Array(256), r = 0; r < t.length; r++)
    t[r] = 255;
  for (var n = 0; n < e.length; n++) {
    var o = e.charAt(n), s = o.charCodeAt(0);
    if (t[s] !== 255)
      throw new TypeError(o + " is ambiguous");
    t[s] = n;
  }
  var f = e.length, l = e.charAt(0), h = Math.log(f) / Math.log(256), p = Math.log(256) / Math.log(f);
  function b(m) {
    if (m instanceof Uint8Array || (ArrayBuffer.isView(m) ? m = new Uint8Array(m.buffer, m.byteOffset, m.byteLength) : Array.isArray(m) && (m = Uint8Array.from(m))), !(m instanceof Uint8Array))
      throw new TypeError("Expected Uint8Array");
    if (m.length === 0)
      return "";
    for (var A = 0, w = 0, S = 0, N = m.length; S !== N && m[S] === 0; )
      S++, A++;
    for (var P = (N - S) * p + 1 >>> 0, C = new Uint8Array(P); S !== N; ) {
      for (var B = m[S], R = 0, F = P - 1; (B !== 0 || R < w) && F !== -1; F--, R++)
        B += 256 * C[F] >>> 0, C[F] = B % f >>> 0, B = B / f >>> 0;
      if (B !== 0)
        throw new Error("Non-zero carry");
      w = R, S++;
    }
    for (var Y = P - w; Y !== P && C[Y] === 0; )
      Y++;
    for (var K = l.repeat(A); Y < P; ++Y)
      K += e.charAt(C[Y]);
    return K;
  }
  function g(m) {
    if (typeof m != "string")
      throw new TypeError("Expected String");
    if (m.length === 0)
      return new Uint8Array();
    for (var A = 0, w = 0, S = 0; m[A] === l; )
      w++, A++;
    for (var N = (m.length - A) * h + 1 >>> 0, P = new Uint8Array(N); m[A]; ) {
      var C = t[m.charCodeAt(A)];
      if (C === 255)
        return;
      for (var B = 0, R = N - 1; (C !== 0 || B < S) && R !== -1; R--, B++)
        C += f * P[R] >>> 0, P[R] = C % 256 >>> 0, C = C / 256 >>> 0;
      if (C !== 0)
        throw new Error("Non-zero carry");
      S = B, A++;
    }
    for (var F = N - S; F !== N && P[F] === 0; )
      F++;
    for (var Y = new Uint8Array(w + (N - F)), K = w; F !== N; )
      Y[K++] = P[F++];
    return Y;
  }
  function E(m) {
    var A = g(m);
    if (A)
      return A;
    throw new Error("Non-base" + f + " character");
  }
  return {
    encode: b,
    decodeUnsafe: g,
    decode: E
  };
}
var wh = xh;
const mh = wh, Eh = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
var du = mh(Eh);
function Ah(e) {
  return e > 64 && e < 91 ? e - 65 : e > 96 && e < 123 ? e - 71 : e > 47 && e < 58 ? e + 4 : e === 43 ? 62 : e === 47 ? 63 : 0;
}
function Mr(e, t) {
  for (var r = e.replace(/[^A-Za-z0-9+/]/g, ""), n = r.length, o = t ? Math.ceil((n * 3 + 1 >> 2) / t) * t : n * 3 + 1 >> 2, s = new Uint8Array(o), f, l, h = 0, p = 0, b = 0; b < n; b++)
    if (l = b & 3, h |= Ah(r.charCodeAt(b)) << 6 * (3 - l), l === 3 || n - b === 1) {
      for (f = 0; f < 3 && p < o; f++, p++)
        s[p] = h >>> (16 >>> f & 24) & 255;
      h = 0;
    }
  return s;
}
function Qi(e) {
  return e < 26 ? e + 65 : e < 52 ? e + 71 : e < 62 ? e - 4 : e === 62 ? 43 : e === 63 ? 47 : 65;
}
function Hr(e) {
  for (var t = 2, r = "", n = e.length, o = 0, s = 0; s < n; s++)
    t = s % 3, s > 0 && s * 4 / 3 % 76 === 0 && (r += ""), o |= e[s] << (16 >>> t & 24), (t === 2 || e.length - s === 1) && (r += String.fromCodePoint(
      Qi(o >>> 18 & 63),
      Qi(o >>> 12 & 63),
      Qi(o >>> 6 & 63),
      Qi(o & 63)
    ), o = 0);
  return r.slice(0, r.length - 2 + t) + (t === 2 ? "" : t === 1 ? "=" : "==");
}
function Aa(e) {
  let t = e.replace("0x", "").match(/.{1,2}/g).map((r) => parseInt(r, 16));
  if (t === null)
    throw new Error(`Unable to parse HEX: ${e}`);
  return Uint8Array.from(t);
}
function Sa(e) {
  return e.reduce(
    (t, r) => t + r.toString(16).padStart(2, "0"),
    ""
  );
}
var Sh = 32;
function ps(e, t) {
  let r = new Uint8Array(t), n = 0;
  for (; e > 0; )
    r[n] = Number(e % BigInt(256)), e = e / BigInt(256), n += 1;
  return r;
}
var Ta = (e) => du.encode(e), Ma = (e) => du.decode(e), Th = class {
  constructor(e) {
    this.bytePosition = 0, this.dataView = new DataView(e.buffer);
  }
  shift(e) {
    return this.bytePosition += e, this;
  }
  read8() {
    let e = this.dataView.getUint8(this.bytePosition);
    return this.shift(1), e;
  }
  read16() {
    let e = this.dataView.getUint16(this.bytePosition, !0);
    return this.shift(2), e;
  }
  read32() {
    let e = this.dataView.getUint32(this.bytePosition, !0);
    return this.shift(4), e;
  }
  read64() {
    let e = this.read32(), r = this.read32().toString(16) + e.toString(16).padStart(8, "0");
    return BigInt("0x" + r).toString(10);
  }
  read128() {
    let e = BigInt(this.read64()), r = BigInt(this.read64()).toString(16) + e.toString(16).padStart(8, "0");
    return BigInt("0x" + r).toString(10);
  }
  read256() {
    let e = BigInt(this.read128()), r = BigInt(this.read128()).toString(16) + e.toString(16).padStart(16, "0");
    return BigInt("0x" + r).toString(10);
  }
  readBytes(e) {
    let t = this.bytePosition + this.dataView.byteOffset, r = new Uint8Array(this.dataView.buffer, t, e);
    return this.shift(e), r;
  }
  readULEB() {
    let e = this.bytePosition + this.dataView.byteOffset, t = new Uint8Array(this.dataView.buffer, e), { value: r, length: n } = Ch(t);
    return this.shift(n), r;
  }
  readVec(e) {
    let t = this.readULEB(), r = [];
    for (let n = 0; n < t; n++)
      r.push(e(this, n, t));
    return r;
  }
}, Mh = class {
  constructor({
    size: e = 1024,
    maxSize: t,
    allocateSize: r = 1024
  } = {}) {
    this.bytePosition = 0, this.size = e, this.maxSize = t || e, this.allocateSize = r, this.dataView = new DataView(new ArrayBuffer(e));
  }
  ensureSizeOrGrow(e) {
    const t = this.bytePosition + e;
    if (t > this.size) {
      const r = Math.min(this.maxSize, this.size + this.allocateSize);
      if (t > r)
        throw new Error(
          `Attempting to serialize to BCS, but buffer does not have enough size. Allocated size: ${this.size}, Max size: ${this.maxSize}, Required size: ${t}`
        );
      this.size = r;
      const n = new ArrayBuffer(this.size);
      new Uint8Array(n).set(new Uint8Array(this.dataView.buffer)), this.dataView = new DataView(n);
    }
  }
  shift(e) {
    return this.bytePosition += e, this;
  }
  write8(e) {
    return this.ensureSizeOrGrow(1), this.dataView.setUint8(this.bytePosition, Number(e)), this.shift(1);
  }
  write16(e) {
    return this.ensureSizeOrGrow(2), this.dataView.setUint16(this.bytePosition, Number(e), !0), this.shift(2);
  }
  write32(e) {
    return this.ensureSizeOrGrow(4), this.dataView.setUint32(this.bytePosition, Number(e), !0), this.shift(4);
  }
  write64(e) {
    return ps(BigInt(e), 8).forEach((t) => this.write8(t)), this;
  }
  write128(e) {
    return ps(BigInt(e), 16).forEach((t) => this.write8(t)), this;
  }
  write256(e) {
    return ps(BigInt(e), 32).forEach((t) => this.write8(t)), this;
  }
  writeULEB(e) {
    return Ih(e).forEach((t) => this.write8(t)), this;
  }
  writeVec(e, t) {
    return this.writeULEB(e.length), Array.from(e).forEach((r, n) => t(this, r, n, e.length)), this;
  }
  *[Symbol.iterator]() {
    for (let e = 0; e < this.bytePosition; e++)
      yield this.dataView.getUint8(e);
    return this.toBytes();
  }
  toBytes() {
    return new Uint8Array(this.dataView.buffer.slice(0, this.bytePosition));
  }
  toString(e) {
    return _h(this.toBytes(), e);
  }
};
function Ih(e) {
  let t = [], r = 0;
  if (e === 0)
    return [0];
  for (; e > 0; )
    t[r] = e & 127, (e >>= 7) && (t[r] |= 128), r += 1;
  return t;
}
function Ch(e) {
  let t = 0, r = 0, n = 0;
  for (; ; ) {
    let o = e[n];
    if (n += 1, t |= (o & 127) << r, (o & 128) === 0)
      break;
    r += 7;
  }
  return {
    value: t,
    length: n
  };
}
var mi = class {
  constructor(e) {
    if (this.types = /* @__PURE__ */ new Map(), this.counter = 0, e instanceof mi) {
      this.schema = e.schema, this.types = new Map(e.types);
      return;
    }
    if (this.schema = e, this.registerAddressType(
      mi.ADDRESS,
      e.addressLength,
      e.addressEncoding
    ), this.registerVectorType(e.vectorType), e.types && e.types.structs)
      for (let t of Object.keys(e.types.structs))
        this.registerStructType(t, e.types.structs[t]);
    if (e.types && e.types.enums)
      for (let t of Object.keys(e.types.enums))
        this.registerEnumType(t, e.types.enums[t]);
    if (e.types && e.types.aliases)
      for (let t of Object.keys(e.types.aliases))
        this.registerAlias(t, e.types.aliases[t]);
    e.withPrimitives !== !1 && Nh(this);
  }
  tempKey() {
    return `bcs-struct-${++this.counter}`;
  }
  ser(e, t, r) {
    if (typeof e == "string" || Array.isArray(e)) {
      const { name: n, params: o } = this.parseTypeName(e);
      return this.getTypeInterface(n).encode(
        this,
        t,
        r,
        o
      );
    }
    if (typeof e == "object") {
      const n = this.tempKey();
      return new mi(this).registerStructType(n, e).ser(n, t, r);
    }
    throw new Error(
      `Incorrect type passed into the '.ser()' function. 
${JSON.stringify(
        e
      )}`
    );
  }
  de(e, t, r) {
    if (typeof t == "string")
      if (r)
        t = Oh(t, r);
      else
        throw new Error("To pass a string to `bcs.de`, specify encoding");
    if (typeof e == "string" || Array.isArray(e)) {
      const { name: n, params: o } = this.parseTypeName(e);
      return this.getTypeInterface(n).decode(this, t, o);
    }
    if (typeof e == "object") {
      const n = new mi(this), o = this.tempKey();
      return n.registerStructType(o, e).de(o, t, r);
    }
    throw new Error(
      `Incorrect type passed into the '.de()' function. 
${JSON.stringify(
        e
      )}`
    );
  }
  hasType(e) {
    return this.types.has(e);
  }
  registerAlias(e, t) {
    return this.types.set(e, t), this;
  }
  registerType(e, t, r, n = () => !0) {
    const { name: o, params: s } = this.parseTypeName(e);
    return this.types.set(o, {
      encode(f, l, h, p) {
        const b = s.reduce(
          (g, E, m) => Object.assign(g, { [E]: p[m] }),
          {}
        );
        return this._encodeRaw.call(
          f,
          new Mh(h),
          l,
          p,
          b
        );
      },
      decode(f, l, h) {
        const p = s.reduce(
          (b, g, E) => Object.assign(b, { [g]: h[E] }),
          {}
        );
        return this._decodeRaw.call(
          f,
          new Th(l),
          h,
          p
        );
      },
      _encodeRaw(f, l, h, p) {
        if (n(l))
          return t.call(this, f, l, h, p);
        throw new Error(`Validation failed for type ${o}, data: ${l}`);
      },
      _decodeRaw(f, l, h) {
        return r.call(this, f, l, h);
      }
    }), this;
  }
  registerAddressType(e, t, r = "hex") {
    switch (r) {
      case "base64":
        return this.registerType(
          e,
          function(o, s) {
            return Mr(s).reduce(
              (f, l) => f.write8(l),
              o
            );
          },
          function(o) {
            return Hr(o.readBytes(t));
          }
        );
      case "hex":
        return this.registerType(
          e,
          function(o, s) {
            return Aa(s).reduce(
              (f, l) => f.write8(l),
              o
            );
          },
          function(o) {
            return Sa(o.readBytes(t));
          }
        );
      default:
        throw new Error("Unsupported encoding! Use either hex or base64");
    }
  }
  registerVectorType(e) {
    let { name: t, params: r } = this.parseTypeName(e);
    if (r.length > 1)
      throw new Error("Vector can have only one type parameter; got " + t);
    return this.registerType(
      e,
      function(o, s, f, l) {
        return o.writeVec(s, (h, p) => {
          let b = f[0];
          if (!b)
            throw new Error(
              `Incorrect number of type parameters passed a to vector '${e}'`
            );
          let { name: g, params: E } = this.parseTypeName(b);
          if (this.hasType(g))
            return this.getTypeInterface(g)._encodeRaw.call(
              this,
              h,
              p,
              E,
              l
            );
          if (!(g in l))
            throw new Error(
              `Unable to find a matching type definition for ${g} in vector; make sure you passed a generic`
            );
          let { name: m, params: A } = this.parseTypeName(
            l[g]
          );
          return this.getTypeInterface(m)._encodeRaw.call(
            this,
            h,
            p,
            A,
            l
          );
        });
      },
      function(o, s, f) {
        return o.readVec((l) => {
          let h = s[0];
          if (!h)
            throw new Error(
              `Incorrect number of type parameters passed to a vector '${e}'`
            );
          let { name: p, params: b } = this.parseTypeName(h);
          if (this.hasType(p))
            return this.getTypeInterface(p)._decodeRaw.call(
              this,
              l,
              b,
              f
            );
          if (!(p in f))
            throw new Error(
              `Unable to find a matching type definition for ${p} in vector; make sure you passed a generic`
            );
          let { name: g, params: E } = this.parseTypeName(
            f[p]
          );
          this.getTypeInterface(g)._decodeRaw.call(
            this,
            l,
            E,
            f
          );
        });
      }
    );
  }
  registerStructType(e, t) {
    for (let f in t) {
      let l = this.tempKey(), h = t[f];
      !Array.isArray(h) && typeof h != "string" && (t[f] = l, this.registerStructType(l, h));
    }
    let r = Object.freeze(t), n = Object.keys(r), { name: o, params: s } = this.parseTypeName(e);
    return this.registerType(
      e,
      function(l, h, p, b) {
        if (!h || h.constructor !== Object)
          throw new Error(
            `Expected ${o} to be an Object, got: ${h}`
          );
        if (p.length !== s.length)
          throw new Error(
            `Incorrect number of generic parameters passed; expected: ${s.length}, got: ${p.length}`
          );
        for (let g of n) {
          if (!(g in h))
            throw new Error(
              `Struct ${o} requires field ${g}:${r[g]}`
            );
          const { name: E, params: m } = this.parseTypeName(
            r[g]
          );
          if (!s.includes(E))
            this.getTypeInterface(E)._encodeRaw.call(
              this,
              l,
              h[g],
              m,
              b
            );
          else {
            const A = s.indexOf(E);
            let { name: w, params: S } = this.parseTypeName(p[A]);
            if (this.hasType(w)) {
              this.getTypeInterface(w)._encodeRaw.call(
                this,
                l,
                h[g],
                S,
                b
              );
              continue;
            }
            if (!(w in b))
              throw new Error(
                `Unable to find a matching type definition for ${w} in ${o}; make sure you passed a generic`
              );
            let { name: N, params: P } = this.parseTypeName(
              b[w]
            );
            this.getTypeInterface(N)._encodeRaw.call(
              this,
              l,
              h[g],
              P,
              b
            );
          }
        }
        return l;
      },
      function(l, h, p) {
        if (h.length !== s.length)
          throw new Error(
            `Incorrect number of generic parameters passed; expected: ${s.length}, got: ${h.length}`
          );
        let b = {};
        for (let g of n) {
          const { name: E, params: m } = this.parseTypeName(
            r[g]
          );
          if (!s.includes(E))
            b[g] = this.getTypeInterface(E)._decodeRaw.call(
              this,
              l,
              m,
              p
            );
          else {
            const A = s.indexOf(E);
            let { name: w, params: S } = this.parseTypeName(h[A]);
            if (this.hasType(w)) {
              b[g] = this.getTypeInterface(w)._decodeRaw.call(
                this,
                l,
                S,
                p
              );
              continue;
            }
            if (!(w in p))
              throw new Error(
                `Unable to find a matching type definition for ${w} in ${o}; make sure you passed a generic`
              );
            let { name: N, params: P } = this.parseTypeName(
              p[w]
            );
            b[g] = this.getTypeInterface(N)._decodeRaw.call(
              this,
              l,
              P,
              p
            );
          }
        }
        return b;
      }
    );
  }
  registerEnumType(e, t) {
    for (let f in t) {
      let l = this.tempKey(), h = t[f];
      h !== null && !Array.isArray(h) && typeof h != "string" && (t[f] = l, this.registerStructType(l, h));
    }
    let r = Object.freeze(t), n = Object.keys(r), { name: o, params: s } = this.parseTypeName(e);
    return this.registerType(
      e,
      function(l, h, p, b) {
        if (!h)
          throw new Error(
            `Unable to write enum "${o}", missing data.
Received: "${h}"`
          );
        if (typeof h != "object")
          throw new Error(
            `Incorrect data passed into enum "${o}", expected object with properties: "${n.join(
              " | "
            )}".
Received: "${JSON.stringify(h)}"`
          );
        let g = Object.keys(h)[0];
        if (g === void 0)
          throw new Error(
            `Empty object passed as invariant of the enum "${o}"`
          );
        let E = n.indexOf(g);
        if (E === -1)
          throw new Error(
            `Unknown invariant of the enum "${o}", allowed values: "${n.join(
              " | "
            )}"; received "${g}"`
          );
        let m = n[E], A = r[m];
        if (l.write8(E), A === null)
          return l;
        let w = s.indexOf(A), S = w === -1 ? A : p[w];
        {
          let { name: N, params: P } = this.parseTypeName(S);
          return this.getTypeInterface(N)._encodeRaw.call(
            this,
            l,
            h[g],
            P,
            b
          );
        }
      },
      function(l, h, p) {
        let b = l.readULEB(), g = n[b], E = r[g];
        if (b === -1)
          throw new Error(
            `Decoding type mismatch, expected enum "${o}" invariant index, received "${b}"`
          );
        if (E === null)
          return { [g]: !0 };
        let m = s.indexOf(E), A = m === -1 ? E : h[m];
        {
          let { name: w, params: S } = this.parseTypeName(A);
          return {
            [g]: this.getTypeInterface(w)._decodeRaw.call(
              this,
              l,
              S,
              p
            )
          };
        }
      }
    );
  }
  getTypeInterface(e) {
    let t = this.types.get(e);
    if (typeof t == "string") {
      let r = [];
      for (; typeof t == "string"; ) {
        if (r.includes(t))
          throw new Error(
            `Recursive definition found: ${r.join(
              " -> "
            )} -> ${t}`
          );
        r.push(t), t = this.types.get(t);
      }
    }
    if (t === void 0)
      throw new Error(`Type ${e} is not registered`);
    return t;
  }
  parseTypeName(e) {
    if (Array.isArray(e)) {
      let [l, ...h] = e;
      return { name: l, params: h };
    }
    if (typeof e != "string")
      throw new Error(`Illegal type passed as a name of the type: ${e}`);
    let [t, r] = this.schema.genericSeparators || ["<", ">"], n = e.indexOf(t), o = Array.from(e).reverse().indexOf(r);
    if (n === -1 && o === -1)
      return { name: e, params: [] };
    if (n === -1 || o === -1)
      throw new Error(`Unclosed generic in name '${e}'`);
    let s = e.slice(0, n), f = e.slice(n + 1, e.length - o - 1).split(",").map((l) => l.trim());
    return { name: s, params: f };
  }
}, ze = mi;
ze.U8 = "u8";
ze.U16 = "u16";
ze.U32 = "u32";
ze.U64 = "u64";
ze.U128 = "u128";
ze.U256 = "u256";
ze.BOOL = "bool";
ze.VECTOR = "vector";
ze.ADDRESS = "address";
ze.STRING = "string";
ze.HEX = "hex-string";
ze.BASE58 = "base58-string";
ze.BASE64 = "base64-string";
function _h(e, t) {
  switch (t) {
    case "base58":
      return Ta(e);
    case "base64":
      return Hr(e);
    case "hex":
      return Sa(e);
    default:
      throw new Error(
        "Unsupported encoding, supported values are: base64, hex"
      );
  }
}
function Oh(e, t) {
  switch (t) {
    case "base58":
      return Ma(e);
    case "base64":
      return Mr(e);
    case "hex":
      return Aa(e);
    default:
      throw new Error(
        "Unsupported encoding, supported values are: base64, hex"
      );
  }
}
function Nh(e) {
  e.registerType(
    ze.U8,
    function(t, r) {
      return t.write8(r);
    },
    function(t) {
      return t.read8();
    },
    (t) => t < 256
  ), e.registerType(
    ze.U16,
    function(t, r) {
      return t.write16(r);
    },
    function(t) {
      return t.read16();
    },
    (t) => t < 65536
  ), e.registerType(
    ze.U32,
    function(t, r) {
      return t.write32(r);
    },
    function(t) {
      return t.read32();
    },
    (t) => t <= 4294967296n
  ), e.registerType(
    ze.U64,
    function(t, r) {
      return t.write64(r);
    },
    function(t) {
      return t.read64();
    }
  ), e.registerType(
    ze.U128,
    function(t, r) {
      return t.write128(r);
    },
    function(t) {
      return t.read128();
    }
  ), e.registerType(
    ze.U256,
    function(t, r) {
      return t.write256(r);
    },
    function(t) {
      return t.read256();
    }
  ), e.registerType(
    ze.BOOL,
    function(t, r) {
      return t.write8(r);
    },
    function(t) {
      return t.read8().toString(10) === "1";
    }
  ), e.registerType(
    ze.STRING,
    function(t, r) {
      return t.writeVec(
        Array.from(r),
        (n, o) => n.write8(o.charCodeAt(0))
      );
    },
    function(t) {
      return t.readVec((r) => r.read8()).map((r) => String.fromCharCode(Number(r))).join("");
    },
    (t) => !0
  ), e.registerType(
    ze.HEX,
    function(t, r) {
      return t.writeVec(
        Array.from(Aa(r)),
        (n, o) => n.write8(o)
      );
    },
    function(t) {
      let r = t.readVec((n) => n.read8());
      return Sa(new Uint8Array(r));
    }
  ), e.registerType(
    ze.BASE58,
    function(t, r) {
      return t.writeVec(
        Array.from(Ma(r)),
        (n, o) => n.write8(o)
      );
    },
    function(t) {
      let r = t.readVec((n) => n.read8());
      return Ta(new Uint8Array(r));
    }
  ), e.registerType(
    ze.BASE64,
    function(t, r) {
      return t.writeVec(
        Array.from(Mr(r)),
        (n, o) => n.write8(o)
      );
    },
    function(t) {
      let r = t.readVec((n) => n.read8());
      return Hr(new Uint8Array(r));
    }
  );
}
function jh() {
  return {
    genericSeparators: ["<", ">"],
    vectorType: "vector",
    addressLength: Sh,
    addressEncoding: "hex"
  };
}
function Ks(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
function Dh(e) {
  if (typeof e != "boolean")
    throw new Error(`Expected boolean, not ${e}`);
}
function hu(e, ...t) {
  if (!(e instanceof Uint8Array))
    throw new TypeError("Expected Uint8Array");
  if (t.length > 0 && !t.includes(e.length))
    throw new TypeError(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
}
function Lh(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  Ks(e.outputLen), Ks(e.blockLen);
}
function Rh(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function Ph(e, t) {
  hu(e);
  const r = t.outputLen;
  if (e.length < r)
    throw new Error(`digestInto() expects output buffer of length at least ${r}`);
}
const nr = {
  number: Ks,
  bool: Dh,
  bytes: hu,
  hash: Lh,
  exists: Rh,
  output: Ph
}, ao = typeof globalThis == "object" && "crypto" in globalThis ? globalThis.crypto : void 0, Uh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  crypto: ao
}, Symbol.toStringTag, { value: "Module" }));
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Bh = (e) => new Uint8Array(e.buffer, e.byteOffset, e.byteLength), Ci = (e) => new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), co = (e) => new DataView(e.buffer, e.byteOffset, e.byteLength), mr = (e, t) => e << 32 - t | e >>> t, pu = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!pu)
  throw new Error("Non little-endian hardware is not supported");
const kh = Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function Ia(e) {
  if (!(e instanceof Uint8Array))
    throw new Error("Uint8Array expected");
  let t = "";
  for (let r = 0; r < e.length; r++)
    t += kh[e[r]];
  return t;
}
function zh(e) {
  if (typeof e != "string")
    throw new TypeError("hexToBytes: expected string, got " + typeof e);
  if (e.length % 2)
    throw new Error("hexToBytes: received invalid unpadded hex");
  const t = new Uint8Array(e.length / 2);
  for (let r = 0; r < t.length; r++) {
    const n = r * 2, o = e.slice(n, n + 2), s = Number.parseInt(o, 16);
    if (Number.isNaN(s) || s < 0)
      throw new Error("Invalid byte sequence");
    t[r] = s;
  }
  return t;
}
const yu = async () => {
};
async function Fh(e, t, r) {
  let n = Date.now();
  for (let o = 0; o < e; o++) {
    r(o);
    const s = Date.now() - n;
    s >= 0 && s < t || (await yu(), n += s);
  }
}
function Ca(e) {
  if (typeof e != "string")
    throw new TypeError(`utf8ToBytes expected string, got ${typeof e}`);
  return new TextEncoder().encode(e);
}
function Kr(e) {
  if (typeof e == "string" && (e = Ca(e)), !(e instanceof Uint8Array))
    throw new TypeError(`Expected input type is Uint8Array (got ${typeof e})`);
  return e;
}
function gu(...e) {
  if (!e.every((n) => n instanceof Uint8Array))
    throw new Error("Uint8Array list expected");
  if (e.length === 1)
    return e[0];
  const t = e.reduce((n, o) => n + o.length, 0), r = new Uint8Array(t);
  for (let n = 0, o = 0; n < e.length; n++) {
    const s = e[n];
    r.set(s, o), o += s.length;
  }
  return r;
}
class Yo {
  clone() {
    return this._cloneInto();
  }
}
const $h = (e) => Object.prototype.toString.call(e) === "[object Object]" && e.constructor === Object;
function Wh(e, t) {
  if (t !== void 0 && (typeof t != "object" || !$h(t)))
    throw new TypeError("Options should be object or undefined");
  return Object.assign(e, t);
}
function Cn(e) {
  const t = (n) => e().update(Kr(n)).digest(), r = e();
  return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = () => e(), t;
}
function vu(e) {
  const t = (n, o) => e(o).update(Kr(n)).digest(), r = e({});
  return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = (n) => e(n), t;
}
function _a(e = 32) {
  if (ao && typeof ao.getRandomValues == "function")
    return ao.getRandomValues(new Uint8Array(e));
  throw new Error("crypto.getRandomValues must be defined");
}
const qh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  u8: Bh,
  u32: Ci,
  createView: co,
  rotr: mr,
  isLE: pu,
  bytesToHex: Ia,
  hexToBytes: zh,
  nextTick: yu,
  asyncLoop: Fh,
  utf8ToBytes: Ca,
  toBytes: Kr,
  concatBytes: gu,
  Hash: Yo,
  checkOpts: Wh,
  wrapConstructor: Cn,
  wrapConstructorWithOpts: vu,
  randomBytes: _a
}, Symbol.toStringTag, { value: "Module" }));
function Yh(e, t, r, n) {
  if (typeof e.setBigUint64 == "function")
    return e.setBigUint64(t, r, n);
  const o = BigInt(32), s = BigInt(4294967295), f = Number(r >> o & s), l = Number(r & s), h = n ? 4 : 0, p = n ? 0 : 4;
  e.setUint32(t + h, f, n), e.setUint32(t + p, l, n);
}
class Oa extends Yo {
  constructor(t, r, n, o) {
    super(), this.blockLen = t, this.outputLen = r, this.padOffset = n, this.isLE = o, this.finished = !1, this.length = 0, this.pos = 0, this.destroyed = !1, this.buffer = new Uint8Array(t), this.view = co(this.buffer);
  }
  update(t) {
    nr.exists(this);
    const { view: r, buffer: n, blockLen: o } = this;
    t = Kr(t);
    const s = t.length;
    for (let f = 0; f < s; ) {
      const l = Math.min(o - this.pos, s - f);
      if (l === o) {
        const h = co(t);
        for (; o <= s - f; f += o)
          this.process(h, f);
        continue;
      }
      n.set(t.subarray(f, f + l), this.pos), this.pos += l, f += l, this.pos === o && (this.process(r, 0), this.pos = 0);
    }
    return this.length += t.length, this.roundClean(), this;
  }
  digestInto(t) {
    nr.exists(this), nr.output(t, this), this.finished = !0;
    const { buffer: r, view: n, blockLen: o, isLE: s } = this;
    let { pos: f } = this;
    r[f++] = 128, this.buffer.subarray(f).fill(0), this.padOffset > o - f && (this.process(n, 0), f = 0);
    for (let g = f; g < o; g++)
      r[g] = 0;
    Yh(n, o - 8, BigInt(this.length * 8), s), this.process(n, 0);
    const l = co(t), h = this.outputLen;
    if (h % 4)
      throw new Error("_sha2: outputLen should be aligned to 32bit");
    const p = h / 4, b = this.get();
    if (p > b.length)
      throw new Error("_sha2: outputLen bigger than state");
    for (let g = 0; g < p; g++)
      l.setUint32(4 * g, b[g], s);
  }
  digest() {
    const { buffer: t, outputLen: r } = this;
    this.digestInto(t);
    const n = t.slice(0, r);
    return this.destroy(), n;
  }
  _cloneInto(t) {
    t || (t = new this.constructor()), t.set(...this.get());
    const { blockLen: r, buffer: n, length: o, finished: s, destroyed: f, pos: l } = this;
    return t.length = o, t.pos = l, t.finished = s, t.destroyed = f, o % r && t.buffer.set(n), t;
  }
}
const Gh = (e, t, r) => e & t ^ ~e & r, Qh = (e, t, r) => e & t ^ e & r ^ t & r, Vh = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), an = new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]), cn = new Uint32Array(64);
class bu extends Oa {
  constructor() {
    super(64, 32, 8, !1), this.A = an[0] | 0, this.B = an[1] | 0, this.C = an[2] | 0, this.D = an[3] | 0, this.E = an[4] | 0, this.F = an[5] | 0, this.G = an[6] | 0, this.H = an[7] | 0;
  }
  get() {
    const { A: t, B: r, C: n, D: o, E: s, F: f, G: l, H: h } = this;
    return [t, r, n, o, s, f, l, h];
  }
  set(t, r, n, o, s, f, l, h) {
    this.A = t | 0, this.B = r | 0, this.C = n | 0, this.D = o | 0, this.E = s | 0, this.F = f | 0, this.G = l | 0, this.H = h | 0;
  }
  process(t, r) {
    for (let g = 0; g < 16; g++, r += 4)
      cn[g] = t.getUint32(r, !1);
    for (let g = 16; g < 64; g++) {
      const E = cn[g - 15], m = cn[g - 2], A = mr(E, 7) ^ mr(E, 18) ^ E >>> 3, w = mr(m, 17) ^ mr(m, 19) ^ m >>> 10;
      cn[g] = w + cn[g - 7] + A + cn[g - 16] | 0;
    }
    let { A: n, B: o, C: s, D: f, E: l, F: h, G: p, H: b } = this;
    for (let g = 0; g < 64; g++) {
      const E = mr(l, 6) ^ mr(l, 11) ^ mr(l, 25), m = b + E + Gh(l, h, p) + Vh[g] + cn[g] | 0, w = (mr(n, 2) ^ mr(n, 13) ^ mr(n, 22)) + Qh(n, o, s) | 0;
      b = p, p = h, h = l, l = f + m | 0, f = s, s = o, o = n, n = m + w | 0;
    }
    n = n + this.A | 0, o = o + this.B | 0, s = s + this.C | 0, f = f + this.D | 0, l = l + this.E | 0, h = h + this.F | 0, p = p + this.G | 0, b = b + this.H | 0, this.set(n, o, s, f, l, h, p, b);
  }
  roundClean() {
    cn.fill(0);
  }
  destroy() {
    this.set(0, 0, 0, 0, 0, 0, 0, 0), this.buffer.fill(0);
  }
}
class Hh extends bu {
  constructor() {
    super(), this.A = -1056596264, this.B = 914150663, this.C = 812702999, this.D = -150054599, this.E = -4191439, this.F = 1750603025, this.G = 1694076839, this.H = -1090891868, this.outputLen = 28;
  }
}
const oi = Cn(() => new bu()), Zh = Cn(() => new Hh()), Kh = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  sha256: oi,
  sha224: Zh
}, Symbol.toStringTag, { value: "Module" })), Xh = new Uint8Array([
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  14,
  10,
  4,
  8,
  9,
  15,
  13,
  6,
  1,
  12,
  0,
  2,
  11,
  7,
  5,
  3,
  11,
  8,
  12,
  0,
  5,
  2,
  15,
  13,
  10,
  14,
  3,
  6,
  7,
  1,
  9,
  4,
  7,
  9,
  3,
  1,
  13,
  12,
  11,
  14,
  2,
  6,
  5,
  10,
  4,
  0,
  15,
  8,
  9,
  0,
  5,
  7,
  2,
  4,
  10,
  15,
  14,
  1,
  11,
  12,
  6,
  8,
  3,
  13,
  2,
  12,
  6,
  10,
  0,
  11,
  8,
  3,
  4,
  13,
  7,
  5,
  15,
  14,
  1,
  9,
  12,
  5,
  1,
  15,
  14,
  13,
  4,
  10,
  0,
  7,
  6,
  3,
  9,
  2,
  8,
  11,
  13,
  11,
  7,
  14,
  12,
  1,
  3,
  9,
  5,
  0,
  15,
  4,
  8,
  6,
  2,
  10,
  6,
  15,
  14,
  9,
  11,
  3,
  0,
  8,
  12,
  2,
  13,
  7,
  1,
  4,
  10,
  5,
  10,
  2,
  8,
  4,
  7,
  6,
  1,
  5,
  15,
  11,
  9,
  14,
  3,
  12,
  13,
  0,
  0,
  1,
  2,
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  12,
  13,
  14,
  15,
  14,
  10,
  4,
  8,
  9,
  15,
  13,
  6,
  1,
  12,
  0,
  2,
  11,
  7,
  5,
  3
]);
class Jh extends Yo {
  constructor(t, r, n = {}, o, s, f) {
    if (super(), this.blockLen = t, this.outputLen = r, this.length = 0, this.pos = 0, this.finished = !1, this.destroyed = !1, nr.number(t), nr.number(r), nr.number(o), r < 0 || r > o)
      throw new Error("outputLen bigger than keyLen");
    if (n.key !== void 0 && (n.key.length < 1 || n.key.length > o))
      throw new Error(`key must be up 1..${o} byte long or undefined`);
    if (n.salt !== void 0 && n.salt.length !== s)
      throw new Error(`salt must be ${s} byte long or undefined`);
    if (n.personalization !== void 0 && n.personalization.length !== f)
      throw new Error(`personalization must be ${f} byte long or undefined`);
    this.buffer32 = Ci(this.buffer = new Uint8Array(t));
  }
  update(t) {
    nr.exists(this);
    const { blockLen: r, buffer: n, buffer32: o } = this;
    t = Kr(t);
    const s = t.length;
    for (let f = 0; f < s; ) {
      this.pos === r && (this.compress(o, 0, !1), this.pos = 0);
      const l = Math.min(r - this.pos, s - f), h = t.byteOffset + f;
      if (l === r && !(h % 4) && f + l < s) {
        const p = new Uint32Array(t.buffer, h, Math.floor((s - f) / 4));
        for (let b = 0; f + r < s; b += o.length, f += r)
          this.length += r, this.compress(p, b, !1);
        continue;
      }
      n.set(t.subarray(f, f + l), this.pos), this.pos += l, this.length += l, f += l;
    }
    return this;
  }
  digestInto(t) {
    nr.exists(this), nr.output(t, this);
    const { pos: r, buffer32: n } = this;
    this.finished = !0, this.buffer.subarray(r).fill(0), this.compress(n, 0, !0);
    const o = Ci(t);
    this.get().forEach((s, f) => o[f] = s);
  }
  digest() {
    const { buffer: t, outputLen: r } = this;
    this.digestInto(t);
    const n = t.slice(0, r);
    return this.destroy(), n;
  }
  _cloneInto(t) {
    const { buffer: r, length: n, finished: o, destroyed: s, outputLen: f, pos: l } = this;
    return t || (t = new this.constructor({ dkLen: f })), t.set(...this.get()), t.length = n, t.finished = o, t.destroyed = s, t.outputLen = f, t.buffer.set(r), t.pos = l, t;
  }
}
const Vi = BigInt(2 ** 32 - 1), Xs = BigInt(32);
function xu(e, t = !1) {
  return t ? { h: Number(e & Vi), l: Number(e >> Xs & Vi) } : { h: Number(e >> Xs & Vi) | 0, l: Number(e & Vi) | 0 };
}
function e1(e, t = !1) {
  let r = new Uint32Array(e.length), n = new Uint32Array(e.length);
  for (let o = 0; o < e.length; o++) {
    const { h: s, l: f } = xu(e[o], t);
    [r[o], n[o]] = [s, f];
  }
  return [r, n];
}
const t1 = (e, t) => BigInt(e >>> 0) << Xs | BigInt(t >>> 0), r1 = (e, t, r) => e >>> r, n1 = (e, t, r) => e << 32 - r | t >>> r, i1 = (e, t, r) => e >>> r | t << 32 - r, o1 = (e, t, r) => e << 32 - r | t >>> r, s1 = (e, t, r) => e << 64 - r | t >>> r - 32, a1 = (e, t, r) => e >>> r - 32 | t << 64 - r, c1 = (e, t) => t, f1 = (e, t) => e, u1 = (e, t, r) => e << r | t >>> 32 - r, l1 = (e, t, r) => t << r | e >>> 32 - r, d1 = (e, t, r) => t << r - 32 | e >>> 64 - r, h1 = (e, t, r) => e << r - 32 | t >>> 64 - r;
function p1(e, t, r, n) {
  const o = (t >>> 0) + (n >>> 0);
  return { h: e + r + (o / 2 ** 32 | 0) | 0, l: o | 0 };
}
const y1 = (e, t, r) => (e >>> 0) + (t >>> 0) + (r >>> 0), g1 = (e, t, r, n) => t + r + n + (e / 2 ** 32 | 0) | 0, v1 = (e, t, r, n) => (e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0), b1 = (e, t, r, n, o) => t + r + n + o + (e / 2 ** 32 | 0) | 0, x1 = (e, t, r, n, o) => (e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0) + (o >>> 0), w1 = (e, t, r, n, o, s) => t + r + n + o + s + (e / 2 ** 32 | 0) | 0, ke = {
  fromBig: xu,
  split: e1,
  toBig: t1,
  shrSH: r1,
  shrSL: n1,
  rotrSH: i1,
  rotrSL: o1,
  rotrBH: s1,
  rotrBL: a1,
  rotr32H: c1,
  rotr32L: f1,
  rotlSH: u1,
  rotlSL: l1,
  rotlBH: d1,
  rotlBL: h1,
  add: p1,
  add3L: y1,
  add3H: g1,
  add4L: v1,
  add4H: b1,
  add5H: w1,
  add5L: x1
}, bt = new Uint32Array([
  4089235720,
  1779033703,
  2227873595,
  3144134277,
  4271175723,
  1013904242,
  1595750129,
  2773480762,
  2917565137,
  1359893119,
  725511199,
  2600822924,
  4215389547,
  528734635,
  327033209,
  1541459225
]), Ce = new Uint32Array(32);
function fn(e, t, r, n, o, s) {
  const f = o[s], l = o[s + 1];
  let h = Ce[2 * e], p = Ce[2 * e + 1], b = Ce[2 * t], g = Ce[2 * t + 1], E = Ce[2 * r], m = Ce[2 * r + 1], A = Ce[2 * n], w = Ce[2 * n + 1], S = ke.add3L(h, b, f);
  p = ke.add3H(S, p, g, l), h = S | 0, { Dh: w, Dl: A } = { Dh: w ^ p, Dl: A ^ h }, { Dh: w, Dl: A } = { Dh: ke.rotr32H(w, A), Dl: ke.rotr32L(w, A) }, { h: m, l: E } = ke.add(m, E, w, A), { Bh: g, Bl: b } = { Bh: g ^ m, Bl: b ^ E }, { Bh: g, Bl: b } = { Bh: ke.rotrSH(g, b, 24), Bl: ke.rotrSL(g, b, 24) }, Ce[2 * e] = h, Ce[2 * e + 1] = p, Ce[2 * t] = b, Ce[2 * t + 1] = g, Ce[2 * r] = E, Ce[2 * r + 1] = m, Ce[2 * n] = A, Ce[2 * n + 1] = w;
}
function un(e, t, r, n, o, s) {
  const f = o[s], l = o[s + 1];
  let h = Ce[2 * e], p = Ce[2 * e + 1], b = Ce[2 * t], g = Ce[2 * t + 1], E = Ce[2 * r], m = Ce[2 * r + 1], A = Ce[2 * n], w = Ce[2 * n + 1], S = ke.add3L(h, b, f);
  p = ke.add3H(S, p, g, l), h = S | 0, { Dh: w, Dl: A } = { Dh: w ^ p, Dl: A ^ h }, { Dh: w, Dl: A } = { Dh: ke.rotrSH(w, A, 16), Dl: ke.rotrSL(w, A, 16) }, { h: m, l: E } = ke.add(m, E, w, A), { Bh: g, Bl: b } = { Bh: g ^ m, Bl: b ^ E }, { Bh: g, Bl: b } = { Bh: ke.rotrBH(g, b, 63), Bl: ke.rotrBL(g, b, 63) }, Ce[2 * e] = h, Ce[2 * e + 1] = p, Ce[2 * t] = b, Ce[2 * t + 1] = g, Ce[2 * r] = E, Ce[2 * r + 1] = m, Ce[2 * n] = A, Ce[2 * n + 1] = w;
}
class m1 extends Jh {
  constructor(t = {}) {
    super(128, t.dkLen === void 0 ? 64 : t.dkLen, t, 64, 16, 16), this.v0l = bt[0] | 0, this.v0h = bt[1] | 0, this.v1l = bt[2] | 0, this.v1h = bt[3] | 0, this.v2l = bt[4] | 0, this.v2h = bt[5] | 0, this.v3l = bt[6] | 0, this.v3h = bt[7] | 0, this.v4l = bt[8] | 0, this.v4h = bt[9] | 0, this.v5l = bt[10] | 0, this.v5h = bt[11] | 0, this.v6l = bt[12] | 0, this.v6h = bt[13] | 0, this.v7l = bt[14] | 0, this.v7h = bt[15] | 0;
    const r = t.key ? t.key.length : 0;
    if (this.v0l ^= this.outputLen | r << 8 | 1 << 16 | 1 << 24, t.salt) {
      const n = Ci(Kr(t.salt));
      this.v4l ^= n[0], this.v4h ^= n[1], this.v5l ^= n[2], this.v5h ^= n[3];
    }
    if (t.personalization) {
      const n = Ci(Kr(t.personalization));
      this.v6l ^= n[0], this.v6h ^= n[1], this.v7l ^= n[2], this.v7h ^= n[3];
    }
    if (t.key) {
      const n = new Uint8Array(this.blockLen);
      n.set(Kr(t.key)), this.update(n);
    }
  }
  get() {
    let { v0l: t, v0h: r, v1l: n, v1h: o, v2l: s, v2h: f, v3l: l, v3h: h, v4l: p, v4h: b, v5l: g, v5h: E, v6l: m, v6h: A, v7l: w, v7h: S } = this;
    return [t, r, n, o, s, f, l, h, p, b, g, E, m, A, w, S];
  }
  set(t, r, n, o, s, f, l, h, p, b, g, E, m, A, w, S) {
    this.v0l = t | 0, this.v0h = r | 0, this.v1l = n | 0, this.v1h = o | 0, this.v2l = s | 0, this.v2h = f | 0, this.v3l = l | 0, this.v3h = h | 0, this.v4l = p | 0, this.v4h = b | 0, this.v5l = g | 0, this.v5h = E | 0, this.v6l = m | 0, this.v6h = A | 0, this.v7l = w | 0, this.v7h = S | 0;
  }
  compress(t, r, n) {
    this.get().forEach((h, p) => Ce[p] = h), Ce.set(bt, 16);
    let { h: o, l: s } = ke.fromBig(BigInt(this.length));
    Ce[24] = bt[8] ^ s, Ce[25] = bt[9] ^ o, n && (Ce[28] = ~Ce[28], Ce[29] = ~Ce[29]);
    let f = 0;
    const l = Xh;
    for (let h = 0; h < 12; h++)
      fn(0, 4, 8, 12, t, r + 2 * l[f++]), un(0, 4, 8, 12, t, r + 2 * l[f++]), fn(1, 5, 9, 13, t, r + 2 * l[f++]), un(1, 5, 9, 13, t, r + 2 * l[f++]), fn(2, 6, 10, 14, t, r + 2 * l[f++]), un(2, 6, 10, 14, t, r + 2 * l[f++]), fn(3, 7, 11, 15, t, r + 2 * l[f++]), un(3, 7, 11, 15, t, r + 2 * l[f++]), fn(0, 5, 10, 15, t, r + 2 * l[f++]), un(0, 5, 10, 15, t, r + 2 * l[f++]), fn(1, 6, 11, 12, t, r + 2 * l[f++]), un(1, 6, 11, 12, t, r + 2 * l[f++]), fn(2, 7, 8, 13, t, r + 2 * l[f++]), un(2, 7, 8, 13, t, r + 2 * l[f++]), fn(3, 4, 9, 14, t, r + 2 * l[f++]), un(3, 4, 9, 14, t, r + 2 * l[f++]);
    this.v0l ^= Ce[0] ^ Ce[16], this.v0h ^= Ce[1] ^ Ce[17], this.v1l ^= Ce[2] ^ Ce[18], this.v1h ^= Ce[3] ^ Ce[19], this.v2l ^= Ce[4] ^ Ce[20], this.v2h ^= Ce[5] ^ Ce[21], this.v3l ^= Ce[6] ^ Ce[22], this.v3h ^= Ce[7] ^ Ce[23], this.v4l ^= Ce[8] ^ Ce[24], this.v4h ^= Ce[9] ^ Ce[25], this.v5l ^= Ce[10] ^ Ce[26], this.v5h ^= Ce[11] ^ Ce[27], this.v6l ^= Ce[12] ^ Ce[28], this.v6h ^= Ce[13] ^ Ce[29], this.v7l ^= Ce[14] ^ Ce[30], this.v7h ^= Ce[15] ^ Ce[31], Ce.fill(0);
  }
  destroy() {
    this.destroyed = !0, this.buffer32.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
const Na = vu((e) => new m1(e));
class E1 extends TypeError {
  constructor(t, r) {
    let n;
    const { message: o, explanation: s, ...f } = t, { path: l } = t, h = l.length === 0 ? o : `At path: ${l.join(".")} -- ${o}`;
    super(s ?? h), s != null && (this.cause = h), Object.assign(this, f), this.name = this.constructor.name, this.failures = () => n ?? (n = [t, ...r()]);
  }
}
function A1(e) {
  return ur(e) && typeof e[Symbol.iterator] == "function";
}
function ur(e) {
  return typeof e == "object" && e != null;
}
function lr(e) {
  return typeof e == "symbol" ? e.toString() : typeof e == "string" ? JSON.stringify(e) : `${e}`;
}
function S1(e) {
  const { done: t, value: r } = e.next();
  return t ? void 0 : r;
}
function T1(e, t, r, n) {
  if (e === !0)
    return;
  e === !1 ? e = {} : typeof e == "string" && (e = { message: e });
  const { path: o, branch: s } = t, { type: f } = r, { refinement: l, message: h = `Expected a value of type \`${f}\`${l ? ` with refinement \`${l}\`` : ""}, but received: \`${lr(n)}\`` } = e;
  return {
    value: n,
    type: f,
    refinement: l,
    key: o[o.length - 1],
    path: o,
    branch: s,
    ...e,
    message: h
  };
}
function* Nc(e, t, r, n) {
  A1(e) || (e = [e]);
  for (const o of e) {
    const s = T1(o, t, r, n);
    s && (yield s);
  }
}
function* ja(e, t, r = {}) {
  const { path: n = [], branch: o = [e], coerce: s = !1, mask: f = !1 } = r, l = { path: n, branch: o };
  if (s && (e = t.coercer(e, l), f && t.type !== "type" && ur(t.schema) && ur(e) && !Array.isArray(e)))
    for (const p in e)
      t.schema[p] === void 0 && delete e[p];
  let h = "valid";
  for (const p of t.validator(e, l))
    p.explanation = r.message, h = "not_valid", yield [p, void 0];
  for (let [p, b, g] of t.entries(e, l)) {
    const E = ja(b, g, {
      path: p === void 0 ? n : [...n, p],
      branch: p === void 0 ? o : [...o, b],
      coerce: s,
      mask: f,
      message: r.message
    });
    for (const m of E)
      m[0] ? (h = m[0].refinement != null ? "not_refined" : "not_valid", yield [m[0], void 0]) : s && (b = m[1], p === void 0 ? e = b : e instanceof Map ? e.set(p, b) : e instanceof Set ? e.add(b) : ur(e) && (b !== void 0 || p in e) && (e[p] = b));
  }
  if (h !== "not_valid")
    for (const p of t.refiner(e, l))
      p.explanation = r.message, h = "not_refined", yield [p, void 0];
  h === "valid" && (yield [void 0, e]);
}
class Fr {
  constructor(t) {
    const { type: r, schema: n, validator: o, refiner: s, coercer: f = (h) => h, entries: l = function* () {
    } } = t;
    this.type = r, this.schema = n, this.entries = l, this.coercer = f, o ? this.validator = (h, p) => {
      const b = o(h, p);
      return Nc(b, p, this, h);
    } : this.validator = () => [], s ? this.refiner = (h, p) => {
      const b = s(h, p);
      return Nc(b, p, this, h);
    } : this.refiner = () => [];
  }
  assert(t, r) {
    return Mo(t, this, r);
  }
  create(t, r) {
    return wu(t, this, r);
  }
  is(t) {
    return Ot(t, this);
  }
  mask(t, r) {
    return mu(t, this, r);
  }
  validate(t, r = {}) {
    return di(t, this, r);
  }
}
function Mo(e, t, r) {
  const n = di(e, t, { message: r });
  if (n[0])
    throw n[0];
}
function wu(e, t, r) {
  const n = di(e, t, { coerce: !0, message: r });
  if (n[0])
    throw n[0];
  return n[1];
}
function mu(e, t, r) {
  const n = di(e, t, { coerce: !0, mask: !0, message: r });
  if (n[0])
    throw n[0];
  return n[1];
}
function Ot(e, t) {
  return !di(e, t)[0];
}
function di(e, t, r = {}) {
  const n = ja(e, t, r), o = S1(n);
  return o[0] ? [new E1(o[0], function* () {
    for (const f of n)
      f[0] && (yield f[0]);
  }), void 0] : [void 0, o[1]];
}
function Zr(...e) {
  const t = e[0].type === "type", r = e.map((o) => o.schema), n = Object.assign({}, ...r);
  return t ? M1(n) : H(n);
}
function dr(e, t) {
  return new Fr({ type: e, schema: null, validator: t });
}
function Jr() {
  return dr("any", () => !0);
}
function de(e) {
  return new Fr({
    type: "array",
    schema: e,
    *entries(t) {
      if (e && Array.isArray(t))
        for (const [r, n] of t.entries())
          yield [r, n, e];
    },
    coercer(t) {
      return Array.isArray(t) ? t.slice() : t;
    },
    validator(t) {
      return Array.isArray(t) || `Expected an array value, but received: ${lr(t)}`;
    }
  });
}
function ot() {
  return dr("boolean", (e) => typeof e == "boolean");
}
function Xr() {
  return dr("integer", (e) => typeof e == "number" && !isNaN(e) && Number.isInteger(e) || `Expected an integer, but received: ${lr(e)}`);
}
function Ue(e) {
  const t = lr(e), r = typeof e;
  return new Fr({
    type: "literal",
    schema: r === "string" || r === "number" || r === "boolean" ? e : null,
    validator(n) {
      return n === e || `Expected the literal \`${t}\`, but received: ${lr(n)}`;
    }
  });
}
function Eu() {
  return dr("never", () => !1);
}
function it(e) {
  return new Fr({
    ...e,
    validator: (t, r) => t === null || e.validator(t, r),
    refiner: (t, r) => t === null || e.refiner(t, r)
  });
}
function Qe() {
  return dr("number", (e) => typeof e == "number" && !isNaN(e) || `Expected a number, but received: ${lr(e)}`);
}
function H(e) {
  const t = e ? Object.keys(e) : [], r = Eu();
  return new Fr({
    type: "object",
    schema: e || null,
    *entries(n) {
      if (e && ur(n)) {
        const o = new Set(Object.keys(n));
        for (const s of t)
          o.delete(s), yield [s, n[s], e[s]];
        for (const s of o)
          yield [s, n[s], r];
      }
    },
    validator(n) {
      return ur(n) || `Expected an object, but received: ${lr(n)}`;
    },
    coercer(n) {
      return ur(n) ? { ...n } : n;
    }
  });
}
function Ie(e) {
  return new Fr({
    ...e,
    validator: (t, r) => t === void 0 || e.validator(t, r),
    refiner: (t, r) => t === void 0 || e.refiner(t, r)
  });
}
function kr(e, t) {
  return new Fr({
    type: "record",
    schema: null,
    *entries(r) {
      if (ur(r))
        for (const n in r) {
          const o = r[n];
          yield [n, n, e], yield [n, o, t];
        }
    },
    validator(r) {
      return ur(r) || `Expected an object, but received: ${lr(r)}`;
    }
  });
}
function O() {
  return dr("string", (e) => typeof e == "string" || `Expected a string, but received: ${lr(e)}`);
}
function Ft(e) {
  const t = Eu();
  return new Fr({
    type: "tuple",
    schema: null,
    *entries(r) {
      if (Array.isArray(r)) {
        const n = Math.max(e.length, r.length);
        for (let o = 0; o < n; o++)
          yield [o, r[o], e[o] || t];
      }
    },
    validator(r) {
      return Array.isArray(r) || `Expected an array, but received: ${lr(r)}`;
    }
  });
}
function M1(e) {
  const t = Object.keys(e);
  return new Fr({
    type: "type",
    schema: e,
    *entries(r) {
      if (ur(r))
        for (const n of t)
          yield [n, r[n], e[n]];
    },
    validator(r) {
      return ur(r) || `Expected an object, but received: ${lr(r)}`;
    },
    coercer(r) {
      return ur(r) ? { ...r } : r;
    }
  });
}
function et(e) {
  const t = e.map((r) => r.type).join(" | ");
  return new Fr({
    type: "union",
    schema: null,
    coercer(r) {
      for (const n of e) {
        const [o, s] = n.validate(r, { coerce: !0 });
        if (!o)
          return s;
      }
      return r;
    },
    validator(r, n) {
      const o = [];
      for (const s of e) {
        const [...f] = ja(r, s, n), [l] = f;
        if (l[0])
          for (const [h] of f)
            h && o.push(h);
        else
          return [];
      }
      return [
        `Expected the value to satisfy a union of \`${t}\`, but received: ${lr(r)}`,
        ...o
      ];
    }
  });
}
function I1() {
  return dr("unknown", () => !0);
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Au = BigInt(0), Go = BigInt(1), C1 = BigInt(2), Qo = (e) => e instanceof Uint8Array, _1 = Array.from({ length: 256 }, (e, t) => t.toString(16).padStart(2, "0"));
function si(e) {
  if (!Qo(e))
    throw new Error("Uint8Array expected");
  let t = "";
  for (let r = 0; r < e.length; r++)
    t += _1[e[r]];
  return t;
}
function Su(e) {
  const t = e.toString(16);
  return t.length & 1 ? `0${t}` : t;
}
function Da(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  return BigInt(e === "" ? "0" : `0x${e}`);
}
function ai(e) {
  if (typeof e != "string")
    throw new Error("hex string expected, got " + typeof e);
  if (e.length % 2)
    throw new Error("hex string is invalid: unpadded " + e.length);
  const t = new Uint8Array(e.length / 2);
  for (let r = 0; r < t.length; r++) {
    const n = r * 2, o = e.slice(n, n + 2), s = Number.parseInt(o, 16);
    if (Number.isNaN(s) || s < 0)
      throw new Error("invalid byte sequence");
    t[r] = s;
  }
  return t;
}
function qt(e) {
  return Da(si(e));
}
function La(e) {
  if (!Qo(e))
    throw new Error("Uint8Array expected");
  return Da(si(Uint8Array.from(e).reverse()));
}
const Tn = (e, t) => ai(e.toString(16).padStart(t * 2, "0")), Tu = (e, t) => Tn(e, t).reverse(), O1 = (e) => ai(Su(e));
function It(e, t, r) {
  let n;
  if (typeof t == "string")
    try {
      n = ai(t);
    } catch (s) {
      throw new Error(`${e} must be valid hex string, got "${t}". Cause: ${s}`);
    }
  else if (Qo(t))
    n = Uint8Array.from(t);
  else
    throw new Error(`${e} must be hex string or Uint8Array`);
  const o = n.length;
  if (typeof r == "number" && o !== r)
    throw new Error(`${e} expected ${r} bytes, got ${o}`);
  return n;
}
function ir(...e) {
  const t = new Uint8Array(e.reduce((n, o) => n + o.length, 0));
  let r = 0;
  return e.forEach((n) => {
    if (!Qo(n))
      throw new Error("Uint8Array expected");
    t.set(n, r), r += n.length;
  }), t;
}
function N1(e, t) {
  if (e.length !== t.length)
    return !1;
  for (let r = 0; r < e.length; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function Vo(e) {
  if (typeof e != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof e}`);
  return new TextEncoder().encode(e);
}
function j1(e) {
  let t;
  for (t = 0; e > Au; e >>= Go, t += 1)
    ;
  return t;
}
const D1 = (e, t) => e >> BigInt(t) & Go, L1 = (e, t, r) => e | (r ? Go : Au) << BigInt(t), Ra = (e) => (C1 << BigInt(e - 1)) - Go, ys = (e) => new Uint8Array(e), jc = (e) => Uint8Array.from(e);
function Mu(e, t, r) {
  if (typeof e != "number" || e < 2)
    throw new Error("hashLen must be a number");
  if (typeof t != "number" || t < 2)
    throw new Error("qByteLen must be a number");
  if (typeof r != "function")
    throw new Error("hmacFn must be a function");
  let n = ys(e), o = ys(e), s = 0;
  const f = () => {
    n.fill(1), o.fill(0), s = 0;
  }, l = (...g) => r(o, n, ...g), h = (g = ys()) => {
    o = l(jc([0]), g), n = l(), g.length !== 0 && (o = l(jc([1]), g), n = l());
  }, p = () => {
    if (s++ >= 1e3)
      throw new Error("drbg: tried 1000 values");
    let g = 0;
    const E = [];
    for (; g < t; ) {
      n = l();
      const m = n.slice();
      E.push(m), g += n.length;
    }
    return ir(...E);
  };
  return (g, E) => {
    f(), h(g);
    let m;
    for (; !(m = E(p())); )
      h();
    return f(), m;
  };
}
const R1 = {
  bigint: (e) => typeof e == "bigint",
  function: (e) => typeof e == "function",
  boolean: (e) => typeof e == "boolean",
  string: (e) => typeof e == "string",
  isSafeInteger: (e) => Number.isSafeInteger(e),
  array: (e) => Array.isArray(e),
  field: (e, t) => t.Fp.isValid(e),
  hash: (e) => typeof e == "function" && Number.isSafeInteger(e.outputLen)
};
function hi(e, t, r = {}) {
  const n = (o, s, f) => {
    const l = R1[s];
    if (typeof l != "function")
      throw new Error(`Invalid validator "${s}", expected function`);
    const h = e[o];
    if (!(f && h === void 0) && !l(h, e))
      throw new Error(`Invalid param ${String(o)}=${h} (${typeof h}), expected ${s}`);
  };
  for (const [o, s] of Object.entries(t))
    n(o, s, !1);
  for (const [o, s] of Object.entries(r))
    n(o, s, !0);
  return e;
}
const P1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  bytesToHex: si,
  numberToHexUnpadded: Su,
  hexToNumber: Da,
  hexToBytes: ai,
  bytesToNumberBE: qt,
  bytesToNumberLE: La,
  numberToBytesBE: Tn,
  numberToBytesLE: Tu,
  numberToVarBytesBE: O1,
  ensureBytes: It,
  concatBytes: ir,
  equalBytes: N1,
  utf8ToBytes: Vo,
  bitLen: j1,
  bitGet: D1,
  bitSet: L1,
  bitMask: Ra,
  createHmacDrbg: Mu,
  validateObject: hi
}, Symbol.toStringTag, { value: "Module" }));
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const mt = BigInt(0), pt = BigInt(1), Un = BigInt(2), U1 = BigInt(3), Js = BigInt(4), Dc = BigInt(5), Lc = BigInt(8);
BigInt(9);
BigInt(16);
function wt(e, t) {
  const r = e % t;
  return r >= mt ? r : t + r;
}
function B1(e, t, r) {
  if (r <= mt || t < mt)
    throw new Error("Expected power/modulo > 0");
  if (r === pt)
    return mt;
  let n = pt;
  for (; t > mt; )
    t & pt && (n = n * e % r), e = e * e % r, t >>= pt;
  return n;
}
function fr(e, t, r) {
  let n = e;
  for (; t-- > mt; )
    n *= n, n %= r;
  return n;
}
function ea(e, t) {
  if (e === mt || t <= mt)
    throw new Error(`invert: expected positive integers, got n=${e} mod=${t}`);
  let r = wt(e, t), n = t, o = mt, s = pt;
  for (; r !== mt; ) {
    const l = n / r, h = n % r, p = o - s * l;
    n = r, r = h, o = s, s = p;
  }
  if (n !== pt)
    throw new Error("invert: does not exist");
  return wt(o, t);
}
function k1(e) {
  const t = (e - pt) / Un;
  let r, n, o;
  for (r = e - pt, n = 0; r % Un === mt; r /= Un, n++)
    ;
  for (o = Un; o < e && B1(o, t, e) !== e - pt; o++)
    ;
  if (n === 1) {
    const f = (e + pt) / Js;
    return function(h, p) {
      const b = h.pow(p, f);
      if (!h.eql(h.sqr(b), p))
        throw new Error("Cannot find square root");
      return b;
    };
  }
  const s = (r + pt) / Un;
  return function(l, h) {
    if (l.pow(h, t) === l.neg(l.ONE))
      throw new Error("Cannot find square root");
    let p = n, b = l.pow(l.mul(l.ONE, o), r), g = l.pow(h, s), E = l.pow(h, r);
    for (; !l.eql(E, l.ONE); ) {
      if (l.eql(E, l.ZERO))
        return l.ZERO;
      let m = 1;
      for (let w = l.sqr(E); m < p && !l.eql(w, l.ONE); m++)
        w = l.sqr(w);
      const A = l.pow(b, pt << BigInt(p - m - 1));
      b = l.sqr(A), g = l.mul(g, A), E = l.mul(E, b), p = m;
    }
    return g;
  };
}
function z1(e) {
  if (e % Js === U1) {
    const t = (e + pt) / Js;
    return function(n, o) {
      const s = n.pow(o, t);
      if (!n.eql(n.sqr(s), o))
        throw new Error("Cannot find square root");
      return s;
    };
  }
  if (e % Lc === Dc) {
    const t = (e - Dc) / Lc;
    return function(n, o) {
      const s = n.mul(o, Un), f = n.pow(s, t), l = n.mul(o, f), h = n.mul(n.mul(l, Un), f), p = n.mul(l, n.sub(h, n.ONE));
      if (!n.eql(n.sqr(p), o))
        throw new Error("Cannot find square root");
      return p;
    };
  }
  return k1(e);
}
const F1 = [
  "create",
  "isValid",
  "is0",
  "neg",
  "inv",
  "sqrt",
  "sqr",
  "eql",
  "add",
  "sub",
  "mul",
  "pow",
  "div",
  "addN",
  "subN",
  "mulN",
  "sqrN"
];
function Iu(e) {
  const t = {
    ORDER: "bigint",
    MASK: "bigint",
    BYTES: "isSafeInteger",
    BITS: "isSafeInteger"
  }, r = F1.reduce((n, o) => (n[o] = "function", n), t);
  return hi(e, r);
}
function $1(e, t, r) {
  if (r < mt)
    throw new Error("Expected power > 0");
  if (r === mt)
    return e.ONE;
  if (r === pt)
    return t;
  let n = e.ONE, o = t;
  for (; r > mt; )
    r & pt && (n = e.mul(n, o)), o = e.sqr(o), r >>= pt;
  return n;
}
function W1(e, t) {
  const r = new Array(t.length), n = t.reduce((s, f, l) => e.is0(f) ? s : (r[l] = s, e.mul(s, f)), e.ONE), o = e.inv(n);
  return t.reduceRight((s, f, l) => e.is0(f) ? s : (r[l] = e.mul(s, r[l]), e.mul(s, f)), o), r;
}
function Pa(e, t) {
  const r = t !== void 0 ? t : e.toString(2).length, n = Math.ceil(r / 8);
  return { nBitLength: r, nByteLength: n };
}
function q1(e, t, r = !1, n = {}) {
  if (e <= mt)
    throw new Error(`Expected Fp ORDER > 0, got ${e}`);
  const { nBitLength: o, nByteLength: s } = Pa(e, t);
  if (s > 2048)
    throw new Error("Field lengths over 2048 bytes are not supported");
  const f = z1(e), l = Object.freeze({
    ORDER: e,
    BITS: o,
    BYTES: s,
    MASK: Ra(o),
    ZERO: mt,
    ONE: pt,
    create: (h) => wt(h, e),
    isValid: (h) => {
      if (typeof h != "bigint")
        throw new Error(`Invalid field element: expected bigint, got ${typeof h}`);
      return mt <= h && h < e;
    },
    is0: (h) => h === mt,
    isOdd: (h) => (h & pt) === pt,
    neg: (h) => wt(-h, e),
    eql: (h, p) => h === p,
    sqr: (h) => wt(h * h, e),
    add: (h, p) => wt(h + p, e),
    sub: (h, p) => wt(h - p, e),
    mul: (h, p) => wt(h * p, e),
    pow: (h, p) => $1(l, h, p),
    div: (h, p) => wt(h * ea(p, e), e),
    sqrN: (h) => h * h,
    addN: (h, p) => h + p,
    subN: (h, p) => h - p,
    mulN: (h, p) => h * p,
    inv: (h) => ea(h, e),
    sqrt: n.sqrt || ((h) => f(l, h)),
    invertBatch: (h) => W1(l, h),
    cmov: (h, p, b) => b ? p : h,
    toBytes: (h) => r ? Tu(h, s) : Tn(h, s),
    fromBytes: (h) => {
      if (h.length !== s)
        throw new Error(`Fp.fromBytes: expected ${s}, got ${h.length}`);
      return r ? La(h) : qt(h);
    }
  });
  return Object.freeze(l);
}
function Y1(e, t, r = !1) {
  e = It("privateHash", e);
  const n = e.length, o = Pa(t).nByteLength + 8;
  if (o < 24 || n < o || n > 1024)
    throw new Error(`hashToPrivateScalar: expected ${o}-1024 bytes of input, got ${n}`);
  const s = r ? La(e) : qt(e);
  return wt(s, t - pt) + pt;
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const G1 = BigInt(0), gs = BigInt(1);
function Q1(e, t) {
  const r = (o, s) => {
    const f = s.negate();
    return o ? f : s;
  }, n = (o) => {
    const s = Math.ceil(t / o) + 1, f = 2 ** (o - 1);
    return { windows: s, windowSize: f };
  };
  return {
    constTimeNegate: r,
    unsafeLadder(o, s) {
      let f = e.ZERO, l = o;
      for (; s > G1; )
        s & gs && (f = f.add(l)), l = l.double(), s >>= gs;
      return f;
    },
    precomputeWindow(o, s) {
      const { windows: f, windowSize: l } = n(s), h = [];
      let p = o, b = p;
      for (let g = 0; g < f; g++) {
        b = p, h.push(b);
        for (let E = 1; E < l; E++)
          b = b.add(p), h.push(b);
        p = b.double();
      }
      return h;
    },
    wNAF(o, s, f) {
      const { windows: l, windowSize: h } = n(o);
      let p = e.ZERO, b = e.BASE;
      const g = BigInt(2 ** o - 1), E = 2 ** o, m = BigInt(o);
      for (let A = 0; A < l; A++) {
        const w = A * h;
        let S = Number(f & g);
        f >>= m, S > h && (S -= E, f += gs);
        const N = w, P = w + Math.abs(S) - 1, C = A % 2 !== 0, B = S < 0;
        S === 0 ? b = b.add(r(C, s[N])) : p = p.add(r(B, s[P]));
      }
      return { p, f: b };
    },
    wNAFCached(o, s, f, l) {
      const h = o._WINDOW_SIZE || 1;
      let p = s.get(o);
      return p || (p = this.precomputeWindow(o, h), h !== 1 && s.set(o, l(p))), this.wNAF(h, p, f);
    }
  };
}
function Cu(e) {
  return Iu(e.Fp), hi(e, {
    n: "bigint",
    h: "bigint",
    Gx: "field",
    Gy: "field"
  }, {
    nBitLength: "isSafeInteger",
    nByteLength: "isSafeInteger"
  }), Object.freeze({
    ...Pa(e.n, e.nBitLength),
    ...e,
    p: e.Fp.ORDER
  });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function V1(e) {
  const t = Cu(e);
  hi(t, {
    a: "field",
    b: "field"
  }, {
    allowedPrivateKeyLengths: "array",
    wrapPrivateKey: "boolean",
    isTorsionFree: "function",
    clearCofactor: "function",
    allowInfinityPoint: "boolean",
    fromBytes: "function",
    toBytes: "function"
  });
  const { endo: r, Fp: n, a: o } = t;
  if (r) {
    if (!n.eql(o, n.ZERO))
      throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
    if (typeof r != "object" || typeof r.beta != "bigint" || typeof r.splitScalar != "function")
      throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
  }
  return Object.freeze({ ...t });
}
const { bytesToNumberBE: H1, hexToBytes: Z1 } = P1, Bn = {
  Err: class extends Error {
    constructor(t = "") {
      super(t);
    }
  },
  _parseInt(e) {
    const { Err: t } = Bn;
    if (e.length < 2 || e[0] !== 2)
      throw new t("Invalid signature integer tag");
    const r = e[1], n = e.subarray(2, r + 2);
    if (!r || n.length !== r)
      throw new t("Invalid signature integer: wrong length");
    if (n[0] & 128)
      throw new t("Invalid signature integer: negative");
    if (n[0] === 0 && !(n[1] & 128))
      throw new t("Invalid signature integer: unnecessary leading zero");
    return { d: H1(n), l: e.subarray(r + 2) };
  },
  toSig(e) {
    const { Err: t } = Bn, r = typeof e == "string" ? Z1(e) : e;
    if (!(r instanceof Uint8Array))
      throw new Error("ui8a expected");
    let n = r.length;
    if (n < 2 || r[0] != 48)
      throw new t("Invalid signature tag");
    if (r[1] !== n - 2)
      throw new t("Invalid signature: incorrect length");
    const { d: o, l: s } = Bn._parseInt(r.subarray(2)), { d: f, l } = Bn._parseInt(s);
    if (l.length)
      throw new t("Invalid signature: left bytes after parsing");
    return { r: o, s: f };
  },
  hexFromSig(e) {
    const t = (p) => Number.parseInt(p[0], 16) & 8 ? "00" + p : p, r = (p) => {
      const b = p.toString(16);
      return b.length & 1 ? `0${b}` : b;
    }, n = t(r(e.s)), o = t(r(e.r)), s = n.length / 2, f = o.length / 2, l = r(s), h = r(f);
    return `30${r(f + s + 4)}02${h}${o}02${l}${n}`;
  }
}, Tr = BigInt(0), vt = BigInt(1), Gr = BigInt(2), Io = BigInt(3), Rc = BigInt(4);
function K1(e) {
  const t = V1(e), { Fp: r } = t, n = t.toBytes || ((A, w, S) => {
    const N = w.toAffine();
    return ir(Uint8Array.from([4]), r.toBytes(N.x), r.toBytes(N.y));
  }), o = t.fromBytes || ((A) => {
    const w = A.subarray(1), S = r.fromBytes(w.subarray(0, r.BYTES)), N = r.fromBytes(w.subarray(r.BYTES, 2 * r.BYTES));
    return { x: S, y: N };
  });
  function s(A) {
    const { a: w, b: S } = t, N = r.sqr(A), P = r.mul(N, A);
    return r.add(r.add(P, r.mul(A, w)), S);
  }
  if (!r.eql(r.sqr(t.Gy), s(t.Gx)))
    throw new Error("bad generator point: equation left != right");
  function f(A) {
    return typeof A == "bigint" && Tr < A && A < t.n;
  }
  function l(A) {
    if (!f(A))
      throw new Error("Expected valid bigint: 0 < bigint < curve.n");
  }
  function h(A) {
    const { allowedPrivateKeyLengths: w, nByteLength: S, wrapPrivateKey: N, n: P } = t;
    if (w && typeof A != "bigint") {
      if (A instanceof Uint8Array && (A = si(A)), typeof A != "string" || !w.includes(A.length))
        throw new Error("Invalid key");
      A = A.padStart(S * 2, "0");
    }
    let C;
    try {
      C = typeof A == "bigint" ? A : qt(It("private key", A, S));
    } catch {
      throw new Error(`private key must be ${S} bytes, hex or bigint, not ${typeof A}`);
    }
    return N && (C = wt(C, P)), l(C), C;
  }
  const p = /* @__PURE__ */ new Map();
  function b(A) {
    if (!(A instanceof g))
      throw new Error("ProjectivePoint expected");
  }
  class g {
    constructor(w, S, N) {
      if (this.px = w, this.py = S, this.pz = N, w == null || !r.isValid(w))
        throw new Error("x required");
      if (S == null || !r.isValid(S))
        throw new Error("y required");
      if (N == null || !r.isValid(N))
        throw new Error("z required");
    }
    static fromAffine(w) {
      const { x: S, y: N } = w || {};
      if (!w || !r.isValid(S) || !r.isValid(N))
        throw new Error("invalid affine point");
      if (w instanceof g)
        throw new Error("projective point not allowed");
      const P = (C) => r.eql(C, r.ZERO);
      return P(S) && P(N) ? g.ZERO : new g(S, N, r.ONE);
    }
    get x() {
      return this.toAffine().x;
    }
    get y() {
      return this.toAffine().y;
    }
    static normalizeZ(w) {
      const S = r.invertBatch(w.map((N) => N.pz));
      return w.map((N, P) => N.toAffine(S[P])).map(g.fromAffine);
    }
    static fromHex(w) {
      const S = g.fromAffine(o(It("pointHex", w)));
      return S.assertValidity(), S;
    }
    static fromPrivateKey(w) {
      return g.BASE.multiply(h(w));
    }
    _setWindowSize(w) {
      this._WINDOW_SIZE = w, p.delete(this);
    }
    assertValidity() {
      if (this.is0()) {
        if (t.allowInfinityPoint)
          return;
        throw new Error("bad point: ZERO");
      }
      const { x: w, y: S } = this.toAffine();
      if (!r.isValid(w) || !r.isValid(S))
        throw new Error("bad point: x or y not FE");
      const N = r.sqr(S), P = s(w);
      if (!r.eql(N, P))
        throw new Error("bad point: equation left != right");
      if (!this.isTorsionFree())
        throw new Error("bad point: not in prime-order subgroup");
    }
    hasEvenY() {
      const { y: w } = this.toAffine();
      if (r.isOdd)
        return !r.isOdd(w);
      throw new Error("Field doesn't support isOdd");
    }
    equals(w) {
      b(w);
      const { px: S, py: N, pz: P } = this, { px: C, py: B, pz: R } = w, F = r.eql(r.mul(S, R), r.mul(C, P)), Y = r.eql(r.mul(N, R), r.mul(B, P));
      return F && Y;
    }
    negate() {
      return new g(this.px, r.neg(this.py), this.pz);
    }
    double() {
      const { a: w, b: S } = t, N = r.mul(S, Io), { px: P, py: C, pz: B } = this;
      let R = r.ZERO, F = r.ZERO, Y = r.ZERO, K = r.mul(P, P), Me = r.mul(C, C), ye = r.mul(B, B), $ = r.mul(P, C);
      return $ = r.add($, $), Y = r.mul(P, B), Y = r.add(Y, Y), R = r.mul(w, Y), F = r.mul(N, ye), F = r.add(R, F), R = r.sub(Me, F), F = r.add(Me, F), F = r.mul(R, F), R = r.mul($, R), Y = r.mul(N, Y), ye = r.mul(w, ye), $ = r.sub(K, ye), $ = r.mul(w, $), $ = r.add($, Y), Y = r.add(K, K), K = r.add(Y, K), K = r.add(K, ye), K = r.mul(K, $), F = r.add(F, K), ye = r.mul(C, B), ye = r.add(ye, ye), K = r.mul(ye, $), R = r.sub(R, K), Y = r.mul(ye, Me), Y = r.add(Y, Y), Y = r.add(Y, Y), new g(R, F, Y);
    }
    add(w) {
      b(w);
      const { px: S, py: N, pz: P } = this, { px: C, py: B, pz: R } = w;
      let F = r.ZERO, Y = r.ZERO, K = r.ZERO;
      const Me = t.a, ye = r.mul(t.b, Io);
      let $ = r.mul(S, C), G = r.mul(N, B), X = r.mul(P, R), ge = r.add(S, N), L = r.add(C, B);
      ge = r.mul(ge, L), L = r.add($, G), ge = r.sub(ge, L), L = r.add(S, P);
      let _ = r.add(C, R);
      return L = r.mul(L, _), _ = r.add($, X), L = r.sub(L, _), _ = r.add(N, P), F = r.add(B, R), _ = r.mul(_, F), F = r.add(G, X), _ = r.sub(_, F), K = r.mul(Me, L), F = r.mul(ye, X), K = r.add(F, K), F = r.sub(G, K), K = r.add(G, K), Y = r.mul(F, K), G = r.add($, $), G = r.add(G, $), X = r.mul(Me, X), L = r.mul(ye, L), G = r.add(G, X), X = r.sub($, X), X = r.mul(Me, X), L = r.add(L, X), $ = r.mul(G, L), Y = r.add(Y, $), $ = r.mul(_, L), F = r.mul(ge, F), F = r.sub(F, $), $ = r.mul(ge, G), K = r.mul(_, K), K = r.add(K, $), new g(F, Y, K);
    }
    subtract(w) {
      return this.add(w.negate());
    }
    is0() {
      return this.equals(g.ZERO);
    }
    wNAF(w) {
      return m.wNAFCached(this, p, w, (S) => {
        const N = r.invertBatch(S.map((P) => P.pz));
        return S.map((P, C) => P.toAffine(N[C])).map(g.fromAffine);
      });
    }
    multiplyUnsafe(w) {
      const S = g.ZERO;
      if (w === Tr)
        return S;
      if (l(w), w === vt)
        return this;
      const { endo: N } = t;
      if (!N)
        return m.unsafeLadder(this, w);
      let { k1neg: P, k1: C, k2neg: B, k2: R } = N.splitScalar(w), F = S, Y = S, K = this;
      for (; C > Tr || R > Tr; )
        C & vt && (F = F.add(K)), R & vt && (Y = Y.add(K)), K = K.double(), C >>= vt, R >>= vt;
      return P && (F = F.negate()), B && (Y = Y.negate()), Y = new g(r.mul(Y.px, N.beta), Y.py, Y.pz), F.add(Y);
    }
    multiply(w) {
      l(w);
      let S = w, N, P;
      const { endo: C } = t;
      if (C) {
        const { k1neg: B, k1: R, k2neg: F, k2: Y } = C.splitScalar(S);
        let { p: K, f: Me } = this.wNAF(R), { p: ye, f: $ } = this.wNAF(Y);
        K = m.constTimeNegate(B, K), ye = m.constTimeNegate(F, ye), ye = new g(r.mul(ye.px, C.beta), ye.py, ye.pz), N = K.add(ye), P = Me.add($);
      } else {
        const { p: B, f: R } = this.wNAF(S);
        N = B, P = R;
      }
      return g.normalizeZ([N, P])[0];
    }
    multiplyAndAddUnsafe(w, S, N) {
      const P = g.BASE, C = (R, F) => F === Tr || F === vt || !R.equals(P) ? R.multiplyUnsafe(F) : R.multiply(F), B = C(this, S).add(C(w, N));
      return B.is0() ? void 0 : B;
    }
    toAffine(w) {
      const { px: S, py: N, pz: P } = this, C = this.is0();
      w == null && (w = C ? r.ONE : r.inv(P));
      const B = r.mul(S, w), R = r.mul(N, w), F = r.mul(P, w);
      if (C)
        return { x: r.ZERO, y: r.ZERO };
      if (!r.eql(F, r.ONE))
        throw new Error("invZ was invalid");
      return { x: B, y: R };
    }
    isTorsionFree() {
      const { h: w, isTorsionFree: S } = t;
      if (w === vt)
        return !0;
      if (S)
        return S(g, this);
      throw new Error("isTorsionFree() has not been declared for the elliptic curve");
    }
    clearCofactor() {
      const { h: w, clearCofactor: S } = t;
      return w === vt ? this : S ? S(g, this) : this.multiplyUnsafe(t.h);
    }
    toRawBytes(w = !0) {
      return this.assertValidity(), n(g, this, w);
    }
    toHex(w = !0) {
      return si(this.toRawBytes(w));
    }
  }
  g.BASE = new g(t.Gx, t.Gy, r.ONE), g.ZERO = new g(r.ZERO, r.ONE, r.ZERO);
  const E = t.nBitLength, m = Q1(g, t.endo ? Math.ceil(E / 2) : E);
  return {
    CURVE: t,
    ProjectivePoint: g,
    normPrivateKeyToScalar: h,
    weierstrassEquation: s,
    isWithinCurveOrder: f
  };
}
function X1(e) {
  const t = Cu(e);
  return hi(t, {
    hash: "hash",
    hmac: "function",
    randomBytes: "function"
  }, {
    bits2int: "function",
    bits2int_modN: "function",
    lowS: "boolean"
  }), Object.freeze({ lowS: !0, ...t });
}
function J1(e) {
  const t = X1(e), { Fp: r, n } = t, o = r.BYTES + 1, s = 2 * r.BYTES + 1;
  function f(L) {
    return Tr < L && L < r.ORDER;
  }
  function l(L) {
    return wt(L, n);
  }
  function h(L) {
    return ea(L, n);
  }
  const { ProjectivePoint: p, normPrivateKeyToScalar: b, weierstrassEquation: g, isWithinCurveOrder: E } = K1({
    ...t,
    toBytes(L, _, q) {
      const se = _.toAffine(), ae = r.toBytes(se.x), Ee = ir;
      return q ? Ee(Uint8Array.from([_.hasEvenY() ? 2 : 3]), ae) : Ee(Uint8Array.from([4]), ae, r.toBytes(se.y));
    },
    fromBytes(L) {
      const _ = L.length, q = L[0], se = L.subarray(1);
      if (_ === o && (q === 2 || q === 3)) {
        const ae = qt(se);
        if (!f(ae))
          throw new Error("Point is not on curve");
        const Ee = g(ae);
        let Se = r.sqrt(Ee);
        const Be = (Se & vt) === vt;
        return (q & 1) === 1 !== Be && (Se = r.neg(Se)), { x: ae, y: Se };
      } else if (_ === s && q === 4) {
        const ae = r.fromBytes(se.subarray(0, r.BYTES)), Ee = r.fromBytes(se.subarray(r.BYTES, 2 * r.BYTES));
        return { x: ae, y: Ee };
      } else
        throw new Error(`Point of length ${_} was invalid. Expected ${o} compressed bytes or ${s} uncompressed bytes`);
    }
  }), m = (L) => si(Tn(L, t.nByteLength));
  function A(L) {
    const _ = n >> vt;
    return L > _;
  }
  function w(L) {
    return A(L) ? l(-L) : L;
  }
  const S = (L, _, q) => qt(L.slice(_, q));
  class N {
    constructor(_, q, se) {
      this.r = _, this.s = q, this.recovery = se, this.assertValidity();
    }
    static fromCompact(_) {
      const q = t.nByteLength;
      return _ = It("compactSignature", _, q * 2), new N(S(_, 0, q), S(_, q, 2 * q));
    }
    static fromDER(_) {
      const { r: q, s: se } = Bn.toSig(It("DER", _));
      return new N(q, se);
    }
    assertValidity() {
      if (!E(this.r))
        throw new Error("r must be 0 < r < CURVE.n");
      if (!E(this.s))
        throw new Error("s must be 0 < s < CURVE.n");
    }
    addRecoveryBit(_) {
      return new N(this.r, this.s, _);
    }
    recoverPublicKey(_) {
      const { r: q, s: se, recovery: ae } = this, Ee = Y(It("msgHash", _));
      if (ae == null || ![0, 1, 2, 3].includes(ae))
        throw new Error("recovery id invalid");
      const Se = ae === 2 || ae === 3 ? q + t.n : q;
      if (Se >= r.ORDER)
        throw new Error("recovery id 2 or 3 invalid");
      const Be = (ae & 1) === 0 ? "02" : "03", Re = p.fromHex(Be + m(Se)), Fe = h(Se), be = l(-Ee * Fe), $e = l(se * Fe), lt = p.BASE.multiplyAndAddUnsafe(Re, be, $e);
      if (!lt)
        throw new Error("point at infinify");
      return lt.assertValidity(), lt;
    }
    hasHighS() {
      return A(this.s);
    }
    normalizeS() {
      return this.hasHighS() ? new N(this.r, l(-this.s), this.recovery) : this;
    }
    toDERRawBytes() {
      return ai(this.toDERHex());
    }
    toDERHex() {
      return Bn.hexFromSig({ r: this.r, s: this.s });
    }
    toCompactRawBytes() {
      return ai(this.toCompactHex());
    }
    toCompactHex() {
      return m(this.r) + m(this.s);
    }
  }
  const P = {
    isValidPrivateKey(L) {
      try {
        return b(L), !0;
      } catch {
        return !1;
      }
    },
    normPrivateKeyToScalar: b,
    randomPrivateKey: () => {
      const L = t.randomBytes(r.BYTES + 8), _ = Y1(L, n);
      return Tn(_, t.nByteLength);
    },
    precompute(L = 8, _ = p.BASE) {
      return _._setWindowSize(L), _.multiply(BigInt(3)), _;
    }
  };
  function C(L, _ = !0) {
    return p.fromPrivateKey(L).toRawBytes(_);
  }
  function B(L) {
    const _ = L instanceof Uint8Array, q = typeof L == "string", se = (_ || q) && L.length;
    return _ ? se === o || se === s : q ? se === 2 * o || se === 2 * s : L instanceof p;
  }
  function R(L, _, q = !0) {
    if (B(L))
      throw new Error("first arg must be private key");
    if (!B(_))
      throw new Error("second arg must be public key");
    return p.fromHex(_).multiply(b(L)).toRawBytes(q);
  }
  const F = t.bits2int || function(L) {
    const _ = qt(L), q = L.length * 8 - t.nBitLength;
    return q > 0 ? _ >> BigInt(q) : _;
  }, Y = t.bits2int_modN || function(L) {
    return l(F(L));
  }, K = Ra(t.nBitLength);
  function Me(L) {
    if (typeof L != "bigint")
      throw new Error("bigint expected");
    if (!(Tr <= L && L < K))
      throw new Error(`bigint expected < 2^${t.nBitLength}`);
    return Tn(L, t.nByteLength);
  }
  function ye(L, _, q = $) {
    if (["recovered", "canonical"].some((dt) => dt in q))
      throw new Error("sign() legacy options not supported");
    const { hash: se, randomBytes: ae } = t;
    let { lowS: Ee, prehash: Se, extraEntropy: Be } = q;
    Ee == null && (Ee = !0), L = It("msgHash", L), Se && (L = It("prehashed msgHash", se(L)));
    const Re = Y(L), Fe = b(_), be = [Me(Fe), Me(Re)];
    if (Be != null) {
      const dt = Be === !0 ? ae(r.BYTES) : Be;
      be.push(It("extraEntropy", dt, r.BYTES));
    }
    const $e = ir(...be), lt = Re;
    function St(dt) {
      const ht = F(dt);
      if (!E(ht))
        return;
      const _r = h(ht), ct = p.BASE.multiply(ht).toAffine(), Qt = l(ct.x);
      if (Qt === Tr)
        return;
      const Or = l(_r * l(lt + Qt * Fe));
      if (Or === Tr)
        return;
      let hr = (ct.x === Qt ? 0 : 2) | Number(ct.y & vt), pr = Or;
      return Ee && A(Or) && (pr = w(Or), hr ^= 1), new N(Qt, pr, hr);
    }
    return { seed: $e, k2sig: St };
  }
  const $ = { lowS: t.lowS, prehash: !1 }, G = { lowS: t.lowS, prehash: !1 };
  function X(L, _, q = $) {
    const { seed: se, k2sig: ae } = ye(L, _, q);
    return Mu(t.hash.outputLen, t.nByteLength, t.hmac)(se, ae);
  }
  p.BASE._setWindowSize(8);
  function ge(L, _, q, se = G) {
    const ae = L;
    if (_ = It("msgHash", _), q = It("publicKey", q), "strict" in se)
      throw new Error("options.strict was renamed to lowS");
    const { lowS: Ee, prehash: Se } = se;
    let Be, Re;
    try {
      if (typeof ae == "string" || ae instanceof Uint8Array)
        try {
          Be = N.fromDER(ae);
        } catch (ct) {
          if (!(ct instanceof Bn.Err))
            throw ct;
          Be = N.fromCompact(ae);
        }
      else if (typeof ae == "object" && typeof ae.r == "bigint" && typeof ae.s == "bigint") {
        const { r: ct, s: Qt } = ae;
        Be = new N(ct, Qt);
      } else
        throw new Error("PARSE");
      Re = p.fromHex(q);
    } catch (ct) {
      if (ct.message === "PARSE")
        throw new Error("signature must be Signature instance, Uint8Array or hex string");
      return !1;
    }
    if (Ee && Be.hasHighS())
      return !1;
    Se && (_ = t.hash(_));
    const { r: Fe, s: be } = Be, $e = Y(_), lt = h(be), St = l($e * lt), dt = l(Fe * lt), ht = p.BASE.multiplyAndAddUnsafe(Re, St, dt)?.toAffine();
    return ht ? l(ht.x) === Fe : !1;
  }
  return {
    CURVE: t,
    getPublicKey: C,
    getSharedSecret: R,
    sign: X,
    verify: ge,
    ProjectivePoint: p,
    Signature: N,
    utils: P
  };
}
function ep(e, t) {
  const r = e.ORDER;
  let n = Tr;
  for (let E = r - vt; E % Gr === Tr; E /= Gr)
    n += vt;
  const o = n, s = (r - vt) / Gr ** o, f = (s - vt) / Gr, l = Gr ** o - vt, h = Gr ** (o - vt), p = e.pow(t, s), b = e.pow(t, (s + vt) / Gr);
  let g = (E, m) => {
    let A = p, w = e.pow(m, l), S = e.sqr(w);
    S = e.mul(S, m);
    let N = e.mul(E, S);
    N = e.pow(N, f), N = e.mul(N, w), w = e.mul(N, m), S = e.mul(N, E);
    let P = e.mul(S, w);
    N = e.pow(P, h);
    let C = e.eql(N, e.ONE);
    w = e.mul(S, b), N = e.mul(P, A), S = e.cmov(w, S, C), P = e.cmov(N, P, C);
    for (let B = o; B > vt; B--) {
      let R = Gr ** (B - Gr), F = e.pow(P, R);
      const Y = e.eql(F, e.ONE);
      w = e.mul(S, A), A = e.mul(A, A), F = e.mul(P, A), S = e.cmov(w, S, Y), P = e.cmov(F, P, Y);
    }
    return { isValid: C, value: S };
  };
  if (e.ORDER % Rc === Io) {
    const E = (e.ORDER - Io) / Rc, m = e.sqrt(e.neg(t));
    g = (A, w) => {
      let S = e.sqr(w);
      const N = e.mul(A, w);
      S = e.mul(S, N);
      let P = e.pow(S, E);
      P = e.mul(P, N);
      const C = e.mul(P, m), B = e.mul(e.sqr(P), w), R = e.eql(B, A);
      let F = e.cmov(C, P, R);
      return { isValid: R, value: F };
    };
  }
  return g;
}
function tp(e, t) {
  if (Iu(e), !e.isValid(t.A) || !e.isValid(t.B) || !e.isValid(t.Z))
    throw new Error("mapToCurveSimpleSWU: invalid opts");
  const r = ep(e, t.Z);
  if (!e.isOdd)
    throw new Error("Fp.isOdd is not implemented!");
  return (n) => {
    let o, s, f, l, h, p, b, g;
    o = e.sqr(n), o = e.mul(o, t.Z), s = e.sqr(o), s = e.add(s, o), f = e.add(s, e.ONE), f = e.mul(f, t.B), l = e.cmov(t.Z, e.neg(s), !e.eql(s, e.ZERO)), l = e.mul(l, t.A), s = e.sqr(f), p = e.sqr(l), h = e.mul(p, t.A), s = e.add(s, h), s = e.mul(s, f), p = e.mul(p, l), h = e.mul(p, t.B), s = e.add(s, h), b = e.mul(o, f);
    const { isValid: E, value: m } = r(s, p);
    g = e.mul(o, n), g = e.mul(g, m), b = e.cmov(b, f, E), g = e.cmov(g, m, E);
    const A = e.isOdd(n) === e.isOdd(g);
    return g = e.cmov(e.neg(g), g, A), b = e.div(b, l), { x: b, y: g };
  };
}
function rp(e) {
  if (e instanceof Uint8Array)
    return e;
  if (typeof e == "string")
    return Vo(e);
  throw new Error("DST must be Uint8Array or string");
}
const np = qt;
function vn(e, t) {
  if (e < 0 || e >= 1 << 8 * t)
    throw new Error(`bad I2OSP call: value=${e} length=${t}`);
  const r = Array.from({ length: t }).fill(0);
  for (let n = t - 1; n >= 0; n--)
    r[n] = e & 255, e >>>= 8;
  return new Uint8Array(r);
}
function ip(e, t) {
  const r = new Uint8Array(e.length);
  for (let n = 0; n < e.length; n++)
    r[n] = e[n] ^ t[n];
  return r;
}
function _i(e) {
  if (!(e instanceof Uint8Array))
    throw new Error("Uint8Array expected");
}
function Ua(e) {
  if (!Number.isSafeInteger(e))
    throw new Error("number expected");
}
function op(e, t, r, n) {
  _i(e), _i(t), Ua(r), t.length > 255 && (t = n(ir(Vo("H2C-OVERSIZE-DST-"), t)));
  const { outputLen: o, blockLen: s } = n, f = Math.ceil(r / o);
  if (f > 255)
    throw new Error("Invalid xmd length");
  const l = ir(t, vn(t.length, 1)), h = vn(0, s), p = vn(r, 2), b = new Array(f), g = n(ir(h, e, p, vn(0, 1), l));
  b[0] = n(ir(g, vn(1, 1), l));
  for (let m = 1; m <= f; m++) {
    const A = [ip(g, b[m - 1]), vn(m + 1, 1), l];
    b[m] = n(ir(...A));
  }
  return ir(...b).slice(0, r);
}
function sp(e, t, r, n, o) {
  if (_i(e), _i(t), Ua(r), t.length > 255) {
    const s = Math.ceil(2 * n / 8);
    t = o.create({ dkLen: s }).update(Vo("H2C-OVERSIZE-DST-")).update(t).digest();
  }
  if (r > 65535 || t.length > 255)
    throw new Error("expand_message_xof: invalid lenInBytes");
  return o.create({ dkLen: r }).update(e).update(vn(r, 2)).update(t).update(vn(t.length, 1)).digest();
}
function Pc(e, t, r) {
  hi(r, {
    DST: "string",
    p: "bigint",
    m: "isSafeInteger",
    k: "isSafeInteger",
    hash: "hash"
  });
  const { p: n, k: o, m: s, hash: f, expand: l, DST: h } = r;
  _i(e), Ua(t);
  const p = rp(h), b = n.toString(2).length, g = Math.ceil((b + o) / 8), E = t * s * g;
  let m;
  if (l === "xmd")
    m = op(e, p, E, f);
  else if (l === "xof")
    m = sp(e, p, E, o, f);
  else if (l === "_internal_pass")
    m = e;
  else
    throw new Error('expand must be "xmd" or "xof"');
  const A = new Array(t);
  for (let w = 0; w < t; w++) {
    const S = new Array(s);
    for (let N = 0; N < s; N++) {
      const P = g * (N + w * s), C = m.subarray(P, P + g);
      S[N] = wt(np(C), n);
    }
    A[w] = S;
  }
  return A;
}
function ap(e, t) {
  const r = t.map((n) => Array.from(n).reverse());
  return (n, o) => {
    const [s, f, l, h] = r.map((p) => p.reduce((b, g) => e.add(e.mul(b, n), g)));
    return n = e.div(s, f), o = e.mul(o, e.div(l, h)), { x: n, y: o };
  };
}
function cp(e, t, r) {
  if (typeof t != "function")
    throw new Error("mapToCurve() must be defined");
  return {
    hashToCurve(n, o) {
      const s = Pc(n, 2, { ...r, DST: r.DST, ...o }), f = e.fromAffine(t(s[0])), l = e.fromAffine(t(s[1])), h = f.add(l).clearCofactor();
      return h.assertValidity(), h;
    },
    encodeToCurve(n, o) {
      const s = Pc(n, 1, { ...r, DST: r.encodeDST, ...o }), f = e.fromAffine(t(s[0])).clearCofactor();
      return f.assertValidity(), f;
    }
  };
}
class _u extends Yo {
  constructor(t, r) {
    super(), this.finished = !1, this.destroyed = !1, nr.hash(t);
    const n = Kr(r);
    if (this.iHash = t.create(), typeof this.iHash.update != "function")
      throw new TypeError("Expected instance of class which extends utils.Hash");
    this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
    const o = this.blockLen, s = new Uint8Array(o);
    s.set(n.length > o ? t.create().update(n).digest() : n);
    for (let f = 0; f < s.length; f++)
      s[f] ^= 54;
    this.iHash.update(s), this.oHash = t.create();
    for (let f = 0; f < s.length; f++)
      s[f] ^= 106;
    this.oHash.update(s), s.fill(0);
  }
  update(t) {
    return nr.exists(this), this.iHash.update(t), this;
  }
  digestInto(t) {
    nr.exists(this), nr.bytes(t, this.outputLen), this.finished = !0, this.iHash.digestInto(t), this.oHash.update(t), this.oHash.digestInto(t), this.destroy();
  }
  digest() {
    const t = new Uint8Array(this.oHash.outputLen);
    return this.digestInto(t), t;
  }
  _cloneInto(t) {
    t || (t = Object.create(Object.getPrototypeOf(this), {}));
    const { oHash: r, iHash: n, finished: o, destroyed: s, blockLen: f, outputLen: l } = this;
    return t = t, t.finished = o, t.destroyed = s, t.blockLen = f, t.outputLen = l, t.oHash = r._cloneInto(t.oHash), t.iHash = n._cloneInto(t.iHash), t;
  }
  destroy() {
    this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
  }
}
const Ou = (e, t, r) => new _u(e, t).update(r).digest();
Ou.create = (e, t) => new _u(e, t);
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
function fp(e) {
  return {
    hash: e,
    hmac: (t, ...r) => Ou(e, t, gu(...r)),
    randomBytes: _a
  };
}
function up(e, t) {
  const r = (n) => J1({ ...e, ...fp(n) });
  return Object.freeze({ ...r(t), create: r });
}
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const Ho = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f"), Co = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141"), Nu = BigInt(1), _o = BigInt(2), Uc = (e, t) => (e + t / _o) / t;
function ju(e) {
  const t = Ho, r = BigInt(3), n = BigInt(6), o = BigInt(11), s = BigInt(22), f = BigInt(23), l = BigInt(44), h = BigInt(88), p = e * e * e % t, b = p * p * e % t, g = fr(b, r, t) * b % t, E = fr(g, r, t) * b % t, m = fr(E, _o, t) * p % t, A = fr(m, o, t) * m % t, w = fr(A, s, t) * A % t, S = fr(w, l, t) * w % t, N = fr(S, h, t) * S % t, P = fr(N, l, t) * w % t, C = fr(P, r, t) * b % t, B = fr(C, f, t) * A % t, R = fr(B, n, t) * p % t, F = fr(R, _o, t);
  if (!In.eql(In.sqr(F), e))
    throw new Error("Cannot find square root");
  return F;
}
const In = q1(Ho, void 0, void 0, { sqrt: ju }), Ui = up({
  a: BigInt(0),
  b: BigInt(7),
  Fp: In,
  n: Co,
  Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
  Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
  h: BigInt(1),
  lowS: !0,
  endo: {
    beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
    splitScalar: (e) => {
      const t = Co, r = BigInt("0x3086d221a7d46bcde86c90e49284eb15"), n = -Nu * BigInt("0xe4437ed6010e88286f547fa90abfe4c3"), o = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8"), s = r, f = BigInt("0x100000000000000000000000000000000"), l = Uc(s * e, t), h = Uc(-n * e, t);
      let p = wt(e - l * r - h * o, t), b = wt(-l * n - h * s, t);
      const g = p > f, E = b > f;
      if (g && (p = t - p), E && (b = t - b), p > f || b > f)
        throw new Error("splitScalar: Endomorphism failed, k=" + e);
      return { k1neg: g, k1: p, k2neg: E, k2: b };
    }
  }
}, oi), Zo = BigInt(0), Du = (e) => typeof e == "bigint" && Zo < e && e < Ho, lp = (e) => typeof e == "bigint" && Zo < e && e < Co, Bc = {};
function Oo(e, ...t) {
  let r = Bc[e];
  if (r === void 0) {
    const n = oi(Uint8Array.from(e, (o) => o.charCodeAt(0)));
    r = ir(n, n), Bc[e] = r;
  }
  return oi(ir(r, ...t));
}
const Ba = (e) => e.toRawBytes(!0).slice(1), ta = (e) => Tn(e, 32), vs = (e) => wt(e, Ho), Oi = (e) => wt(e, Co), ka = Ui.ProjectivePoint, dp = (e, t, r) => ka.BASE.multiplyAndAddUnsafe(e, t, r);
function ra(e) {
  let t = Ui.utils.normPrivateKeyToScalar(e), r = ka.fromPrivateKey(t);
  return { scalar: r.hasEvenY() ? t : Oi(-t), bytes: Ba(r) };
}
function Lu(e) {
  if (!Du(e))
    throw new Error("bad x: need 0 < x < p");
  const t = vs(e * e), r = vs(t * e + BigInt(7));
  let n = ju(r);
  n % _o !== Zo && (n = vs(-n));
  const o = new ka(e, n, Nu);
  return o.assertValidity(), o;
}
function Ru(...e) {
  return Oi(qt(Oo("BIP0340/challenge", ...e)));
}
function hp(e) {
  return ra(e).bytes;
}
function pp(e, t, r = _a(32)) {
  const n = It("message", e), { bytes: o, scalar: s } = ra(t), f = It("auxRand", r, 32), l = ta(s ^ qt(Oo("BIP0340/aux", f))), h = Oo("BIP0340/nonce", l, o, n), p = Oi(qt(h));
  if (p === Zo)
    throw new Error("sign failed: k is zero");
  const { bytes: b, scalar: g } = ra(p), E = Ru(b, o, n), m = new Uint8Array(64);
  if (m.set(b, 0), m.set(ta(Oi(g + E * s)), 32), !Pu(m, n, o))
    throw new Error("sign: Invalid signature produced");
  return m;
}
function Pu(e, t, r) {
  const n = It("signature", e, 64), o = It("message", t), s = It("publicKey", r, 32);
  try {
    const f = Lu(qt(s)), l = qt(n.subarray(0, 32));
    if (!Du(l))
      return !1;
    const h = qt(n.subarray(32, 64));
    if (!lp(h))
      return !1;
    const p = Ru(ta(l), Ba(f), o), b = dp(f, h, Oi(-p));
    return !(!b || !b.hasEvenY() || b.toAffine().x !== l);
  } catch {
    return !1;
  }
}
Ui.utils.randomPrivateKey;
const yp = ap(In, [
  [
    "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
    "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
    "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
    "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
  ],
  [
    "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
    "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
    "0x0000000000000000000000000000000000000000000000000000000000000001"
  ],
  [
    "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
    "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
    "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
    "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
  ],
  [
    "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
    "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
    "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
    "0x0000000000000000000000000000000000000000000000000000000000000001"
  ]
].map((e) => e.map((t) => BigInt(t)))), gp = tp(In, {
  A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
  B: BigInt("1771"),
  Z: In.create(BigInt("-11"))
});
cp(Ui.ProjectivePoint, (e) => {
  const { x: t, y: r } = gp(In.create(e[0]));
  return yp(t, r);
}, {
  DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
  encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
  p: In.ORDER,
  m: 1,
  k: 128,
  expand: "xmd",
  hash: oi
});
var or = {}, Ct = {};
Object.defineProperty(Ct, "__esModule", { value: !0 });
Ct.output = Ct.exists = Ct.hash = Ct.bytes = Ct.bool = Ct.number = void 0;
function No(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
Ct.number = No;
function Uu(e) {
  if (typeof e != "boolean")
    throw new Error(`Expected boolean, not ${e}`);
}
Ct.bool = Uu;
function za(e, ...t) {
  if (!(e instanceof Uint8Array))
    throw new TypeError("Expected Uint8Array");
  if (t.length > 0 && !t.includes(e.length))
    throw new TypeError(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
}
Ct.bytes = za;
function Bu(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  No(e.outputLen), No(e.blockLen);
}
Ct.hash = Bu;
function ku(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
Ct.exists = ku;
function zu(e, t) {
  za(e);
  const r = t.outputLen;
  if (e.length < r)
    throw new Error(`digestInto() expects output buffer of length at least ${r}`);
}
Ct.output = zu;
const vp = {
  number: No,
  bool: Uu,
  bytes: za,
  hash: Bu,
  exists: ku,
  output: zu
};
Ct.default = vp;
var ci = {}, Fu = {}, Fa = {};
const bp = /* @__PURE__ */ ui(Uh);
(function(e) {
  /*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  Object.defineProperty(e, "__esModule", { value: !0 }), e.randomBytes = e.wrapConstructorWithOpts = e.wrapConstructor = e.checkOpts = e.Hash = e.concatBytes = e.toBytes = e.utf8ToBytes = e.asyncLoop = e.nextTick = e.hexToBytes = e.bytesToHex = e.isLE = e.rotr = e.createView = e.u32 = e.u8 = void 0;
  const t = bp, r = (B) => new Uint8Array(B.buffer, B.byteOffset, B.byteLength);
  e.u8 = r;
  const n = (B) => new Uint32Array(B.buffer, B.byteOffset, Math.floor(B.byteLength / 4));
  e.u32 = n;
  const o = (B) => new DataView(B.buffer, B.byteOffset, B.byteLength);
  e.createView = o;
  const s = (B, R) => B << 32 - R | B >>> R;
  if (e.rotr = s, e.isLE = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68, !e.isLE)
    throw new Error("Non little-endian hardware is not supported");
  const f = Array.from({ length: 256 }, (B, R) => R.toString(16).padStart(2, "0"));
  function l(B) {
    if (!(B instanceof Uint8Array))
      throw new Error("Uint8Array expected");
    let R = "";
    for (let F = 0; F < B.length; F++)
      R += f[B[F]];
    return R;
  }
  e.bytesToHex = l;
  function h(B) {
    if (typeof B != "string")
      throw new TypeError("hexToBytes: expected string, got " + typeof B);
    if (B.length % 2)
      throw new Error("hexToBytes: received invalid unpadded hex");
    const R = new Uint8Array(B.length / 2);
    for (let F = 0; F < R.length; F++) {
      const Y = F * 2, K = B.slice(Y, Y + 2), Me = Number.parseInt(K, 16);
      if (Number.isNaN(Me) || Me < 0)
        throw new Error("Invalid byte sequence");
      R[F] = Me;
    }
    return R;
  }
  e.hexToBytes = h;
  const p = async () => {
  };
  e.nextTick = p;
  async function b(B, R, F) {
    let Y = Date.now();
    for (let K = 0; K < B; K++) {
      F(K);
      const Me = Date.now() - Y;
      Me >= 0 && Me < R || (await (0, e.nextTick)(), Y += Me);
    }
  }
  e.asyncLoop = b;
  function g(B) {
    if (typeof B != "string")
      throw new TypeError(`utf8ToBytes expected string, got ${typeof B}`);
    return new TextEncoder().encode(B);
  }
  e.utf8ToBytes = g;
  function E(B) {
    if (typeof B == "string" && (B = g(B)), !(B instanceof Uint8Array))
      throw new TypeError(`Expected input type is Uint8Array (got ${typeof B})`);
    return B;
  }
  e.toBytes = E;
  function m(...B) {
    if (!B.every((Y) => Y instanceof Uint8Array))
      throw new Error("Uint8Array list expected");
    if (B.length === 1)
      return B[0];
    const R = B.reduce((Y, K) => Y + K.length, 0), F = new Uint8Array(R);
    for (let Y = 0, K = 0; Y < B.length; Y++) {
      const Me = B[Y];
      F.set(Me, K), K += Me.length;
    }
    return F;
  }
  e.concatBytes = m;
  class A {
    clone() {
      return this._cloneInto();
    }
  }
  e.Hash = A;
  const w = (B) => Object.prototype.toString.call(B) === "[object Object]" && B.constructor === Object;
  function S(B, R) {
    if (R !== void 0 && (typeof R != "object" || !w(R)))
      throw new TypeError("Options should be object or undefined");
    return Object.assign(B, R);
  }
  e.checkOpts = S;
  function N(B) {
    const R = (Y) => B().update(E(Y)).digest(), F = B();
    return R.outputLen = F.outputLen, R.blockLen = F.blockLen, R.create = () => B(), R;
  }
  e.wrapConstructor = N;
  function P(B) {
    const R = (Y, K) => B(K).update(E(Y)).digest(), F = B({});
    return R.outputLen = F.outputLen, R.blockLen = F.blockLen, R.create = (Y) => B(Y), R;
  }
  e.wrapConstructorWithOpts = P;
  function C(B = 32) {
    if (t.crypto && typeof t.crypto.getRandomValues == "function")
      return t.crypto.getRandomValues(new Uint8Array(B));
    throw new Error("crypto.getRandomValues must be defined");
  }
  e.randomBytes = C;
})(Fa);
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.hmac = void 0;
  const t = Ct, r = Fa;
  class n extends r.Hash {
    constructor(f, l) {
      super(), this.finished = !1, this.destroyed = !1, t.default.hash(f);
      const h = (0, r.toBytes)(l);
      if (this.iHash = f.create(), typeof this.iHash.update != "function")
        throw new TypeError("Expected instance of class which extends utils.Hash");
      this.blockLen = this.iHash.blockLen, this.outputLen = this.iHash.outputLen;
      const p = this.blockLen, b = new Uint8Array(p);
      b.set(h.length > p ? f.create().update(h).digest() : h);
      for (let g = 0; g < b.length; g++)
        b[g] ^= 54;
      this.iHash.update(b), this.oHash = f.create();
      for (let g = 0; g < b.length; g++)
        b[g] ^= 106;
      this.oHash.update(b), b.fill(0);
    }
    update(f) {
      return t.default.exists(this), this.iHash.update(f), this;
    }
    digestInto(f) {
      t.default.exists(this), t.default.bytes(f, this.outputLen), this.finished = !0, this.iHash.digestInto(f), this.oHash.update(f), this.oHash.digestInto(f), this.destroy();
    }
    digest() {
      const f = new Uint8Array(this.oHash.outputLen);
      return this.digestInto(f), f;
    }
    _cloneInto(f) {
      f || (f = Object.create(Object.getPrototypeOf(this), {}));
      const { oHash: l, iHash: h, finished: p, destroyed: b, blockLen: g, outputLen: E } = this;
      return f = f, f.finished = p, f.destroyed = b, f.blockLen = g, f.outputLen = E, f.oHash = l._cloneInto(f.oHash), f.iHash = h._cloneInto(f.iHash), f;
    }
    destroy() {
      this.destroyed = !0, this.oHash.destroy(), this.iHash.destroy();
    }
  }
  const o = (s, f, l) => new n(s, f).update(l).digest();
  e.hmac = o, e.hmac.create = (s, f) => new n(s, f);
})(Fu);
Object.defineProperty(ci, "__esModule", { value: !0 });
ci.pbkdf2Async = ci.pbkdf2 = void 0;
const Hi = Ct, xp = Fu, ni = Fa;
function $u(e, t, r, n) {
  Hi.default.hash(e);
  const o = (0, ni.checkOpts)({ dkLen: 32, asyncTick: 10 }, n), { c: s, dkLen: f, asyncTick: l } = o;
  if (Hi.default.number(s), Hi.default.number(f), Hi.default.number(l), s < 1)
    throw new Error("PBKDF2: iterations (c) should be >= 1");
  const h = (0, ni.toBytes)(t), p = (0, ni.toBytes)(r), b = new Uint8Array(f), g = xp.hmac.create(e, h), E = g._cloneInto().update(p);
  return { c: s, dkLen: f, asyncTick: l, DK: b, PRF: g, PRFSalt: E };
}
function Wu(e, t, r, n, o) {
  return e.destroy(), t.destroy(), n && n.destroy(), o.fill(0), r;
}
function wp(e, t, r, n) {
  const { c: o, dkLen: s, DK: f, PRF: l, PRFSalt: h } = $u(e, t, r, n);
  let p;
  const b = new Uint8Array(4), g = (0, ni.createView)(b), E = new Uint8Array(l.outputLen);
  for (let m = 1, A = 0; A < s; m++, A += l.outputLen) {
    const w = f.subarray(A, A + l.outputLen);
    g.setInt32(0, m, !1), (p = h._cloneInto(p)).update(b).digestInto(E), w.set(E.subarray(0, w.length));
    for (let S = 1; S < o; S++) {
      l._cloneInto(p).update(E).digestInto(E);
      for (let N = 0; N < w.length; N++)
        w[N] ^= E[N];
    }
  }
  return Wu(l, h, f, p, E);
}
ci.pbkdf2 = wp;
async function mp(e, t, r, n) {
  const { c: o, dkLen: s, asyncTick: f, DK: l, PRF: h, PRFSalt: p } = $u(e, t, r, n);
  let b;
  const g = new Uint8Array(4), E = (0, ni.createView)(g), m = new Uint8Array(h.outputLen);
  for (let A = 1, w = 0; w < s; A++, w += h.outputLen) {
    const S = l.subarray(w, w + h.outputLen);
    E.setInt32(0, A, !1), (b = p._cloneInto(b)).update(g).digestInto(m), S.set(m.subarray(0, S.length)), await (0, ni.asyncLoop)(o - 1, f, (N) => {
      h._cloneInto(b).update(m).digestInto(m);
      for (let P = 0; P < S.length; P++)
        S[P] ^= m[P];
    });
  }
  return Wu(h, p, l, b, m);
}
ci.pbkdf2Async = mp;
const Ep = /* @__PURE__ */ ui(Kh), [Ap, Sp] = ke.split([
  "0x428a2f98d728ae22",
  "0x7137449123ef65cd",
  "0xb5c0fbcfec4d3b2f",
  "0xe9b5dba58189dbbc",
  "0x3956c25bf348b538",
  "0x59f111f1b605d019",
  "0x923f82a4af194f9b",
  "0xab1c5ed5da6d8118",
  "0xd807aa98a3030242",
  "0x12835b0145706fbe",
  "0x243185be4ee4b28c",
  "0x550c7dc3d5ffb4e2",
  "0x72be5d74f27b896f",
  "0x80deb1fe3b1696b1",
  "0x9bdc06a725c71235",
  "0xc19bf174cf692694",
  "0xe49b69c19ef14ad2",
  "0xefbe4786384f25e3",
  "0x0fc19dc68b8cd5b5",
  "0x240ca1cc77ac9c65",
  "0x2de92c6f592b0275",
  "0x4a7484aa6ea6e483",
  "0x5cb0a9dcbd41fbd4",
  "0x76f988da831153b5",
  "0x983e5152ee66dfab",
  "0xa831c66d2db43210",
  "0xb00327c898fb213f",
  "0xbf597fc7beef0ee4",
  "0xc6e00bf33da88fc2",
  "0xd5a79147930aa725",
  "0x06ca6351e003826f",
  "0x142929670a0e6e70",
  "0x27b70a8546d22ffc",
  "0x2e1b21385c26c926",
  "0x4d2c6dfc5ac42aed",
  "0x53380d139d95b3df",
  "0x650a73548baf63de",
  "0x766a0abb3c77b2a8",
  "0x81c2c92e47edaee6",
  "0x92722c851482353b",
  "0xa2bfe8a14cf10364",
  "0xa81a664bbc423001",
  "0xc24b8b70d0f89791",
  "0xc76c51a30654be30",
  "0xd192e819d6ef5218",
  "0xd69906245565a910",
  "0xf40e35855771202a",
  "0x106aa07032bbd1b8",
  "0x19a4c116b8d2d0c8",
  "0x1e376c085141ab53",
  "0x2748774cdf8eeb99",
  "0x34b0bcb5e19b48a8",
  "0x391c0cb3c5c95a63",
  "0x4ed8aa4ae3418acb",
  "0x5b9cca4f7763e373",
  "0x682e6ff3d6b2b8a3",
  "0x748f82ee5defb2fc",
  "0x78a5636f43172f60",
  "0x84c87814a1f0ab72",
  "0x8cc702081a6439ec",
  "0x90befffa23631e28",
  "0xa4506cebde82bde9",
  "0xbef9a3f7b2c67915",
  "0xc67178f2e372532b",
  "0xca273eceea26619c",
  "0xd186b8c721c0c207",
  "0xeada7dd6cde0eb1e",
  "0xf57d4f7fee6ed178",
  "0x06f067aa72176fba",
  "0x0a637dc5a2c898a6",
  "0x113f9804bef90dae",
  "0x1b710b35131c471b",
  "0x28db77f523047d84",
  "0x32caab7b40c72493",
  "0x3c9ebe0a15c9bebc",
  "0x431d67c49c100d4c",
  "0x4cc5d4becb3e42b6",
  "0x597f299cfc657e2a",
  "0x5fcb6fab3ad6faec",
  "0x6c44198c4a475817"
].map((e) => BigInt(e))), ln = new Uint32Array(80), dn = new Uint32Array(80);
class Bi extends Oa {
  constructor() {
    super(128, 64, 16, !1), this.Ah = 1779033703, this.Al = -205731576, this.Bh = -1150833019, this.Bl = -2067093701, this.Ch = 1013904242, this.Cl = -23791573, this.Dh = -1521486534, this.Dl = 1595750129, this.Eh = 1359893119, this.El = -1377402159, this.Fh = -1694144372, this.Fl = 725511199, this.Gh = 528734635, this.Gl = -79577749, this.Hh = 1541459225, this.Hl = 327033209;
  }
  get() {
    const { Ah: t, Al: r, Bh: n, Bl: o, Ch: s, Cl: f, Dh: l, Dl: h, Eh: p, El: b, Fh: g, Fl: E, Gh: m, Gl: A, Hh: w, Hl: S } = this;
    return [t, r, n, o, s, f, l, h, p, b, g, E, m, A, w, S];
  }
  set(t, r, n, o, s, f, l, h, p, b, g, E, m, A, w, S) {
    this.Ah = t | 0, this.Al = r | 0, this.Bh = n | 0, this.Bl = o | 0, this.Ch = s | 0, this.Cl = f | 0, this.Dh = l | 0, this.Dl = h | 0, this.Eh = p | 0, this.El = b | 0, this.Fh = g | 0, this.Fl = E | 0, this.Gh = m | 0, this.Gl = A | 0, this.Hh = w | 0, this.Hl = S | 0;
  }
  process(t, r) {
    for (let C = 0; C < 16; C++, r += 4)
      ln[C] = t.getUint32(r), dn[C] = t.getUint32(r += 4);
    for (let C = 16; C < 80; C++) {
      const B = ln[C - 15] | 0, R = dn[C - 15] | 0, F = ke.rotrSH(B, R, 1) ^ ke.rotrSH(B, R, 8) ^ ke.shrSH(B, R, 7), Y = ke.rotrSL(B, R, 1) ^ ke.rotrSL(B, R, 8) ^ ke.shrSL(B, R, 7), K = ln[C - 2] | 0, Me = dn[C - 2] | 0, ye = ke.rotrSH(K, Me, 19) ^ ke.rotrBH(K, Me, 61) ^ ke.shrSH(K, Me, 6), $ = ke.rotrSL(K, Me, 19) ^ ke.rotrBL(K, Me, 61) ^ ke.shrSL(K, Me, 6), G = ke.add4L(Y, $, dn[C - 7], dn[C - 16]), X = ke.add4H(G, F, ye, ln[C - 7], ln[C - 16]);
      ln[C] = X | 0, dn[C] = G | 0;
    }
    let { Ah: n, Al: o, Bh: s, Bl: f, Ch: l, Cl: h, Dh: p, Dl: b, Eh: g, El: E, Fh: m, Fl: A, Gh: w, Gl: S, Hh: N, Hl: P } = this;
    for (let C = 0; C < 80; C++) {
      const B = ke.rotrSH(g, E, 14) ^ ke.rotrSH(g, E, 18) ^ ke.rotrBH(g, E, 41), R = ke.rotrSL(g, E, 14) ^ ke.rotrSL(g, E, 18) ^ ke.rotrBL(g, E, 41), F = g & m ^ ~g & w, Y = E & A ^ ~E & S, K = ke.add5L(P, R, Y, Sp[C], dn[C]), Me = ke.add5H(K, N, B, F, Ap[C], ln[C]), ye = K | 0, $ = ke.rotrSH(n, o, 28) ^ ke.rotrBH(n, o, 34) ^ ke.rotrBH(n, o, 39), G = ke.rotrSL(n, o, 28) ^ ke.rotrBL(n, o, 34) ^ ke.rotrBL(n, o, 39), X = n & s ^ n & l ^ s & l, ge = o & f ^ o & h ^ f & h;
      N = w | 0, P = S | 0, w = m | 0, S = A | 0, m = g | 0, A = E | 0, { h: g, l: E } = ke.add(p | 0, b | 0, Me | 0, ye | 0), p = l | 0, b = h | 0, l = s | 0, h = f | 0, s = n | 0, f = o | 0;
      const L = ke.add3L(ye, G, ge);
      n = ke.add3H(L, Me, $, X), o = L | 0;
    }
    ({ h: n, l: o } = ke.add(this.Ah | 0, this.Al | 0, n | 0, o | 0)), { h: s, l: f } = ke.add(this.Bh | 0, this.Bl | 0, s | 0, f | 0), { h: l, l: h } = ke.add(this.Ch | 0, this.Cl | 0, l | 0, h | 0), { h: p, l: b } = ke.add(this.Dh | 0, this.Dl | 0, p | 0, b | 0), { h: g, l: E } = ke.add(this.Eh | 0, this.El | 0, g | 0, E | 0), { h: m, l: A } = ke.add(this.Fh | 0, this.Fl | 0, m | 0, A | 0), { h: w, l: S } = ke.add(this.Gh | 0, this.Gl | 0, w | 0, S | 0), { h: N, l: P } = ke.add(this.Hh | 0, this.Hl | 0, N | 0, P | 0), this.set(n, o, s, f, l, h, p, b, g, E, m, A, w, S, N, P);
  }
  roundClean() {
    ln.fill(0), dn.fill(0);
  }
  destroy() {
    this.buffer.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
class Tp extends Bi {
  constructor() {
    super(), this.Ah = -1942145080, this.Al = 424955298, this.Bh = 1944164710, this.Bl = -1982016298, this.Ch = 502970286, this.Cl = 855612546, this.Dh = 1738396948, this.Dl = 1479516111, this.Eh = 258812777, this.El = 2077511080, this.Fh = 2011393907, this.Fl = 79989058, this.Gh = 1067287976, this.Gl = 1780299464, this.Hh = 286451373, this.Hl = -1848208735, this.outputLen = 28;
  }
}
class Mp extends Bi {
  constructor() {
    super(), this.Ah = 573645204, this.Al = -64227540, this.Bh = -1621794909, this.Bl = -934517566, this.Ch = 596883563, this.Cl = 1867755857, this.Dh = -1774684391, this.Dl = 1497426621, this.Eh = -1775747358, this.El = -1467023389, this.Fh = -1101128155, this.Fl = 1401305490, this.Gh = 721525244, this.Gl = 746961066, this.Hh = 246885852, this.Hl = -2117784414, this.outputLen = 32;
  }
}
class Ip extends Bi {
  constructor() {
    super(), this.Ah = -876896931, this.Al = -1056596264, this.Bh = 1654270250, this.Bl = 914150663, this.Ch = -1856437926, this.Cl = 812702999, this.Dh = 355462360, this.Dl = -150054599, this.Eh = 1731405415, this.El = -4191439, this.Fh = -1900787065, this.Fl = 1750603025, this.Gh = -619958771, this.Gl = 1694076839, this.Hh = 1203062813, this.Hl = -1090891868, this.outputLen = 48;
  }
}
const Cp = Cn(() => new Bi()), _p = Cn(() => new Tp()), Op = Cn(() => new Mp()), Np = Cn(() => new Ip()), jp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  SHA512: Bi,
  sha512: Cp,
  sha512_224: _p,
  sha512_256: Op,
  sha384: Np
}, Symbol.toStringTag, { value: "Module" })), Dp = /* @__PURE__ */ ui(jp), Lp = /* @__PURE__ */ ui(qh);
var $a = {};
(function(e) {
  /*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */
  Object.defineProperty(e, "__esModule", { value: !0 }), e.bytes = e.stringToBytes = e.str = e.bytesToString = e.hex = e.utf8 = e.bech32m = e.bech32 = e.base58check = e.base58xmr = e.base58xrp = e.base58flickr = e.base58 = e.base64url = e.base64 = e.base32crockford = e.base32hex = e.base32 = e.base16 = e.utils = e.assertNumber = void 0;
  function t($) {
    if (!Number.isSafeInteger($))
      throw new Error(`Wrong integer: ${$}`);
  }
  e.assertNumber = t;
  function r(...$) {
    const G = (L, _) => (q) => L(_(q)), X = Array.from($).reverse().reduce((L, _) => L ? G(L, _.encode) : _.encode, void 0), ge = $.reduce((L, _) => L ? G(L, _.decode) : _.decode, void 0);
    return { encode: X, decode: ge };
  }
  function n($) {
    return {
      encode: (G) => {
        if (!Array.isArray(G) || G.length && typeof G[0] != "number")
          throw new Error("alphabet.encode input should be an array of numbers");
        return G.map((X) => {
          if (t(X), X < 0 || X >= $.length)
            throw new Error(`Digit index outside alphabet: ${X} (alphabet: ${$.length})`);
          return $[X];
        });
      },
      decode: (G) => {
        if (!Array.isArray(G) || G.length && typeof G[0] != "string")
          throw new Error("alphabet.decode input should be array of strings");
        return G.map((X) => {
          if (typeof X != "string")
            throw new Error(`alphabet.decode: not string element=${X}`);
          const ge = $.indexOf(X);
          if (ge === -1)
            throw new Error(`Unknown letter: "${X}". Allowed: ${$}`);
          return ge;
        });
      }
    };
  }
  function o($ = "") {
    if (typeof $ != "string")
      throw new Error("join separator should be string");
    return {
      encode: (G) => {
        if (!Array.isArray(G) || G.length && typeof G[0] != "string")
          throw new Error("join.encode input should be array of strings");
        for (let X of G)
          if (typeof X != "string")
            throw new Error(`join.encode: non-string input=${X}`);
        return G.join($);
      },
      decode: (G) => {
        if (typeof G != "string")
          throw new Error("join.decode input should be string");
        return G.split($);
      }
    };
  }
  function s($, G = "=") {
    if (t($), typeof G != "string")
      throw new Error("padding chr should be string");
    return {
      encode(X) {
        if (!Array.isArray(X) || X.length && typeof X[0] != "string")
          throw new Error("padding.encode input should be array of strings");
        for (let ge of X)
          if (typeof ge != "string")
            throw new Error(`padding.encode: non-string input=${ge}`);
        for (; X.length * $ % 8; )
          X.push(G);
        return X;
      },
      decode(X) {
        if (!Array.isArray(X) || X.length && typeof X[0] != "string")
          throw new Error("padding.encode input should be array of strings");
        for (let L of X)
          if (typeof L != "string")
            throw new Error(`padding.decode: non-string input=${L}`);
        let ge = X.length;
        if (ge * $ % 8)
          throw new Error("Invalid padding: string should have whole number of bytes");
        for (; ge > 0 && X[ge - 1] === G; ge--)
          if (!((ge - 1) * $ % 8))
            throw new Error("Invalid padding: string has too much padding");
        return X.slice(0, ge);
      }
    };
  }
  function f($) {
    if (typeof $ != "function")
      throw new Error("normalize fn should be function");
    return { encode: (G) => G, decode: (G) => $(G) };
  }
  function l($, G, X) {
    if (G < 2)
      throw new Error(`convertRadix: wrong from=${G}, base cannot be less than 2`);
    if (X < 2)
      throw new Error(`convertRadix: wrong to=${X}, base cannot be less than 2`);
    if (!Array.isArray($))
      throw new Error("convertRadix: data should be array");
    if (!$.length)
      return [];
    let ge = 0;
    const L = [], _ = Array.from($);
    for (_.forEach((q) => {
      if (t(q), q < 0 || q >= G)
        throw new Error(`Wrong integer: ${q}`);
    }); ; ) {
      let q = 0, se = !0;
      for (let ae = ge; ae < _.length; ae++) {
        const Ee = _[ae], Se = G * q + Ee;
        if (!Number.isSafeInteger(Se) || G * q / G !== q || Se - Ee !== G * q)
          throw new Error("convertRadix: carry overflow");
        if (q = Se % X, _[ae] = Math.floor(Se / X), !Number.isSafeInteger(_[ae]) || _[ae] * X + q !== Se)
          throw new Error("convertRadix: carry overflow");
        if (se)
          _[ae] ? se = !1 : ge = ae;
        else
          continue;
      }
      if (L.push(q), se)
        break;
    }
    for (let q = 0; q < $.length - 1 && $[q] === 0; q++)
      L.push(0);
    return L.reverse();
  }
  const h = ($, G) => G ? h(G, $ % G) : $, p = ($, G) => $ + (G - h($, G));
  function b($, G, X, ge) {
    if (!Array.isArray($))
      throw new Error("convertRadix2: data should be array");
    if (G <= 0 || G > 32)
      throw new Error(`convertRadix2: wrong from=${G}`);
    if (X <= 0 || X > 32)
      throw new Error(`convertRadix2: wrong to=${X}`);
    if (p(G, X) > 32)
      throw new Error(`convertRadix2: carry overflow from=${G} to=${X} carryBits=${p(G, X)}`);
    let L = 0, _ = 0;
    const q = 2 ** X - 1, se = [];
    for (const ae of $) {
      if (t(ae), ae >= 2 ** G)
        throw new Error(`convertRadix2: invalid data word=${ae} from=${G}`);
      if (L = L << G | ae, _ + G > 32)
        throw new Error(`convertRadix2: carry overflow pos=${_} from=${G}`);
      for (_ += G; _ >= X; _ -= X)
        se.push((L >> _ - X & q) >>> 0);
      L &= 2 ** _ - 1;
    }
    if (L = L << X - _ & q, !ge && _ >= G)
      throw new Error("Excess padding");
    if (!ge && L)
      throw new Error(`Non-zero padding: ${L}`);
    return ge && _ > 0 && se.push(L >>> 0), se;
  }
  function g($) {
    return t($), {
      encode: (G) => {
        if (!(G instanceof Uint8Array))
          throw new Error("radix.encode input should be Uint8Array");
        return l(Array.from(G), 2 ** 8, $);
      },
      decode: (G) => {
        if (!Array.isArray(G) || G.length && typeof G[0] != "number")
          throw new Error("radix.decode input should be array of strings");
        return Uint8Array.from(l(G, $, 2 ** 8));
      }
    };
  }
  function E($, G = !1) {
    if (t($), $ <= 0 || $ > 32)
      throw new Error("radix2: bits should be in (0..32]");
    if (p(8, $) > 32 || p($, 8) > 32)
      throw new Error("radix2: carry overflow");
    return {
      encode: (X) => {
        if (!(X instanceof Uint8Array))
          throw new Error("radix2.encode input should be Uint8Array");
        return b(Array.from(X), 8, $, !G);
      },
      decode: (X) => {
        if (!Array.isArray(X) || X.length && typeof X[0] != "number")
          throw new Error("radix2.decode input should be array of strings");
        return Uint8Array.from(b(X, $, 8, G));
      }
    };
  }
  function m($) {
    if (typeof $ != "function")
      throw new Error("unsafeWrapper fn should be function");
    return function(...G) {
      try {
        return $.apply(null, G);
      } catch {
      }
    };
  }
  function A($, G) {
    if (t($), typeof G != "function")
      throw new Error("checksum fn should be function");
    return {
      encode(X) {
        if (!(X instanceof Uint8Array))
          throw new Error("checksum.encode: input should be Uint8Array");
        const ge = G(X).slice(0, $), L = new Uint8Array(X.length + $);
        return L.set(X), L.set(ge, X.length), L;
      },
      decode(X) {
        if (!(X instanceof Uint8Array))
          throw new Error("checksum.decode: input should be Uint8Array");
        const ge = X.slice(0, -$), L = G(ge).slice(0, $), _ = X.slice(-$);
        for (let q = 0; q < $; q++)
          if (L[q] !== _[q])
            throw new Error("Invalid checksum");
        return ge;
      }
    };
  }
  e.utils = { alphabet: n, chain: r, checksum: A, radix: g, radix2: E, join: o, padding: s }, e.base16 = r(E(4), n("0123456789ABCDEF"), o("")), e.base32 = r(E(5), n("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), s(5), o("")), e.base32hex = r(E(5), n("0123456789ABCDEFGHIJKLMNOPQRSTUV"), s(5), o("")), e.base32crockford = r(E(5), n("0123456789ABCDEFGHJKMNPQRSTVWXYZ"), o(""), f(($) => $.toUpperCase().replace(/O/g, "0").replace(/[IL]/g, "1"))), e.base64 = r(E(6), n("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), s(6), o("")), e.base64url = r(E(6), n("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), s(6), o(""));
  const w = ($) => r(g(58), n($), o(""));
  e.base58 = w("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"), e.base58flickr = w("123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"), e.base58xrp = w("rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz");
  const S = [0, 2, 3, 5, 6, 7, 9, 10, 11];
  e.base58xmr = {
    encode($) {
      let G = "";
      for (let X = 0; X < $.length; X += 8) {
        const ge = $.subarray(X, X + 8);
        G += e.base58.encode(ge).padStart(S[ge.length], "1");
      }
      return G;
    },
    decode($) {
      let G = [];
      for (let X = 0; X < $.length; X += 11) {
        const ge = $.slice(X, X + 11), L = S.indexOf(ge.length), _ = e.base58.decode(ge);
        for (let q = 0; q < _.length - L; q++)
          if (_[q] !== 0)
            throw new Error("base58xmr: wrong padding");
        G = G.concat(Array.from(_.slice(_.length - L)));
      }
      return Uint8Array.from(G);
    }
  };
  const N = ($) => r(A(4, (G) => $($(G))), e.base58);
  e.base58check = N;
  const P = r(n("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), o("")), C = [996825010, 642813549, 513874426, 1027748829, 705979059];
  function B($) {
    const G = $ >> 25;
    let X = ($ & 33554431) << 5;
    for (let ge = 0; ge < C.length; ge++)
      (G >> ge & 1) === 1 && (X ^= C[ge]);
    return X;
  }
  function R($, G, X = 1) {
    const ge = $.length;
    let L = 1;
    for (let _ = 0; _ < ge; _++) {
      const q = $.charCodeAt(_);
      if (q < 33 || q > 126)
        throw new Error(`Invalid prefix (${$})`);
      L = B(L) ^ q >> 5;
    }
    L = B(L);
    for (let _ = 0; _ < ge; _++)
      L = B(L) ^ $.charCodeAt(_) & 31;
    for (let _ of G)
      L = B(L) ^ _;
    for (let _ = 0; _ < 6; _++)
      L = B(L);
    return L ^= X, P.encode(b([L % 2 ** 30], 30, 5, !1));
  }
  function F($) {
    const G = $ === "bech32" ? 1 : 734539939, X = E(5), ge = X.decode, L = X.encode, _ = m(ge);
    function q(Se, Be, Re = 90) {
      if (typeof Se != "string")
        throw new Error(`bech32.encode prefix should be string, not ${typeof Se}`);
      if (!Array.isArray(Be) || Be.length && typeof Be[0] != "number")
        throw new Error(`bech32.encode words should be array of numbers, not ${typeof Be}`);
      const Fe = Se.length + 7 + Be.length;
      if (Re !== !1 && Fe > Re)
        throw new TypeError(`Length ${Fe} exceeds limit ${Re}`);
      return Se = Se.toLowerCase(), `${Se}1${P.encode(Be)}${R(Se, Be, G)}`;
    }
    function se(Se, Be = 90) {
      if (typeof Se != "string")
        throw new Error(`bech32.decode input should be string, not ${typeof Se}`);
      if (Se.length < 8 || Be !== !1 && Se.length > Be)
        throw new TypeError(`Wrong string length: ${Se.length} (${Se}). Expected (8..${Be})`);
      const Re = Se.toLowerCase();
      if (Se !== Re && Se !== Se.toUpperCase())
        throw new Error("String must be lowercase or uppercase");
      Se = Re;
      const Fe = Se.lastIndexOf("1");
      if (Fe === 0 || Fe === -1)
        throw new Error('Letter "1" must be present between prefix and data only');
      const be = Se.slice(0, Fe), $e = Se.slice(Fe + 1);
      if ($e.length < 6)
        throw new Error("Data must be at least 6 characters long");
      const lt = P.decode($e).slice(0, -6), St = R(be, lt, G);
      if (!$e.endsWith(St))
        throw new Error(`Invalid checksum in ${Se}: expected "${St}"`);
      return { prefix: be, words: lt };
    }
    const ae = m(se);
    function Ee(Se) {
      const { prefix: Be, words: Re } = se(Se, !1);
      return { prefix: Be, words: Re, bytes: ge(Re) };
    }
    return { encode: q, decode: se, decodeToBytes: Ee, decodeUnsafe: ae, fromWords: ge, fromWordsUnsafe: _, toWords: L };
  }
  e.bech32 = F("bech32"), e.bech32m = F("bech32m"), e.utf8 = {
    encode: ($) => new TextDecoder().decode($),
    decode: ($) => new TextEncoder().encode($)
  }, e.hex = r(E(4), n("0123456789abcdef"), o(""), f(($) => {
    if (typeof $ != "string" || $.length % 2)
      throw new TypeError(`hex.decode: expected string, got ${typeof $} with length ${$.length}`);
    return $.toLowerCase();
  }));
  const Y = {
    utf8: e.utf8,
    hex: e.hex,
    base16: e.base16,
    base32: e.base32,
    base64: e.base64,
    base64url: e.base64url,
    base58: e.base58,
    base58xmr: e.base58xmr
  }, K = `Invalid encoding type. Available types: ${Object.keys(Y).join(", ")}`, Me = ($, G) => {
    if (typeof $ != "string" || !Y.hasOwnProperty($))
      throw new TypeError(K);
    if (!(G instanceof Uint8Array))
      throw new TypeError("bytesToString() expects Uint8Array");
    return Y[$].encode(G);
  };
  e.bytesToString = Me, e.str = e.bytesToString;
  const ye = ($, G) => {
    if (!Y.hasOwnProperty($))
      throw new TypeError(K);
    if (typeof G != "string")
      throw new TypeError("stringToBytes() expects string");
    return Y[$].decode(G);
  };
  e.stringToBytes = ye, e.bytes = e.stringToBytes;
})($a);
Object.defineProperty(or, "__esModule", { value: !0 });
or.mnemonicToSeedSync = or.mnemonicToSeed = or.validateMnemonic = or.entropyToMnemonic = or.mnemonicToEntropy = or.generateMnemonic = void 0;
/*! scure-bip39 - MIT License (c) 2022 Patricio Palladino, Paul Miller (paulmillr.com) */
const qu = Ct, Yu = ci, Rp = Ep, Gu = Dp, Pp = Lp, Zi = $a, Up = (e) => e[0] === "\u3042\u3044\u3053\u304F\u3057\u3093";
function Qu(e) {
  if (typeof e != "string")
    throw new TypeError(`Invalid mnemonic type: ${typeof e}`);
  return e.normalize("NFKD");
}
function Wa(e) {
  const t = Qu(e), r = t.split(" ");
  if (![12, 15, 18, 21, 24].includes(r.length))
    throw new Error("Invalid mnemonic");
  return { nfkd: t, words: r };
}
function Vu(e) {
  qu.default.bytes(e, 16, 20, 24, 28, 32);
}
function Bp(e, t = 128) {
  if (qu.default.number(t), t % 32 !== 0 || t > 256)
    throw new TypeError("Invalid entropy");
  return Ku((0, Pp.randomBytes)(t / 8), e);
}
or.generateMnemonic = Bp;
const kp = (e) => {
  const t = 8 - e.length / 4;
  return new Uint8Array([(0, Rp.sha256)(e)[0] >> t << t]);
};
function Hu(e) {
  if (!Array.isArray(e) || e.length !== 2048 || typeof e[0] != "string")
    throw new Error("Worlist: expected array of 2048 strings");
  return e.forEach((t) => {
    if (typeof t != "string")
      throw new Error(`Wordlist: non-string element: ${t}`);
  }), Zi.utils.chain(Zi.utils.checksum(1, kp), Zi.utils.radix2(11, !0), Zi.utils.alphabet(e));
}
function Zu(e, t) {
  const { words: r } = Wa(e), n = Hu(t).decode(r);
  return Vu(n), n;
}
or.mnemonicToEntropy = Zu;
function Ku(e, t) {
  return Vu(e), Hu(t).encode(e).join(Up(t) ? "\u3000" : " ");
}
or.entropyToMnemonic = Ku;
function zp(e, t) {
  try {
    Zu(e, t);
  } catch {
    return !1;
  }
  return !0;
}
or.validateMnemonic = zp;
const Xu = (e) => Qu(`mnemonic${e}`);
function Fp(e, t = "") {
  return (0, Yu.pbkdf2Async)(Gu.sha512, Wa(e).nfkd, Xu(t), { c: 2048, dkLen: 64 });
}
or.mnemonicToSeed = Fp;
function $p(e, t = "") {
  return (0, Yu.pbkdf2)(Gu.sha512, Wa(e).nfkd, Xu(t), { c: 2048, dkLen: 64 });
}
or.mnemonicToSeedSync = $p;
const Wp = new Uint8Array([7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8]), Ju = Uint8Array.from({ length: 16 }, (e, t) => t), qp = Ju.map((e) => (9 * e + 5) % 16);
let qa = [Ju], Ya = [qp];
for (let e = 0; e < 4; e++)
  for (let t of [qa, Ya])
    t.push(t[e].map((r) => Wp[r]));
const el = [
  [11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8],
  [12, 13, 11, 15, 6, 9, 9, 7, 12, 15, 11, 13, 7, 8, 7, 7],
  [13, 15, 14, 11, 7, 7, 6, 8, 13, 14, 13, 12, 5, 5, 6, 9],
  [14, 11, 12, 14, 8, 6, 5, 5, 15, 12, 15, 14, 9, 9, 8, 6],
  [15, 12, 13, 13, 9, 5, 8, 6, 14, 11, 12, 11, 8, 6, 5, 5]
].map((e) => new Uint8Array(e)), Yp = qa.map((e, t) => e.map((r) => el[t][r])), Gp = Ya.map((e, t) => e.map((r) => el[t][r])), Qp = new Uint32Array([0, 1518500249, 1859775393, 2400959708, 2840853838]), Vp = new Uint32Array([1352829926, 1548603684, 1836072691, 2053994217, 0]), Ki = (e, t) => e << t | e >>> 32 - t;
function kc(e, t, r, n) {
  return e === 0 ? t ^ r ^ n : e === 1 ? t & r | ~t & n : e === 2 ? (t | ~r) ^ n : e === 3 ? t & n | r & ~n : t ^ (r | ~n);
}
const Xi = new Uint32Array(16);
class Hp extends Oa {
  constructor() {
    super(64, 20, 8, !0), this.h0 = 1732584193, this.h1 = -271733879, this.h2 = -1732584194, this.h3 = 271733878, this.h4 = -1009589776;
  }
  get() {
    const { h0: t, h1: r, h2: n, h3: o, h4: s } = this;
    return [t, r, n, o, s];
  }
  set(t, r, n, o, s) {
    this.h0 = t | 0, this.h1 = r | 0, this.h2 = n | 0, this.h3 = o | 0, this.h4 = s | 0;
  }
  process(t, r) {
    for (let m = 0; m < 16; m++, r += 4)
      Xi[m] = t.getUint32(r, !0);
    let n = this.h0 | 0, o = n, s = this.h1 | 0, f = s, l = this.h2 | 0, h = l, p = this.h3 | 0, b = p, g = this.h4 | 0, E = g;
    for (let m = 0; m < 5; m++) {
      const A = 4 - m, w = Qp[m], S = Vp[m], N = qa[m], P = Ya[m], C = Yp[m], B = Gp[m];
      for (let R = 0; R < 16; R++) {
        const F = Ki(n + kc(m, s, l, p) + Xi[N[R]] + w, C[R]) + g | 0;
        n = g, g = p, p = Ki(l, 10) | 0, l = s, s = F;
      }
      for (let R = 0; R < 16; R++) {
        const F = Ki(o + kc(A, f, h, b) + Xi[P[R]] + S, B[R]) + E | 0;
        o = E, E = b, b = Ki(h, 10) | 0, h = f, f = F;
      }
    }
    this.set(this.h1 + l + b | 0, this.h2 + p + E | 0, this.h3 + g + o | 0, this.h4 + n + f | 0, this.h0 + s + h | 0);
  }
  roundClean() {
    Xi.fill(0);
  }
  destroy() {
    this.destroyed = !0, this.buffer.fill(0), this.set(0, 0, 0, 0, 0);
  }
}
Cn(() => new Hp());
Ui.ProjectivePoint;
$a.base58check(oi);
Ca("Bitcoin seed");
var Ji, Zp = new Uint8Array(16);
function tl() {
  if (!Ji && (Ji = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !Ji))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Ji(Zp);
}
const Kp = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function Ko(e) {
  return typeof e == "string" && Kp.test(e);
}
var Mt = [];
for (var bs = 0; bs < 256; ++bs)
  Mt.push((bs + 256).toString(16).substr(1));
function Xo(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r = (Mt[e[t + 0]] + Mt[e[t + 1]] + Mt[e[t + 2]] + Mt[e[t + 3]] + "-" + Mt[e[t + 4]] + Mt[e[t + 5]] + "-" + Mt[e[t + 6]] + Mt[e[t + 7]] + "-" + Mt[e[t + 8]] + Mt[e[t + 9]] + "-" + Mt[e[t + 10]] + Mt[e[t + 11]] + Mt[e[t + 12]] + Mt[e[t + 13]] + Mt[e[t + 14]] + Mt[e[t + 15]]).toLowerCase();
  if (!Ko(r))
    throw TypeError("Stringified UUID is invalid");
  return r;
}
var zc, xs, ws = 0, ms = 0;
function Xp(e, t, r) {
  var n = t && r || 0, o = t || new Array(16);
  e = e || {};
  var s = e.node || zc, f = e.clockseq !== void 0 ? e.clockseq : xs;
  if (s == null || f == null) {
    var l = e.random || (e.rng || tl)();
    s == null && (s = zc = [l[0] | 1, l[1], l[2], l[3], l[4], l[5]]), f == null && (f = xs = (l[6] << 8 | l[7]) & 16383);
  }
  var h = e.msecs !== void 0 ? e.msecs : Date.now(), p = e.nsecs !== void 0 ? e.nsecs : ms + 1, b = h - ws + (p - ms) / 1e4;
  if (b < 0 && e.clockseq === void 0 && (f = f + 1 & 16383), (b < 0 || h > ws) && e.nsecs === void 0 && (p = 0), p >= 1e4)
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  ws = h, ms = p, xs = f, h += 122192928e5;
  var g = ((h & 268435455) * 1e4 + p) % 4294967296;
  o[n++] = g >>> 24 & 255, o[n++] = g >>> 16 & 255, o[n++] = g >>> 8 & 255, o[n++] = g & 255;
  var E = h / 4294967296 * 1e4 & 268435455;
  o[n++] = E >>> 8 & 255, o[n++] = E & 255, o[n++] = E >>> 24 & 15 | 16, o[n++] = E >>> 16 & 255, o[n++] = f >>> 8 | 128, o[n++] = f & 255;
  for (var m = 0; m < 6; ++m)
    o[n + m] = s[m];
  return t || Xo(o);
}
function rl(e) {
  if (!Ko(e))
    throw TypeError("Invalid UUID");
  var t, r = new Uint8Array(16);
  return r[0] = (t = parseInt(e.slice(0, 8), 16)) >>> 24, r[1] = t >>> 16 & 255, r[2] = t >>> 8 & 255, r[3] = t & 255, r[4] = (t = parseInt(e.slice(9, 13), 16)) >>> 8, r[5] = t & 255, r[6] = (t = parseInt(e.slice(14, 18), 16)) >>> 8, r[7] = t & 255, r[8] = (t = parseInt(e.slice(19, 23), 16)) >>> 8, r[9] = t & 255, r[10] = (t = parseInt(e.slice(24, 36), 16)) / 1099511627776 & 255, r[11] = t / 4294967296 & 255, r[12] = t >>> 24 & 255, r[13] = t >>> 16 & 255, r[14] = t >>> 8 & 255, r[15] = t & 255, r;
}
function Jp(e) {
  e = unescape(encodeURIComponent(e));
  for (var t = [], r = 0; r < e.length; ++r)
    t.push(e.charCodeAt(r));
  return t;
}
var ey = "6ba7b810-9dad-11d1-80b4-00c04fd430c8", ty = "6ba7b811-9dad-11d1-80b4-00c04fd430c8";
function nl(e, t, r) {
  function n(o, s, f, l) {
    if (typeof o == "string" && (o = Jp(o)), typeof s == "string" && (s = rl(s)), s.length !== 16)
      throw TypeError("Namespace must be array-like (16 iterable integer values, 0-255)");
    var h = new Uint8Array(16 + o.length);
    if (h.set(s), h.set(o, s.length), h = r(h), h[6] = h[6] & 15 | t, h[8] = h[8] & 63 | 128, f) {
      l = l || 0;
      for (var p = 0; p < 16; ++p)
        f[l + p] = h[p];
      return f;
    }
    return Xo(h);
  }
  try {
    n.name = e;
  } catch {
  }
  return n.DNS = ey, n.URL = ty, n;
}
function ry(e) {
  if (typeof e == "string") {
    var t = unescape(encodeURIComponent(e));
    e = new Uint8Array(t.length);
    for (var r = 0; r < t.length; ++r)
      e[r] = t.charCodeAt(r);
  }
  return ny(iy(oy(e), e.length * 8));
}
function ny(e) {
  for (var t = [], r = e.length * 32, n = "0123456789abcdef", o = 0; o < r; o += 8) {
    var s = e[o >> 5] >>> o % 32 & 255, f = parseInt(n.charAt(s >>> 4 & 15) + n.charAt(s & 15), 16);
    t.push(f);
  }
  return t;
}
function il(e) {
  return (e + 64 >>> 9 << 4) + 14 + 1;
}
function iy(e, t) {
  e[t >> 5] |= 128 << t % 32, e[il(t) - 1] = t;
  for (var r = 1732584193, n = -271733879, o = -1732584194, s = 271733878, f = 0; f < e.length; f += 16) {
    var l = r, h = n, p = o, b = s;
    r = jt(r, n, o, s, e[f], 7, -680876936), s = jt(s, r, n, o, e[f + 1], 12, -389564586), o = jt(o, s, r, n, e[f + 2], 17, 606105819), n = jt(n, o, s, r, e[f + 3], 22, -1044525330), r = jt(r, n, o, s, e[f + 4], 7, -176418897), s = jt(s, r, n, o, e[f + 5], 12, 1200080426), o = jt(o, s, r, n, e[f + 6], 17, -1473231341), n = jt(n, o, s, r, e[f + 7], 22, -45705983), r = jt(r, n, o, s, e[f + 8], 7, 1770035416), s = jt(s, r, n, o, e[f + 9], 12, -1958414417), o = jt(o, s, r, n, e[f + 10], 17, -42063), n = jt(n, o, s, r, e[f + 11], 22, -1990404162), r = jt(r, n, o, s, e[f + 12], 7, 1804603682), s = jt(s, r, n, o, e[f + 13], 12, -40341101), o = jt(o, s, r, n, e[f + 14], 17, -1502002290), n = jt(n, o, s, r, e[f + 15], 22, 1236535329), r = Dt(r, n, o, s, e[f + 1], 5, -165796510), s = Dt(s, r, n, o, e[f + 6], 9, -1069501632), o = Dt(o, s, r, n, e[f + 11], 14, 643717713), n = Dt(n, o, s, r, e[f], 20, -373897302), r = Dt(r, n, o, s, e[f + 5], 5, -701558691), s = Dt(s, r, n, o, e[f + 10], 9, 38016083), o = Dt(o, s, r, n, e[f + 15], 14, -660478335), n = Dt(n, o, s, r, e[f + 4], 20, -405537848), r = Dt(r, n, o, s, e[f + 9], 5, 568446438), s = Dt(s, r, n, o, e[f + 14], 9, -1019803690), o = Dt(o, s, r, n, e[f + 3], 14, -187363961), n = Dt(n, o, s, r, e[f + 8], 20, 1163531501), r = Dt(r, n, o, s, e[f + 13], 5, -1444681467), s = Dt(s, r, n, o, e[f + 2], 9, -51403784), o = Dt(o, s, r, n, e[f + 7], 14, 1735328473), n = Dt(n, o, s, r, e[f + 12], 20, -1926607734), r = Lt(r, n, o, s, e[f + 5], 4, -378558), s = Lt(s, r, n, o, e[f + 8], 11, -2022574463), o = Lt(o, s, r, n, e[f + 11], 16, 1839030562), n = Lt(n, o, s, r, e[f + 14], 23, -35309556), r = Lt(r, n, o, s, e[f + 1], 4, -1530992060), s = Lt(s, r, n, o, e[f + 4], 11, 1272893353), o = Lt(o, s, r, n, e[f + 7], 16, -155497632), n = Lt(n, o, s, r, e[f + 10], 23, -1094730640), r = Lt(r, n, o, s, e[f + 13], 4, 681279174), s = Lt(s, r, n, o, e[f], 11, -358537222), o = Lt(o, s, r, n, e[f + 3], 16, -722521979), n = Lt(n, o, s, r, e[f + 6], 23, 76029189), r = Lt(r, n, o, s, e[f + 9], 4, -640364487), s = Lt(s, r, n, o, e[f + 12], 11, -421815835), o = Lt(o, s, r, n, e[f + 15], 16, 530742520), n = Lt(n, o, s, r, e[f + 2], 23, -995338651), r = Rt(r, n, o, s, e[f], 6, -198630844), s = Rt(s, r, n, o, e[f + 7], 10, 1126891415), o = Rt(o, s, r, n, e[f + 14], 15, -1416354905), n = Rt(n, o, s, r, e[f + 5], 21, -57434055), r = Rt(r, n, o, s, e[f + 12], 6, 1700485571), s = Rt(s, r, n, o, e[f + 3], 10, -1894986606), o = Rt(o, s, r, n, e[f + 10], 15, -1051523), n = Rt(n, o, s, r, e[f + 1], 21, -2054922799), r = Rt(r, n, o, s, e[f + 8], 6, 1873313359), s = Rt(s, r, n, o, e[f + 15], 10, -30611744), o = Rt(o, s, r, n, e[f + 6], 15, -1560198380), n = Rt(n, o, s, r, e[f + 13], 21, 1309151649), r = Rt(r, n, o, s, e[f + 4], 6, -145523070), s = Rt(s, r, n, o, e[f + 11], 10, -1120210379), o = Rt(o, s, r, n, e[f + 2], 15, 718787259), n = Rt(n, o, s, r, e[f + 9], 21, -343485551), r = mn(r, l), n = mn(n, h), o = mn(o, p), s = mn(s, b);
  }
  return [r, n, o, s];
}
function oy(e) {
  if (e.length === 0)
    return [];
  for (var t = e.length * 8, r = new Uint32Array(il(t)), n = 0; n < t; n += 8)
    r[n >> 5] |= (e[n / 8] & 255) << n % 32;
  return r;
}
function mn(e, t) {
  var r = (e & 65535) + (t & 65535), n = (e >> 16) + (t >> 16) + (r >> 16);
  return n << 16 | r & 65535;
}
function sy(e, t) {
  return e << t | e >>> 32 - t;
}
function Jo(e, t, r, n, o, s) {
  return mn(sy(mn(mn(t, e), mn(n, s)), o), r);
}
function jt(e, t, r, n, o, s, f) {
  return Jo(t & r | ~t & n, e, t, o, s, f);
}
function Dt(e, t, r, n, o, s, f) {
  return Jo(t & n | r & ~n, e, t, o, s, f);
}
function Lt(e, t, r, n, o, s, f) {
  return Jo(t ^ r ^ n, e, t, o, s, f);
}
function Rt(e, t, r, n, o, s, f) {
  return Jo(r ^ (t | ~n), e, t, o, s, f);
}
var ay = nl("v3", 48, ry);
const cy = ay;
function fy(e, t, r) {
  e = e || {};
  var n = e.random || (e.rng || tl)();
  if (n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, t) {
    r = r || 0;
    for (var o = 0; o < 16; ++o)
      t[r + o] = n[o];
    return t;
  }
  return Xo(n);
}
function uy(e, t, r, n) {
  switch (e) {
    case 0:
      return t & r ^ ~t & n;
    case 1:
      return t ^ r ^ n;
    case 2:
      return t & r ^ t & n ^ r & n;
    case 3:
      return t ^ r ^ n;
  }
}
function Es(e, t) {
  return e << t | e >>> 32 - t;
}
function ly(e) {
  var t = [1518500249, 1859775393, 2400959708, 3395469782], r = [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
  if (typeof e == "string") {
    var n = unescape(encodeURIComponent(e));
    e = [];
    for (var o = 0; o < n.length; ++o)
      e.push(n.charCodeAt(o));
  } else
    Array.isArray(e) || (e = Array.prototype.slice.call(e));
  e.push(128);
  for (var s = e.length / 4 + 2, f = Math.ceil(s / 16), l = new Array(f), h = 0; h < f; ++h) {
    for (var p = new Uint32Array(16), b = 0; b < 16; ++b)
      p[b] = e[h * 64 + b * 4] << 24 | e[h * 64 + b * 4 + 1] << 16 | e[h * 64 + b * 4 + 2] << 8 | e[h * 64 + b * 4 + 3];
    l[h] = p;
  }
  l[f - 1][14] = (e.length - 1) * 8 / Math.pow(2, 32), l[f - 1][14] = Math.floor(l[f - 1][14]), l[f - 1][15] = (e.length - 1) * 8 & 4294967295;
  for (var g = 0; g < f; ++g) {
    for (var E = new Uint32Array(80), m = 0; m < 16; ++m)
      E[m] = l[g][m];
    for (var A = 16; A < 80; ++A)
      E[A] = Es(E[A - 3] ^ E[A - 8] ^ E[A - 14] ^ E[A - 16], 1);
    for (var w = r[0], S = r[1], N = r[2], P = r[3], C = r[4], B = 0; B < 80; ++B) {
      var R = Math.floor(B / 20), F = Es(w, 5) + uy(R, S, N, P) + C + t[R] + E[B] >>> 0;
      C = P, P = N, N = Es(S, 30) >>> 0, S = w, w = F;
    }
    r[0] = r[0] + w >>> 0, r[1] = r[1] + S >>> 0, r[2] = r[2] + N >>> 0, r[3] = r[3] + P >>> 0, r[4] = r[4] + C >>> 0;
  }
  return [r[0] >> 24 & 255, r[0] >> 16 & 255, r[0] >> 8 & 255, r[0] & 255, r[1] >> 24 & 255, r[1] >> 16 & 255, r[1] >> 8 & 255, r[1] & 255, r[2] >> 24 & 255, r[2] >> 16 & 255, r[2] >> 8 & 255, r[2] & 255, r[3] >> 24 & 255, r[3] >> 16 & 255, r[3] >> 8 & 255, r[3] & 255, r[4] >> 24 & 255, r[4] >> 16 & 255, r[4] >> 8 & 255, r[4] & 255];
}
var dy = nl("v5", 80, ly);
const hy = dy, py = "00000000-0000-0000-0000-000000000000";
function yy(e) {
  if (!Ko(e))
    throw TypeError("Invalid UUID");
  return parseInt(e.substr(14, 1), 16);
}
const gy = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  v1: Xp,
  v3: cy,
  v4: fy,
  v5: hy,
  NIL: py,
  version: yy,
  validate: Ko,
  stringify: Xo,
  parse: rl
}, Symbol.toStringTag, { value: "Module" })), ol = /* @__PURE__ */ ui(gy), vy = ol.v4, by = function(e, t, r, n) {
  if (typeof e != "string")
    throw new TypeError(e + " must be a string");
  n = n || {};
  const o = typeof n.version == "number" ? n.version : 2;
  if (o !== 1 && o !== 2)
    throw new TypeError(o + " must be 1 or 2");
  const s = {
    method: e
  };
  if (o === 2 && (s.jsonrpc = "2.0"), t) {
    if (typeof t != "object" && !Array.isArray(t))
      throw new TypeError(t + " must be an object, array or omitted");
    s.params = t;
  }
  if (typeof r > "u") {
    const f = typeof n.generator == "function" ? n.generator : function() {
      return vy();
    };
    s.id = f(s, n);
  } else
    o === 2 && r === null ? n.notificationIdNull && (s.id = null) : s.id = r;
  return s;
};
var xy = by;
const wy = ol.v4, my = xy, Ni = function(e, t) {
  if (!(this instanceof Ni))
    return new Ni(e, t);
  t || (t = {}), this.options = {
    reviver: typeof t.reviver < "u" ? t.reviver : null,
    replacer: typeof t.replacer < "u" ? t.replacer : null,
    generator: typeof t.generator < "u" ? t.generator : function() {
      return wy();
    },
    version: typeof t.version < "u" ? t.version : 2,
    notificationIdNull: typeof t.notificationIdNull == "boolean" ? t.notificationIdNull : !1
  }, this.callServer = e;
};
var Ey = Ni;
Ni.prototype.request = function(e, t, r, n) {
  const o = this;
  let s = null;
  const f = Array.isArray(e) && typeof t == "function";
  if (this.options.version === 1 && f)
    throw new TypeError("JSON-RPC 1.0 does not support batching");
  if (f || !f && e && typeof e == "object" && typeof t == "function")
    n = t, s = e;
  else {
    typeof r == "function" && (n = r, r = void 0);
    const p = typeof n == "function";
    try {
      s = my(e, t, r, {
        generator: this.options.generator,
        version: this.options.version,
        notificationIdNull: this.options.notificationIdNull
      });
    } catch (b) {
      if (p)
        return n(b);
      throw b;
    }
    if (!p)
      return s;
  }
  let h;
  try {
    h = JSON.stringify(s, this.options.replacer);
  } catch (p) {
    return n(p);
  }
  return this.callServer(h, function(p, b) {
    o._parseResponse(p, b, n);
  }), s;
};
Ni.prototype._parseResponse = function(e, t, r) {
  if (e) {
    r(e);
    return;
  }
  if (!t)
    return r();
  let n;
  try {
    n = JSON.parse(t, this.options.reviver);
  } catch (o) {
    return r(o);
  }
  if (r.length === 3)
    if (Array.isArray(n)) {
      const o = function(f) {
        return typeof f.error < "u";
      }, s = function(f) {
        return !o(f);
      };
      return r(null, n.filter(o), n.filter(s));
    } else
      return r(null, n.error, n.result);
  r(null, n);
};
var Ga = {}, es = { exports: {} };
(function(e) {
  function t(r) {
    return r && r.__esModule ? r : {
      default: r
    };
  }
  e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
})(es);
var As = { exports: {} }, Ss = { exports: {} }, Ts = { exports: {} }, Fc;
function ki() {
  return Fc || (Fc = 1, function(e) {
    function t(r) {
      return e.exports = t = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
        return typeof n;
      } : function(n) {
        return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Ts)), Ts.exports;
}
var Ms = { exports: {} }, $c;
function Ay() {
  return $c || ($c = 1, function(e) {
    var t = ki().default;
    function r(n, o) {
      if (t(n) !== "object" || n === null)
        return n;
      var s = n[Symbol.toPrimitive];
      if (s !== void 0) {
        var f = s.call(n, o || "default");
        if (t(f) !== "object")
          return f;
        throw new TypeError("@@toPrimitive must return a primitive value.");
      }
      return (o === "string" ? String : Number)(n);
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Ms)), Ms.exports;
}
var Wc;
function Sy() {
  return Wc || (Wc = 1, function(e) {
    var t = ki().default, r = Ay();
    function n(o) {
      var s = r(o, "string");
      return t(s) === "symbol" ? s : String(s);
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Ss)), Ss.exports;
}
var qc;
function Qa() {
  return qc || (qc = 1, function(e) {
    var t = Sy();
    function r(o, s) {
      for (var f = 0; f < s.length; f++) {
        var l = s[f];
        l.enumerable = l.enumerable || !1, l.configurable = !0, "value" in l && (l.writable = !0), Object.defineProperty(o, t(l.key), l);
      }
    }
    function n(o, s, f) {
      return s && r(o.prototype, s), f && r(o, f), Object.defineProperty(o, "prototype", {
        writable: !1
      }), o;
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(As)), As.exports;
}
var Is = { exports: {} }, Yc;
function Va() {
  return Yc || (Yc = 1, function(e) {
    function t(r, n) {
      if (!(r instanceof n))
        throw new TypeError("Cannot call a class as a function");
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Is)), Is.exports;
}
var Cs = { exports: {} }, _s = { exports: {} }, Gc;
function Ty() {
  return Gc || (Gc = 1, function(e) {
    function t(r, n) {
      return e.exports = t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(s, f) {
        return s.__proto__ = f, s;
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r, n);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(_s)), _s.exports;
}
var Qc;
function Ha() {
  return Qc || (Qc = 1, function(e) {
    var t = Ty();
    function r(n, o) {
      if (typeof o != "function" && o !== null)
        throw new TypeError("Super expression must either be null or a function");
      n.prototype = Object.create(o && o.prototype, {
        constructor: {
          value: n,
          writable: !0,
          configurable: !0
        }
      }), Object.defineProperty(n, "prototype", {
        writable: !1
      }), o && t(n, o);
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Cs)), Cs.exports;
}
var Os = { exports: {} }, Ns = { exports: {} }, Vc;
function My() {
  return Vc || (Vc = 1, function(e) {
    function t(r) {
      if (r === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return r;
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Ns)), Ns.exports;
}
var Hc;
function Za() {
  return Hc || (Hc = 1, function(e) {
    var t = ki().default, r = My();
    function n(o, s) {
      if (s && (t(s) === "object" || typeof s == "function"))
        return s;
      if (s !== void 0)
        throw new TypeError("Derived constructors may only return object or undefined");
      return r(o);
    }
    e.exports = n, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Os)), Os.exports;
}
var js = { exports: {} }, Zc;
function Ka() {
  return Zc || (Zc = 1, function(e) {
    function t(r) {
      return e.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
      }, e.exports.__esModule = !0, e.exports.default = e.exports, t(r);
    }
    e.exports = t, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(js)), js.exports;
}
var Ds = {}, Ls = { exports: {} }, Kc;
function sl() {
  return Kc || (Kc = 1, function(e) {
    var t = Object.prototype.hasOwnProperty, r = "~";
    function n() {
    }
    Object.create && (n.prototype = /* @__PURE__ */ Object.create(null), new n().__proto__ || (r = !1));
    function o(h, p, b) {
      this.fn = h, this.context = p, this.once = b || !1;
    }
    function s(h, p, b, g, E) {
      if (typeof b != "function")
        throw new TypeError("The listener must be a function");
      var m = new o(b, g || h, E), A = r ? r + p : p;
      return h._events[A] ? h._events[A].fn ? h._events[A] = [h._events[A], m] : h._events[A].push(m) : (h._events[A] = m, h._eventsCount++), h;
    }
    function f(h, p) {
      --h._eventsCount === 0 ? h._events = new n() : delete h._events[p];
    }
    function l() {
      this._events = new n(), this._eventsCount = 0;
    }
    l.prototype.eventNames = function() {
      var p = [], b, g;
      if (this._eventsCount === 0)
        return p;
      for (g in b = this._events)
        t.call(b, g) && p.push(r ? g.slice(1) : g);
      return Object.getOwnPropertySymbols ? p.concat(Object.getOwnPropertySymbols(b)) : p;
    }, l.prototype.listeners = function(p) {
      var b = r ? r + p : p, g = this._events[b];
      if (!g)
        return [];
      if (g.fn)
        return [g.fn];
      for (var E = 0, m = g.length, A = new Array(m); E < m; E++)
        A[E] = g[E].fn;
      return A;
    }, l.prototype.listenerCount = function(p) {
      var b = r ? r + p : p, g = this._events[b];
      return g ? g.fn ? 1 : g.length : 0;
    }, l.prototype.emit = function(p, b, g, E, m, A) {
      var w = r ? r + p : p;
      if (!this._events[w])
        return !1;
      var S = this._events[w], N = arguments.length, P, C;
      if (S.fn) {
        switch (S.once && this.removeListener(p, S.fn, void 0, !0), N) {
          case 1:
            return S.fn.call(S.context), !0;
          case 2:
            return S.fn.call(S.context, b), !0;
          case 3:
            return S.fn.call(S.context, b, g), !0;
          case 4:
            return S.fn.call(S.context, b, g, E), !0;
          case 5:
            return S.fn.call(S.context, b, g, E, m), !0;
          case 6:
            return S.fn.call(S.context, b, g, E, m, A), !0;
        }
        for (C = 1, P = new Array(N - 1); C < N; C++)
          P[C - 1] = arguments[C];
        S.fn.apply(S.context, P);
      } else {
        var B = S.length, R;
        for (C = 0; C < B; C++)
          switch (S[C].once && this.removeListener(p, S[C].fn, void 0, !0), N) {
            case 1:
              S[C].fn.call(S[C].context);
              break;
            case 2:
              S[C].fn.call(S[C].context, b);
              break;
            case 3:
              S[C].fn.call(S[C].context, b, g);
              break;
            case 4:
              S[C].fn.call(S[C].context, b, g, E);
              break;
            default:
              if (!P)
                for (R = 1, P = new Array(N - 1); R < N; R++)
                  P[R - 1] = arguments[R];
              S[C].fn.apply(S[C].context, P);
          }
      }
      return !0;
    }, l.prototype.on = function(p, b, g) {
      return s(this, p, b, g, !1);
    }, l.prototype.once = function(p, b, g) {
      return s(this, p, b, g, !0);
    }, l.prototype.removeListener = function(p, b, g, E) {
      var m = r ? r + p : p;
      if (!this._events[m])
        return this;
      if (!b)
        return f(this, m), this;
      var A = this._events[m];
      if (A.fn)
        A.fn === b && (!E || A.once) && (!g || A.context === g) && f(this, m);
      else {
        for (var w = 0, S = [], N = A.length; w < N; w++)
          (A[w].fn !== b || E && !A[w].once || g && A[w].context !== g) && S.push(A[w]);
        S.length ? this._events[m] = S.length === 1 ? S[0] : S : f(this, m);
      }
      return this;
    }, l.prototype.removeAllListeners = function(p) {
      var b;
      return p ? (b = r ? r + p : p, this._events[b] && f(this, b)) : (this._events = new n(), this._eventsCount = 0), this;
    }, l.prototype.off = l.prototype.removeListener, l.prototype.addListener = l.prototype.on, l.prefixed = r, l.EventEmitter = l, e.exports = l;
  }(Ls)), Ls.exports;
}
var Xc;
function Iy() {
  return Xc || (Xc = 1, function(e) {
    var t = es.exports;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = g;
    var r = t(Va()), n = t(Qa()), o = t(Ha()), s = t(Za()), f = t(Ka()), l = sl();
    function h(E) {
      var m = p();
      return function() {
        var w = (0, f.default)(E), S;
        if (m) {
          var N = (0, f.default)(this).constructor;
          S = Reflect.construct(w, arguments, N);
        } else
          S = w.apply(this, arguments);
        return (0, s.default)(this, S);
      };
    }
    function p() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var b = /* @__PURE__ */ function(E) {
      (0, o.default)(A, E);
      var m = h(A);
      function A(w, S, N) {
        var P;
        return (0, r.default)(this, A), P = m.call(this), P.socket = new window.WebSocket(w, N), P.socket.onopen = function() {
          return P.emit("open");
        }, P.socket.onmessage = function(C) {
          return P.emit("message", C.data);
        }, P.socket.onerror = function(C) {
          return P.emit("error", C);
        }, P.socket.onclose = function(C) {
          P.emit("close", C.code, C.reason);
        }, P;
      }
      return (0, n.default)(A, [{
        key: "send",
        value: function(S, N, P) {
          var C = P || N;
          try {
            this.socket.send(S), C();
          } catch (B) {
            C(B);
          }
        }
      }, {
        key: "close",
        value: function(S, N) {
          this.socket.close(S, N);
        }
      }, {
        key: "addEventListener",
        value: function(S, N, P) {
          this.socket.addEventListener(S, N, P);
        }
      }]), A;
    }(l.EventEmitter);
    function g(E, m) {
      return new b(E, m);
    }
  }(Ds)), Ds;
}
var Rs = {}, Ps = { exports: {} }, Jc;
function Cy() {
  return Jc || (Jc = 1, function(e) {
    var t = ki().default;
    function r() {
      e.exports = r = function() {
        return n;
      }, e.exports.__esModule = !0, e.exports.default = e.exports;
      var n = {}, o = Object.prototype, s = o.hasOwnProperty, f = Object.defineProperty || function(L, _, q) {
        L[_] = q.value;
      }, l = typeof Symbol == "function" ? Symbol : {}, h = l.iterator || "@@iterator", p = l.asyncIterator || "@@asyncIterator", b = l.toStringTag || "@@toStringTag";
      function g(L, _, q) {
        return Object.defineProperty(L, _, {
          value: q,
          enumerable: !0,
          configurable: !0,
          writable: !0
        }), L[_];
      }
      try {
        g({}, "");
      } catch {
        g = function(q, se, ae) {
          return q[se] = ae;
        };
      }
      function E(L, _, q, se) {
        var ae = _ && _.prototype instanceof w ? _ : w, Ee = Object.create(ae.prototype), Se = new G(se || []);
        return f(Ee, "_invoke", {
          value: K(L, q, Se)
        }), Ee;
      }
      function m(L, _, q) {
        try {
          return {
            type: "normal",
            arg: L.call(_, q)
          };
        } catch (se) {
          return {
            type: "throw",
            arg: se
          };
        }
      }
      n.wrap = E;
      var A = {};
      function w() {
      }
      function S() {
      }
      function N() {
      }
      var P = {};
      g(P, h, function() {
        return this;
      });
      var C = Object.getPrototypeOf, B = C && C(C(X([])));
      B && B !== o && s.call(B, h) && (P = B);
      var R = N.prototype = w.prototype = Object.create(P);
      function F(L) {
        ["next", "throw", "return"].forEach(function(_) {
          g(L, _, function(q) {
            return this._invoke(_, q);
          });
        });
      }
      function Y(L, _) {
        function q(ae, Ee, Se, Be) {
          var Re = m(L[ae], L, Ee);
          if (Re.type !== "throw") {
            var Fe = Re.arg, be = Fe.value;
            return be && t(be) == "object" && s.call(be, "__await") ? _.resolve(be.__await).then(function($e) {
              q("next", $e, Se, Be);
            }, function($e) {
              q("throw", $e, Se, Be);
            }) : _.resolve(be).then(function($e) {
              Fe.value = $e, Se(Fe);
            }, function($e) {
              return q("throw", $e, Se, Be);
            });
          }
          Be(Re.arg);
        }
        var se;
        f(this, "_invoke", {
          value: function(Ee, Se) {
            function Be() {
              return new _(function(Re, Fe) {
                q(Ee, Se, Re, Fe);
              });
            }
            return se = se ? se.then(Be, Be) : Be();
          }
        });
      }
      function K(L, _, q) {
        var se = "suspendedStart";
        return function(ae, Ee) {
          if (se === "executing")
            throw new Error("Generator is already running");
          if (se === "completed") {
            if (ae === "throw")
              throw Ee;
            return ge();
          }
          for (q.method = ae, q.arg = Ee; ; ) {
            var Se = q.delegate;
            if (Se) {
              var Be = Me(Se, q);
              if (Be) {
                if (Be === A)
                  continue;
                return Be;
              }
            }
            if (q.method === "next")
              q.sent = q._sent = q.arg;
            else if (q.method === "throw") {
              if (se === "suspendedStart")
                throw se = "completed", q.arg;
              q.dispatchException(q.arg);
            } else
              q.method === "return" && q.abrupt("return", q.arg);
            se = "executing";
            var Re = m(L, _, q);
            if (Re.type === "normal") {
              if (se = q.done ? "completed" : "suspendedYield", Re.arg === A)
                continue;
              return {
                value: Re.arg,
                done: q.done
              };
            }
            Re.type === "throw" && (se = "completed", q.method = "throw", q.arg = Re.arg);
          }
        };
      }
      function Me(L, _) {
        var q = _.method, se = L.iterator[q];
        if (se === void 0)
          return _.delegate = null, q === "throw" && L.iterator.return && (_.method = "return", _.arg = void 0, Me(L, _), _.method === "throw") || q !== "return" && (_.method = "throw", _.arg = new TypeError("The iterator does not provide a '" + q + "' method")), A;
        var ae = m(se, L.iterator, _.arg);
        if (ae.type === "throw")
          return _.method = "throw", _.arg = ae.arg, _.delegate = null, A;
        var Ee = ae.arg;
        return Ee ? Ee.done ? (_[L.resultName] = Ee.value, _.next = L.nextLoc, _.method !== "return" && (_.method = "next", _.arg = void 0), _.delegate = null, A) : Ee : (_.method = "throw", _.arg = new TypeError("iterator result is not an object"), _.delegate = null, A);
      }
      function ye(L) {
        var _ = {
          tryLoc: L[0]
        };
        1 in L && (_.catchLoc = L[1]), 2 in L && (_.finallyLoc = L[2], _.afterLoc = L[3]), this.tryEntries.push(_);
      }
      function $(L) {
        var _ = L.completion || {};
        _.type = "normal", delete _.arg, L.completion = _;
      }
      function G(L) {
        this.tryEntries = [{
          tryLoc: "root"
        }], L.forEach(ye, this), this.reset(!0);
      }
      function X(L) {
        if (L) {
          var _ = L[h];
          if (_)
            return _.call(L);
          if (typeof L.next == "function")
            return L;
          if (!isNaN(L.length)) {
            var q = -1, se = function ae() {
              for (; ++q < L.length; )
                if (s.call(L, q))
                  return ae.value = L[q], ae.done = !1, ae;
              return ae.value = void 0, ae.done = !0, ae;
            };
            return se.next = se;
          }
        }
        return {
          next: ge
        };
      }
      function ge() {
        return {
          value: void 0,
          done: !0
        };
      }
      return S.prototype = N, f(R, "constructor", {
        value: N,
        configurable: !0
      }), f(N, "constructor", {
        value: S,
        configurable: !0
      }), S.displayName = g(N, b, "GeneratorFunction"), n.isGeneratorFunction = function(L) {
        var _ = typeof L == "function" && L.constructor;
        return !!_ && (_ === S || (_.displayName || _.name) === "GeneratorFunction");
      }, n.mark = function(L) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(L, N) : (L.__proto__ = N, g(L, b, "GeneratorFunction")), L.prototype = Object.create(R), L;
      }, n.awrap = function(L) {
        return {
          __await: L
        };
      }, F(Y.prototype), g(Y.prototype, p, function() {
        return this;
      }), n.AsyncIterator = Y, n.async = function(L, _, q, se, ae) {
        ae === void 0 && (ae = Promise);
        var Ee = new Y(E(L, _, q, se), ae);
        return n.isGeneratorFunction(_) ? Ee : Ee.next().then(function(Se) {
          return Se.done ? Se.value : Ee.next();
        });
      }, F(R), g(R, b, "Generator"), g(R, h, function() {
        return this;
      }), g(R, "toString", function() {
        return "[object Generator]";
      }), n.keys = function(L) {
        var _ = Object(L), q = [];
        for (var se in _)
          q.push(se);
        return q.reverse(), function ae() {
          for (; q.length; ) {
            var Ee = q.pop();
            if (Ee in _)
              return ae.value = Ee, ae.done = !1, ae;
          }
          return ae.done = !0, ae;
        };
      }, n.values = X, G.prototype = {
        constructor: G,
        reset: function(_) {
          if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach($), !_)
            for (var q in this)
              q.charAt(0) === "t" && s.call(this, q) && !isNaN(+q.slice(1)) && (this[q] = void 0);
        },
        stop: function() {
          this.done = !0;
          var _ = this.tryEntries[0].completion;
          if (_.type === "throw")
            throw _.arg;
          return this.rval;
        },
        dispatchException: function(_) {
          if (this.done)
            throw _;
          var q = this;
          function se(Fe, be) {
            return Se.type = "throw", Se.arg = _, q.next = Fe, be && (q.method = "next", q.arg = void 0), !!be;
          }
          for (var ae = this.tryEntries.length - 1; ae >= 0; --ae) {
            var Ee = this.tryEntries[ae], Se = Ee.completion;
            if (Ee.tryLoc === "root")
              return se("end");
            if (Ee.tryLoc <= this.prev) {
              var Be = s.call(Ee, "catchLoc"), Re = s.call(Ee, "finallyLoc");
              if (Be && Re) {
                if (this.prev < Ee.catchLoc)
                  return se(Ee.catchLoc, !0);
                if (this.prev < Ee.finallyLoc)
                  return se(Ee.finallyLoc);
              } else if (Be) {
                if (this.prev < Ee.catchLoc)
                  return se(Ee.catchLoc, !0);
              } else {
                if (!Re)
                  throw new Error("try statement without catch or finally");
                if (this.prev < Ee.finallyLoc)
                  return se(Ee.finallyLoc);
              }
            }
          }
        },
        abrupt: function(_, q) {
          for (var se = this.tryEntries.length - 1; se >= 0; --se) {
            var ae = this.tryEntries[se];
            if (ae.tryLoc <= this.prev && s.call(ae, "finallyLoc") && this.prev < ae.finallyLoc) {
              var Ee = ae;
              break;
            }
          }
          Ee && (_ === "break" || _ === "continue") && Ee.tryLoc <= q && q <= Ee.finallyLoc && (Ee = null);
          var Se = Ee ? Ee.completion : {};
          return Se.type = _, Se.arg = q, Ee ? (this.method = "next", this.next = Ee.finallyLoc, A) : this.complete(Se);
        },
        complete: function(_, q) {
          if (_.type === "throw")
            throw _.arg;
          return _.type === "break" || _.type === "continue" ? this.next = _.arg : _.type === "return" ? (this.rval = this.arg = _.arg, this.method = "return", this.next = "end") : _.type === "normal" && q && (this.next = q), A;
        },
        finish: function(_) {
          for (var q = this.tryEntries.length - 1; q >= 0; --q) {
            var se = this.tryEntries[q];
            if (se.finallyLoc === _)
              return this.complete(se.completion, se.afterLoc), $(se), A;
          }
        },
        catch: function(_) {
          for (var q = this.tryEntries.length - 1; q >= 0; --q) {
            var se = this.tryEntries[q];
            if (se.tryLoc === _) {
              var ae = se.completion;
              if (ae.type === "throw") {
                var Ee = ae.arg;
                $(se);
              }
              return Ee;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function(_, q, se) {
          return this.delegate = {
            iterator: X(_),
            resultName: q,
            nextLoc: se
          }, this.method === "next" && (this.arg = void 0), A;
        }
      }, n;
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Ps)), Ps.exports;
}
var Us, ef;
function _y() {
  if (ef)
    return Us;
  ef = 1;
  var e = Cy()();
  Us = e;
  try {
    regeneratorRuntime = e;
  } catch {
    typeof globalThis == "object" ? globalThis.regeneratorRuntime = e : Function("r", "regeneratorRuntime = r")(e);
  }
  return Us;
}
var Bs = { exports: {} }, tf;
function Oy() {
  return tf || (tf = 1, function(e) {
    function t(n, o, s, f, l, h, p) {
      try {
        var b = n[h](p), g = b.value;
      } catch (E) {
        s(E);
        return;
      }
      b.done ? o(g) : Promise.resolve(g).then(f, l);
    }
    function r(n) {
      return function() {
        var o = this, s = arguments;
        return new Promise(function(f, l) {
          var h = n.apply(o, s);
          function p(g) {
            t(h, f, l, p, b, "next", g);
          }
          function b(g) {
            t(h, f, l, p, b, "throw", g);
          }
          p(void 0);
        });
      };
    }
    e.exports = r, e.exports.__esModule = !0, e.exports.default = e.exports;
  }(Bs)), Bs.exports;
}
var rf;
function Ny() {
  return rf || (rf = 1, function(e) {
    var t = es.exports;
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var r = t(_y()), n = t(Oy()), o = t(ki()), s = t(Va()), f = t(Qa()), l = t(Ha()), h = t(Za()), p = t(Ka()), b = sl();
    function g(w) {
      var S = E();
      return function() {
        var P = (0, p.default)(w), C;
        if (S) {
          var B = (0, p.default)(this).constructor;
          C = Reflect.construct(P, arguments, B);
        } else
          C = P.apply(this, arguments);
        return (0, h.default)(this, C);
      };
    }
    function E() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    var m = function(w, S) {
      var N = {};
      for (var P in w)
        Object.prototype.hasOwnProperty.call(w, P) && S.indexOf(P) < 0 && (N[P] = w[P]);
      if (w != null && typeof Object.getOwnPropertySymbols == "function")
        for (var C = 0, P = Object.getOwnPropertySymbols(w); C < P.length; C++)
          S.indexOf(P[C]) < 0 && Object.prototype.propertyIsEnumerable.call(w, P[C]) && (N[P[C]] = w[P[C]]);
      return N;
    }, A = /* @__PURE__ */ function(w) {
      (0, l.default)(N, w);
      var S = g(N);
      function N(P) {
        var C, B = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "ws://localhost:8080", R = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, F = arguments.length > 3 ? arguments[3] : void 0;
        (0, s.default)(this, N);
        var Y = R.autoconnect, K = Y === void 0 ? !0 : Y, Me = R.reconnect, ye = Me === void 0 ? !0 : Me, $ = R.reconnect_interval, G = $ === void 0 ? 1e3 : $, X = R.max_reconnects, ge = X === void 0 ? 5 : X, L = m(R, ["autoconnect", "reconnect", "reconnect_interval", "max_reconnects"]);
        return C = S.call(this), C.webSocketFactory = P, C.queue = {}, C.rpc_id = 0, C.address = B, C.autoconnect = K, C.ready = !1, C.reconnect = ye, C.reconnect_timer_id = void 0, C.reconnect_interval = G, C.max_reconnects = ge, C.rest_options = L, C.current_reconnects = 0, C.generate_request_id = F || function() {
          return ++C.rpc_id;
        }, C.autoconnect && C._connect(C.address, Object.assign({
          autoconnect: C.autoconnect,
          reconnect: C.reconnect,
          reconnect_interval: C.reconnect_interval,
          max_reconnects: C.max_reconnects
        }, C.rest_options)), C;
      }
      return (0, f.default)(N, [{
        key: "connect",
        value: function() {
          this.socket || this._connect(this.address, Object.assign({
            autoconnect: this.autoconnect,
            reconnect: this.reconnect,
            reconnect_interval: this.reconnect_interval,
            max_reconnects: this.max_reconnects
          }, this.rest_options));
        }
      }, {
        key: "call",
        value: function(C, B, R, F) {
          var Y = this;
          return !F && (0, o.default)(R) === "object" && (F = R, R = null), new Promise(function(K, Me) {
            if (!Y.ready)
              return Me(new Error("socket not ready"));
            var ye = Y.generate_request_id(C, B), $ = {
              jsonrpc: "2.0",
              method: C,
              params: B || null,
              id: ye
            };
            Y.socket.send(JSON.stringify($), F, function(G) {
              if (G)
                return Me(G);
              Y.queue[ye] = {
                promise: [K, Me]
              }, R && (Y.queue[ye].timeout = setTimeout(function() {
                delete Y.queue[ye], Me(new Error("reply timeout"));
              }, R));
            });
          });
        }
      }, {
        key: "login",
        value: function() {
          var P = (0, n.default)(/* @__PURE__ */ r.default.mark(function B(R) {
            var F;
            return r.default.wrap(function(K) {
              for (; ; )
                switch (K.prev = K.next) {
                  case 0:
                    return K.next = 2, this.call("rpc.login", R);
                  case 2:
                    if (F = K.sent, F) {
                      K.next = 5;
                      break;
                    }
                    throw new Error("authentication failed");
                  case 5:
                    return K.abrupt("return", F);
                  case 6:
                  case "end":
                    return K.stop();
                }
            }, B, this);
          }));
          function C(B) {
            return P.apply(this, arguments);
          }
          return C;
        }()
      }, {
        key: "listMethods",
        value: function() {
          var P = (0, n.default)(/* @__PURE__ */ r.default.mark(function B() {
            return r.default.wrap(function(F) {
              for (; ; )
                switch (F.prev = F.next) {
                  case 0:
                    return F.next = 2, this.call("__listMethods");
                  case 2:
                    return F.abrupt("return", F.sent);
                  case 3:
                  case "end":
                    return F.stop();
                }
            }, B, this);
          }));
          function C() {
            return P.apply(this, arguments);
          }
          return C;
        }()
      }, {
        key: "notify",
        value: function(C, B) {
          var R = this;
          return new Promise(function(F, Y) {
            if (!R.ready)
              return Y(new Error("socket not ready"));
            var K = {
              jsonrpc: "2.0",
              method: C,
              params: B || null
            };
            R.socket.send(JSON.stringify(K), function(Me) {
              if (Me)
                return Y(Me);
              F();
            });
          });
        }
      }, {
        key: "subscribe",
        value: function() {
          var P = (0, n.default)(/* @__PURE__ */ r.default.mark(function B(R) {
            var F;
            return r.default.wrap(function(K) {
              for (; ; )
                switch (K.prev = K.next) {
                  case 0:
                    return typeof R == "string" && (R = [R]), K.next = 3, this.call("rpc.on", R);
                  case 3:
                    if (F = K.sent, !(typeof R == "string" && F[R] !== "ok")) {
                      K.next = 6;
                      break;
                    }
                    throw new Error("Failed subscribing to an event '" + R + "' with: " + F[R]);
                  case 6:
                    return K.abrupt("return", F);
                  case 7:
                  case "end":
                    return K.stop();
                }
            }, B, this);
          }));
          function C(B) {
            return P.apply(this, arguments);
          }
          return C;
        }()
      }, {
        key: "unsubscribe",
        value: function() {
          var P = (0, n.default)(/* @__PURE__ */ r.default.mark(function B(R) {
            var F;
            return r.default.wrap(function(K) {
              for (; ; )
                switch (K.prev = K.next) {
                  case 0:
                    return typeof R == "string" && (R = [R]), K.next = 3, this.call("rpc.off", R);
                  case 3:
                    if (F = K.sent, !(typeof R == "string" && F[R] !== "ok")) {
                      K.next = 6;
                      break;
                    }
                    throw new Error("Failed unsubscribing from an event with: " + F);
                  case 6:
                    return K.abrupt("return", F);
                  case 7:
                  case "end":
                    return K.stop();
                }
            }, B, this);
          }));
          function C(B) {
            return P.apply(this, arguments);
          }
          return C;
        }()
      }, {
        key: "close",
        value: function(C, B) {
          this.socket.close(C || 1e3, B);
        }
      }, {
        key: "_connect",
        value: function(C, B) {
          var R = this;
          clearTimeout(this.reconnect_timer_id), this.socket = this.webSocketFactory(C, B), this.socket.addEventListener("open", function() {
            R.ready = !0, R.emit("open"), R.current_reconnects = 0;
          }), this.socket.addEventListener("message", function(F) {
            var Y = F.data;
            Y instanceof ArrayBuffer && (Y = Buffer.from(Y).toString());
            try {
              Y = JSON.parse(Y);
            } catch {
              return;
            }
            if (Y.notification && R.listeners(Y.notification).length) {
              if (!Object.keys(Y.params).length)
                return R.emit(Y.notification);
              var K = [Y.notification];
              if (Y.params.constructor === Object)
                K.push(Y.params);
              else
                for (var Me = 0; Me < Y.params.length; Me++)
                  K.push(Y.params[Me]);
              return Promise.resolve().then(function() {
                R.emit.apply(R, K);
              });
            }
            if (!R.queue[Y.id])
              return Y.method && Y.params ? Promise.resolve().then(function() {
                R.emit(Y.method, Y.params);
              }) : void 0;
            "error" in Y == "result" in Y && R.queue[Y.id].promise[1](new Error('Server response malformed. Response must include either "result" or "error", but not both.')), R.queue[Y.id].timeout && clearTimeout(R.queue[Y.id].timeout), Y.error ? R.queue[Y.id].promise[1](Y.error) : R.queue[Y.id].promise[0](Y.result), delete R.queue[Y.id];
          }), this.socket.addEventListener("error", function(F) {
            return R.emit("error", F);
          }), this.socket.addEventListener("close", function(F) {
            var Y = F.code, K = F.reason;
            R.ready && setTimeout(function() {
              return R.emit("close", Y, K);
            }, 0), R.ready = !1, R.socket = void 0, Y !== 1e3 && (R.current_reconnects++, R.reconnect && (R.max_reconnects > R.current_reconnects || R.max_reconnects === 0) && (R.reconnect_timer_id = setTimeout(function() {
              return R._connect(C, B);
            }, R.reconnect_interval)));
          });
        }
      }]), N;
    }(b.EventEmitter);
    e.default = A;
  }(Rs)), Rs;
}
var Qn = es.exports;
Object.defineProperty(Ga, "__esModule", {
  value: !0
});
var al = Ga.Client = void 0, jy = Qn(Qa()), Dy = Qn(Va()), Ly = Qn(Ha()), Ry = Qn(Za()), nf = Qn(Ka()), Py = Qn(Iy()), Uy = Qn(Ny());
function By(e) {
  var t = ky();
  return function() {
    var n = (0, nf.default)(e), o;
    if (t) {
      var s = (0, nf.default)(this).constructor;
      o = Reflect.construct(n, arguments, s);
    } else
      o = n.apply(this, arguments);
    return (0, Ry.default)(this, o);
  };
}
function ky() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
var zy = /* @__PURE__ */ function(e) {
  (0, Ly.default)(r, e);
  var t = By(r);
  function r() {
    var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "ws://localhost:8080", o = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s = o.autoconnect, f = s === void 0 ? !0 : s, l = o.reconnect, h = l === void 0 ? !0 : l, p = o.reconnect_interval, b = p === void 0 ? 1e3 : p, g = o.max_reconnects, E = g === void 0 ? 5 : g, m = arguments.length > 2 ? arguments[2] : void 0;
    return (0, Dy.default)(this, r), t.call(this, Py.default, n, {
      autoconnect: f,
      reconnect: h,
      reconnect_interval: b,
      max_reconnects: E
    }, m);
  }
  return (0, jy.default)(r);
}(Uy.default);
al = Ga.Client = zy;
function cl(e) {
  return /^\d+\.\d+\.\d+$/.test(e);
}
function Ir(e) {
  if (!cl(e))
    throw new Error("Invalid semver version: " + e);
  const [t, r, n] = e.split(".").map((o) => parseInt(o, 10));
  return { major: t, minor: r, patch: n };
}
function Fy(e, t) {
  const r = Ir(e), n = Ir(t);
  return r.major !== n.major ? r.major < n.major : r.minor !== n.minor ? r.minor < n.minor : r.patch !== n.patch ? r.patch < n.patch : !1;
}
function $y(e, t) {
  const r = Ir(e), n = Ir(t);
  return r.major !== n.major ? r.major <= n.major : r.minor !== n.minor ? r.minor <= n.minor : r.patch !== n.patch ? r.patch <= n.patch : !0;
}
function Wy(e, t) {
  const r = Ir(e), n = Ir(t);
  return r.major !== n.major ? r.major > n.major : r.minor !== n.minor ? r.minor > n.minor : r.patch !== n.patch ? r.patch > n.patch : !1;
}
function qy(e, t) {
  const r = Ir(e), n = Ir(t);
  return r.major !== n.major ? r.major >= n.major : r.minor !== n.minor ? r.minor >= n.minor : r.patch !== n.patch ? r.patch >= n.patch : !0;
}
function Yy(e, t) {
  return Ir(e), Ir(t), e === t;
}
var of = {
  isValid: cl,
  parse: Ir,
  lt: Fy,
  lte: $y,
  gt: Wy,
  gte: qy,
  eq: Yy
}, Xa = (e, t, r) => {
  if (!t.has(e))
    throw TypeError("Cannot " + r);
}, nt = (e, t, r) => (Xa(e, t, "read from private field"), r ? r.call(e) : t.get(e)), Rn = (e, t, r) => {
  if (t.has(e))
    throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(e) : t.set(e, r);
}, Ei = (e, t, r, n) => (Xa(e, t, "write to private field"), n ? n.call(e, r) : t.set(e, r), r), kn = (e, t, r) => (Xa(e, t, "access private method"), r), sr = O(), Gy = O(), Qy = O(), Ze = O(), Yt = O(), Kt = O(), _n = et([
  H({
    AddressOwner: Yt
  }),
  H({
    ObjectOwner: Yt
  }),
  H({
    Shared: H({
      initial_shared_version: Qe()
    })
  }),
  Ue("Immutable")
]), Vy = dr("SuiJsonValue", () => !0), Hy = 32;
function sf(e) {
  try {
    return Ma(e).length === Hy;
  } catch {
    return !1;
  }
}
var ts = 32;
function bn(e) {
  return Zy(e) && Ky(e) === ts;
}
function eo(e) {
  return bn(e);
}
function _t(e, t = !1) {
  let r = e.toLowerCase();
  return !t && r.startsWith("0x") && (r = r.slice(2)), `0x${r.padStart(ts * 2, "0")}`;
}
function Rr(e, t = !1) {
  return _t(e, t);
}
function Zy(e) {
  return /^(0x|0X)?[a-fA-F0-9]+$/.test(e) && e.length % 2 === 0;
}
function Ky(e) {
  return /^(0x|0X)/.test(e) ? (e.length - 2) / 2 : e.length / 2;
}
et([O(), Ue("package")]);
var Pr = H({
  digest: sr,
  objectId: O(),
  version: et([Qe(), O()])
}), Xy = H({
  payment: de(Pr),
  owner: O(),
  price: O(),
  budget: O()
}), Jy = Zr(
  Pr,
  H({
    type: O(),
    owner: _n,
    previousTransaction: sr
  })
), eg = kr(O(), Jr()), tg = kr(O(), O()), fl = H({
  type: O(),
  fields: eg,
  hasPublicTransfer: ot()
}), na = H({
  disassembled: tg
}), rg = et([
  Zr(fl, H({ dataType: Ue("moveObject") })),
  Zr(na, H({ dataType: Ue("package") }))
]);
H({
  type: O(),
  hasPublicTransfer: ot(),
  version: Kt,
  bcsBytes: de(Qe())
});
var ng = H({
  id: Ze,
  moduleMap: kr(O(), O())
}), ig = et([
  Zr(fl, H({ dataType: Ue("moveObject") })),
  Zr(ng, H({ dataType: Ue("package") }))
]);
BigInt(1e9);
var Vn = O(), ul = H({
  code: O(),
  error: Ie(O()),
  object_id: Ie(Ze),
  version: Ie(Kt),
  digest: Ie(Vn)
}), og = H({
  data: it(kr(O(), O())),
  error: it(ul)
}), sg = et([
  og,
  Ie(kr(O(), O()))
]), ag = H({
  objectId: Ze,
  version: Kt,
  digest: Vn,
  type: Ie(O()),
  content: Ie(rg),
  bcs: Ie(ig),
  owner: Ie(_n),
  previousTransaction: Ie(sr),
  storageRebate: Ie(O()),
  display: Ie(sg)
});
H({
  showType: Ie(ot()),
  showContent: Ie(ot()),
  showBcs: Ie(ot()),
  showOwner: Ie(ot()),
  showPreviousTransaction: Ie(ot()),
  showStorageRebate: Ie(ot()),
  showDisplay: Ie(ot())
});
et([
  Ue("Exists"),
  Ue("notExists"),
  Ue("Deleted")
]);
de(Jy);
var fo = H({
  data: Ie(ag),
  error: Ie(ul)
});
function rs(e) {
  return e.data;
}
function cg(e) {
  if (e.error && "object_id" in e.error && "version" in e.error && "digest" in e.error) {
    const t = e.error;
    return {
      objectId: t.object_id,
      version: t.version,
      digest: t.digest
    };
  }
}
function fg(e) {
  if (e.error && "object_id" in e.error && !("version" in e.error) && !("digest" in e.error))
    return e.error.object_id;
}
function ll(e) {
  if ("reference" in e)
    return e.reference;
  const t = rs(e);
  return t ? {
    objectId: t.objectId,
    version: t.version,
    digest: t.digest
  } : cg(e);
}
function ug(e) {
  return "objectId" in e ? e.objectId : ll(e)?.objectId ?? fg(e);
}
function lg(e) {
  return e.data !== void 0;
}
function dg(e) {
  const t = lg(e) ? e.data : e;
  return !t?.type && "data" in e ? t?.content?.dataType === "package" ? "package" : yg(e) : t?.type;
}
function hg(e) {
  return Ot(e, _n) ? e : rs(e)?.owner;
}
function pg(e) {
  const t = hg(e);
  if (typeof t == "object" && "Shared" in t)
    return t.Shared.initial_shared_version;
}
function yg(e) {
  return jo(e)?.type;
}
function gg(e) {
  return "fields" in e ? e.fields : jo(e)?.fields;
}
function vg(e) {
  return e.content !== void 0;
}
function jo(e) {
  const t = "data" in e ? rs(e) : e;
  if (!(!t || !vg(t) || t.content.dataType !== "moveObject"))
    return t.content;
}
var bg = H({
  objectId: Ze,
  atCheckpoint: Ie(Qe())
}), xg = H({
  data: de(fo),
  nextCursor: et([it(Ze), it(bg)]),
  hasNextPage: ot()
}), dl = H({
  txDigest: sr,
  eventSeq: Kt
}), Ja = H({
  id: dl,
  packageId: Ze,
  transactionModule: O(),
  sender: Yt,
  type: O(),
  parsedJson: Ie(kr(O(), Jr())),
  bcs: Ie(O()),
  timestampMs: Ie(O())
}), wg = H({
  data: de(Ja),
  nextCursor: it(dl),
  hasNextPage: ot()
}), mg = Qe(), Eg = H({
  subscription: mg,
  result: Ja
}), Wn = O(), Ag = H({
  epoch: Wn,
  storage_charge: O(),
  computation_charge: O(),
  storage_rebate: O(),
  epoch_start_timestamp_ms: Ie(O())
}), Sg = H({
  epoch: Wn,
  round: O(),
  commit_timestamp_ms: O()
}), Tg = H({
  objects: de(Ze)
}), Er = et([
  Ue("GasCoin"),
  H({ Input: Qe() }),
  H({ Result: Qe() }),
  H({ NestedResult: Ft([Qe(), Qe()]) })
]), Mg = H({
  arguments: Ie(de(Er)),
  type_arguments: Ie(de(O())),
  package: Ze,
  module: O(),
  function: O()
}), Ig = et([
  H({ MoveCall: Mg }),
  H({ TransferObjects: Ft([de(Er), Er]) }),
  H({ SplitCoins: Ft([Er, de(Er)]) }),
  H({ MergeCoins: Ft([Er, de(Er)]) }),
  H({
    Publish: et([
      Ft([na, de(Ze)]),
      de(Ze)
    ])
  }),
  H({
    Upgrade: et([
      Ft([na, de(Ze), Ze, Er]),
      Ft([de(Ze), Ze, Er])
    ])
  }),
  H({ MakeMoveVec: Ft([it(O()), de(Er)]) })
]), Cg = et([
  H({
    type: Ue("pure"),
    valueType: Ie(O()),
    value: Vy
  }),
  H({
    type: Ue("object"),
    objectType: Ue("immOrOwnedObject"),
    objectId: Ze,
    version: Kt,
    digest: Vn
  }),
  H({
    type: Ue("object"),
    objectType: Ue("sharedObject"),
    objectId: Ze,
    initialSharedVersion: Kt,
    mutable: ot()
  })
]), _g = H({
  transactions: de(Ig),
  inputs: de(Cg)
}), Og = et([
  Zr(Ag, H({ kind: Ue("ChangeEpoch") })),
  Zr(
    Sg,
    H({
      kind: Ue("ConsensusCommitPrologue")
    })
  ),
  Zr(Tg, H({ kind: Ue("Genesis") })),
  Zr(
    _g,
    H({ kind: Ue("ProgrammableTransaction") })
  )
]), hl = H({
  messageVersion: Ue("v1"),
  transaction: Og,
  sender: Yt,
  gasData: Xy
}), af = O(), Ng = et([
  af,
  de(af)
]);
H({
  epoch: Wn,
  signature: Ng,
  signers_map: de(Qe())
});
var jg = H({
  computationCost: O(),
  storageCost: O(),
  storageRebate: O(),
  nonRefundableStorageFee: O()
}), Dg = et([
  Ue("success"),
  Ue("failure")
]), Lg = H({
  status: Dg,
  error: Ie(O())
}), to = H({
  owner: _n,
  reference: Pr
}), Rg = H({
  objectId: Ze,
  sequenceNumber: Kt
}), ec = H({
  messageVersion: Ue("v1"),
  status: Lg,
  executedEpoch: Wn,
  modifiedAtVersions: Ie(de(Rg)),
  gasUsed: jg,
  sharedObjects: Ie(de(Pr)),
  transactionDigest: sr,
  created: Ie(de(to)),
  mutated: Ie(de(to)),
  unwrapped: Ie(de(to)),
  deleted: Ie(de(Pr)),
  unwrapped_then_deleted: Ie(de(Pr)),
  wrapped: Ie(de(Pr)),
  gasObject: to,
  eventsDigest: Ie(Qy),
  dependencies: Ie(de(sr))
}), tc = de(Ja), Pg = Ft([de(Qe()), O()]), Ug = Ft([
  Er,
  de(Qe()),
  O()
]), Bg = H({
  mutableReferenceOutputs: Ie(de(Ug)),
  returnValues: Ie(de(Pg))
}), kg = H({
  effects: ec,
  events: tc,
  results: Ie(de(Bg)),
  error: Ie(O())
}), zg = O(), Fg = H({
  data: hl,
  txSignatures: de(O())
}), $g = H({
  type: Ue("published"),
  packageId: Ze,
  version: Kt,
  digest: Vn,
  modules: de(O())
}), Wg = H({
  type: Ue("transferred"),
  sender: Yt,
  recipient: _n,
  objectType: O(),
  objectId: Ze,
  version: Kt,
  digest: Vn
}), qg = H({
  type: Ue("mutated"),
  sender: Yt,
  owner: _n,
  objectType: O(),
  objectId: Ze,
  version: Kt,
  previousVersion: Kt,
  digest: Vn
}), Yg = H({
  type: Ue("deleted"),
  sender: Yt,
  objectType: O(),
  objectId: Ze,
  version: Kt
}), Gg = H({
  type: Ue("wrapped"),
  sender: Yt,
  objectType: O(),
  objectId: Ze,
  version: Kt
}), Qg = H({
  type: Ue("created"),
  sender: Yt,
  owner: _n,
  objectType: O(),
  objectId: Ze,
  version: Kt,
  digest: Vn
}), pl = et([
  $g,
  Wg,
  qg,
  Yg,
  Gg,
  Qg
]), yl = H({
  owner: _n,
  coinType: O(),
  amount: O()
}), uo = H({
  digest: sr,
  transaction: Ie(Fg),
  effects: Ie(ec),
  events: Ie(tc),
  timestampMs: Ie(O()),
  checkpoint: Ie(O()),
  confirmedLocalExecution: Ie(ot()),
  objectChanges: Ie(de(pl)),
  balanceChanges: Ie(de(yl)),
  errors: Ie(de(O()))
});
H({
  showInput: Ie(ot()),
  showEffects: Ie(ot()),
  showEvents: Ie(ot()),
  showObjectChanges: Ie(ot()),
  showBalanceChanges: Ie(ot())
});
var Vg = H({
  data: de(uo),
  nextCursor: it(sr),
  hasNextPage: ot()
}), Hg = H({
  effects: ec,
  events: tc,
  objectChanges: de(pl),
  balanceChanges: de(yl),
  input: Ie(hl)
}), gl = "0x2", rc = "0x1", Zg = "object", Kg = "ID", nc = `${gl}::sui::SUI`;
Rr("0x6");
var cf = /^0x2::coin::Coin<(.+)>$/;
function Xg(e) {
  return !!e.data || !!e.type;
}
var Jg = H({
  decimals: Qe(),
  name: O(),
  symbol: O(),
  description: O(),
  iconUrl: it(O()),
  id: it(Ze)
}), Ht = class {
  static isCoin(e) {
    return Ht.getType(e)?.match(cf) != null;
  }
  static getCoinType(e) {
    const [, t] = e.match(cf) ?? [];
    return t || null;
  }
  static getCoinTypeArg(e) {
    const t = Ht.getType(e);
    return t ? Ht.getCoinType(t) : null;
  }
  static isSUI(e) {
    const t = Ht.getCoinTypeArg(e);
    return t ? Ht.getCoinSymbol(t) === "SUI" : !1;
  }
  static getCoinSymbol(e) {
    return e.substring(e.lastIndexOf(":") + 1);
  }
  static getCoinStructTag(e) {
    return {
      address: Rr(e.split("::")[0]),
      module: e.split("::")[1],
      name: e.split("::")[2],
      typeParams: []
    };
  }
  static getID(e) {
    return "fields" in e ? e.fields.id.id : ug(e);
  }
  static totalBalance(e) {
    return e.reduce(
      (t, r) => t + Ht.getBalanceFromCoinStruct(r),
      BigInt(0)
    );
  }
  static sortByBalance(e) {
    return [...e].sort(
      (t, r) => Ht.getBalanceFromCoinStruct(t) < Ht.getBalanceFromCoinStruct(r) ? -1 : Ht.getBalanceFromCoinStruct(t) > Ht.getBalanceFromCoinStruct(r) ? 1 : 0
    );
  }
  static getBalanceFromCoinStruct(e) {
    return BigInt(e.balance);
  }
  static getBalance(e) {
    if (!Ht.isCoin(e))
      return;
    const t = gg(e)?.balance;
    return BigInt(t);
  }
  static getType(e) {
    return Xg(e) ? dg(e) : e.type;
  }
}, ei = "vector", ev = {
  kind: "TransactionKind",
  sender: ze.ADDRESS,
  gasData: "GasData",
  expiration: "TransactionExpiration"
}, tv = {
  enums: {
    "Option<T>": {
      None: null,
      Some: "T"
    },
    ObjectArg: {
      ImmOrOwned: "SuiObjectRef",
      Shared: "SharedObjectRef"
    },
    CallArg: {
      Pure: [ei, ze.U8],
      Object: "ObjectArg",
      ObjVec: [ei, "ObjectArg"]
    },
    TypeTag: {
      bool: null,
      u8: null,
      u64: null,
      u128: null,
      address: null,
      signer: null,
      vector: "TypeTag",
      struct: "StructTag",
      u16: null,
      u32: null,
      u256: null
    },
    TransactionKind: {
      ProgrammableTransaction: "ProgrammableTransaction",
      ChangeEpoch: null,
      Genesis: null,
      ConsensusCommitPrologue: null
    },
    TransactionExpiration: {
      None: null,
      Epoch: ze.U64
    },
    TransactionData: {
      V1: "TransactionDataV1"
    }
  },
  structs: {
    SuiObjectRef: {
      objectId: ze.ADDRESS,
      version: ze.U64,
      digest: "ObjectDigest"
    },
    SharedObjectRef: {
      objectId: ze.ADDRESS,
      initialSharedVersion: ze.U64,
      mutable: ze.BOOL
    },
    StructTag: {
      address: ze.ADDRESS,
      module: ze.STRING,
      name: ze.STRING,
      typeParams: [ei, "TypeTag"]
    },
    GasData: {
      payment: [ei, "SuiObjectRef"],
      owner: ze.ADDRESS,
      price: ze.U64,
      budget: ze.U64
    },
    SenderSignedData: {
      data: "TransactionData",
      txSignatures: [ei, [ei, ze.U8]]
    },
    TransactionDataV1: ev
  },
  aliases: {
    ObjectDigest: ze.BASE58
  }
}, vl = new ze({ ...jh(), types: tv });
vl.registerType(
  "utf8string",
  (e, t) => {
    const r = Array.from(new TextEncoder().encode(t));
    return e.writeVec(r, (n, o) => n.write8(o));
  },
  (e) => {
    let t = e.readVec((r) => r.read8());
    return new TextDecoder().decode(new Uint8Array(t));
  }
);
var rv = H({
  amount: Qe(),
  id: Ze,
  transferTxDigest: sr
});
H({
  transferredGasObjects: de(rv),
  error: it(O())
});
var nv = et([
  O(),
  H({ Object: O() })
]), iv = de(nv), ov = H({
  address: O(),
  name: O()
}), sv = et([
  Ue("Private"),
  Ue("Public"),
  Ue("Friend")
]), ic = H({
  abilities: de(O())
}), av = H({
  constraints: ic,
  isPhantom: ot()
}), cv = H({
  TypeParameter: Qe()
}), ks = Ft([
  H({
    module: O(),
    package: O(),
    function: O()
  }),
  O()
]), fv = H({
  rank3Days: de(ks),
  rank7Days: de(ks),
  rank30Days: de(ks)
});
function bl(e) {
  if (!e)
    return !1;
  if (typeof e == "string" || Ot(e, cv) || xl(e))
    return !0;
  if (typeof e != "object")
    return !1;
  const t = e;
  return !!(Ot(t.Reference, ii) || Ot(t.MutableReference, ii) || Ot(t.Vector, ii));
}
var ii = dr(
  "SuiMoveNormalizedType",
  bl
);
function xl(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = e;
  if (!t.Struct || typeof t.Struct != "object")
    return !1;
  const r = t.Struct;
  return !(typeof r.address != "string" || typeof r.module != "string" || typeof r.name != "string" || !Array.isArray(r.typeArguments) || !r.typeArguments.every(
    (n) => bl(n)
  ));
}
dr(
  "SuiMoveNormalizedStructType",
  xl
);
var wl = H({
  visibility: sv,
  isEntry: ot(),
  typeParameters: de(ic),
  parameters: de(ii),
  return: de(ii)
}), uv = H({
  name: O(),
  type: ii
}), ml = H({
  abilities: ic,
  typeParameters: de(av),
  fields: de(uv)
}), El = H({
  fileFormatVersion: Qe(),
  address: O(),
  name: O(),
  friends: de(ov),
  structs: kr(O(), ml),
  exposedFunctions: kr(O(), wl)
}), lv = kr(
  O(),
  El
);
function Al(e) {
  return typeof e == "object" && "MutableReference" in e ? e.MutableReference : void 0;
}
function dv(e) {
  return typeof e == "object" && "Reference" in e ? e.Reference : void 0;
}
function Sl(e) {
  if (typeof e == "object" && "Struct" in e)
    return e;
  const t = dv(e), r = Al(e);
  if (typeof t == "object" && "Struct" in t)
    return t;
  if (typeof r == "object" && "Struct" in r)
    return r;
}
var hv = H({
  apy: Qe(),
  address: Yt
}), pv = H({
  epoch: O(),
  apys: de(hv)
});
H({
  value: Qe()
});
var yv = H({
  stakedSuiId: Ze,
  stakeRequestEpoch: Wn,
  stakeActiveEpoch: Wn,
  principal: O(),
  status: et([Ue("Active"), Ue("Pending"), Ue("Unstaked")]),
  estimatedReward: Ie(O())
}), ff = H({
  validatorAddress: Yt,
  stakingPool: Ze,
  stakes: de(yv)
}), gv = H({
  balance: H({ value: Qe() }),
  distribution_counter: Qe(),
  current_distribution_amount: Qe(),
  stake_subsidy_period_length: Qe(),
  stake_subsidy_decrease_rate: Qe()
});
H({
  type: O(),
  fields: gv
});
H({
  value: Qe()
});
var vv = H({
  id: O(),
  size: Qe(),
  head: H({ vec: de() }),
  tail: H({ vec: de() })
});
H({
  id: O(),
  size: Qe()
});
H({
  type: O(),
  fields: vv
});
var bv = H({
  exchangeRates: H({
    id: O(),
    size: Qe()
  }),
  id: O(),
  pendingStake: Qe(),
  pendingPoolTokenWithdraw: Qe(),
  pendingTotalSuiWithdraw: Qe(),
  poolTokenBalance: Qe(),
  rewardsPool: H({ value: Qe() }),
  activationEpoch: H({ vec: de() }),
  deactivationEpoch: H({ vec: de() }),
  suiBalance: Qe()
});
H({
  type: O(),
  fields: bv
});
var xv = de(Ft([zg, O()])), wv = H({
  epoch: Wn,
  validators: xv
}), Tl = H({
  suiAddress: Yt,
  protocolPubkeyBytes: O(),
  networkPubkeyBytes: O(),
  workerPubkeyBytes: O(),
  proofOfPossessionBytes: O(),
  operationCapId: O(),
  name: O(),
  description: O(),
  imageUrl: O(),
  projectUrl: O(),
  p2pAddress: O(),
  netAddress: O(),
  primaryAddress: O(),
  workerAddress: O(),
  nextEpochProtocolPubkeyBytes: it(O()),
  nextEpochProofOfPossession: it(O()),
  nextEpochNetworkPubkeyBytes: it(O()),
  nextEpochWorkerPubkeyBytes: it(O()),
  nextEpochNetAddress: it(O()),
  nextEpochP2pAddress: it(O()),
  nextEpochPrimaryAddress: it(O()),
  nextEpochWorkerAddress: it(O()),
  votingPower: O(),
  gasPrice: O(),
  commissionRate: O(),
  nextEpochStake: O(),
  nextEpochGasPrice: O(),
  nextEpochCommissionRate: O(),
  stakingPoolId: O(),
  stakingPoolActivationEpoch: it(O()),
  stakingPoolDeactivationEpoch: it(O()),
  stakingPoolSuiBalance: O(),
  rewardsPool: O(),
  poolTokenBalance: O(),
  pendingStake: O(),
  pendingPoolTokenWithdraw: O(),
  pendingTotalSuiWithdraw: O(),
  exchangeRatesId: O(),
  exchangeRatesSize: O()
}), mv = H({
  epoch: O(),
  protocolVersion: O(),
  systemStateVersion: O(),
  storageFundTotalObjectStorageRebates: O(),
  storageFundNonRefundableBalance: O(),
  referenceGasPrice: O(),
  safeMode: ot(),
  safeModeStorageRewards: O(),
  safeModeComputationRewards: O(),
  safeModeStorageRebates: O(),
  safeModeNonRefundableStorageFee: O(),
  epochStartTimestampMs: O(),
  epochDurationMs: O(),
  stakeSubsidyStartEpoch: O(),
  maxValidatorCount: O(),
  minValidatorJoiningStake: O(),
  validatorLowStakeThreshold: O(),
  validatorVeryLowStakeThreshold: O(),
  validatorLowStakeGracePeriod: O(),
  stakeSubsidyBalance: O(),
  stakeSubsidyDistributionCounter: O(),
  stakeSubsidyCurrentDistributionAmount: O(),
  stakeSubsidyPeriodLength: O(),
  stakeSubsidyDecreaseRate: Qe(),
  totalStake: O(),
  activeValidators: de(Tl),
  pendingActiveValidatorsId: O(),
  pendingActiveValidatorsSize: O(),
  pendingRemovals: de(O()),
  stakingPoolMappingsId: O(),
  stakingPoolMappingsSize: O(),
  inactivePoolsId: O(),
  inactivePoolsSize: O(),
  validatorCandidatesId: O(),
  validatorCandidatesSize: O(),
  atRiskValidators: de(Ft([Yt, O()])),
  validatorReportRecords: de(Ft([Yt, de(Yt)]))
}), Ev = H({
  coinType: O(),
  coinObjectId: Ze,
  version: O(),
  digest: sr,
  balance: O(),
  lockedUntilEpoch: Ie(it(Qe())),
  previousTransaction: sr
}), uf = H({
  data: de(Ev),
  nextCursor: it(Ze),
  hasNextPage: ot()
}), lf = H({
  coinType: O(),
  coinObjectCount: Qe(),
  totalBalance: O(),
  lockedBalance: H({
    epochId: Ie(Qe()),
    number: Ie(Qe())
  })
}), Av = H({
  value: O()
}), Sv = H({
  lastCheckpointId: O(),
  epochEndTimestamp: O(),
  protocolVersion: O(),
  referenceGasPrice: O(),
  totalStake: O(),
  storageFundReinvestment: O(),
  storageCharge: O(),
  storageRebate: O(),
  storageFundBalance: O(),
  stakeSubsidyAmount: O(),
  totalGasFees: O(),
  totalStakeRewardsDistributed: O(),
  leftoverStorageFundInflow: O()
}), Ml = H({
  epoch: O(),
  validators: de(Tl),
  epochTotalTransactions: O(),
  firstCheckpointId: O(),
  epochStartTimestamp: O(),
  endOfEpochInfo: it(Sv)
}), Tv = H({
  data: de(Ml),
  nextCursor: it(O()),
  hasNextPage: ot()
}), Mv = H({
  computationCost: O(),
  storageCost: O(),
  storageRebate: O(),
  nonRefundableStorageFee: O()
});
O();
var df = O();
H({
  digest: de(Qe())
});
var Il = Jr(), Iv = O(), Cv = H({
  nextEpochCommittee: de(Ft([O(), O()])),
  nextEpochProtocolVersion: O(),
  epochCommitments: de(Il)
});
H({
  transaction: sr,
  effects: Gy
});
var Cl = H({
  epoch: O(),
  sequenceNumber: O(),
  digest: df,
  networkTotalTransactions: O(),
  previousDigest: Ie(df),
  epochRollingGasCostSummary: Mv,
  timestampMs: O(),
  endOfEpochData: Ie(Cv),
  validatorSignature: Ie(Iv),
  transactions: de(sr),
  checkpointCommitments: de(Il)
}), _v = H({
  data: de(Cl),
  nextCursor: it(O()),
  hasNextPage: ot()
}), _l = {
  ED25519: 0,
  Secp256k1: 1
}, Ov = {
  0: "ED25519",
  1: "Secp256k1"
};
function Nv(e) {
  const t = Mr(e), r = Ov[t[0]], n = r === "ED25519" ? Ol : jl, o = t.slice(1, t.length - n.SIZE), s = t.slice(1 + o.length), f = new n(s);
  return {
    signatureScheme: r,
    signature: o,
    pubKey: f
  };
}
var lo = 32, Ol = class {
  constructor(e) {
    if (typeof e == "string" ? this.data = Mr(e) : e instanceof Uint8Array ? this.data = e : this.data = Uint8Array.from(e), this.data.length !== lo)
      throw new Error(
        `Invalid public key input. Expected ${lo} bytes, got ${this.data.length}`
      );
  }
  equals(e) {
    return Nl(this.toBytes(), e.toBytes());
  }
  toBase64() {
    return Hr(this.toBytes());
  }
  toBytes() {
    return this.data;
  }
  toString() {
    return this.toBase64();
  }
  toSuiAddress() {
    let e = new Uint8Array(lo + 1);
    return e.set([_l.ED25519]), e.set(this.toBytes(), 1), _t(
      Ia(Na(e, { dkLen: 32 })).slice(0, ts * 2)
    );
  }
};
Ol.SIZE = lo;
function Nl(e, t) {
  if (e === t)
    return !0;
  if (e.length !== t.length)
    return !1;
  for (let r = 0; r < e.length; r++)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
var ho = 33, jl = class {
  constructor(e) {
    if (typeof e == "string" ? this.data = Mr(e) : e instanceof Uint8Array ? this.data = e : this.data = Uint8Array.from(e), this.data.length !== ho)
      throw new Error(
        `Invalid public key input. Expected ${ho} bytes, got ${this.data.length}`
      );
  }
  equals(e) {
    return Nl(this.toBytes(), e.toBytes());
  }
  toBase64() {
    return Hr(this.toBytes());
  }
  toBytes() {
    return this.data;
  }
  toString() {
    return this.toBase64();
  }
  toSuiAddress() {
    let e = new Uint8Array(ho + 1);
    return e.set([_l.Secp256k1]), e.set(this.toBytes(), 1), _t(
      Ia(Na(e, { dkLen: 32 })).slice(0, ts * 2)
    );
  }
};
jl.SIZE = ho;
var jv = "0.34.0", Dv = "1.2.0", ia = class extends Error {
  constructor(e) {
    super(
      e.cause ? `RPC Error: ${e.cause.message}` : "Unknown RPC Error",
      { cause: e.cause }
    ), this.req = e.req, this.code = e.code, this.data = e.data;
  }
}, Lv = class extends Error {
  constructor(e) {
    super(
      "RPC Validation Error: The response returned from RPC server does not match the TypeScript definition. This is likely because the SDK version is not compatible with the RPC server.",
      { cause: e.cause }
    ), this.req = e.req, this.result = e.result, this.message = this.toString();
  }
  toString() {
    let e = super.toString();
    return this.cause && (e += `
Cause: ${this.cause}`), this.result && (e += `
Reponse Received: ${JSON.stringify(this.result, null, 2)}`), e;
  }
}, Rv = class extends Error {
}, Pv = H({
  jsonrpc: Ue("2.0"),
  id: O(),
  result: Jr()
}), Dl = H({
  jsonrpc: Ue("2.0"),
  id: O(),
  error: H({
    code: Jr(),
    message: O(),
    data: Ie(Jr())
  })
}), Uv = class {
  constructor(e, t) {
    this.rpcClient = new Ey(
      async (r, n) => {
        const o = {
          method: "POST",
          body: r,
          headers: {
            "Content-Type": "application/json",
            "Client-Sdk-Type": "typescript",
            "Client-Sdk-Version": jv,
            "Client-Target-Api-Version": Dv,
            ...t
          }
        };
        try {
          let s = await fetch(e, o);
          const f = await s.text();
          if (s.ok)
            n(null, f);
          else {
            const l = s.headers.get("content-type") === "text/html";
            n(
              new Error(
                `${s.status} ${s.statusText}${l ? "" : `: ${f}`}`
              )
            );
          }
        } catch (s) {
          n(s);
        }
      },
      {}
    );
  }
  async requestWithType(e, t, r) {
    const n = { method: e, args: t }, o = await this.request(e, t);
    if (Ot(o, Dl))
      throw new ia({
        req: n,
        code: o.error.code,
        data: o.error.data,
        cause: new Error(o.error.message)
      });
    if (Ot(o, Pv)) {
      const [s] = di(o.result, r);
      return s && console.warn(
        new Lv({
          req: n,
          result: o.result,
          cause: s
        })
      ), o.result;
    }
    throw new ia({ req: n, data: o });
  }
  async request(e, t) {
    return new Promise((r, n) => {
      this.rpcClient.request(e, t, (o, s) => {
        if (o) {
          n(o);
          return;
        }
        r(s);
      });
    });
  }
}, Bv = et([
  Ue("DynamicField"),
  Ue("DynamicObject")
]), kv = H({
  type: O(),
  value: Jr()
}), zv = H({
  name: kv,
  bcsName: O(),
  type: Bv,
  objectType: O(),
  objectId: Ze,
  version: Qe(),
  digest: O()
}), Fv = H({
  data: de(zv),
  nextCursor: it(Ze),
  hasNextPage: ot()
}), $v = (e, t) => {
  const r = new URL(e);
  return r.protocol = r.protocol.replace("http", "ws"), t && (r.port = t.toString()), r.toString();
}, Wv = (e) => e && "subscription" in e && typeof e.subscription == "number" && "result" in e && typeof e.result == "object", Ll = {
  connectTimeout: 15e3,
  callTimeout: 3e4,
  reconnectInterval: 3e3,
  maxReconnects: 5
}, hf = "suix_subscribeEvent", qv = "suix_unsubscribeEvent", Yv = class {
  constructor(e, t = Ll) {
    this.endpoint = e, this.options = t, this.connectionState = 0, this.connectionTimeout = null, this.isSetup = !1, this.connectionPromise = null, this.eventSubscriptions = /* @__PURE__ */ new Map(), this.endpoint.startsWith("http") && (this.endpoint = $v(this.endpoint)), this.rpcClient = new al(this.endpoint, {
      reconnect_interval: this.options.reconnectInterval,
      max_reconnects: this.options.maxReconnects,
      autoconnect: !1
    });
  }
  setupSocket() {
    this.isSetup || (this.rpcClient.on("open", () => {
      this.connectionTimeout && (clearTimeout(this.connectionTimeout), this.connectionTimeout = null), this.connectionState = 2, this.rpcClient.socket.on(
        "message",
        this.onSocketMessage.bind(this)
      );
    }), this.rpcClient.on("close", () => {
      this.connectionState = 0;
    }), this.rpcClient.on("error", console.error), this.isSetup = !0);
  }
  onSocketMessage(e) {
    const t = JSON.parse(e), r = t.params;
    if (t.method === hf) {
      if (Wv(r)) {
        const n = this.eventSubscriptions.get(r.subscription);
        n && n.onMessage(r.result);
      } else if (Ot(r, Eg)) {
        const n = this.eventSubscriptions.get(r.subscription);
        n && n.onMessage(r.result);
      }
    }
  }
  async connect() {
    return this.connectionPromise ? this.connectionPromise : this.connectionState === 2 ? Promise.resolve() : (this.setupSocket(), this.rpcClient.connect(), this.connectionState = 1, this.connectionPromise = new Promise((e, t) => {
      this.connectionTimeout = setTimeout(
        () => t(new Error("timeout")),
        this.options.connectTimeout
      ), this.rpcClient.once("open", () => {
        this.refreshSubscriptions(), this.connectionPromise = null, e();
      }), this.rpcClient.once("error", (r) => {
        this.connectionPromise = null, t(r);
      });
    }), this.connectionPromise);
  }
  async refreshSubscriptions() {
    if (this.eventSubscriptions.size !== 0)
      try {
        let e = /* @__PURE__ */ new Map();
        (await Promise.all(
          Array.from(this.eventSubscriptions.values()).map(async (r) => {
            const n = r.onMessage, o = r.filter;
            return !o || !n ? Promise.resolve(null) : { id: await this.subscribeEvent(o, n), onMessage: n, filter: o };
          })
        )).forEach((r) => {
          if (r === null)
            return;
          const n = r.filter, o = r.onMessage;
          e.set(r.id, { filter: n, onMessage: o });
        }), this.eventSubscriptions = e;
      } catch (e) {
        throw new Error(`error refreshing event subscriptions: ${e}`);
      }
  }
  async subscribeEvent(e, t) {
    try {
      this.connectionState !== 2 && await this.connect();
      let r = await this.rpcClient.call(
        hf,
        [e],
        this.options.callTimeout
      );
      return this.eventSubscriptions.set(r, { filter: e, onMessage: t }), r;
    } catch (r) {
      throw new Error(
        `Error subscribing to event: ${JSON.stringify(
          r,
          null,
          2
        )}, filter: ${JSON.stringify(e)}`
      );
    }
  }
  async unsubscribeEvent(e) {
    try {
      this.connectionState !== 2 && await this.connect();
      let t = await this.rpcClient.call(
        qv,
        [e],
        this.options.callTimeout
      );
      return this.eventSubscriptions.delete(e) || t;
    } catch (t) {
      throw new Error(
        `Error unsubscribing from event: ${t}, subscription: ${e}`
      );
    }
  }
};
async function Gv(e, t, r) {
  const n = await fetch(e, {
    method: "POST",
    body: JSON.stringify({
      FixedAmountRequest: {
        recipient: t
      }
    }),
    headers: {
      "Content-Type": "application/json",
      ...r || {}
    }
  });
  if (n.status === 429)
    throw new Rv(
      "Too many requests from this client have been sent to the faucet. Please retry later"
    );
  let o;
  try {
    o = await n.json();
  } catch (s) {
    throw new Error(
      `Encountered error when parsing response from faucet, error: ${s}, status ${n.status}, response ${n}`
    );
  }
  if (o.error)
    throw new Error(`Faucet returns error: ${o.error}`);
  return o;
}
var Pn, pi = class {
  constructor(e) {
    Rn(this, Pn, void 0), Ei(this, Pn, e);
  }
  get fullnode() {
    return nt(this, Pn).fullnode;
  }
  get websocket() {
    return nt(this, Pn).websocket || nt(this, Pn).fullnode;
  }
  get faucet() {
    return nt(this, Pn).faucet;
  }
};
Pn = /* @__PURE__ */ new WeakMap();
new pi({
  fullnode: "http://127.0.0.1:9000",
  faucet: "http://127.0.0.1:9123/gas"
});
var Qv = new pi({
  fullnode: "https://fullnode.devnet.sui.io:443/",
  faucet: "https://faucet.devnet.sui.io/gas"
});
new pi({
  fullnode: "https://fullnode.testnet.sui.io:443/",
  faucet: "https://faucet.testnet.sui.io/gas"
});
new pi({
  fullnode: "https://fullnode.mainnet.sui.io:443/"
});
function rr(e, t) {
  return wu(e, t);
}
var Do = Symbol("transaction-argument-type"), Vv = /^vector<(.+)>$/, Hv = /^([^:]+)::([^:]+)::([^<]+)(<(.+)>)?/, wn = class {
  static parseFromStr(e, t = !1) {
    if (e === "address")
      return { address: null };
    if (e === "bool")
      return { bool: null };
    if (e === "u8")
      return { u8: null };
    if (e === "u16")
      return { u16: null };
    if (e === "u32")
      return { u32: null };
    if (e === "u64")
      return { u64: null };
    if (e === "u128")
      return { u128: null };
    if (e === "u256")
      return { u256: null };
    if (e === "signer")
      return { signer: null };
    const r = e.match(Vv);
    if (r)
      return {
        vector: wn.parseFromStr(
          r[1],
          t
        )
      };
    const n = e.match(Hv);
    if (n)
      return {
        struct: {
          address: t ? _t(n[1]) : n[1],
          module: n[2],
          name: n[3],
          typeParams: n[5] === void 0 ? [] : wn.parseStructTypeArgs(
            n[5],
            t
          )
        }
      };
    throw new Error(
      `Encountered unexpected token when parsing type args for ${e}`
    );
  }
  static parseStructTypeArgs(e, t = !1) {
    const r = [];
    let n = "", o = 0;
    for (let s = 0; s < e.length; s++) {
      const f = e[s];
      if (f === "<" && o++, f === ">" && o--, o === 0 && f === ",") {
        r.push(n.trim()), n = "";
        continue;
      }
      n += f;
    }
    return r.push(n.trim()), r.map(
      (s) => wn.parseFromStr(s, t)
    );
  }
  static tagToString(e) {
    if ("bool" in e)
      return "bool";
    if ("u8" in e)
      return "u8";
    if ("u16" in e)
      return "u16";
    if ("u32" in e)
      return "u32";
    if ("u64" in e)
      return "u64";
    if ("u128" in e)
      return "u128";
    if ("u256" in e)
      return "u256";
    if ("address" in e)
      return "address";
    if ("signer" in e)
      return "signer";
    if ("vector" in e)
      return `vector<${wn.tagToString(e.vector)}>`;
    if ("struct" in e) {
      const t = e.struct, r = t.typeParams.map(wn.tagToString).join(", ");
      return `${t.address}::${t.module}::${t.name}${r ? `<${r}>` : ""}`;
    }
    throw new Error("Invalid TypeTag");
  }
}, Zv = (e) => et([
  H({ None: et([Ue(!0), Ue(null)]) }),
  H({ Some: e })
]), ji = H({
  kind: Ue("Input"),
  index: Xr(),
  value: Ie(Jr()),
  type: Ie(et([Ue("pure"), Ue("object")]))
}), oc = [
  ji,
  H({ kind: Ue("GasCoin") }),
  H({ kind: Ue("Result"), index: Xr() }),
  H({
    kind: Ue("NestedResult"),
    index: Xr(),
    resultIndex: Xr()
  })
], Kv = et([...oc]), qn = et([...oc]);
qn[Do] = {
  kind: "object"
};
var Rl = (e) => {
  const t = et([...oc]);
  return t[Do] = {
    kind: "pure",
    type: e
  }, t;
}, Pl = H({
  kind: Ue("MoveCall"),
  target: dr(
    "target",
    O().validator
  ),
  typeArguments: de(O()),
  arguments: de(Kv)
}), Ul = H({
  kind: Ue("TransferObjects"),
  objects: de(qn),
  address: Rl(ze.ADDRESS)
}), Bl = H({
  kind: Ue("SplitCoins"),
  coin: qn,
  amounts: de(Rl("u64"))
}), kl = H({
  kind: Ue("MergeCoins"),
  destination: qn,
  sources: de(qn)
}), zl = H({
  kind: Ue("MakeMoveVec"),
  type: Ie(Zv(kr(O(), I1()))),
  objects: de(qn)
}), Fl = H({
  kind: Ue("Publish"),
  modules: de(de(Xr())),
  dependencies: de(Ze)
}), $l = H({
  kind: Ue("Upgrade"),
  modules: de(de(Xr())),
  dependencies: de(Ze),
  packageId: Ze,
  ticket: qn
}), Wl = [
  Pl,
  Ul,
  Bl,
  kl,
  Fl,
  $l,
  zl
], ql = et([...Wl]);
function Xv(e) {
  return Mo(e, ql), Wl.find((t) => Ot(e, t));
}
var hn = {
  MoveCall(e) {
    return rr(
      {
        kind: "MoveCall",
        target: e.target,
        arguments: e.arguments ?? [],
        typeArguments: e.typeArguments ?? []
      },
      Pl
    );
  },
  TransferObjects(e, t) {
    return rr(
      { kind: "TransferObjects", objects: e, address: t },
      Ul
    );
  },
  SplitCoins(e, t) {
    return rr({ kind: "SplitCoins", coin: e, amounts: t }, Bl);
  },
  MergeCoins(e, t) {
    return rr(
      { kind: "MergeCoins", destination: e, sources: t },
      kl
    );
  },
  Publish({
    modules: e,
    dependencies: t
  }) {
    return rr(
      {
        kind: "Publish",
        modules: e.map(
          (r) => typeof r == "string" ? Array.from(Mr(r)) : r
        ),
        dependencies: t.map((r) => Rr(r))
      },
      Fl
    );
  },
  Upgrade({
    modules: e,
    dependencies: t,
    packageId: r,
    ticket: n
  }) {
    return rr(
      {
        kind: "Upgrade",
        modules: e.map(
          (o) => typeof o == "string" ? Array.from(Mr(o)) : o
        ),
        dependencies: t.map((o) => Rr(o)),
        packageId: r,
        ticket: n
      },
      $l
    );
  },
  MakeMoveVec({
    type: e,
    objects: t
  }) {
    return rr(
      {
        kind: "MakeMoveVec",
        type: e ? { Some: wn.parseFromStr(e) } : { None: null },
        objects: t
      },
      zl
    );
  }
}, Yl = "Argument", Vt = "vector", Jv = "Option", eb = "CallArg", pf = "TypeTag", tb = "ProgrammableTransaction", oa = "ProgrammableMoveCall", Gl = "Transaction", sc = "EnumKind", rb = [sc, Gl], Qr = [sc, Yl], Ql = "SimpleProgrammableMoveCall", En = new ze(vl).registerStructType(tb, {
  inputs: [Vt, eb],
  transactions: [Vt, rb]
}).registerEnumType(Yl, {
  GasCoin: null,
  Input: { index: ze.U16 },
  Result: { index: ze.U16 },
  NestedResult: { index: ze.U16, resultIndex: ze.U16 }
}).registerStructType(oa, {
  package: ze.ADDRESS,
  module: ze.STRING,
  function: ze.STRING,
  type_arguments: [Vt, pf],
  arguments: [Vt, Qr]
}).registerEnumType(Gl, {
  MoveCall: Ql,
  TransferObjects: {
    objects: [Vt, Qr],
    address: Qr
  },
  SplitCoins: { coin: Qr, amounts: [Vt, Qr] },
  MergeCoins: { destination: Qr, sources: [Vt, Qr] },
  Publish: {
    modules: [Vt, [Vt, ze.U8]],
    dependencies: [Vt, ze.ADDRESS]
  },
  MakeMoveVec: {
    type: [Jv, pf],
    objects: [Vt, Qr]
  },
  Upgrade: {
    modules: [Vt, [Vt, ze.U8]],
    dependencies: [Vt, ze.ADDRESS],
    packageId: ze.ADDRESS,
    ticket: Qr
  }
});
En.registerType(
  [sc, "T"],
  function(t, r, n, o) {
    const f = { [r.kind]: r }, [l] = n;
    return this.getTypeInterface(l)._encodeRaw.call(
      this,
      t,
      f,
      n,
      o
    );
  },
  function(t, r, n) {
    const [o] = r, s = this.getTypeInterface(o)._decodeRaw.call(
      this,
      t,
      r,
      n
    ), f = Object.keys(s)[0];
    return { kind: f, ...s[f] };
  },
  (e) => {
    if (typeof e != "object" && !("kind" in e))
      throw new Error(
        `EnumKind: Missing property "kind" in the input ${JSON.stringify(
          e
        )}`
      );
    return !0;
  }
);
En.registerType(
  Ql,
  function(t, r, n, o) {
    const [s, f, l] = r.target.split("::"), h = r.typeArguments.map(
      (p) => wn.parseFromStr(p, !0)
    );
    return this.getTypeInterface(oa)._encodeRaw.call(
      this,
      t,
      {
        package: _t(s),
        module: f,
        function: l,
        type_arguments: h,
        arguments: r.arguments
      },
      n,
      o
    );
  },
  function(t, r, n) {
    let o = En.getTypeInterface(oa)._decodeRaw.call(this, t, r, n);
    return {
      target: [o.package, o.module, o.function].join("::"),
      arguments: o.arguments,
      typeArguments: o.type_arguments.map(wn.tagToString)
    };
  },
  (e) => e.target.split("::").length === 3
);
var nb = et([
  H({ ImmOrOwned: Pr }),
  H({
    Shared: H({
      objectId: O(),
      initialSharedVersion: et([Xr(), O()]),
      mutable: ot()
    })
  })
]), sa = H({ Pure: de(Xr()) }), ib = H({ Object: nb }), Ai = et([sa, ib]), ob = 16 * 1024, Vr = {
  Pure(e, t) {
    return {
      Pure: Array.from(
        e instanceof Uint8Array ? e : En.ser(t, e, { maxSize: ob }).toBytes()
      )
    };
  },
  ObjectRef({ objectId: e, digest: t, version: r }) {
    return {
      Object: {
        ImmOrOwned: {
          digest: t,
          version: r,
          objectId: _t(e)
        }
      }
    };
  },
  SharedObjectRef({
    objectId: e,
    mutable: t,
    initialSharedVersion: r
  }) {
    return {
      Object: {
        Shared: {
          mutable: t,
          initialSharedVersion: r,
          objectId: _t(e)
        }
      }
    };
  }
};
function yf(e) {
  return typeof e == "string" ? _t(e) : "ImmOrOwned" in e.Object ? _t(e.Object.ImmOrOwned.objectId) : _t(e.Object.Shared.objectId);
}
function sb(e) {
  return typeof e == "object" && "Object" in e && "Shared" in e.Object ? e.Object.Shared : void 0;
}
function ab(e) {
  return sb(e)?.mutable ?? !1;
}
var cb = "ascii", fb = "String", ub = "string", lb = "String", db = "option", hb = "Option", pb = {
  address: gl,
  module: Zg,
  name: Kg
}, yb = {
  address: rc,
  module: cb,
  name: fb
}, gb = {
  address: rc,
  module: ub,
  name: lb
}, vb = {
  address: rc,
  module: db,
  name: hb
}, ro = (e, t) => e.address === t.address && e.module === t.module && e.name === t.name;
function bb(e) {
  const t = Sl(e)?.Struct;
  return t?.address === "0x2" && t?.module === "tx_context" && t?.name === "TxContext";
}
function zs(e, t) {
  if (!(typeof t > "u") && typeof t !== e)
    throw new Error(
      `Expect ${t} to be ${e}, received ${typeof t}`
    );
}
var xb = [
  "Address",
  "Bool",
  "U8",
  "U16",
  "U32",
  "U64",
  "U128",
  "U256"
];
function aa(e, t) {
  if (typeof e == "string" && xb.includes(e)) {
    if (e in ["U8", "U16", "U32", "U64", "U128", "U256"])
      zs("number", t);
    else if (e === "Bool")
      zs("boolean", t);
    else if (e === "Address" && (zs("string", t), t && !bn(t)))
      throw new Error("Invalid Sui Address");
    return e.toLowerCase();
  } else if (typeof e == "string")
    throw new Error(
      `Unknown pure normalized type ${JSON.stringify(e, null, 2)}`
    );
  if ("Vector" in e) {
    if ((t === void 0 || typeof t == "string") && e.Vector === "U8")
      return "string";
    if (t !== void 0 && !Array.isArray(t))
      throw new Error(
        `Expect ${t} to be a array, received ${typeof t}`
      );
    const r = aa(
      e.Vector,
      t ? t[0] : void 0
    );
    return r === void 0 ? void 0 : `vector<${r}>`;
  }
  if ("Struct" in e) {
    if (ro(e.Struct, yb))
      return "string";
    if (ro(e.Struct, gb))
      return "utf8string";
    if (ro(e.Struct, pb))
      return "address";
    if (ro(e.Struct, vb)) {
      const r = {
        Vector: e.Struct.typeArguments[0]
      };
      return aa(r, t);
    }
  }
}
function wb(e, t) {
  const r = Array.from(`${e}::`).map((o) => o.charCodeAt(0)), n = new Uint8Array(r.length + t.length);
  return n.set(r), n.set(t, r.length), Na(n, { dkLen: 32 });
}
var mb = Ie(
  it(
    et([
      H({ Epoch: Xr() }),
      H({ None: et([Ue(!0), Ue(null)]) })
    ])
  )
), Vl = O(), gf = dr("StringEncodedBigint", (e) => {
  if (!["string", "number", "bigint"].includes(typeof e))
    return !1;
  try {
    return BigInt(e), !0;
  } catch {
    return !1;
  }
}), Eb = H({
  budget: Ie(gf),
  price: Ie(gf),
  payment: Ie(de(Pr)),
  owner: Ie(Vl)
}), no = H({
  version: Ue(1),
  sender: Ie(Vl),
  expiration: mb,
  gasConfig: Eb,
  inputs: de(ji),
  transactions: de(ql)
});
function vf(e) {
  return _t(e).replace("0x", "");
}
var bf = 128 * 1024, An = class {
  constructor(e) {
    this.version = 1, this.sender = e?.sender, this.expiration = e?.expiration, this.gasConfig = e?.gasConfig ?? {}, this.inputs = e?.inputs ?? [], this.transactions = e?.transactions ?? [];
  }
  static fromKindBytes(e) {
    const r = En.de("TransactionKind", e)?.ProgrammableTransaction;
    if (!r)
      throw new Error("Unable to deserialize from bytes.");
    const n = rr(
      {
        version: 1,
        gasConfig: {},
        inputs: r.inputs.map(
          (o, s) => rr(
            {
              kind: "Input",
              value: o,
              index: s,
              type: Ot(o, sa) ? "pure" : "object"
            },
            ji
          )
        ),
        transactions: r.transactions
      },
      no
    );
    return An.restore(n);
  }
  static fromBytes(e) {
    const r = En.de("TransactionData", e)?.V1, n = r?.kind?.ProgrammableTransaction;
    if (!r || !n)
      throw new Error("Unable to deserialize from bytes.");
    const o = rr(
      {
        version: 1,
        sender: r.sender,
        expiration: r.expiration,
        gasConfig: r.gasData,
        inputs: n.inputs.map(
          (s, f) => rr(
            {
              kind: "Input",
              value: s,
              index: f,
              type: Ot(s, sa) ? "pure" : "object"
            },
            ji
          )
        ),
        transactions: n.transactions
      },
      no
    );
    return An.restore(o);
  }
  static restore(e) {
    Mo(e, no);
    const t = new An();
    return Object.assign(t, e), t;
  }
  static getDigestFromBytes(e) {
    const t = wb("TransactionData", e);
    return Ta(t);
  }
  build({
    overrides: e,
    onlyTransactionKind: t
  } = {}) {
    const r = this.inputs.map((h) => (Mo(h.value, Ai), h.value)), n = {
      ProgrammableTransaction: {
        inputs: r,
        transactions: this.transactions
      }
    };
    if (t)
      return En.ser("TransactionKind", n, { maxSize: bf }).toBytes();
    const o = e?.expiration ?? this.expiration, s = e?.sender ?? this.sender, f = { ...this.gasConfig, ...e?.gasConfig };
    if (!s)
      throw new Error("Missing transaction sender");
    if (!f.budget)
      throw new Error("Missing gas budget");
    if (!f.payment)
      throw new Error("Missing gas payment");
    if (!f.price)
      throw new Error("Missing gas price");
    const l = {
      sender: vf(s),
      expiration: o || { None: !0 },
      gasData: {
        payment: f.payment,
        owner: vf(this.gasConfig.owner ?? s),
        price: BigInt(f.price),
        budget: BigInt(f.budget)
      },
      kind: {
        ProgrammableTransaction: {
          inputs: r,
          transactions: this.transactions
        }
      }
    };
    return En.ser(
      "TransactionData",
      { V1: l },
      { maxSize: bf }
    ).toBytes();
  }
  getDigest() {
    const e = this.build({ onlyTransactionKind: !1 });
    return An.getDigestFromBytes(e);
  }
  snapshot() {
    return rr(this, no);
  }
};
function Ab(e) {
  const t = { kind: "Result", index: e }, r = [], n = (o) => r[o] ?? (r[o] = {
    kind: "NestedResult",
    index: e,
    resultIndex: o
  });
  return new Proxy(t, {
    set() {
      throw new Error(
        "The transaction result is a proxy, and does not support setting properties directly"
      );
    },
    get(o, s) {
      if (s in o)
        return Reflect.get(o, s);
      if (s === Symbol.iterator)
        return function* () {
          let l = 0;
          for (; ; )
            yield n(l), l++;
        };
      if (typeof s == "symbol")
        return;
      const f = parseInt(s, 10);
      if (!(Number.isNaN(f) || f < 0))
        return n(f);
    }
  });
}
function Di(e) {
  if (!e)
    throw new Error(
      "No provider passed to Transaction#build, but transaction data was not sufficient to build offline."
    );
  return e;
}
var xf = Symbol.for("@mysten/transaction"), ca = 256, Sb = 5e10, Tb = 1000n, Mb = 50, Ib = (e, t) => Array.from(
  { length: Math.ceil(e.length / t) },
  (r, n) => e.slice(n * t, n * t + t)
), tt, po, fa, ac, Hl, cc, Zl, fc, Kl, yo, ua, la = class {
  constructor(e) {
    Rn(this, po), Rn(this, ac), Rn(this, cc), Rn(this, fc), Rn(this, yo), Rn(this, tt, void 0), Ei(this, tt, new An(
      e ? e.blockData : void 0
    ));
  }
  static is(e) {
    return !!e && typeof e == "object" && e[xf] === !0;
  }
  static fromKind(e) {
    const t = new la();
    return Ei(t, tt, An.fromKindBytes(
      typeof e == "string" ? Mr(e) : e
    )), t;
  }
  static from(e) {
    const t = new la();
    return typeof e != "string" || !e.startsWith("{") ? Ei(t, tt, An.fromBytes(
      typeof e == "string" ? Mr(e) : e
    )) : Ei(t, tt, An.restore(
      JSON.parse(e)
    )), t;
  }
  static get Transactions() {
    return hn;
  }
  static get Inputs() {
    return Vr;
  }
  setSender(e) {
    nt(this, tt).sender = e;
  }
  setSenderIfNotSet(e) {
    nt(this, tt).sender || (nt(this, tt).sender = e);
  }
  setExpiration(e) {
    nt(this, tt).expiration = e;
  }
  setGasPrice(e) {
    nt(this, tt).gasConfig.price = String(e);
  }
  setGasBudget(e) {
    nt(this, tt).gasConfig.budget = String(e);
  }
  setGasOwner(e) {
    nt(this, tt).gasConfig.owner = e;
  }
  setGasPayment(e) {
    if (e.length >= ca)
      throw new Error(
        `Payment objects exceed maximum amount ${ca}`
      );
    nt(this, tt).gasConfig.payment = e.map(
      (t) => mu(t, Pr)
    );
  }
  get blockData() {
    return nt(this, tt).snapshot();
  }
  get [xf]() {
    return !0;
  }
  get gas() {
    return { kind: "GasCoin" };
  }
  object(e) {
    const t = yf(e);
    return nt(this, tt).inputs.find(
      (n) => n.type === "object" && t === yf(n.value)
    ) ?? kn(this, po, fa).call(this, "object", e);
  }
  objectRef(...e) {
    return this.object(Vr.ObjectRef(...e));
  }
  sharedObjectRef(...e) {
    return this.object(Vr.SharedObjectRef(...e));
  }
  pure(e, t) {
    return kn(this, po, fa).call(this, "pure", e instanceof Uint8Array ? Vr.Pure(e) : t ? Vr.Pure(e, t) : e);
  }
  add(e) {
    const t = nt(this, tt).transactions.push(e);
    return Ab(t - 1);
  }
  splitCoins(...e) {
    return this.add(hn.SplitCoins(...e));
  }
  mergeCoins(...e) {
    return this.add(hn.MergeCoins(...e));
  }
  publish(...e) {
    return this.add(hn.Publish(...e));
  }
  upgrade(...e) {
    return this.add(hn.Upgrade(...e));
  }
  moveCall(...e) {
    return this.add(hn.MoveCall(...e));
  }
  transferObjects(...e) {
    return this.add(hn.TransferObjects(...e));
  }
  makeMoveVec(...e) {
    return this.add(hn.MakeMoveVec(...e));
  }
  serialize() {
    return JSON.stringify(nt(this, tt).snapshot());
  }
  async build({
    provider: e,
    onlyTransactionKind: t
  } = {}) {
    return await kn(this, yo, ua).call(this, { provider: e, onlyTransactionKind: t }), nt(this, tt).build({ onlyTransactionKind: t });
  }
  async getDigest({
    provider: e
  } = {}) {
    return await kn(this, yo, ua).call(this, { provider: e }), nt(this, tt).getDigest();
  }
}, Cb = la;
tt = /* @__PURE__ */ new WeakMap();
po = /* @__PURE__ */ new WeakSet();
fa = function(e, t) {
  const r = nt(this, tt).inputs.length, n = rr(
    {
      kind: "Input",
      value: typeof t == "bigint" ? String(t) : t,
      index: r,
      type: e
    },
    ji
  );
  return nt(this, tt).inputs.push(n), n;
};
ac = /* @__PURE__ */ new WeakSet();
Hl = async function({ provider: e, onlyTransactionKind: t }) {
  if (t || nt(this, tt).gasConfig.payment)
    return;
  const r = nt(this, tt).gasConfig.owner ?? nt(this, tt).sender, o = (await Di(e).getCoins({
    owner: r,
    coinType: nc
  })).data.filter((s) => !nt(this, tt).inputs.find((l) => Ot(l.value, Ai) && "Object" in l.value && "ImmOrOwned" in l.value.Object ? s.coinObjectId === l.value.Object.ImmOrOwned.objectId : !1)).slice(0, ca - 1).map((s) => ({
    objectId: s.coinObjectId,
    digest: s.digest,
    version: s.version
  }));
  if (!o.length)
    throw new Error("No valid gas coins found for the transaction.");
  this.setGasPayment(o);
};
cc = /* @__PURE__ */ new WeakSet();
Zl = async function({ provider: e, onlyTransactionKind: t }) {
  t || nt(this, tt).gasConfig.price || this.setGasPrice(await Di(e).getReferenceGasPrice());
};
fc = /* @__PURE__ */ new WeakSet();
Kl = async function(e) {
  const { inputs: t, transactions: r } = nt(this, tt), n = [], o = [];
  if (r.forEach((s) => {
    if (s.kind === "MoveCall") {
      s.arguments.some(
        (h) => h.kind === "Input" && !Ot(t[h.index].value, Ai)
      ) && n.push(s);
      return;
    }
    const f = Xv(s);
    !f.schema || Object.entries(s).forEach(([l, h]) => {
      if (l === "kind")
        return;
      const p = f.schema[l], b = p.type === "array", g = b ? p.schema[Do] : p[Do];
      if (!g)
        return;
      const E = (m) => {
        const A = t[m];
        if (!A)
          throw new Error(`Missing input ${h.index}`);
        if (!Ot(A.value, Ai))
          if (g.kind === "object" && typeof A.value == "string")
            o.push({ id: A.value, input: A });
          else if (g.kind === "pure")
            A.value = Vr.Pure(A.value, g.type);
          else
            throw new Error("Unexpected input format.");
      };
      if (b)
        h.forEach((m) => {
          m.kind === "Input" && E(m.index);
        });
      else {
        if (h.kind !== "Input")
          return;
        E(h.index);
      }
    });
  }), n.length && await Promise.all(
    n.map(async (s) => {
      const [f, l, h] = s.target.split("::"), p = await Di(
        e
      ).getNormalizedMoveFunction({
        package: Rr(f),
        module: l,
        function: h
      }), g = p.parameters.length > 0 && bb(p.parameters.at(-1)) ? p.parameters.slice(0, p.parameters.length - 1) : p.parameters;
      if (g.length !== s.arguments.length)
        throw new Error("Incorrect number of arguments.");
      g.forEach((E, m) => {
        const A = s.arguments[m];
        if (A.kind !== "Input")
          return;
        const w = t[A.index];
        if (Ot(w.value, Ai))
          return;
        const S = w.value, N = aa(E, S);
        if (N) {
          w.value = Vr.Pure(S, N);
          return;
        }
        if (Sl(E) != null || typeof E == "object" && "TypeParameter" in E) {
          if (typeof S != "string")
            throw new Error(
              `Expect the argument to be an object id string, got ${JSON.stringify(
                S,
                null,
                2
              )}`
            );
          o.push({
            id: S,
            input: w,
            normalizedType: E
          });
          return;
        }
        throw new Error(
          `Unknown call arg type ${JSON.stringify(
            E,
            null,
            2
          )} for value ${JSON.stringify(S, null, 2)}`
        );
      });
    })
  ), o.length) {
    const s = [...new Set(o.map(({ id: b }) => b))], f = Ib(s, Mb), l = (await Promise.all(
      f.map(
        (b) => Di(e).multiGetObjects({
          ids: b,
          options: { showOwner: !0 }
        })
      )
    )).flat();
    let h = new Map(
      s.map((b, g) => [b, l[g]])
    );
    const p = Array.from(h).filter(([b, g]) => g.error).map(([b, g]) => b);
    if (p.length)
      throw new Error(
        `The following input objects are not invalid: ${p.join(
          ", "
        )}`
      );
    o.forEach(({ id: b, input: g, normalizedType: E }) => {
      const m = h.get(b), A = pg(m);
      if (A) {
        const w = ab(g.value) || E != null && Al(E) != null;
        g.value = Vr.SharedObjectRef({
          objectId: b,
          initialSharedVersion: A,
          mutable: w
        });
      } else
        g.value = Vr.ObjectRef(ll(m));
    });
  }
};
yo = /* @__PURE__ */ new WeakSet();
ua = async function({ provider: e, onlyTransactionKind: t }) {
  if (!t && !nt(this, tt).sender)
    throw new Error("Missing transaction sender");
  if (await Promise.all([
    kn(this, cc, Zl).call(this, { provider: e, onlyTransactionKind: t }),
    kn(this, fc, Kl).call(this, e)
  ]), !t && (await kn(this, ac, Hl).call(this, { provider: e, onlyTransactionKind: t }), !nt(this, tt).gasConfig.budget)) {
    const r = await Di(
      e
    ).dryRunTransactionBlock({
      transactionBlock: nt(this, tt).build({
        overrides: {
          gasConfig: {
            budget: String(Sb),
            payment: []
          }
        }
      })
    });
    if (r.effects.status.status !== "success")
      throw new Error(
        `Dry run failed, could not automatically determine a budget: ${r.effects.status.error}`,
        { cause: r }
      );
    const n = Tb * BigInt(this.blockData.gasConfig.price || 1n), o = BigInt(r.effects.gasUsed.computationCost) + n, s = o + BigInt(r.effects.gasUsed.storageCost) - BigInt(r.effects.gasUsed.storageRebate);
    this.setGasBudget(
      s > o ? s : o
    );
  }
};
var _b = H({
  currentTps: Qe(),
  tps30Days: Qe(),
  currentCheckpoint: O(),
  currentEpoch: O(),
  totalAddresses: O(),
  totalObjects: O(),
  totalPackages: O()
}), wf = {
  socketOptions: Ll,
  versionCacheTimeoutInSeconds: 600
}, Xl = class {
  constructor(e = Qv, t = wf) {
    this.options = t, this.connection = e;
    const r = { ...wf, ...t };
    this.options = r, this.client = r.rpcClient ?? new Uv(this.connection.fullnode), this.wsClient = r.websocketClient ?? new Yv(this.connection.websocket, r.socketOptions);
  }
  async getRpcApiVersion() {
    if (this.rpcApiVersion && this.cacheExpiry && this.cacheExpiry <= Date.now())
      return this.rpcApiVersion;
    try {
      const e = await this.client.requestWithType("rpc.discover", [], Jr());
      return this.rpcApiVersion = e.info.version, this.cacheExpiry = Date.now() + (this.options.versionCacheTimeoutInSeconds ?? 0) * 1e3, this.rpcApiVersion;
    } catch (e) {
      console.warn("Error fetching version number of the RPC API", e);
    }
  }
  async requestSuiFromFaucet(e, t) {
    if (!this.connection.faucet)
      throw new Error("Faucet URL is not specified");
    return Gv(this.connection.faucet, e, t);
  }
  async getCoins(e) {
    if (!e.owner || !bn(_t(e.owner)))
      throw new Error("Invalid Sui address");
    return await this.client.requestWithType(
      "suix_getCoins",
      [e.owner, e.coinType, e.cursor, e.limit],
      uf
    );
  }
  async getAllCoins(e) {
    if (!e.owner || !bn(_t(e.owner)))
      throw new Error("Invalid Sui address");
    return await this.client.requestWithType(
      "suix_getAllCoins",
      [e.owner, e.cursor, e.limit],
      uf
    );
  }
  async getBalance(e) {
    if (!e.owner || !bn(_t(e.owner)))
      throw new Error("Invalid Sui address");
    return await this.client.requestWithType(
      "suix_getBalance",
      [e.owner, e.coinType],
      lf
    );
  }
  async getAllBalances(e) {
    if (!e.owner || !bn(_t(e.owner)))
      throw new Error("Invalid Sui address");
    return await this.client.requestWithType(
      "suix_getAllBalances",
      [e.owner],
      de(lf)
    );
  }
  async getCoinMetadata(e) {
    return await this.client.requestWithType(
      "suix_getCoinMetadata",
      [e.coinType],
      Jg
    );
  }
  async getTotalSupply(e) {
    return await this.client.requestWithType(
      "suix_getTotalSupply",
      [e.coinType],
      Av
    );
  }
  async call(e, t) {
    const r = await this.client.request(e, t);
    if (Ot(r, Dl))
      throw new ia({
        req: { method: e, args: t },
        code: r.error.code,
        data: r.error.data,
        cause: new Error(r.error.message)
      });
    return r.result;
  }
  async getMoveFunctionArgTypes(e) {
    return await this.client.requestWithType(
      "sui_getMoveFunctionArgTypes",
      [e.package, e.module, e.function],
      iv
    );
  }
  async getNormalizedMoveModulesByPackage(e) {
    return await this.client.requestWithType(
      "sui_getNormalizedMoveModulesByPackage",
      [e.package],
      lv
    );
  }
  async getNormalizedMoveModule(e) {
    return await this.client.requestWithType(
      "sui_getNormalizedMoveModule",
      [e.package, e.module],
      El
    );
  }
  async getNormalizedMoveFunction(e) {
    return await this.client.requestWithType(
      "sui_getNormalizedMoveFunction",
      [e.package, e.module, e.function],
      wl
    );
  }
  async getNormalizedMoveStruct(e) {
    return await this.client.requestWithType(
      "sui_getNormalizedMoveStruct",
      [e.package, e.module, e.struct],
      ml
    );
  }
  async getOwnedObjects(e) {
    if (!e.owner || !bn(_t(e.owner)))
      throw new Error("Invalid Sui address");
    return await this.client.requestWithType(
      "suix_getOwnedObjects",
      [
        e.owner,
        {
          filter: e.filter,
          options: e.options
        },
        e.cursor,
        e.limit
      ],
      xg
    );
  }
  async getObject(e) {
    if (!e.id || !eo(Rr(e.id)))
      throw new Error("Invalid Sui Object id");
    return await this.client.requestWithType(
      "sui_getObject",
      [e.id, e.options],
      fo
    );
  }
  async multiGetObjects(e) {
    if (e.ids.forEach((r) => {
      if (!r || !eo(Rr(r)))
        throw new Error(`Invalid Sui Object id ${r}`);
    }), e.ids.length !== new Set(e.ids).size)
      throw new Error(`Duplicate object ids in batch call ${e.ids}`);
    return await this.client.requestWithType(
      "sui_multiGetObjects",
      [e.ids, e.options],
      de(fo)
    );
  }
  async queryTransactionBlocks(e) {
    return await this.client.requestWithType(
      "suix_queryTransactionBlocks",
      [
        {
          filter: e.filter,
          options: e.options
        },
        e.cursor,
        e.limit,
        (e.order || "descending") === "descending"
      ],
      Vg
    );
  }
  async getTransactionBlock(e) {
    if (!sf(e.digest))
      throw new Error("Invalid Transaction digest");
    return await this.client.requestWithType(
      "sui_getTransactionBlock",
      [e.digest, e.options],
      uo
    );
  }
  async multiGetTransactionBlocks(e) {
    if (e.digests.forEach((r) => {
      if (!sf(r))
        throw new Error(`Invalid Transaction digest ${r}`);
    }), e.digests.length !== new Set(e.digests).size)
      throw new Error(`Duplicate digests in batch call ${e.digests}`);
    return await this.client.requestWithType(
      "sui_multiGetTransactionBlocks",
      [e.digests, e.options],
      de(uo)
    );
  }
  async executeTransactionBlock(e) {
    return await this.client.requestWithType(
      "sui_executeTransactionBlock",
      [
        typeof e.transactionBlock == "string" ? e.transactionBlock : Hr(e.transactionBlock),
        Array.isArray(e.signature) ? e.signature : [e.signature],
        e.options,
        e.requestType
      ],
      uo
    );
  }
  async getTotalTransactionBlocks() {
    const e = await this.client.requestWithType(
      "sui_getTotalTransactionBlocks",
      [],
      O()
    );
    return BigInt(e);
  }
  async getReferenceGasPrice() {
    const e = await this.client.requestWithType(
      "suix_getReferenceGasPrice",
      [],
      O()
    );
    return BigInt(e);
  }
  async getStakes(e) {
    if (!e.owner || !bn(_t(e.owner)))
      throw new Error("Invalid Sui address");
    return await this.client.requestWithType(
      "suix_getStakes",
      [e.owner],
      de(ff)
    );
  }
  async getStakesByIds(e) {
    return e.stakedSuiIds.forEach((t) => {
      if (!t || !eo(Rr(t)))
        throw new Error(`Invalid Sui Stake id ${t}`);
    }), await this.client.requestWithType(
      "suix_getStakesByIds",
      [e.stakedSuiIds],
      de(ff)
    );
  }
  async getLatestSuiSystemState() {
    return await this.client.requestWithType(
      "suix_getLatestSuiSystemState",
      [],
      mv
    );
  }
  async queryEvents(e) {
    return await this.client.requestWithType(
      "suix_queryEvents",
      [
        e.query,
        e.cursor,
        e.limit,
        (e.order || "descending") === "descending"
      ],
      wg
    );
  }
  async subscribeEvent(e) {
    return this.wsClient.subscribeEvent(e.filter, e.onMessage);
  }
  async unsubscribeEvent(e) {
    return this.wsClient.unsubscribeEvent(e.id);
  }
  async devInspectTransactionBlock(e) {
    let t;
    if (Cb.is(e.transactionBlock))
      e.transactionBlock.setSenderIfNotSet(e.sender), t = Hr(
        await e.transactionBlock.build({
          provider: this,
          onlyTransactionKind: !0
        })
      );
    else if (typeof e.transactionBlock == "string")
      t = e.transactionBlock;
    else if (e.transactionBlock instanceof Uint8Array)
      t = Hr(e.transactionBlock);
    else
      throw new Error("Unknown transaction block format.");
    return await this.client.requestWithType(
      "sui_devInspectTransactionBlock",
      [e.sender, t, e.gasPrice, e.epoch],
      kg
    );
  }
  async dryRunTransactionBlock(e) {
    return await this.client.requestWithType(
      "sui_dryRunTransactionBlock",
      [
        typeof e.transactionBlock == "string" ? e.transactionBlock : Hr(e.transactionBlock)
      ],
      Hg
    );
  }
  async getDynamicFields(e) {
    if (!e.parentId || !eo(Rr(e.parentId)))
      throw new Error("Invalid Sui Object id");
    return await this.client.requestWithType(
      "suix_getDynamicFields",
      [e.parentId, e.cursor, e.limit],
      Fv
    );
  }
  async getDynamicFieldObject(e) {
    return await this.client.requestWithType(
      "suix_getDynamicFieldObject",
      [e.parentId, e.name],
      fo
    );
  }
  async getLatestCheckpointSequenceNumber() {
    const e = await this.client.requestWithType(
      "sui_getLatestCheckpointSequenceNumber",
      [],
      O()
    );
    return String(e);
  }
  async getCheckpoint(e) {
    return await this.client.requestWithType(
      "sui_getCheckpoint",
      [e.id],
      Cl
    );
  }
  async getCheckpoints(e) {
    const t = await this.getRpcApiVersion();
    return await this.client.requestWithType(
      "sui_getCheckpoints",
      [
        e.cursor,
        t && of.lt(t, "0.32.0") ? String(e?.limit) : e?.limit,
        e.descendingOrder
      ],
      _v
    );
  }
  async getCommitteeInfo(e) {
    return await this.client.requestWithType(
      "suix_getCommitteeInfo",
      [e?.epoch],
      wv
    );
  }
  async getNetworkMetrics() {
    return await this.client.requestWithType(
      "suix_getNetworkMetrics",
      [],
      _b
    );
  }
  async getEpochs(e) {
    const t = await this.getRpcApiVersion();
    return await this.client.requestWithType(
      "suix_getEpochs",
      [
        e?.cursor,
        t && of.lt(t, "0.32.0") ? String(e?.limit) : e?.limit,
        e?.descendingOrder
      ],
      Tv
    );
  }
  async getMoveCallMetrics() {
    return await this.client.requestWithType(
      "suix_getMoveCallMetrics",
      [],
      fv
    );
  }
  async getCurrentEpoch() {
    return await this.client.requestWithType(
      "suix_getCurrentEpoch",
      [],
      Ml
    );
  }
  async getValidatorsApy() {
    return await this.client.requestWithType(
      "suix_getValidatorsApy",
      [],
      pv
    );
  }
  async waitForTransactionBlock({
    signal: e,
    timeout: t = 60 * 1e3,
    pollInterval: r = 2 * 1e3,
    ...n
  }) {
    const o = AbortSignal.timeout(t), s = new Promise((f, l) => {
      o.addEventListener(
        "abort",
        () => l(o.reason)
      );
    });
    for (; !o.aborted; ) {
      e?.throwIfAborted();
      try {
        return await this.getTransactionBlock(n);
      } catch {
        await Promise.race([
          new Promise((l) => setTimeout(l, r)),
          s
        ]);
      }
    }
    throw o.throwIfAborted(), new Error("Unexpected error while waiting for transaction block.");
  }
}, Jl = /* @__PURE__ */ ((e) => (e[e.TransactionData = 0] = "TransactionData", e[e.TransactionEffects = 1] = "TransactionEffects", e[e.CheckpointSummary = 2] = "CheckpointSummary", e[e.PersonalMessage = 3] = "PersonalMessage", e))(Jl || {});
function Ob(e) {
  return [e, 0, 0];
}
function Nb(e, t) {
  const r = Ob(e), n = new Uint8Array(r.length + t.length);
  return n.set(r), n.set(t, r.length), n;
}
Rr("0x5");
function da(e, t) {
  return da = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, o) {
    return n.__proto__ = o, n;
  }, da(e, t);
}
function zi(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, da(e, t);
}
var Fi = /* @__PURE__ */ function() {
  function e() {
    this.listeners = [];
  }
  var t = e.prototype;
  return t.subscribe = function(n) {
    var o = this, s = n || function() {
    };
    return this.listeners.push(s), this.onSubscribe(), function() {
      o.listeners = o.listeners.filter(function(f) {
        return f !== s;
      }), o.onUnsubscribe();
    };
  }, t.hasListeners = function() {
    return this.listeners.length > 0;
  }, t.onSubscribe = function() {
  }, t.onUnsubscribe = function() {
  }, e;
}(), Lo = typeof window > "u";
function Pt() {
}
function jb(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ha(e) {
  return typeof e == "number" && e >= 0 && e !== 1 / 0;
}
function Ro(e) {
  return Array.isArray(e) ? e : [e];
}
function e0(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function go(e, t, r) {
  return ns(e) ? typeof t == "function" ? Ve({}, r, {
    queryKey: e,
    queryFn: t
  }) : Ve({}, t, {
    queryKey: e
  }) : e;
}
function xn(e, t, r) {
  return ns(e) ? [Ve({}, t, {
    queryKey: e
  }), r] : [e || {}, t];
}
function Db(e, t) {
  if (e === !0 && t === !0 || e == null && t == null)
    return "all";
  if (e === !1 && t === !1)
    return "none";
  var r = e ?? !t;
  return r ? "active" : "inactive";
}
function mf(e, t) {
  var r = e.active, n = e.exact, o = e.fetching, s = e.inactive, f = e.predicate, l = e.queryKey, h = e.stale;
  if (ns(l)) {
    if (n) {
      if (t.queryHash !== uc(l, t.options))
        return !1;
    } else if (!Po(t.queryKey, l))
      return !1;
  }
  var p = Db(r, s);
  if (p === "none")
    return !1;
  if (p !== "all") {
    var b = t.isActive();
    if (p === "active" && !b || p === "inactive" && b)
      return !1;
  }
  return !(typeof h == "boolean" && t.isStale() !== h || typeof o == "boolean" && t.isFetching() !== o || f && !f(t));
}
function Ef(e, t) {
  var r = e.exact, n = e.fetching, o = e.predicate, s = e.mutationKey;
  if (ns(s)) {
    if (!t.options.mutationKey)
      return !1;
    if (r) {
      if (zn(t.options.mutationKey) !== zn(s))
        return !1;
    } else if (!Po(t.options.mutationKey, s))
      return !1;
  }
  return !(typeof n == "boolean" && t.state.status === "loading" !== n || o && !o(t));
}
function uc(e, t) {
  var r = t?.queryKeyHashFn || zn;
  return r(e);
}
function zn(e) {
  var t = Ro(e);
  return Lb(t);
}
function Lb(e) {
  return JSON.stringify(e, function(t, r) {
    return pa(r) ? Object.keys(r).sort().reduce(function(n, o) {
      return n[o] = r[o], n;
    }, {}) : r;
  });
}
function Po(e, t) {
  return t0(Ro(e), Ro(t));
}
function t0(e, t) {
  return e === t ? !0 : typeof e != typeof t ? !1 : e && t && typeof e == "object" && typeof t == "object" ? !Object.keys(t).some(function(r) {
    return !t0(e[r], t[r]);
  }) : !1;
}
function Uo(e, t) {
  if (e === t)
    return e;
  var r = Array.isArray(e) && Array.isArray(t);
  if (r || pa(e) && pa(t)) {
    for (var n = r ? e.length : Object.keys(e).length, o = r ? t : Object.keys(t), s = o.length, f = r ? [] : {}, l = 0, h = 0; h < s; h++) {
      var p = r ? h : o[h];
      f[p] = Uo(e[p], t[p]), f[p] === e[p] && l++;
    }
    return n === s && l === n ? e : f;
  }
  return t;
}
function Rb(e, t) {
  if (e && !t || t && !e)
    return !1;
  for (var r in e)
    if (e[r] !== t[r])
      return !1;
  return !0;
}
function pa(e) {
  if (!Af(e))
    return !1;
  var t = e.constructor;
  if (typeof t > "u")
    return !0;
  var r = t.prototype;
  return !(!Af(r) || !r.hasOwnProperty("isPrototypeOf"));
}
function Af(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function ns(e) {
  return typeof e == "string" || Array.isArray(e);
}
function Pb(e) {
  return new Promise(function(t) {
    setTimeout(t, e);
  });
}
function Sf(e) {
  Promise.resolve().then(e).catch(function(t) {
    return setTimeout(function() {
      throw t;
    });
  });
}
function r0() {
  if (typeof AbortController == "function")
    return new AbortController();
}
var Ub = /* @__PURE__ */ function(e) {
  zi(t, e);
  function t() {
    var n;
    return n = e.call(this) || this, n.setup = function(o) {
      var s;
      if (!Lo && ((s = window) == null ? void 0 : s.addEventListener)) {
        var f = function() {
          return o();
        };
        return window.addEventListener("visibilitychange", f, !1), window.addEventListener("focus", f, !1), function() {
          window.removeEventListener("visibilitychange", f), window.removeEventListener("focus", f);
        };
      }
    }, n;
  }
  var r = t.prototype;
  return r.onSubscribe = function() {
    this.cleanup || this.setEventListener(this.setup);
  }, r.onUnsubscribe = function() {
    if (!this.hasListeners()) {
      var o;
      (o = this.cleanup) == null || o.call(this), this.cleanup = void 0;
    }
  }, r.setEventListener = function(o) {
    var s, f = this;
    this.setup = o, (s = this.cleanup) == null || s.call(this), this.cleanup = o(function(l) {
      typeof l == "boolean" ? f.setFocused(l) : f.onFocus();
    });
  }, r.setFocused = function(o) {
    this.focused = o, o && this.onFocus();
  }, r.onFocus = function() {
    this.listeners.forEach(function(o) {
      o();
    });
  }, r.isFocused = function() {
    return typeof this.focused == "boolean" ? this.focused : typeof document > "u" ? !0 : [void 0, "visible", "prerender"].includes(document.visibilityState);
  }, t;
}(Fi), Si = new Ub(), Bb = /* @__PURE__ */ function(e) {
  zi(t, e);
  function t() {
    var n;
    return n = e.call(this) || this, n.setup = function(o) {
      var s;
      if (!Lo && ((s = window) == null ? void 0 : s.addEventListener)) {
        var f = function() {
          return o();
        };
        return window.addEventListener("online", f, !1), window.addEventListener("offline", f, !1), function() {
          window.removeEventListener("online", f), window.removeEventListener("offline", f);
        };
      }
    }, n;
  }
  var r = t.prototype;
  return r.onSubscribe = function() {
    this.cleanup || this.setEventListener(this.setup);
  }, r.onUnsubscribe = function() {
    if (!this.hasListeners()) {
      var o;
      (o = this.cleanup) == null || o.call(this), this.cleanup = void 0;
    }
  }, r.setEventListener = function(o) {
    var s, f = this;
    this.setup = o, (s = this.cleanup) == null || s.call(this), this.cleanup = o(function(l) {
      typeof l == "boolean" ? f.setOnline(l) : f.onOnline();
    });
  }, r.setOnline = function(o) {
    this.online = o, o && this.onOnline();
  }, r.onOnline = function() {
    this.listeners.forEach(function(o) {
      o();
    });
  }, r.isOnline = function() {
    return typeof this.online == "boolean" ? this.online : typeof navigator > "u" || typeof navigator.onLine > "u" ? !0 : navigator.onLine;
  }, t;
}(Fi), vo = new Bb();
function kb(e) {
  return Math.min(1e3 * Math.pow(2, e), 3e4);
}
function Bo(e) {
  return typeof e?.cancel == "function";
}
var n0 = function(t) {
  this.revert = t?.revert, this.silent = t?.silent;
};
function bo(e) {
  return e instanceof n0;
}
var i0 = function(t) {
  var r = this, n = !1, o, s, f, l;
  this.abort = t.abort, this.cancel = function(E) {
    return o?.(E);
  }, this.cancelRetry = function() {
    n = !0;
  }, this.continueRetry = function() {
    n = !1;
  }, this.continue = function() {
    return s?.();
  }, this.failureCount = 0, this.isPaused = !1, this.isResolved = !1, this.isTransportCancelable = !1, this.promise = new Promise(function(E, m) {
    f = E, l = m;
  });
  var h = function(m) {
    r.isResolved || (r.isResolved = !0, t.onSuccess == null || t.onSuccess(m), s?.(), f(m));
  }, p = function(m) {
    r.isResolved || (r.isResolved = !0, t.onError == null || t.onError(m), s?.(), l(m));
  }, b = function() {
    return new Promise(function(m) {
      s = m, r.isPaused = !0, t.onPause == null || t.onPause();
    }).then(function() {
      s = void 0, r.isPaused = !1, t.onContinue == null || t.onContinue();
    });
  }, g = function E() {
    if (!r.isResolved) {
      var m;
      try {
        m = t.fn();
      } catch (A) {
        m = Promise.reject(A);
      }
      o = function(w) {
        if (!r.isResolved && (p(new n0(w)), r.abort == null || r.abort(), Bo(m)))
          try {
            m.cancel();
          } catch {
          }
      }, r.isTransportCancelable = Bo(m), Promise.resolve(m).then(h).catch(function(A) {
        var w, S;
        if (!r.isResolved) {
          var N = (w = t.retry) != null ? w : 3, P = (S = t.retryDelay) != null ? S : kb, C = typeof P == "function" ? P(r.failureCount, A) : P, B = N === !0 || typeof N == "number" && r.failureCount < N || typeof N == "function" && N(r.failureCount, A);
          if (n || !B) {
            p(A);
            return;
          }
          r.failureCount++, t.onFail == null || t.onFail(r.failureCount, A), Pb(C).then(function() {
            if (!Si.isFocused() || !vo.isOnline())
              return b();
          }).then(function() {
            n ? p(A) : E();
          });
        }
      });
    }
  };
  g();
}, zb = /* @__PURE__ */ function() {
  function e() {
    this.queue = [], this.transactions = 0, this.notifyFn = function(r) {
      r();
    }, this.batchNotifyFn = function(r) {
      r();
    };
  }
  var t = e.prototype;
  return t.batch = function(n) {
    var o;
    this.transactions++;
    try {
      o = n();
    } finally {
      this.transactions--, this.transactions || this.flush();
    }
    return o;
  }, t.schedule = function(n) {
    var o = this;
    this.transactions ? this.queue.push(n) : Sf(function() {
      o.notifyFn(n);
    });
  }, t.batchCalls = function(n) {
    var o = this;
    return function() {
      for (var s = arguments.length, f = new Array(s), l = 0; l < s; l++)
        f[l] = arguments[l];
      o.schedule(function() {
        n.apply(void 0, f);
      });
    };
  }, t.flush = function() {
    var n = this, o = this.queue;
    this.queue = [], o.length && Sf(function() {
      n.batchNotifyFn(function() {
        o.forEach(function(s) {
          n.notifyFn(s);
        });
      });
    });
  }, t.setNotifyFunction = function(n) {
    this.notifyFn = n;
  }, t.setBatchNotifyFunction = function(n) {
    this.batchNotifyFn = n;
  }, e;
}(), ut = new zb(), o0 = console;
function ko() {
  return o0;
}
function Fb(e) {
  o0 = e;
}
var $b = /* @__PURE__ */ function() {
  function e(r) {
    this.abortSignalConsumed = !1, this.hadObservers = !1, this.defaultOptions = r.defaultOptions, this.setOptions(r.options), this.observers = [], this.cache = r.cache, this.queryKey = r.queryKey, this.queryHash = r.queryHash, this.initialState = r.state || this.getDefaultState(this.options), this.state = this.initialState, this.meta = r.meta, this.scheduleGc();
  }
  var t = e.prototype;
  return t.setOptions = function(n) {
    var o;
    this.options = Ve({}, this.defaultOptions, n), this.meta = n?.meta, this.cacheTime = Math.max(this.cacheTime || 0, (o = this.options.cacheTime) != null ? o : 5 * 60 * 1e3);
  }, t.setDefaultOptions = function(n) {
    this.defaultOptions = n;
  }, t.scheduleGc = function() {
    var n = this;
    this.clearGcTimeout(), ha(this.cacheTime) && (this.gcTimeout = setTimeout(function() {
      n.optionalRemove();
    }, this.cacheTime));
  }, t.clearGcTimeout = function() {
    this.gcTimeout && (clearTimeout(this.gcTimeout), this.gcTimeout = void 0);
  }, t.optionalRemove = function() {
    this.observers.length || (this.state.isFetching ? this.hadObservers && this.scheduleGc() : this.cache.remove(this));
  }, t.setData = function(n, o) {
    var s, f, l = this.state.data, h = jb(n, l);
    return (s = (f = this.options).isDataEqual) != null && s.call(f, l, h) ? h = l : this.options.structuralSharing !== !1 && (h = Uo(l, h)), this.dispatch({
      data: h,
      type: "success",
      dataUpdatedAt: o?.updatedAt
    }), h;
  }, t.setState = function(n, o) {
    this.dispatch({
      type: "setState",
      state: n,
      setStateOptions: o
    });
  }, t.cancel = function(n) {
    var o, s = this.promise;
    return (o = this.retryer) == null || o.cancel(n), s ? s.then(Pt).catch(Pt) : Promise.resolve();
  }, t.destroy = function() {
    this.clearGcTimeout(), this.cancel({
      silent: !0
    });
  }, t.reset = function() {
    this.destroy(), this.setState(this.initialState);
  }, t.isActive = function() {
    return this.observers.some(function(n) {
      return n.options.enabled !== !1;
    });
  }, t.isFetching = function() {
    return this.state.isFetching;
  }, t.isStale = function() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(function(n) {
      return n.getCurrentResult().isStale;
    });
  }, t.isStaleByTime = function(n) {
    return n === void 0 && (n = 0), this.state.isInvalidated || !this.state.dataUpdatedAt || !e0(this.state.dataUpdatedAt, n);
  }, t.onFocus = function() {
    var n, o = this.observers.find(function(s) {
      return s.shouldFetchOnWindowFocus();
    });
    o && o.refetch(), (n = this.retryer) == null || n.continue();
  }, t.onOnline = function() {
    var n, o = this.observers.find(function(s) {
      return s.shouldFetchOnReconnect();
    });
    o && o.refetch(), (n = this.retryer) == null || n.continue();
  }, t.addObserver = function(n) {
    this.observers.indexOf(n) === -1 && (this.observers.push(n), this.hadObservers = !0, this.clearGcTimeout(), this.cache.notify({
      type: "observerAdded",
      query: this,
      observer: n
    }));
  }, t.removeObserver = function(n) {
    this.observers.indexOf(n) !== -1 && (this.observers = this.observers.filter(function(o) {
      return o !== n;
    }), this.observers.length || (this.retryer && (this.retryer.isTransportCancelable || this.abortSignalConsumed ? this.retryer.cancel({
      revert: !0
    }) : this.retryer.cancelRetry()), this.cacheTime ? this.scheduleGc() : this.cache.remove(this)), this.cache.notify({
      type: "observerRemoved",
      query: this,
      observer: n
    }));
  }, t.getObserversCount = function() {
    return this.observers.length;
  }, t.invalidate = function() {
    this.state.isInvalidated || this.dispatch({
      type: "invalidate"
    });
  }, t.fetch = function(n, o) {
    var s = this, f, l, h;
    if (this.state.isFetching) {
      if (this.state.dataUpdatedAt && o?.cancelRefetch)
        this.cancel({
          silent: !0
        });
      else if (this.promise) {
        var p;
        return (p = this.retryer) == null || p.continueRetry(), this.promise;
      }
    }
    if (n && this.setOptions(n), !this.options.queryFn) {
      var b = this.observers.find(function(P) {
        return P.options.queryFn;
      });
      b && this.setOptions(b.options);
    }
    var g = Ro(this.queryKey), E = r0(), m = {
      queryKey: g,
      pageParam: void 0,
      meta: this.meta
    };
    Object.defineProperty(m, "signal", {
      enumerable: !0,
      get: function() {
        if (E)
          return s.abortSignalConsumed = !0, E.signal;
      }
    });
    var A = function() {
      return s.options.queryFn ? (s.abortSignalConsumed = !1, s.options.queryFn(m)) : Promise.reject("Missing queryFn");
    }, w = {
      fetchOptions: o,
      options: this.options,
      queryKey: g,
      state: this.state,
      fetchFn: A,
      meta: this.meta
    };
    if ((f = this.options.behavior) != null && f.onFetch) {
      var S;
      (S = this.options.behavior) == null || S.onFetch(w);
    }
    if (this.revertState = this.state, !this.state.isFetching || this.state.fetchMeta !== ((l = w.fetchOptions) == null ? void 0 : l.meta)) {
      var N;
      this.dispatch({
        type: "fetch",
        meta: (N = w.fetchOptions) == null ? void 0 : N.meta
      });
    }
    return this.retryer = new i0({
      fn: w.fetchFn,
      abort: E == null || (h = E.abort) == null ? void 0 : h.bind(E),
      onSuccess: function(C) {
        s.setData(C), s.cache.config.onSuccess == null || s.cache.config.onSuccess(C, s), s.cacheTime === 0 && s.optionalRemove();
      },
      onError: function(C) {
        bo(C) && C.silent || s.dispatch({
          type: "error",
          error: C
        }), bo(C) || (s.cache.config.onError == null || s.cache.config.onError(C, s), ko().error(C)), s.cacheTime === 0 && s.optionalRemove();
      },
      onFail: function() {
        s.dispatch({
          type: "failed"
        });
      },
      onPause: function() {
        s.dispatch({
          type: "pause"
        });
      },
      onContinue: function() {
        s.dispatch({
          type: "continue"
        });
      },
      retry: w.options.retry,
      retryDelay: w.options.retryDelay
    }), this.promise = this.retryer.promise, this.promise;
  }, t.dispatch = function(n) {
    var o = this;
    this.state = this.reducer(this.state, n), ut.batch(function() {
      o.observers.forEach(function(s) {
        s.onQueryUpdate(n);
      }), o.cache.notify({
        query: o,
        type: "queryUpdated",
        action: n
      });
    });
  }, t.getDefaultState = function(n) {
    var o = typeof n.initialData == "function" ? n.initialData() : n.initialData, s = typeof n.initialData < "u", f = s ? typeof n.initialDataUpdatedAt == "function" ? n.initialDataUpdatedAt() : n.initialDataUpdatedAt : 0, l = typeof o < "u";
    return {
      data: o,
      dataUpdateCount: 0,
      dataUpdatedAt: l ? f ?? Date.now() : 0,
      error: null,
      errorUpdateCount: 0,
      errorUpdatedAt: 0,
      fetchFailureCount: 0,
      fetchMeta: null,
      isFetching: !1,
      isInvalidated: !1,
      isPaused: !1,
      status: l ? "success" : "idle"
    };
  }, t.reducer = function(n, o) {
    var s, f;
    switch (o.type) {
      case "failed":
        return Ve({}, n, {
          fetchFailureCount: n.fetchFailureCount + 1
        });
      case "pause":
        return Ve({}, n, {
          isPaused: !0
        });
      case "continue":
        return Ve({}, n, {
          isPaused: !1
        });
      case "fetch":
        return Ve({}, n, {
          fetchFailureCount: 0,
          fetchMeta: (s = o.meta) != null ? s : null,
          isFetching: !0,
          isPaused: !1
        }, !n.dataUpdatedAt && {
          error: null,
          status: "loading"
        });
      case "success":
        return Ve({}, n, {
          data: o.data,
          dataUpdateCount: n.dataUpdateCount + 1,
          dataUpdatedAt: (f = o.dataUpdatedAt) != null ? f : Date.now(),
          error: null,
          fetchFailureCount: 0,
          isFetching: !1,
          isInvalidated: !1,
          isPaused: !1,
          status: "success"
        });
      case "error":
        var l = o.error;
        return bo(l) && l.revert && this.revertState ? Ve({}, this.revertState) : Ve({}, n, {
          error: l,
          errorUpdateCount: n.errorUpdateCount + 1,
          errorUpdatedAt: Date.now(),
          fetchFailureCount: n.fetchFailureCount + 1,
          isFetching: !1,
          isPaused: !1,
          status: "error"
        });
      case "invalidate":
        return Ve({}, n, {
          isInvalidated: !0
        });
      case "setState":
        return Ve({}, n, o.state);
      default:
        return n;
    }
  }, e;
}(), Wb = /* @__PURE__ */ function(e) {
  zi(t, e);
  function t(n) {
    var o;
    return o = e.call(this) || this, o.config = n || {}, o.queries = [], o.queriesMap = {}, o;
  }
  var r = t.prototype;
  return r.build = function(o, s, f) {
    var l, h = s.queryKey, p = (l = s.queryHash) != null ? l : uc(h, s), b = this.get(p);
    return b || (b = new $b({
      cache: this,
      queryKey: h,
      queryHash: p,
      options: o.defaultQueryOptions(s),
      state: f,
      defaultOptions: o.getQueryDefaults(h),
      meta: s.meta
    }), this.add(b)), b;
  }, r.add = function(o) {
    this.queriesMap[o.queryHash] || (this.queriesMap[o.queryHash] = o, this.queries.push(o), this.notify({
      type: "queryAdded",
      query: o
    }));
  }, r.remove = function(o) {
    var s = this.queriesMap[o.queryHash];
    s && (o.destroy(), this.queries = this.queries.filter(function(f) {
      return f !== o;
    }), s === o && delete this.queriesMap[o.queryHash], this.notify({
      type: "queryRemoved",
      query: o
    }));
  }, r.clear = function() {
    var o = this;
    ut.batch(function() {
      o.queries.forEach(function(s) {
        o.remove(s);
      });
    });
  }, r.get = function(o) {
    return this.queriesMap[o];
  }, r.getAll = function() {
    return this.queries;
  }, r.find = function(o, s) {
    var f = xn(o, s), l = f[0];
    return typeof l.exact > "u" && (l.exact = !0), this.queries.find(function(h) {
      return mf(l, h);
    });
  }, r.findAll = function(o, s) {
    var f = xn(o, s), l = f[0];
    return Object.keys(l).length > 0 ? this.queries.filter(function(h) {
      return mf(l, h);
    }) : this.queries;
  }, r.notify = function(o) {
    var s = this;
    ut.batch(function() {
      s.listeners.forEach(function(f) {
        f(o);
      });
    });
  }, r.onFocus = function() {
    var o = this;
    ut.batch(function() {
      o.queries.forEach(function(s) {
        s.onFocus();
      });
    });
  }, r.onOnline = function() {
    var o = this;
    ut.batch(function() {
      o.queries.forEach(function(s) {
        s.onOnline();
      });
    });
  }, t;
}(Fi), qb = /* @__PURE__ */ function() {
  function e(r) {
    this.options = Ve({}, r.defaultOptions, r.options), this.mutationId = r.mutationId, this.mutationCache = r.mutationCache, this.observers = [], this.state = r.state || Yb(), this.meta = r.meta;
  }
  var t = e.prototype;
  return t.setState = function(n) {
    this.dispatch({
      type: "setState",
      state: n
    });
  }, t.addObserver = function(n) {
    this.observers.indexOf(n) === -1 && this.observers.push(n);
  }, t.removeObserver = function(n) {
    this.observers = this.observers.filter(function(o) {
      return o !== n;
    });
  }, t.cancel = function() {
    return this.retryer ? (this.retryer.cancel(), this.retryer.promise.then(Pt).catch(Pt)) : Promise.resolve();
  }, t.continue = function() {
    return this.retryer ? (this.retryer.continue(), this.retryer.promise) : this.execute();
  }, t.execute = function() {
    var n = this, o, s = this.state.status === "loading", f = Promise.resolve();
    return s || (this.dispatch({
      type: "loading",
      variables: this.options.variables
    }), f = f.then(function() {
      n.mutationCache.config.onMutate == null || n.mutationCache.config.onMutate(n.state.variables, n);
    }).then(function() {
      return n.options.onMutate == null ? void 0 : n.options.onMutate(n.state.variables);
    }).then(function(l) {
      l !== n.state.context && n.dispatch({
        type: "loading",
        context: l,
        variables: n.state.variables
      });
    })), f.then(function() {
      return n.executeMutation();
    }).then(function(l) {
      o = l, n.mutationCache.config.onSuccess == null || n.mutationCache.config.onSuccess(o, n.state.variables, n.state.context, n);
    }).then(function() {
      return n.options.onSuccess == null ? void 0 : n.options.onSuccess(o, n.state.variables, n.state.context);
    }).then(function() {
      return n.options.onSettled == null ? void 0 : n.options.onSettled(o, null, n.state.variables, n.state.context);
    }).then(function() {
      return n.dispatch({
        type: "success",
        data: o
      }), o;
    }).catch(function(l) {
      return n.mutationCache.config.onError == null || n.mutationCache.config.onError(l, n.state.variables, n.state.context, n), ko().error(l), Promise.resolve().then(function() {
        return n.options.onError == null ? void 0 : n.options.onError(l, n.state.variables, n.state.context);
      }).then(function() {
        return n.options.onSettled == null ? void 0 : n.options.onSettled(void 0, l, n.state.variables, n.state.context);
      }).then(function() {
        throw n.dispatch({
          type: "error",
          error: l
        }), l;
      });
    });
  }, t.executeMutation = function() {
    var n = this, o;
    return this.retryer = new i0({
      fn: function() {
        return n.options.mutationFn ? n.options.mutationFn(n.state.variables) : Promise.reject("No mutationFn found");
      },
      onFail: function() {
        n.dispatch({
          type: "failed"
        });
      },
      onPause: function() {
        n.dispatch({
          type: "pause"
        });
      },
      onContinue: function() {
        n.dispatch({
          type: "continue"
        });
      },
      retry: (o = this.options.retry) != null ? o : 0,
      retryDelay: this.options.retryDelay
    }), this.retryer.promise;
  }, t.dispatch = function(n) {
    var o = this;
    this.state = Gb(this.state, n), ut.batch(function() {
      o.observers.forEach(function(s) {
        s.onMutationUpdate(n);
      }), o.mutationCache.notify(o);
    });
  }, e;
}();
function Yb() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    isPaused: !1,
    status: "idle",
    variables: void 0
  };
}
function Gb(e, t) {
  switch (t.type) {
    case "failed":
      return Ve({}, e, {
        failureCount: e.failureCount + 1
      });
    case "pause":
      return Ve({}, e, {
        isPaused: !0
      });
    case "continue":
      return Ve({}, e, {
        isPaused: !1
      });
    case "loading":
      return Ve({}, e, {
        context: t.context,
        data: void 0,
        error: null,
        isPaused: !1,
        status: "loading",
        variables: t.variables
      });
    case "success":
      return Ve({}, e, {
        data: t.data,
        error: null,
        status: "success",
        isPaused: !1
      });
    case "error":
      return Ve({}, e, {
        data: void 0,
        error: t.error,
        failureCount: e.failureCount + 1,
        isPaused: !1,
        status: "error"
      });
    case "setState":
      return Ve({}, e, t.state);
    default:
      return e;
  }
}
var Qb = /* @__PURE__ */ function(e) {
  zi(t, e);
  function t(n) {
    var o;
    return o = e.call(this) || this, o.config = n || {}, o.mutations = [], o.mutationId = 0, o;
  }
  var r = t.prototype;
  return r.build = function(o, s, f) {
    var l = new qb({
      mutationCache: this,
      mutationId: ++this.mutationId,
      options: o.defaultMutationOptions(s),
      state: f,
      defaultOptions: s.mutationKey ? o.getMutationDefaults(s.mutationKey) : void 0,
      meta: s.meta
    });
    return this.add(l), l;
  }, r.add = function(o) {
    this.mutations.push(o), this.notify(o);
  }, r.remove = function(o) {
    this.mutations = this.mutations.filter(function(s) {
      return s !== o;
    }), o.cancel(), this.notify(o);
  }, r.clear = function() {
    var o = this;
    ut.batch(function() {
      o.mutations.forEach(function(s) {
        o.remove(s);
      });
    });
  }, r.getAll = function() {
    return this.mutations;
  }, r.find = function(o) {
    return typeof o.exact > "u" && (o.exact = !0), this.mutations.find(function(s) {
      return Ef(o, s);
    });
  }, r.findAll = function(o) {
    return this.mutations.filter(function(s) {
      return Ef(o, s);
    });
  }, r.notify = function(o) {
    var s = this;
    ut.batch(function() {
      s.listeners.forEach(function(f) {
        f(o);
      });
    });
  }, r.onFocus = function() {
    this.resumePausedMutations();
  }, r.onOnline = function() {
    this.resumePausedMutations();
  }, r.resumePausedMutations = function() {
    var o = this.mutations.filter(function(s) {
      return s.state.isPaused;
    });
    return ut.batch(function() {
      return o.reduce(function(s, f) {
        return s.then(function() {
          return f.continue().catch(Pt);
        });
      }, Promise.resolve());
    });
  }, t;
}(Fi);
function Vb() {
  return {
    onFetch: function(t) {
      t.fetchFn = function() {
        var r, n, o, s, f, l, h = (r = t.fetchOptions) == null || (n = r.meta) == null ? void 0 : n.refetchPage, p = (o = t.fetchOptions) == null || (s = o.meta) == null ? void 0 : s.fetchMore, b = p?.pageParam, g = p?.direction === "forward", E = p?.direction === "backward", m = ((f = t.state.data) == null ? void 0 : f.pages) || [], A = ((l = t.state.data) == null ? void 0 : l.pageParams) || [], w = r0(), S = w?.signal, N = A, P = !1, C = t.options.queryFn || function() {
          return Promise.reject("Missing queryFn");
        }, B = function(ge, L, _, q) {
          return N = q ? [L].concat(N) : [].concat(N, [L]), q ? [_].concat(ge) : [].concat(ge, [_]);
        }, R = function(ge, L, _, q) {
          if (P)
            return Promise.reject("Cancelled");
          if (typeof _ > "u" && !L && ge.length)
            return Promise.resolve(ge);
          var se = {
            queryKey: t.queryKey,
            signal: S,
            pageParam: _,
            meta: t.meta
          }, ae = C(se), Ee = Promise.resolve(ae).then(function(Be) {
            return B(ge, _, Be, q);
          });
          if (Bo(ae)) {
            var Se = Ee;
            Se.cancel = ae.cancel;
          }
          return Ee;
        }, F;
        if (!m.length)
          F = R([]);
        else if (g) {
          var Y = typeof b < "u", K = Y ? b : Tf(t.options, m);
          F = R(m, Y, K);
        } else if (E) {
          var Me = typeof b < "u", ye = Me ? b : Hb(t.options, m);
          F = R(m, Me, ye, !0);
        } else
          (function() {
            N = [];
            var X = typeof t.options.getNextPageParam > "u", ge = h && m[0] ? h(m[0], 0, m) : !0;
            F = ge ? R([], X, A[0]) : Promise.resolve(B([], A[0], m[0]));
            for (var L = function(se) {
              F = F.then(function(ae) {
                var Ee = h && m[se] ? h(m[se], se, m) : !0;
                if (Ee) {
                  var Se = X ? A[se] : Tf(t.options, ae);
                  return R(ae, X, Se);
                }
                return Promise.resolve(B(ae, A[se], m[se]));
              });
            }, _ = 1; _ < m.length; _++)
              L(_);
          })();
        var $ = F.then(function(X) {
          return {
            pages: X,
            pageParams: N
          };
        }), G = $;
        return G.cancel = function() {
          P = !0, w?.abort(), Bo(F) && F.cancel();
        }, $;
      };
    }
  };
}
function Tf(e, t) {
  return e.getNextPageParam == null ? void 0 : e.getNextPageParam(t[t.length - 1], t);
}
function Hb(e, t) {
  return e.getPreviousPageParam == null ? void 0 : e.getPreviousPageParam(t[0], t);
}
var Zb = /* @__PURE__ */ function() {
  function e(r) {
    r === void 0 && (r = {}), this.queryCache = r.queryCache || new Wb(), this.mutationCache = r.mutationCache || new Qb(), this.defaultOptions = r.defaultOptions || {}, this.queryDefaults = [], this.mutationDefaults = [];
  }
  var t = e.prototype;
  return t.mount = function() {
    var n = this;
    this.unsubscribeFocus = Si.subscribe(function() {
      Si.isFocused() && vo.isOnline() && (n.mutationCache.onFocus(), n.queryCache.onFocus());
    }), this.unsubscribeOnline = vo.subscribe(function() {
      Si.isFocused() && vo.isOnline() && (n.mutationCache.onOnline(), n.queryCache.onOnline());
    });
  }, t.unmount = function() {
    var n, o;
    (n = this.unsubscribeFocus) == null || n.call(this), (o = this.unsubscribeOnline) == null || o.call(this);
  }, t.isFetching = function(n, o) {
    var s = xn(n, o), f = s[0];
    return f.fetching = !0, this.queryCache.findAll(f).length;
  }, t.isMutating = function(n) {
    return this.mutationCache.findAll(Ve({}, n, {
      fetching: !0
    })).length;
  }, t.getQueryData = function(n, o) {
    var s;
    return (s = this.queryCache.find(n, o)) == null ? void 0 : s.state.data;
  }, t.getQueriesData = function(n) {
    return this.getQueryCache().findAll(n).map(function(o) {
      var s = o.queryKey, f = o.state, l = f.data;
      return [s, l];
    });
  }, t.setQueryData = function(n, o, s) {
    var f = go(n), l = this.defaultQueryOptions(f);
    return this.queryCache.build(this, l).setData(o, s);
  }, t.setQueriesData = function(n, o, s) {
    var f = this;
    return ut.batch(function() {
      return f.getQueryCache().findAll(n).map(function(l) {
        var h = l.queryKey;
        return [h, f.setQueryData(h, o, s)];
      });
    });
  }, t.getQueryState = function(n, o) {
    var s;
    return (s = this.queryCache.find(n, o)) == null ? void 0 : s.state;
  }, t.removeQueries = function(n, o) {
    var s = xn(n, o), f = s[0], l = this.queryCache;
    ut.batch(function() {
      l.findAll(f).forEach(function(h) {
        l.remove(h);
      });
    });
  }, t.resetQueries = function(n, o, s) {
    var f = this, l = xn(n, o, s), h = l[0], p = l[1], b = this.queryCache, g = Ve({}, h, {
      active: !0
    });
    return ut.batch(function() {
      return b.findAll(h).forEach(function(E) {
        E.reset();
      }), f.refetchQueries(g, p);
    });
  }, t.cancelQueries = function(n, o, s) {
    var f = this, l = xn(n, o, s), h = l[0], p = l[1], b = p === void 0 ? {} : p;
    typeof b.revert > "u" && (b.revert = !0);
    var g = ut.batch(function() {
      return f.queryCache.findAll(h).map(function(E) {
        return E.cancel(b);
      });
    });
    return Promise.all(g).then(Pt).catch(Pt);
  }, t.invalidateQueries = function(n, o, s) {
    var f, l, h, p = this, b = xn(n, o, s), g = b[0], E = b[1], m = Ve({}, g, {
      active: (f = (l = g.refetchActive) != null ? l : g.active) != null ? f : !0,
      inactive: (h = g.refetchInactive) != null ? h : !1
    });
    return ut.batch(function() {
      return p.queryCache.findAll(g).forEach(function(A) {
        A.invalidate();
      }), p.refetchQueries(m, E);
    });
  }, t.refetchQueries = function(n, o, s) {
    var f = this, l = xn(n, o, s), h = l[0], p = l[1], b = ut.batch(function() {
      return f.queryCache.findAll(h).map(function(E) {
        return E.fetch(void 0, Ve({}, p, {
          meta: {
            refetchPage: h?.refetchPage
          }
        }));
      });
    }), g = Promise.all(b).then(Pt);
    return p?.throwOnError || (g = g.catch(Pt)), g;
  }, t.fetchQuery = function(n, o, s) {
    var f = go(n, o, s), l = this.defaultQueryOptions(f);
    typeof l.retry > "u" && (l.retry = !1);
    var h = this.queryCache.build(this, l);
    return h.isStaleByTime(l.staleTime) ? h.fetch(l) : Promise.resolve(h.state.data);
  }, t.prefetchQuery = function(n, o, s) {
    return this.fetchQuery(n, o, s).then(Pt).catch(Pt);
  }, t.fetchInfiniteQuery = function(n, o, s) {
    var f = go(n, o, s);
    return f.behavior = Vb(), this.fetchQuery(f);
  }, t.prefetchInfiniteQuery = function(n, o, s) {
    return this.fetchInfiniteQuery(n, o, s).then(Pt).catch(Pt);
  }, t.cancelMutations = function() {
    var n = this, o = ut.batch(function() {
      return n.mutationCache.getAll().map(function(s) {
        return s.cancel();
      });
    });
    return Promise.all(o).then(Pt).catch(Pt);
  }, t.resumePausedMutations = function() {
    return this.getMutationCache().resumePausedMutations();
  }, t.executeMutation = function(n) {
    return this.mutationCache.build(this, n).execute();
  }, t.getQueryCache = function() {
    return this.queryCache;
  }, t.getMutationCache = function() {
    return this.mutationCache;
  }, t.getDefaultOptions = function() {
    return this.defaultOptions;
  }, t.setDefaultOptions = function(n) {
    this.defaultOptions = n;
  }, t.setQueryDefaults = function(n, o) {
    var s = this.queryDefaults.find(function(f) {
      return zn(n) === zn(f.queryKey);
    });
    s ? s.defaultOptions = o : this.queryDefaults.push({
      queryKey: n,
      defaultOptions: o
    });
  }, t.getQueryDefaults = function(n) {
    var o;
    return n ? (o = this.queryDefaults.find(function(s) {
      return Po(n, s.queryKey);
    })) == null ? void 0 : o.defaultOptions : void 0;
  }, t.setMutationDefaults = function(n, o) {
    var s = this.mutationDefaults.find(function(f) {
      return zn(n) === zn(f.mutationKey);
    });
    s ? s.defaultOptions = o : this.mutationDefaults.push({
      mutationKey: n,
      defaultOptions: o
    });
  }, t.getMutationDefaults = function(n) {
    var o;
    return n ? (o = this.mutationDefaults.find(function(s) {
      return Po(n, s.mutationKey);
    })) == null ? void 0 : o.defaultOptions : void 0;
  }, t.defaultQueryOptions = function(n) {
    if (n?._defaulted)
      return n;
    var o = Ve({}, this.defaultOptions.queries, this.getQueryDefaults(n?.queryKey), n, {
      _defaulted: !0
    });
    return !o.queryHash && o.queryKey && (o.queryHash = uc(o.queryKey, o)), o;
  }, t.defaultQueryObserverOptions = function(n) {
    return this.defaultQueryOptions(n);
  }, t.defaultMutationOptions = function(n) {
    return n?._defaulted ? n : Ve({}, this.defaultOptions.mutations, this.getMutationDefaults(n?.mutationKey), n, {
      _defaulted: !0
    });
  }, t.clear = function() {
    this.queryCache.clear(), this.mutationCache.clear();
  }, e;
}(), Kb = /* @__PURE__ */ function(e) {
  zi(t, e);
  function t(n, o) {
    var s;
    return s = e.call(this) || this, s.client = n, s.options = o, s.trackedProps = [], s.selectError = null, s.bindMethods(), s.setOptions(o), s;
  }
  var r = t.prototype;
  return r.bindMethods = function() {
    this.remove = this.remove.bind(this), this.refetch = this.refetch.bind(this);
  }, r.onSubscribe = function() {
    this.listeners.length === 1 && (this.currentQuery.addObserver(this), Mf(this.currentQuery, this.options) && this.executeFetch(), this.updateTimers());
  }, r.onUnsubscribe = function() {
    this.listeners.length || this.destroy();
  }, r.shouldFetchOnReconnect = function() {
    return ya(this.currentQuery, this.options, this.options.refetchOnReconnect);
  }, r.shouldFetchOnWindowFocus = function() {
    return ya(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  }, r.destroy = function() {
    this.listeners = [], this.clearTimers(), this.currentQuery.removeObserver(this);
  }, r.setOptions = function(o, s) {
    var f = this.options, l = this.currentQuery;
    if (this.options = this.client.defaultQueryObserverOptions(o), typeof this.options.enabled < "u" && typeof this.options.enabled != "boolean")
      throw new Error("Expected enabled to be a boolean");
    this.options.queryKey || (this.options.queryKey = f.queryKey), this.updateQuery();
    var h = this.hasListeners();
    h && If(this.currentQuery, l, this.options, f) && this.executeFetch(), this.updateResult(s), h && (this.currentQuery !== l || this.options.enabled !== f.enabled || this.options.staleTime !== f.staleTime) && this.updateStaleTimeout();
    var p = this.computeRefetchInterval();
    h && (this.currentQuery !== l || this.options.enabled !== f.enabled || p !== this.currentRefetchInterval) && this.updateRefetchInterval(p);
  }, r.getOptimisticResult = function(o) {
    var s = this.client.defaultQueryObserverOptions(o), f = this.client.getQueryCache().build(this.client, s);
    return this.createResult(f, s);
  }, r.getCurrentResult = function() {
    return this.currentResult;
  }, r.trackResult = function(o, s) {
    var f = this, l = {}, h = function(b) {
      f.trackedProps.includes(b) || f.trackedProps.push(b);
    };
    return Object.keys(o).forEach(function(p) {
      Object.defineProperty(l, p, {
        configurable: !1,
        enumerable: !0,
        get: function() {
          return h(p), o[p];
        }
      });
    }), (s.useErrorBoundary || s.suspense) && h("error"), l;
  }, r.getNextResult = function(o) {
    var s = this;
    return new Promise(function(f, l) {
      var h = s.subscribe(function(p) {
        p.isFetching || (h(), p.isError && o?.throwOnError ? l(p.error) : f(p));
      });
    });
  }, r.getCurrentQuery = function() {
    return this.currentQuery;
  }, r.remove = function() {
    this.client.getQueryCache().remove(this.currentQuery);
  }, r.refetch = function(o) {
    return this.fetch(Ve({}, o, {
      meta: {
        refetchPage: o?.refetchPage
      }
    }));
  }, r.fetchOptimistic = function(o) {
    var s = this, f = this.client.defaultQueryObserverOptions(o), l = this.client.getQueryCache().build(this.client, f);
    return l.fetch().then(function() {
      return s.createResult(l, f);
    });
  }, r.fetch = function(o) {
    var s = this;
    return this.executeFetch(o).then(function() {
      return s.updateResult(), s.currentResult;
    });
  }, r.executeFetch = function(o) {
    this.updateQuery();
    var s = this.currentQuery.fetch(this.options, o);
    return o?.throwOnError || (s = s.catch(Pt)), s;
  }, r.updateStaleTimeout = function() {
    var o = this;
    if (this.clearStaleTimeout(), !(Lo || this.currentResult.isStale || !ha(this.options.staleTime))) {
      var s = e0(this.currentResult.dataUpdatedAt, this.options.staleTime), f = s + 1;
      this.staleTimeoutId = setTimeout(function() {
        o.currentResult.isStale || o.updateResult();
      }, f);
    }
  }, r.computeRefetchInterval = function() {
    var o;
    return typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (o = this.options.refetchInterval) != null ? o : !1;
  }, r.updateRefetchInterval = function(o) {
    var s = this;
    this.clearRefetchInterval(), this.currentRefetchInterval = o, !(Lo || this.options.enabled === !1 || !ha(this.currentRefetchInterval) || this.currentRefetchInterval === 0) && (this.refetchIntervalId = setInterval(function() {
      (s.options.refetchIntervalInBackground || Si.isFocused()) && s.executeFetch();
    }, this.currentRefetchInterval));
  }, r.updateTimers = function() {
    this.updateStaleTimeout(), this.updateRefetchInterval(this.computeRefetchInterval());
  }, r.clearTimers = function() {
    this.clearStaleTimeout(), this.clearRefetchInterval();
  }, r.clearStaleTimeout = function() {
    this.staleTimeoutId && (clearTimeout(this.staleTimeoutId), this.staleTimeoutId = void 0);
  }, r.clearRefetchInterval = function() {
    this.refetchIntervalId && (clearInterval(this.refetchIntervalId), this.refetchIntervalId = void 0);
  }, r.createResult = function(o, s) {
    var f = this.currentQuery, l = this.options, h = this.currentResult, p = this.currentResultState, b = this.currentResultOptions, g = o !== f, E = g ? o.state : this.currentQueryInitialState, m = g ? this.currentResult : this.previousQueryResult, A = o.state, w = A.dataUpdatedAt, S = A.error, N = A.errorUpdatedAt, P = A.isFetching, C = A.status, B = !1, R = !1, F;
    if (s.optimisticResults) {
      var Y = this.hasListeners(), K = !Y && Mf(o, s), Me = Y && If(o, f, s, l);
      (K || Me) && (P = !0, w || (C = "loading"));
    }
    if (s.keepPreviousData && !A.dataUpdateCount && m?.isSuccess && C !== "error")
      F = m.data, w = m.dataUpdatedAt, C = m.status, B = !0;
    else if (s.select && typeof A.data < "u")
      if (h && A.data === p?.data && s.select === this.selectFn)
        F = this.selectResult;
      else
        try {
          this.selectFn = s.select, F = s.select(A.data), s.structuralSharing !== !1 && (F = Uo(h?.data, F)), this.selectResult = F, this.selectError = null;
        } catch (G) {
          ko().error(G), this.selectError = G;
        }
    else
      F = A.data;
    if (typeof s.placeholderData < "u" && typeof F > "u" && (C === "loading" || C === "idle")) {
      var ye;
      if (h?.isPlaceholderData && s.placeholderData === b?.placeholderData)
        ye = h.data;
      else if (ye = typeof s.placeholderData == "function" ? s.placeholderData() : s.placeholderData, s.select && typeof ye < "u")
        try {
          ye = s.select(ye), s.structuralSharing !== !1 && (ye = Uo(h?.data, ye)), this.selectError = null;
        } catch (G) {
          ko().error(G), this.selectError = G;
        }
      typeof ye < "u" && (C = "success", F = ye, R = !0);
    }
    this.selectError && (S = this.selectError, F = this.selectResult, N = Date.now(), C = "error");
    var $ = {
      status: C,
      isLoading: C === "loading",
      isSuccess: C === "success",
      isError: C === "error",
      isIdle: C === "idle",
      data: F,
      dataUpdatedAt: w,
      error: S,
      errorUpdatedAt: N,
      failureCount: A.fetchFailureCount,
      errorUpdateCount: A.errorUpdateCount,
      isFetched: A.dataUpdateCount > 0 || A.errorUpdateCount > 0,
      isFetchedAfterMount: A.dataUpdateCount > E.dataUpdateCount || A.errorUpdateCount > E.errorUpdateCount,
      isFetching: P,
      isRefetching: P && C !== "loading",
      isLoadingError: C === "error" && A.dataUpdatedAt === 0,
      isPlaceholderData: R,
      isPreviousData: B,
      isRefetchError: C === "error" && A.dataUpdatedAt !== 0,
      isStale: lc(o, s),
      refetch: this.refetch,
      remove: this.remove
    };
    return $;
  }, r.shouldNotifyListeners = function(o, s) {
    if (!s)
      return !0;
    var f = this.options, l = f.notifyOnChangeProps, h = f.notifyOnChangePropsExclusions;
    if (!l && !h || l === "tracked" && !this.trackedProps.length)
      return !0;
    var p = l === "tracked" ? this.trackedProps : l;
    return Object.keys(o).some(function(b) {
      var g = b, E = o[g] !== s[g], m = p?.some(function(w) {
        return w === b;
      }), A = h?.some(function(w) {
        return w === b;
      });
      return E && !A && (!p || m);
    });
  }, r.updateResult = function(o) {
    var s = this.currentResult;
    if (this.currentResult = this.createResult(this.currentQuery, this.options), this.currentResultState = this.currentQuery.state, this.currentResultOptions = this.options, !Rb(this.currentResult, s)) {
      var f = {
        cache: !0
      };
      o?.listeners !== !1 && this.shouldNotifyListeners(this.currentResult, s) && (f.listeners = !0), this.notify(Ve({}, f, o));
    }
  }, r.updateQuery = function() {
    var o = this.client.getQueryCache().build(this.client, this.options);
    if (o !== this.currentQuery) {
      var s = this.currentQuery;
      this.currentQuery = o, this.currentQueryInitialState = o.state, this.previousQueryResult = this.currentResult, this.hasListeners() && (s?.removeObserver(this), o.addObserver(this));
    }
  }, r.onQueryUpdate = function(o) {
    var s = {};
    o.type === "success" ? s.onSuccess = !0 : o.type === "error" && !bo(o.error) && (s.onError = !0), this.updateResult(s), this.hasListeners() && this.updateTimers();
  }, r.notify = function(o) {
    var s = this;
    ut.batch(function() {
      o.onSuccess ? (s.options.onSuccess == null || s.options.onSuccess(s.currentResult.data), s.options.onSettled == null || s.options.onSettled(s.currentResult.data, null)) : o.onError && (s.options.onError == null || s.options.onError(s.currentResult.error), s.options.onSettled == null || s.options.onSettled(void 0, s.currentResult.error)), o.listeners && s.listeners.forEach(function(f) {
        f(s.currentResult);
      }), o.cache && s.client.getQueryCache().notify({
        query: s.currentQuery,
        type: "observerResultsUpdated"
      });
    });
  }, t;
}(Fi);
function Xb(e, t) {
  return t.enabled !== !1 && !e.state.dataUpdatedAt && !(e.state.status === "error" && t.retryOnMount === !1);
}
function Mf(e, t) {
  return Xb(e, t) || e.state.dataUpdatedAt > 0 && ya(e, t, t.refetchOnMount);
}
function ya(e, t, r) {
  if (t.enabled !== !1) {
    var n = typeof r == "function" ? r(e) : r;
    return n === "always" || n !== !1 && lc(e, t);
  }
  return !1;
}
function If(e, t, r, n) {
  return r.enabled !== !1 && (e !== t || n.enabled === !1) && (!r.suspense || e.state.status !== "error") && lc(e, r);
}
function lc(e, t) {
  return e.isStaleByTime(t.staleTime);
}
var Jb = qf.unstable_batchedUpdates;
ut.setBatchNotifyFunction(Jb);
var ex = console;
Fb(ex);
var Cf = /* @__PURE__ */ Wt.createContext(void 0), s0 = /* @__PURE__ */ Wt.createContext(!1);
function a0(e) {
  return e && typeof window < "u" ? (window.ReactQueryClientContext || (window.ReactQueryClientContext = Cf), window.ReactQueryClientContext) : Cf;
}
var tx = function() {
  var t = Wt.useContext(a0(Wt.useContext(s0)));
  if (!t)
    throw new Error("No QueryClient set, use QueryClientProvider to set one");
  return t;
}, rx = function(t) {
  var r = t.client, n = t.contextSharing, o = n === void 0 ? !1 : n, s = t.children;
  Wt.useEffect(function() {
    return r.mount(), function() {
      r.unmount();
    };
  }, [r]);
  var f = a0(o);
  return /* @__PURE__ */ je(s0.Provider, {
    value: o,
    children: /* @__PURE__ */ je(f.Provider, {
      value: r,
      children: s
    })
  });
};
function nx() {
  var e = !1;
  return {
    clearReset: function() {
      e = !1;
    },
    reset: function() {
      e = !0;
    },
    isReset: function() {
      return e;
    }
  };
}
var ix = /* @__PURE__ */ Wt.createContext(nx()), ox = function() {
  return Wt.useContext(ix);
};
function sx(e, t, r) {
  return typeof t == "function" ? t.apply(void 0, r) : typeof t == "boolean" ? t : !!e;
}
function ax(e, t) {
  var r = Wt.useRef(!1), n = Wt.useState(0), o = n[1], s = tx(), f = ox(), l = s.defaultQueryObserverOptions(e);
  l.optimisticResults = !0, l.onError && (l.onError = ut.batchCalls(l.onError)), l.onSuccess && (l.onSuccess = ut.batchCalls(l.onSuccess)), l.onSettled && (l.onSettled = ut.batchCalls(l.onSettled)), l.suspense && (typeof l.staleTime != "number" && (l.staleTime = 1e3), l.cacheTime === 0 && (l.cacheTime = 1)), (l.suspense || l.useErrorBoundary) && (f.isReset() || (l.retryOnMount = !1));
  var h = Wt.useState(function() {
    return new t(s, l);
  }), p = h[0], b = p.getOptimisticResult(l);
  if (Wt.useEffect(function() {
    r.current = !0, f.clearReset();
    var g = p.subscribe(ut.batchCalls(function() {
      r.current && o(function(E) {
        return E + 1;
      });
    }));
    return p.updateResult(), function() {
      r.current = !1, g();
    };
  }, [f, p]), Wt.useEffect(function() {
    p.setOptions(l, {
      listeners: !1
    });
  }, [l, p]), l.suspense && b.isLoading)
    throw p.fetchOptimistic(l).then(function(g) {
      var E = g.data;
      l.onSuccess == null || l.onSuccess(E), l.onSettled == null || l.onSettled(E, null);
    }).catch(function(g) {
      f.clearReset(), l.onError == null || l.onError(g), l.onSettled == null || l.onSettled(void 0, g);
    });
  if (b.isError && !f.isReset() && !b.isFetching && sx(l.suspense, l.useErrorBoundary, [b.error, p.getCurrentQuery()]))
    throw b.error;
  return l.notifyOnChangeProps === "tracked" && (b = p.trackResult(b, l)), b;
}
function cx(e, t, r) {
  var n = go(e, t, r);
  return ax(n, Kb);
}
var fx = /* @__PURE__ */ ((e) => (e.DEV_NET = "sui:devnet", e.TEST_NET = "sui:testnet", e.MAIN_NET = "sui:mainnet", e.DEVNET = "sui:devnet", e.TestNET = "sui:testnet", e))(fx || {});
const ux = {
  id: "sui:devnet",
  name: "Sui Devnet",
  rpcUrl: "https://fullnode.devnet.sui.io/"
}, lx = {
  id: "sui:testnet",
  name: "Sui Testnet",
  rpcUrl: "https://fullnode.testnet.sui.io/"
}, dx = {
  id: "sui:mainnet",
  name: "Sui Mainnet",
  rpcUrl: "https://rpc.mainnet.sui.io/"
}, xo = {
  id: "unknown:unknown",
  name: "Unknown Network",
  rpcUrl: ""
}, hx = [
  ux,
  lx,
  dx
];
var c0 = /* @__PURE__ */ ((e) => (e.COIN_BALANCE = "SUIET_COIN_BALANCE", e))(c0 || {});
function px(e, t) {
  const r = new URLSearchParams(t);
  return e + "?" + r.toString();
}
class yx {
  constructor(t, r) {
    Object.defineProperty(this, "provider", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "address", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.provider = t, this.address = r;
  }
  async get(t = nc) {
    return (await this.getAllCoins()).find((o) => o.typeArg === t)?.balance || BigInt(0);
  }
  async getAllCoins() {
    const t = await this.provider.query.getOwnedCoins(this.address), r = /* @__PURE__ */ new Map();
    for (const n of t)
      r.has(n.typeArg) ? r.set(n.typeArg, r.get(n.typeArg) + n.balance) : r.set(n.typeArg, n.balance);
    return Array.from(r.entries()).map((n) => ({
      typeArg: n[0],
      balance: n[1]
    }));
  }
}
class gx {
  constructor(t, r) {
    Object.defineProperty(this, "balance", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.balance = new yx(t, r);
  }
}
const _f = "0x2::coin::Coin";
class dc {
  constructor(t, r, n) {
    Object.defineProperty(this, "_objectId", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "_typeArg", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "_balance", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "_symbol", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this._objectId = t, this._balance = n, this._typeArg = r, this._symbol = Li.getCoinSymbol(r);
  }
  get objectId() {
    return this._objectId;
  }
  get typeArg() {
    return this._typeArg;
  }
  get balance() {
    return this._balance;
  }
  get symbol() {
    return this._symbol;
  }
  static fromDto(t) {
    return new dc(t.objectId, t.typeArg, t.balance);
  }
  toDto() {
    return {
      objectId: this._objectId,
      balance: this._balance,
      typeArg: this._typeArg,
      symbol: this._symbol
    };
  }
  toString() {
    return JSON.stringify(this.toDto());
  }
}
class Li {
  static isCoin(t) {
    return t.type.startsWith(_f);
  }
  static isSUI(t) {
    const r = Li.getCoinTypeArg(t);
    return r ? Li.getCoinSymbol(r) === "SUI" : !1;
  }
  static getCoinObject(t) {
    const r = Ht.getCoinTypeArg(t);
    if (!r)
      throw new Error("coin typeArg cannot be null");
    return new dc(t.fields.id.id, r, BigInt(t.fields.balance));
  }
  static getBalance(t) {
    return BigInt(t.fields.balance);
  }
  static getCoinTypeArg(t) {
    return Ht.getCoinTypeArg(t);
  }
  static getCoinSymbol(t) {
    return t.substring(t.lastIndexOf(":") + 1);
  }
  static getCoinTypeFromArg(t) {
    return `${_f}<${t}>`;
  }
}
class Of {
  static isNft(t) {
    return !!(t.fields.name && t.fields.description && t.fields.url);
  }
  static getNftObject(t, r) {
    return {
      objectId: t.fields.id.id,
      name: t.fields.name,
      description: t.fields.description,
      url: t.fields.url,
      previousTransaction: r,
      objectType: t.type
    };
  }
}
const D6 = "0x0000000000000000000000000000000000000005";
class vx {
  constructor(t) {
    Object.defineProperty(this, "query", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.query = new bx(t);
  }
}
class bx {
  constructor(t) {
    Object.defineProperty(this, "provider", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.provider = new Xl(new pi({ fullnode: t }));
  }
  async getOwnedObjects(t) {
    let r = !0, n = null, o = [];
    for (; r; ) {
      const s = await this.provider.getOwnedObjects({
        owner: t,
        cursor: n,
        options: {
          showType: !0,
          showDisplay: !0,
          showContent: !0,
          showOwner: !0
        }
      });
      s.data?.forEach((l) => {
        const h = rs(l);
        h && o.push(h);
      }), r = s.hasNextPage, n = s.nextCursor;
    }
    return o;
  }
  async getOwnedCoins(t) {
    return (await this.getOwnedObjects(t)).map((o) => ({
      id: o.objectId,
      object: jo(o)
    })).filter((o) => o.object && Ht.isCoin(o.object)).map((o) => Li.getCoinObject(o.object));
  }
  async getOwnedNfts(t) {
    return (await this.getOwnedObjects(t)).map((o) => ({
      id: o.objectId,
      object: jo(o),
      previousTransaction: o.previousTransaction
    })).filter((o) => o.object && Of.isNft(o.object)).map((o) => {
      const s = o.object;
      return Of.getNftObject(s, o.previousTransaction);
    });
  }
}
const Nf = 1e6, Fs = 1e9, $s = 1e12;
function xx(e, t) {
  return f0(e, Object.assign({
    decimals: 9
  }, t));
}
function f0(e, t) {
  const { decimals: r = 0, withAbbr: n = !0 } = t ?? {};
  if (typeof e == "bigint" && !mx(e))
    return l0(BigInt(e), {
      decimals: r,
      withAbbr: n
    });
  if (Number(e) === 0)
    return "0";
  if (Number(e) < 0)
    return "-" + f0(-Number(e), t);
  const o = Number(e) / 10 ** r;
  return o > 0 && o < 1 ? wx(o) : u0(o, n);
}
function u0(e, t) {
  if (t) {
    if (e >= Nf && e < Fs)
      return Ws(e, Nf, "M");
    if (e >= Fs && e < $s)
      return Ws(e, Fs, "B");
    if (e >= $s)
      return Ws(e, $s, "T");
  }
  return Intl.NumberFormat("en-US").format(e);
}
function Ws(e, t, r) {
  let n;
  typeof e == "bigint" ? n = String(e / (BigInt(t) / 1000n)) : n = String(Math.floor(e / (t / 1e3)));
  const o = n.padEnd(4, "0");
  return Intl.NumberFormat("en-US").format(Number(o)).replace(",", ".") + r;
}
function wx(e) {
  if (e <= 0)
    return "0";
  const t = Math.ceil(-Math.log10(e));
  return Number(e) % Math.pow(10, 10 - (t + 2)) === 0 && Number(e) % Math.pow(10, 10 - (t + 1)) === 0 ? qs(e, t) : Number(e) % Math.pow(10, 10 - (t + 2)) === 0 && Number(e) % Math.pow(10, 10 - (t + 1)) !== 0 ? qs(e, t + 1) : qs(e, t + 2);
}
function qs(e, t) {
  function r(n) {
    if (isNaN(n))
      return n.toString();
    const o = "" + n;
    return /e/i.test(o) ? n.toFixed(18).replace(/\.?0+$/, "") : n.toString();
  }
  return t = t || 0, t = Math.pow(10, t), r(Math.floor(e * t) / t);
}
function l0(e, t) {
  if (e === 0n)
    return "0";
  if (e < 0n)
    return "-" + l0(-e, t);
  const { decimals: r = 9, withAbbr: n = !0 } = t ?? {}, o = e / 10n ** BigInt(r);
  return u0(o, n);
}
function mx(e) {
  const t = Number.MIN_SAFE_INTEGER, r = Number.MAX_SAFE_INTEGER;
  return e >= BigInt(t) && e <= BigInt(r);
}
function Ex(e) {
  if (typeof e != "string")
    throw new Error("address is not a string");
  return !e || !e.startsWith("0x") ? e : e.slice(0, 7) + "...." + e.slice(-4, e.length);
}
function Ax(e) {
  var t = e.default;
  if (typeof t == "function") {
    var r = function() {
      return t.apply(this, arguments);
    };
    r.prototype = t.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(e).forEach(function(n) {
    var o = Object.getOwnPropertyDescriptor(e, n);
    Object.defineProperty(r, n, o.get ? o : {
      enumerable: !0,
      get: function() {
        return e[n];
      }
    });
  }), r;
}
function Sx(e) {
  throw new Error('Could not dynamically require "' + e + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var d0 = { exports: {} }, Tx = {}, Mx = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  default: Tx
}), Ix = /* @__PURE__ */ Ax(Mx);
(function(e) {
  (function(t) {
    var r = function(a) {
      var d, u = new Float64Array(16);
      if (a)
        for (d = 0; d < a.length; d++)
          u[d] = a[d];
      return u;
    }, n = function() {
      throw new Error("no PRNG");
    }, o = new Uint8Array(16), s = new Uint8Array(32);
    s[0] = 9;
    var f = r(), l = r([1]), h = r([56129, 1]), p = r([30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139, 11119, 27886, 20995]), b = r([61785, 9906, 39828, 60374, 45398, 33411, 5274, 224, 53552, 61171, 33010, 6542, 64743, 22239, 55772, 9222]), g = r([54554, 36645, 11616, 51542, 42930, 38181, 51040, 26924, 56412, 64982, 57905, 49316, 21502, 52590, 14035, 8553]), E = r([26200, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214]), m = r([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);
    function A(a, d, u, i) {
      a[d] = u >> 24 & 255, a[d + 1] = u >> 16 & 255, a[d + 2] = u >> 8 & 255, a[d + 3] = u & 255, a[d + 4] = i >> 24 & 255, a[d + 5] = i >> 16 & 255, a[d + 6] = i >> 8 & 255, a[d + 7] = i & 255;
    }
    function w(a, d, u, i, c) {
      var v, x = 0;
      for (v = 0; v < c; v++)
        x |= a[d + v] ^ u[i + v];
      return (1 & x - 1 >>> 8) - 1;
    }
    function S(a, d, u, i) {
      return w(a, d, u, i, 16);
    }
    function N(a, d, u, i) {
      return w(a, d, u, i, 32);
    }
    function P(a, d, u, i) {
      for (var c = i[0] & 255 | (i[1] & 255) << 8 | (i[2] & 255) << 16 | (i[3] & 255) << 24, v = u[0] & 255 | (u[1] & 255) << 8 | (u[2] & 255) << 16 | (u[3] & 255) << 24, x = u[4] & 255 | (u[5] & 255) << 8 | (u[6] & 255) << 16 | (u[7] & 255) << 24, I = u[8] & 255 | (u[9] & 255) << 8 | (u[10] & 255) << 16 | (u[11] & 255) << 24, U = u[12] & 255 | (u[13] & 255) << 8 | (u[14] & 255) << 16 | (u[15] & 255) << 24, Q = i[4] & 255 | (i[5] & 255) << 8 | (i[6] & 255) << 16 | (i[7] & 255) << 24, W = d[0] & 255 | (d[1] & 255) << 8 | (d[2] & 255) << 16 | (d[3] & 255) << 24, fe = d[4] & 255 | (d[5] & 255) << 8 | (d[6] & 255) << 16 | (d[7] & 255) << 24, V = d[8] & 255 | (d[9] & 255) << 8 | (d[10] & 255) << 16 | (d[11] & 255) << 24, ne = d[12] & 255 | (d[13] & 255) << 8 | (d[14] & 255) << 16 | (d[15] & 255) << 24, oe = i[8] & 255 | (i[9] & 255) << 8 | (i[10] & 255) << 16 | (i[11] & 255) << 24, le = u[16] & 255 | (u[17] & 255) << 8 | (u[18] & 255) << 16 | (u[19] & 255) << 24, pe = u[20] & 255 | (u[21] & 255) << 8 | (u[22] & 255) << 16 | (u[23] & 255) << 24, he = u[24] & 255 | (u[25] & 255) << 8 | (u[26] & 255) << 16 | (u[27] & 255) << 24, ue = u[28] & 255 | (u[29] & 255) << 8 | (u[30] & 255) << 16 | (u[31] & 255) << 24, ve = i[12] & 255 | (i[13] & 255) << 8 | (i[14] & 255) << 16 | (i[15] & 255) << 24, ee = c, ie = v, J = x, te = I, re = U, Z = Q, T = W, M = fe, k = V, j = ne, D = oe, z = le, ce = pe, xe = he, me = ue, we = ve, y, Te = 0; Te < 20; Te += 2)
        y = ee + ce | 0, re ^= y << 7 | y >>> 32 - 7, y = re + ee | 0, k ^= y << 9 | y >>> 32 - 9, y = k + re | 0, ce ^= y << 13 | y >>> 32 - 13, y = ce + k | 0, ee ^= y << 18 | y >>> 32 - 18, y = Z + ie | 0, j ^= y << 7 | y >>> 32 - 7, y = j + Z | 0, xe ^= y << 9 | y >>> 32 - 9, y = xe + j | 0, ie ^= y << 13 | y >>> 32 - 13, y = ie + xe | 0, Z ^= y << 18 | y >>> 32 - 18, y = D + T | 0, me ^= y << 7 | y >>> 32 - 7, y = me + D | 0, J ^= y << 9 | y >>> 32 - 9, y = J + me | 0, T ^= y << 13 | y >>> 32 - 13, y = T + J | 0, D ^= y << 18 | y >>> 32 - 18, y = we + z | 0, te ^= y << 7 | y >>> 32 - 7, y = te + we | 0, M ^= y << 9 | y >>> 32 - 9, y = M + te | 0, z ^= y << 13 | y >>> 32 - 13, y = z + M | 0, we ^= y << 18 | y >>> 32 - 18, y = ee + te | 0, ie ^= y << 7 | y >>> 32 - 7, y = ie + ee | 0, J ^= y << 9 | y >>> 32 - 9, y = J + ie | 0, te ^= y << 13 | y >>> 32 - 13, y = te + J | 0, ee ^= y << 18 | y >>> 32 - 18, y = Z + re | 0, T ^= y << 7 | y >>> 32 - 7, y = T + Z | 0, M ^= y << 9 | y >>> 32 - 9, y = M + T | 0, re ^= y << 13 | y >>> 32 - 13, y = re + M | 0, Z ^= y << 18 | y >>> 32 - 18, y = D + j | 0, z ^= y << 7 | y >>> 32 - 7, y = z + D | 0, k ^= y << 9 | y >>> 32 - 9, y = k + z | 0, j ^= y << 13 | y >>> 32 - 13, y = j + k | 0, D ^= y << 18 | y >>> 32 - 18, y = we + me | 0, ce ^= y << 7 | y >>> 32 - 7, y = ce + we | 0, xe ^= y << 9 | y >>> 32 - 9, y = xe + ce | 0, me ^= y << 13 | y >>> 32 - 13, y = me + xe | 0, we ^= y << 18 | y >>> 32 - 18;
      ee = ee + c | 0, ie = ie + v | 0, J = J + x | 0, te = te + I | 0, re = re + U | 0, Z = Z + Q | 0, T = T + W | 0, M = M + fe | 0, k = k + V | 0, j = j + ne | 0, D = D + oe | 0, z = z + le | 0, ce = ce + pe | 0, xe = xe + he | 0, me = me + ue | 0, we = we + ve | 0, a[0] = ee >>> 0 & 255, a[1] = ee >>> 8 & 255, a[2] = ee >>> 16 & 255, a[3] = ee >>> 24 & 255, a[4] = ie >>> 0 & 255, a[5] = ie >>> 8 & 255, a[6] = ie >>> 16 & 255, a[7] = ie >>> 24 & 255, a[8] = J >>> 0 & 255, a[9] = J >>> 8 & 255, a[10] = J >>> 16 & 255, a[11] = J >>> 24 & 255, a[12] = te >>> 0 & 255, a[13] = te >>> 8 & 255, a[14] = te >>> 16 & 255, a[15] = te >>> 24 & 255, a[16] = re >>> 0 & 255, a[17] = re >>> 8 & 255, a[18] = re >>> 16 & 255, a[19] = re >>> 24 & 255, a[20] = Z >>> 0 & 255, a[21] = Z >>> 8 & 255, a[22] = Z >>> 16 & 255, a[23] = Z >>> 24 & 255, a[24] = T >>> 0 & 255, a[25] = T >>> 8 & 255, a[26] = T >>> 16 & 255, a[27] = T >>> 24 & 255, a[28] = M >>> 0 & 255, a[29] = M >>> 8 & 255, a[30] = M >>> 16 & 255, a[31] = M >>> 24 & 255, a[32] = k >>> 0 & 255, a[33] = k >>> 8 & 255, a[34] = k >>> 16 & 255, a[35] = k >>> 24 & 255, a[36] = j >>> 0 & 255, a[37] = j >>> 8 & 255, a[38] = j >>> 16 & 255, a[39] = j >>> 24 & 255, a[40] = D >>> 0 & 255, a[41] = D >>> 8 & 255, a[42] = D >>> 16 & 255, a[43] = D >>> 24 & 255, a[44] = z >>> 0 & 255, a[45] = z >>> 8 & 255, a[46] = z >>> 16 & 255, a[47] = z >>> 24 & 255, a[48] = ce >>> 0 & 255, a[49] = ce >>> 8 & 255, a[50] = ce >>> 16 & 255, a[51] = ce >>> 24 & 255, a[52] = xe >>> 0 & 255, a[53] = xe >>> 8 & 255, a[54] = xe >>> 16 & 255, a[55] = xe >>> 24 & 255, a[56] = me >>> 0 & 255, a[57] = me >>> 8 & 255, a[58] = me >>> 16 & 255, a[59] = me >>> 24 & 255, a[60] = we >>> 0 & 255, a[61] = we >>> 8 & 255, a[62] = we >>> 16 & 255, a[63] = we >>> 24 & 255;
    }
    function C(a, d, u, i) {
      for (var c = i[0] & 255 | (i[1] & 255) << 8 | (i[2] & 255) << 16 | (i[3] & 255) << 24, v = u[0] & 255 | (u[1] & 255) << 8 | (u[2] & 255) << 16 | (u[3] & 255) << 24, x = u[4] & 255 | (u[5] & 255) << 8 | (u[6] & 255) << 16 | (u[7] & 255) << 24, I = u[8] & 255 | (u[9] & 255) << 8 | (u[10] & 255) << 16 | (u[11] & 255) << 24, U = u[12] & 255 | (u[13] & 255) << 8 | (u[14] & 255) << 16 | (u[15] & 255) << 24, Q = i[4] & 255 | (i[5] & 255) << 8 | (i[6] & 255) << 16 | (i[7] & 255) << 24, W = d[0] & 255 | (d[1] & 255) << 8 | (d[2] & 255) << 16 | (d[3] & 255) << 24, fe = d[4] & 255 | (d[5] & 255) << 8 | (d[6] & 255) << 16 | (d[7] & 255) << 24, V = d[8] & 255 | (d[9] & 255) << 8 | (d[10] & 255) << 16 | (d[11] & 255) << 24, ne = d[12] & 255 | (d[13] & 255) << 8 | (d[14] & 255) << 16 | (d[15] & 255) << 24, oe = i[8] & 255 | (i[9] & 255) << 8 | (i[10] & 255) << 16 | (i[11] & 255) << 24, le = u[16] & 255 | (u[17] & 255) << 8 | (u[18] & 255) << 16 | (u[19] & 255) << 24, pe = u[20] & 255 | (u[21] & 255) << 8 | (u[22] & 255) << 16 | (u[23] & 255) << 24, he = u[24] & 255 | (u[25] & 255) << 8 | (u[26] & 255) << 16 | (u[27] & 255) << 24, ue = u[28] & 255 | (u[29] & 255) << 8 | (u[30] & 255) << 16 | (u[31] & 255) << 24, ve = i[12] & 255 | (i[13] & 255) << 8 | (i[14] & 255) << 16 | (i[15] & 255) << 24, ee = c, ie = v, J = x, te = I, re = U, Z = Q, T = W, M = fe, k = V, j = ne, D = oe, z = le, ce = pe, xe = he, me = ue, we = ve, y, Te = 0; Te < 20; Te += 2)
        y = ee + ce | 0, re ^= y << 7 | y >>> 32 - 7, y = re + ee | 0, k ^= y << 9 | y >>> 32 - 9, y = k + re | 0, ce ^= y << 13 | y >>> 32 - 13, y = ce + k | 0, ee ^= y << 18 | y >>> 32 - 18, y = Z + ie | 0, j ^= y << 7 | y >>> 32 - 7, y = j + Z | 0, xe ^= y << 9 | y >>> 32 - 9, y = xe + j | 0, ie ^= y << 13 | y >>> 32 - 13, y = ie + xe | 0, Z ^= y << 18 | y >>> 32 - 18, y = D + T | 0, me ^= y << 7 | y >>> 32 - 7, y = me + D | 0, J ^= y << 9 | y >>> 32 - 9, y = J + me | 0, T ^= y << 13 | y >>> 32 - 13, y = T + J | 0, D ^= y << 18 | y >>> 32 - 18, y = we + z | 0, te ^= y << 7 | y >>> 32 - 7, y = te + we | 0, M ^= y << 9 | y >>> 32 - 9, y = M + te | 0, z ^= y << 13 | y >>> 32 - 13, y = z + M | 0, we ^= y << 18 | y >>> 32 - 18, y = ee + te | 0, ie ^= y << 7 | y >>> 32 - 7, y = ie + ee | 0, J ^= y << 9 | y >>> 32 - 9, y = J + ie | 0, te ^= y << 13 | y >>> 32 - 13, y = te + J | 0, ee ^= y << 18 | y >>> 32 - 18, y = Z + re | 0, T ^= y << 7 | y >>> 32 - 7, y = T + Z | 0, M ^= y << 9 | y >>> 32 - 9, y = M + T | 0, re ^= y << 13 | y >>> 32 - 13, y = re + M | 0, Z ^= y << 18 | y >>> 32 - 18, y = D + j | 0, z ^= y << 7 | y >>> 32 - 7, y = z + D | 0, k ^= y << 9 | y >>> 32 - 9, y = k + z | 0, j ^= y << 13 | y >>> 32 - 13, y = j + k | 0, D ^= y << 18 | y >>> 32 - 18, y = we + me | 0, ce ^= y << 7 | y >>> 32 - 7, y = ce + we | 0, xe ^= y << 9 | y >>> 32 - 9, y = xe + ce | 0, me ^= y << 13 | y >>> 32 - 13, y = me + xe | 0, we ^= y << 18 | y >>> 32 - 18;
      a[0] = ee >>> 0 & 255, a[1] = ee >>> 8 & 255, a[2] = ee >>> 16 & 255, a[3] = ee >>> 24 & 255, a[4] = Z >>> 0 & 255, a[5] = Z >>> 8 & 255, a[6] = Z >>> 16 & 255, a[7] = Z >>> 24 & 255, a[8] = D >>> 0 & 255, a[9] = D >>> 8 & 255, a[10] = D >>> 16 & 255, a[11] = D >>> 24 & 255, a[12] = we >>> 0 & 255, a[13] = we >>> 8 & 255, a[14] = we >>> 16 & 255, a[15] = we >>> 24 & 255, a[16] = T >>> 0 & 255, a[17] = T >>> 8 & 255, a[18] = T >>> 16 & 255, a[19] = T >>> 24 & 255, a[20] = M >>> 0 & 255, a[21] = M >>> 8 & 255, a[22] = M >>> 16 & 255, a[23] = M >>> 24 & 255, a[24] = k >>> 0 & 255, a[25] = k >>> 8 & 255, a[26] = k >>> 16 & 255, a[27] = k >>> 24 & 255, a[28] = j >>> 0 & 255, a[29] = j >>> 8 & 255, a[30] = j >>> 16 & 255, a[31] = j >>> 24 & 255;
    }
    function B(a, d, u, i) {
      P(a, d, u, i);
    }
    function R(a, d, u, i) {
      C(a, d, u, i);
    }
    var F = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);
    function Y(a, d, u, i, c, v, x) {
      var I = new Uint8Array(16), U = new Uint8Array(64), Q, W;
      for (W = 0; W < 16; W++)
        I[W] = 0;
      for (W = 0; W < 8; W++)
        I[W] = v[W];
      for (; c >= 64; ) {
        for (B(U, I, x, F), W = 0; W < 64; W++)
          a[d + W] = u[i + W] ^ U[W];
        for (Q = 1, W = 8; W < 16; W++)
          Q = Q + (I[W] & 255) | 0, I[W] = Q & 255, Q >>>= 8;
        c -= 64, d += 64, i += 64;
      }
      if (c > 0)
        for (B(U, I, x, F), W = 0; W < c; W++)
          a[d + W] = u[i + W] ^ U[W];
      return 0;
    }
    function K(a, d, u, i, c) {
      var v = new Uint8Array(16), x = new Uint8Array(64), I, U;
      for (U = 0; U < 16; U++)
        v[U] = 0;
      for (U = 0; U < 8; U++)
        v[U] = i[U];
      for (; u >= 64; ) {
        for (B(x, v, c, F), U = 0; U < 64; U++)
          a[d + U] = x[U];
        for (I = 1, U = 8; U < 16; U++)
          I = I + (v[U] & 255) | 0, v[U] = I & 255, I >>>= 8;
        u -= 64, d += 64;
      }
      if (u > 0)
        for (B(x, v, c, F), U = 0; U < u; U++)
          a[d + U] = x[U];
      return 0;
    }
    function Me(a, d, u, i, c) {
      var v = new Uint8Array(32);
      R(v, i, c, F);
      for (var x = new Uint8Array(8), I = 0; I < 8; I++)
        x[I] = i[I + 16];
      return K(a, d, u, x, v);
    }
    function ye(a, d, u, i, c, v, x) {
      var I = new Uint8Array(32);
      R(I, v, x, F);
      for (var U = new Uint8Array(8), Q = 0; Q < 8; Q++)
        U[Q] = v[Q + 16];
      return Y(a, d, u, i, c, U, I);
    }
    var $ = function(a) {
      this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.leftover = 0, this.fin = 0;
      var d, u, i, c, v, x, I, U;
      d = a[0] & 255 | (a[1] & 255) << 8, this.r[0] = d & 8191, u = a[2] & 255 | (a[3] & 255) << 8, this.r[1] = (d >>> 13 | u << 3) & 8191, i = a[4] & 255 | (a[5] & 255) << 8, this.r[2] = (u >>> 10 | i << 6) & 7939, c = a[6] & 255 | (a[7] & 255) << 8, this.r[3] = (i >>> 7 | c << 9) & 8191, v = a[8] & 255 | (a[9] & 255) << 8, this.r[4] = (c >>> 4 | v << 12) & 255, this.r[5] = v >>> 1 & 8190, x = a[10] & 255 | (a[11] & 255) << 8, this.r[6] = (v >>> 14 | x << 2) & 8191, I = a[12] & 255 | (a[13] & 255) << 8, this.r[7] = (x >>> 11 | I << 5) & 8065, U = a[14] & 255 | (a[15] & 255) << 8, this.r[8] = (I >>> 8 | U << 8) & 8191, this.r[9] = U >>> 5 & 127, this.pad[0] = a[16] & 255 | (a[17] & 255) << 8, this.pad[1] = a[18] & 255 | (a[19] & 255) << 8, this.pad[2] = a[20] & 255 | (a[21] & 255) << 8, this.pad[3] = a[22] & 255 | (a[23] & 255) << 8, this.pad[4] = a[24] & 255 | (a[25] & 255) << 8, this.pad[5] = a[26] & 255 | (a[27] & 255) << 8, this.pad[6] = a[28] & 255 | (a[29] & 255) << 8, this.pad[7] = a[30] & 255 | (a[31] & 255) << 8;
    };
    $.prototype.blocks = function(a, d, u) {
      for (var i = this.fin ? 0 : 2048, c, v, x, I, U, Q, W, fe, V, ne, oe, le, pe, he, ue, ve, ee, ie, J, te = this.h[0], re = this.h[1], Z = this.h[2], T = this.h[3], M = this.h[4], k = this.h[5], j = this.h[6], D = this.h[7], z = this.h[8], ce = this.h[9], xe = this.r[0], me = this.r[1], we = this.r[2], y = this.r[3], Te = this.r[4], De = this.r[5], Le = this.r[6], Ae = this.r[7], Oe = this.r[8], Ne = this.r[9]; u >= 16; )
        c = a[d + 0] & 255 | (a[d + 1] & 255) << 8, te += c & 8191, v = a[d + 2] & 255 | (a[d + 3] & 255) << 8, re += (c >>> 13 | v << 3) & 8191, x = a[d + 4] & 255 | (a[d + 5] & 255) << 8, Z += (v >>> 10 | x << 6) & 8191, I = a[d + 6] & 255 | (a[d + 7] & 255) << 8, T += (x >>> 7 | I << 9) & 8191, U = a[d + 8] & 255 | (a[d + 9] & 255) << 8, M += (I >>> 4 | U << 12) & 8191, k += U >>> 1 & 8191, Q = a[d + 10] & 255 | (a[d + 11] & 255) << 8, j += (U >>> 14 | Q << 2) & 8191, W = a[d + 12] & 255 | (a[d + 13] & 255) << 8, D += (Q >>> 11 | W << 5) & 8191, fe = a[d + 14] & 255 | (a[d + 15] & 255) << 8, z += (W >>> 8 | fe << 8) & 8191, ce += fe >>> 5 | i, V = 0, ne = V, ne += te * xe, ne += re * (5 * Ne), ne += Z * (5 * Oe), ne += T * (5 * Ae), ne += M * (5 * Le), V = ne >>> 13, ne &= 8191, ne += k * (5 * De), ne += j * (5 * Te), ne += D * (5 * y), ne += z * (5 * we), ne += ce * (5 * me), V += ne >>> 13, ne &= 8191, oe = V, oe += te * me, oe += re * xe, oe += Z * (5 * Ne), oe += T * (5 * Oe), oe += M * (5 * Ae), V = oe >>> 13, oe &= 8191, oe += k * (5 * Le), oe += j * (5 * De), oe += D * (5 * Te), oe += z * (5 * y), oe += ce * (5 * we), V += oe >>> 13, oe &= 8191, le = V, le += te * we, le += re * me, le += Z * xe, le += T * (5 * Ne), le += M * (5 * Oe), V = le >>> 13, le &= 8191, le += k * (5 * Ae), le += j * (5 * Le), le += D * (5 * De), le += z * (5 * Te), le += ce * (5 * y), V += le >>> 13, le &= 8191, pe = V, pe += te * y, pe += re * we, pe += Z * me, pe += T * xe, pe += M * (5 * Ne), V = pe >>> 13, pe &= 8191, pe += k * (5 * Oe), pe += j * (5 * Ae), pe += D * (5 * Le), pe += z * (5 * De), pe += ce * (5 * Te), V += pe >>> 13, pe &= 8191, he = V, he += te * Te, he += re * y, he += Z * we, he += T * me, he += M * xe, V = he >>> 13, he &= 8191, he += k * (5 * Ne), he += j * (5 * Oe), he += D * (5 * Ae), he += z * (5 * Le), he += ce * (5 * De), V += he >>> 13, he &= 8191, ue = V, ue += te * De, ue += re * Te, ue += Z * y, ue += T * we, ue += M * me, V = ue >>> 13, ue &= 8191, ue += k * xe, ue += j * (5 * Ne), ue += D * (5 * Oe), ue += z * (5 * Ae), ue += ce * (5 * Le), V += ue >>> 13, ue &= 8191, ve = V, ve += te * Le, ve += re * De, ve += Z * Te, ve += T * y, ve += M * we, V = ve >>> 13, ve &= 8191, ve += k * me, ve += j * xe, ve += D * (5 * Ne), ve += z * (5 * Oe), ve += ce * (5 * Ae), V += ve >>> 13, ve &= 8191, ee = V, ee += te * Ae, ee += re * Le, ee += Z * De, ee += T * Te, ee += M * y, V = ee >>> 13, ee &= 8191, ee += k * we, ee += j * me, ee += D * xe, ee += z * (5 * Ne), ee += ce * (5 * Oe), V += ee >>> 13, ee &= 8191, ie = V, ie += te * Oe, ie += re * Ae, ie += Z * Le, ie += T * De, ie += M * Te, V = ie >>> 13, ie &= 8191, ie += k * y, ie += j * we, ie += D * me, ie += z * xe, ie += ce * (5 * Ne), V += ie >>> 13, ie &= 8191, J = V, J += te * Ne, J += re * Oe, J += Z * Ae, J += T * Le, J += M * De, V = J >>> 13, J &= 8191, J += k * Te, J += j * y, J += D * we, J += z * me, J += ce * xe, V += J >>> 13, J &= 8191, V = (V << 2) + V | 0, V = V + ne | 0, ne = V & 8191, V = V >>> 13, oe += V, te = ne, re = oe, Z = le, T = pe, M = he, k = ue, j = ve, D = ee, z = ie, ce = J, d += 16, u -= 16;
      this.h[0] = te, this.h[1] = re, this.h[2] = Z, this.h[3] = T, this.h[4] = M, this.h[5] = k, this.h[6] = j, this.h[7] = D, this.h[8] = z, this.h[9] = ce;
    }, $.prototype.finish = function(a, d) {
      var u = new Uint16Array(10), i, c, v, x;
      if (this.leftover) {
        for (x = this.leftover, this.buffer[x++] = 1; x < 16; x++)
          this.buffer[x] = 0;
        this.fin = 1, this.blocks(this.buffer, 0, 16);
      }
      for (i = this.h[1] >>> 13, this.h[1] &= 8191, x = 2; x < 10; x++)
        this.h[x] += i, i = this.h[x] >>> 13, this.h[x] &= 8191;
      for (this.h[0] += i * 5, i = this.h[0] >>> 13, this.h[0] &= 8191, this.h[1] += i, i = this.h[1] >>> 13, this.h[1] &= 8191, this.h[2] += i, u[0] = this.h[0] + 5, i = u[0] >>> 13, u[0] &= 8191, x = 1; x < 10; x++)
        u[x] = this.h[x] + i, i = u[x] >>> 13, u[x] &= 8191;
      for (u[9] -= 1 << 13, c = (i ^ 1) - 1, x = 0; x < 10; x++)
        u[x] &= c;
      for (c = ~c, x = 0; x < 10; x++)
        this.h[x] = this.h[x] & c | u[x];
      for (this.h[0] = (this.h[0] | this.h[1] << 13) & 65535, this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 65535, this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 65535, this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 65535, this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 65535, this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 65535, this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 65535, this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 65535, v = this.h[0] + this.pad[0], this.h[0] = v & 65535, x = 1; x < 8; x++)
        v = (this.h[x] + this.pad[x] | 0) + (v >>> 16) | 0, this.h[x] = v & 65535;
      a[d + 0] = this.h[0] >>> 0 & 255, a[d + 1] = this.h[0] >>> 8 & 255, a[d + 2] = this.h[1] >>> 0 & 255, a[d + 3] = this.h[1] >>> 8 & 255, a[d + 4] = this.h[2] >>> 0 & 255, a[d + 5] = this.h[2] >>> 8 & 255, a[d + 6] = this.h[3] >>> 0 & 255, a[d + 7] = this.h[3] >>> 8 & 255, a[d + 8] = this.h[4] >>> 0 & 255, a[d + 9] = this.h[4] >>> 8 & 255, a[d + 10] = this.h[5] >>> 0 & 255, a[d + 11] = this.h[5] >>> 8 & 255, a[d + 12] = this.h[6] >>> 0 & 255, a[d + 13] = this.h[6] >>> 8 & 255, a[d + 14] = this.h[7] >>> 0 & 255, a[d + 15] = this.h[7] >>> 8 & 255;
    }, $.prototype.update = function(a, d, u) {
      var i, c;
      if (this.leftover) {
        for (c = 16 - this.leftover, c > u && (c = u), i = 0; i < c; i++)
          this.buffer[this.leftover + i] = a[d + i];
        if (u -= c, d += c, this.leftover += c, this.leftover < 16)
          return;
        this.blocks(this.buffer, 0, 16), this.leftover = 0;
      }
      if (u >= 16 && (c = u - u % 16, this.blocks(a, d, c), d += c, u -= c), u) {
        for (i = 0; i < u; i++)
          this.buffer[this.leftover + i] = a[d + i];
        this.leftover += u;
      }
    };
    function G(a, d, u, i, c, v) {
      var x = new $(v);
      return x.update(u, i, c), x.finish(a, d), 0;
    }
    function X(a, d, u, i, c, v) {
      var x = new Uint8Array(16);
      return G(x, 0, u, i, c, v), S(a, d, x, 0);
    }
    function ge(a, d, u, i, c) {
      var v;
      if (u < 32)
        return -1;
      for (ye(a, 0, d, 0, u, i, c), G(a, 16, a, 32, u - 32, a), v = 0; v < 16; v++)
        a[v] = 0;
      return 0;
    }
    function L(a, d, u, i, c) {
      var v, x = new Uint8Array(32);
      if (u < 32 || (Me(x, 0, 32, i, c), X(d, 16, d, 32, u - 32, x) !== 0))
        return -1;
      for (ye(a, 0, d, 0, u, i, c), v = 0; v < 32; v++)
        a[v] = 0;
      return 0;
    }
    function _(a, d) {
      var u;
      for (u = 0; u < 16; u++)
        a[u] = d[u] | 0;
    }
    function q(a) {
      var d, u, i = 1;
      for (d = 0; d < 16; d++)
        u = a[d] + i + 65535, i = Math.floor(u / 65536), a[d] = u - i * 65536;
      a[0] += i - 1 + 37 * (i - 1);
    }
    function se(a, d, u) {
      for (var i, c = ~(u - 1), v = 0; v < 16; v++)
        i = c & (a[v] ^ d[v]), a[v] ^= i, d[v] ^= i;
    }
    function ae(a, d) {
      var u, i, c, v = r(), x = r();
      for (u = 0; u < 16; u++)
        x[u] = d[u];
      for (q(x), q(x), q(x), i = 0; i < 2; i++) {
        for (v[0] = x[0] - 65517, u = 1; u < 15; u++)
          v[u] = x[u] - 65535 - (v[u - 1] >> 16 & 1), v[u - 1] &= 65535;
        v[15] = x[15] - 32767 - (v[14] >> 16 & 1), c = v[15] >> 16 & 1, v[14] &= 65535, se(x, v, 1 - c);
      }
      for (u = 0; u < 16; u++)
        a[2 * u] = x[u] & 255, a[2 * u + 1] = x[u] >> 8;
    }
    function Ee(a, d) {
      var u = new Uint8Array(32), i = new Uint8Array(32);
      return ae(u, a), ae(i, d), N(u, 0, i, 0);
    }
    function Se(a) {
      var d = new Uint8Array(32);
      return ae(d, a), d[0] & 1;
    }
    function Be(a, d) {
      var u;
      for (u = 0; u < 16; u++)
        a[u] = d[2 * u] + (d[2 * u + 1] << 8);
      a[15] &= 32767;
    }
    function Re(a, d, u) {
      for (var i = 0; i < 16; i++)
        a[i] = d[i] + u[i];
    }
    function Fe(a, d, u) {
      for (var i = 0; i < 16; i++)
        a[i] = d[i] - u[i];
    }
    function be(a, d, u) {
      var i, c, v = 0, x = 0, I = 0, U = 0, Q = 0, W = 0, fe = 0, V = 0, ne = 0, oe = 0, le = 0, pe = 0, he = 0, ue = 0, ve = 0, ee = 0, ie = 0, J = 0, te = 0, re = 0, Z = 0, T = 0, M = 0, k = 0, j = 0, D = 0, z = 0, ce = 0, xe = 0, me = 0, we = 0, y = u[0], Te = u[1], De = u[2], Le = u[3], Ae = u[4], Oe = u[5], Ne = u[6], Ge = u[7], Pe = u[8], We = u[9], qe = u[10], Ye = u[11], He = u[12], Ke = u[13], Xe = u[14], Je = u[15];
      i = d[0], v += i * y, x += i * Te, I += i * De, U += i * Le, Q += i * Ae, W += i * Oe, fe += i * Ne, V += i * Ge, ne += i * Pe, oe += i * We, le += i * qe, pe += i * Ye, he += i * He, ue += i * Ke, ve += i * Xe, ee += i * Je, i = d[1], x += i * y, I += i * Te, U += i * De, Q += i * Le, W += i * Ae, fe += i * Oe, V += i * Ne, ne += i * Ge, oe += i * Pe, le += i * We, pe += i * qe, he += i * Ye, ue += i * He, ve += i * Ke, ee += i * Xe, ie += i * Je, i = d[2], I += i * y, U += i * Te, Q += i * De, W += i * Le, fe += i * Ae, V += i * Oe, ne += i * Ne, oe += i * Ge, le += i * Pe, pe += i * We, he += i * qe, ue += i * Ye, ve += i * He, ee += i * Ke, ie += i * Xe, J += i * Je, i = d[3], U += i * y, Q += i * Te, W += i * De, fe += i * Le, V += i * Ae, ne += i * Oe, oe += i * Ne, le += i * Ge, pe += i * Pe, he += i * We, ue += i * qe, ve += i * Ye, ee += i * He, ie += i * Ke, J += i * Xe, te += i * Je, i = d[4], Q += i * y, W += i * Te, fe += i * De, V += i * Le, ne += i * Ae, oe += i * Oe, le += i * Ne, pe += i * Ge, he += i * Pe, ue += i * We, ve += i * qe, ee += i * Ye, ie += i * He, J += i * Ke, te += i * Xe, re += i * Je, i = d[5], W += i * y, fe += i * Te, V += i * De, ne += i * Le, oe += i * Ae, le += i * Oe, pe += i * Ne, he += i * Ge, ue += i * Pe, ve += i * We, ee += i * qe, ie += i * Ye, J += i * He, te += i * Ke, re += i * Xe, Z += i * Je, i = d[6], fe += i * y, V += i * Te, ne += i * De, oe += i * Le, le += i * Ae, pe += i * Oe, he += i * Ne, ue += i * Ge, ve += i * Pe, ee += i * We, ie += i * qe, J += i * Ye, te += i * He, re += i * Ke, Z += i * Xe, T += i * Je, i = d[7], V += i * y, ne += i * Te, oe += i * De, le += i * Le, pe += i * Ae, he += i * Oe, ue += i * Ne, ve += i * Ge, ee += i * Pe, ie += i * We, J += i * qe, te += i * Ye, re += i * He, Z += i * Ke, T += i * Xe, M += i * Je, i = d[8], ne += i * y, oe += i * Te, le += i * De, pe += i * Le, he += i * Ae, ue += i * Oe, ve += i * Ne, ee += i * Ge, ie += i * Pe, J += i * We, te += i * qe, re += i * Ye, Z += i * He, T += i * Ke, M += i * Xe, k += i * Je, i = d[9], oe += i * y, le += i * Te, pe += i * De, he += i * Le, ue += i * Ae, ve += i * Oe, ee += i * Ne, ie += i * Ge, J += i * Pe, te += i * We, re += i * qe, Z += i * Ye, T += i * He, M += i * Ke, k += i * Xe, j += i * Je, i = d[10], le += i * y, pe += i * Te, he += i * De, ue += i * Le, ve += i * Ae, ee += i * Oe, ie += i * Ne, J += i * Ge, te += i * Pe, re += i * We, Z += i * qe, T += i * Ye, M += i * He, k += i * Ke, j += i * Xe, D += i * Je, i = d[11], pe += i * y, he += i * Te, ue += i * De, ve += i * Le, ee += i * Ae, ie += i * Oe, J += i * Ne, te += i * Ge, re += i * Pe, Z += i * We, T += i * qe, M += i * Ye, k += i * He, j += i * Ke, D += i * Xe, z += i * Je, i = d[12], he += i * y, ue += i * Te, ve += i * De, ee += i * Le, ie += i * Ae, J += i * Oe, te += i * Ne, re += i * Ge, Z += i * Pe, T += i * We, M += i * qe, k += i * Ye, j += i * He, D += i * Ke, z += i * Xe, ce += i * Je, i = d[13], ue += i * y, ve += i * Te, ee += i * De, ie += i * Le, J += i * Ae, te += i * Oe, re += i * Ne, Z += i * Ge, T += i * Pe, M += i * We, k += i * qe, j += i * Ye, D += i * He, z += i * Ke, ce += i * Xe, xe += i * Je, i = d[14], ve += i * y, ee += i * Te, ie += i * De, J += i * Le, te += i * Ae, re += i * Oe, Z += i * Ne, T += i * Ge, M += i * Pe, k += i * We, j += i * qe, D += i * Ye, z += i * He, ce += i * Ke, xe += i * Xe, me += i * Je, i = d[15], ee += i * y, ie += i * Te, J += i * De, te += i * Le, re += i * Ae, Z += i * Oe, T += i * Ne, M += i * Ge, k += i * Pe, j += i * We, D += i * qe, z += i * Ye, ce += i * He, xe += i * Ke, me += i * Xe, we += i * Je, v += 38 * ie, x += 38 * J, I += 38 * te, U += 38 * re, Q += 38 * Z, W += 38 * T, fe += 38 * M, V += 38 * k, ne += 38 * j, oe += 38 * D, le += 38 * z, pe += 38 * ce, he += 38 * xe, ue += 38 * me, ve += 38 * we, c = 1, i = v + c + 65535, c = Math.floor(i / 65536), v = i - c * 65536, i = x + c + 65535, c = Math.floor(i / 65536), x = i - c * 65536, i = I + c + 65535, c = Math.floor(i / 65536), I = i - c * 65536, i = U + c + 65535, c = Math.floor(i / 65536), U = i - c * 65536, i = Q + c + 65535, c = Math.floor(i / 65536), Q = i - c * 65536, i = W + c + 65535, c = Math.floor(i / 65536), W = i - c * 65536, i = fe + c + 65535, c = Math.floor(i / 65536), fe = i - c * 65536, i = V + c + 65535, c = Math.floor(i / 65536), V = i - c * 65536, i = ne + c + 65535, c = Math.floor(i / 65536), ne = i - c * 65536, i = oe + c + 65535, c = Math.floor(i / 65536), oe = i - c * 65536, i = le + c + 65535, c = Math.floor(i / 65536), le = i - c * 65536, i = pe + c + 65535, c = Math.floor(i / 65536), pe = i - c * 65536, i = he + c + 65535, c = Math.floor(i / 65536), he = i - c * 65536, i = ue + c + 65535, c = Math.floor(i / 65536), ue = i - c * 65536, i = ve + c + 65535, c = Math.floor(i / 65536), ve = i - c * 65536, i = ee + c + 65535, c = Math.floor(i / 65536), ee = i - c * 65536, v += c - 1 + 37 * (c - 1), c = 1, i = v + c + 65535, c = Math.floor(i / 65536), v = i - c * 65536, i = x + c + 65535, c = Math.floor(i / 65536), x = i - c * 65536, i = I + c + 65535, c = Math.floor(i / 65536), I = i - c * 65536, i = U + c + 65535, c = Math.floor(i / 65536), U = i - c * 65536, i = Q + c + 65535, c = Math.floor(i / 65536), Q = i - c * 65536, i = W + c + 65535, c = Math.floor(i / 65536), W = i - c * 65536, i = fe + c + 65535, c = Math.floor(i / 65536), fe = i - c * 65536, i = V + c + 65535, c = Math.floor(i / 65536), V = i - c * 65536, i = ne + c + 65535, c = Math.floor(i / 65536), ne = i - c * 65536, i = oe + c + 65535, c = Math.floor(i / 65536), oe = i - c * 65536, i = le + c + 65535, c = Math.floor(i / 65536), le = i - c * 65536, i = pe + c + 65535, c = Math.floor(i / 65536), pe = i - c * 65536, i = he + c + 65535, c = Math.floor(i / 65536), he = i - c * 65536, i = ue + c + 65535, c = Math.floor(i / 65536), ue = i - c * 65536, i = ve + c + 65535, c = Math.floor(i / 65536), ve = i - c * 65536, i = ee + c + 65535, c = Math.floor(i / 65536), ee = i - c * 65536, v += c - 1 + 37 * (c - 1), a[0] = v, a[1] = x, a[2] = I, a[3] = U, a[4] = Q, a[5] = W, a[6] = fe, a[7] = V, a[8] = ne, a[9] = oe, a[10] = le, a[11] = pe, a[12] = he, a[13] = ue, a[14] = ve, a[15] = ee;
    }
    function $e(a, d) {
      be(a, d, d);
    }
    function lt(a, d) {
      var u = r(), i;
      for (i = 0; i < 16; i++)
        u[i] = d[i];
      for (i = 253; i >= 0; i--)
        $e(u, u), i !== 2 && i !== 4 && be(u, u, d);
      for (i = 0; i < 16; i++)
        a[i] = u[i];
    }
    function St(a, d) {
      var u = r(), i;
      for (i = 0; i < 16; i++)
        u[i] = d[i];
      for (i = 250; i >= 0; i--)
        $e(u, u), i !== 1 && be(u, u, d);
      for (i = 0; i < 16; i++)
        a[i] = u[i];
    }
    function dt(a, d, u) {
      var i = new Uint8Array(32), c = new Float64Array(80), v, x, I = r(), U = r(), Q = r(), W = r(), fe = r(), V = r();
      for (x = 0; x < 31; x++)
        i[x] = d[x];
      for (i[31] = d[31] & 127 | 64, i[0] &= 248, Be(c, u), x = 0; x < 16; x++)
        U[x] = c[x], W[x] = I[x] = Q[x] = 0;
      for (I[0] = W[0] = 1, x = 254; x >= 0; --x)
        v = i[x >>> 3] >>> (x & 7) & 1, se(I, U, v), se(Q, W, v), Re(fe, I, Q), Fe(I, I, Q), Re(Q, U, W), Fe(U, U, W), $e(W, fe), $e(V, I), be(I, Q, I), be(Q, U, fe), Re(fe, I, Q), Fe(I, I, Q), $e(U, I), Fe(Q, W, V), be(I, Q, h), Re(I, I, W), be(Q, Q, I), be(I, W, V), be(W, U, c), $e(U, fe), se(I, U, v), se(Q, W, v);
      for (x = 0; x < 16; x++)
        c[x + 16] = I[x], c[x + 32] = Q[x], c[x + 48] = U[x], c[x + 64] = W[x];
      var ne = c.subarray(32), oe = c.subarray(16);
      return lt(ne, ne), be(oe, oe, ne), ae(a, oe), 0;
    }
    function ht(a, d) {
      return dt(a, d, s);
    }
    function _r(a, d) {
      return n(d, 32), ht(a, d);
    }
    function ct(a, d, u) {
      var i = new Uint8Array(32);
      return dt(i, u, d), R(a, o, i, F);
    }
    var Qt = ge, Or = L;
    function hr(a, d, u, i, c, v) {
      var x = new Uint8Array(32);
      return ct(x, c, v), Qt(a, d, u, i, x);
    }
    function pr(a, d, u, i, c, v) {
      var x = new Uint8Array(32);
      return ct(x, c, v), Or(a, d, u, i, x);
    }
    var en = [1116352408, 3609767458, 1899447441, 602891725, 3049323471, 3964484399, 3921009573, 2173295548, 961987163, 4081628472, 1508970993, 3053834265, 2453635748, 2937671579, 2870763221, 3664609560, 3624381080, 2734883394, 310598401, 1164996542, 607225278, 1323610764, 1426881987, 3590304994, 1925078388, 4068182383, 2162078206, 991336113, 2614888103, 633803317, 3248222580, 3479774868, 3835390401, 2666613458, 4022224774, 944711139, 264347078, 2341262773, 604807628, 2007800933, 770255983, 1495990901, 1249150122, 1856431235, 1555081692, 3175218132, 1996064986, 2198950837, 2554220882, 3999719339, 2821834349, 766784016, 2952996808, 2566594879, 3210313671, 3203337956, 3336571891, 1034457026, 3584528711, 2466948901, 113926993, 3758326383, 338241895, 168717936, 666307205, 1188179964, 773529912, 1546045734, 1294757372, 1522805485, 1396182291, 2643833823, 1695183700, 2343527390, 1986661051, 1014477480, 2177026350, 1206759142, 2456956037, 344077627, 2730485921, 1290863460, 2820302411, 3158454273, 3259730800, 3505952657, 3345764771, 106217008, 3516065817, 3606008344, 3600352804, 1432725776, 4094571909, 1467031594, 275423344, 851169720, 430227734, 3100823752, 506948616, 1363258195, 659060556, 3750685593, 883997877, 3785050280, 958139571, 3318307427, 1322822218, 3812723403, 1537002063, 2003034995, 1747873779, 3602036899, 1955562222, 1575990012, 2024104815, 1125592928, 2227730452, 2716904306, 2361852424, 442776044, 2428436474, 593698344, 2756734187, 3733110249, 3204031479, 2999351573, 3329325298, 3815920427, 3391569614, 3928383900, 3515267271, 566280711, 3940187606, 3454069534, 4118630271, 4000239992, 116418474, 1914138554, 174292421, 2731055270, 289380356, 3203993006, 460393269, 320620315, 685471733, 587496836, 852142971, 1086792851, 1017036298, 365543100, 1126000580, 2618297676, 1288033470, 3409855158, 1501505948, 4234509866, 1607167915, 987167468, 1816402316, 1246189591];
    function tn(a, d, u, i) {
      for (var c = new Int32Array(16), v = new Int32Array(16), x, I, U, Q, W, fe, V, ne, oe, le, pe, he, ue, ve, ee, ie, J, te, re, Z, T, M, k, j, D, z, ce = a[0], xe = a[1], me = a[2], we = a[3], y = a[4], Te = a[5], De = a[6], Le = a[7], Ae = d[0], Oe = d[1], Ne = d[2], Ge = d[3], Pe = d[4], We = d[5], qe = d[6], Ye = d[7], He = 0; i >= 128; ) {
        for (re = 0; re < 16; re++)
          Z = 8 * re + He, c[re] = u[Z + 0] << 24 | u[Z + 1] << 16 | u[Z + 2] << 8 | u[Z + 3], v[re] = u[Z + 4] << 24 | u[Z + 5] << 16 | u[Z + 6] << 8 | u[Z + 7];
        for (re = 0; re < 80; re++)
          if (x = ce, I = xe, U = me, Q = we, W = y, fe = Te, V = De, ne = Le, oe = Ae, le = Oe, pe = Ne, he = Ge, ue = Pe, ve = We, ee = qe, ie = Ye, T = Le, M = Ye, k = M & 65535, j = M >>> 16, D = T & 65535, z = T >>> 16, T = (y >>> 14 | Pe << 32 - 14) ^ (y >>> 18 | Pe << 32 - 18) ^ (Pe >>> 41 - 32 | y << 32 - (41 - 32)), M = (Pe >>> 14 | y << 32 - 14) ^ (Pe >>> 18 | y << 32 - 18) ^ (y >>> 41 - 32 | Pe << 32 - (41 - 32)), k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, T = y & Te ^ ~y & De, M = Pe & We ^ ~Pe & qe, k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, T = en[re * 2], M = en[re * 2 + 1], k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, T = c[re % 16], M = v[re % 16], k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, j += k >>> 16, D += j >>> 16, z += D >>> 16, J = D & 65535 | z << 16, te = k & 65535 | j << 16, T = J, M = te, k = M & 65535, j = M >>> 16, D = T & 65535, z = T >>> 16, T = (ce >>> 28 | Ae << 32 - 28) ^ (Ae >>> 34 - 32 | ce << 32 - (34 - 32)) ^ (Ae >>> 39 - 32 | ce << 32 - (39 - 32)), M = (Ae >>> 28 | ce << 32 - 28) ^ (ce >>> 34 - 32 | Ae << 32 - (34 - 32)) ^ (ce >>> 39 - 32 | Ae << 32 - (39 - 32)), k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, T = ce & xe ^ ce & me ^ xe & me, M = Ae & Oe ^ Ae & Ne ^ Oe & Ne, k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, j += k >>> 16, D += j >>> 16, z += D >>> 16, ne = D & 65535 | z << 16, ie = k & 65535 | j << 16, T = Q, M = he, k = M & 65535, j = M >>> 16, D = T & 65535, z = T >>> 16, T = J, M = te, k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, j += k >>> 16, D += j >>> 16, z += D >>> 16, Q = D & 65535 | z << 16, he = k & 65535 | j << 16, xe = x, me = I, we = U, y = Q, Te = W, De = fe, Le = V, ce = ne, Oe = oe, Ne = le, Ge = pe, Pe = he, We = ue, qe = ve, Ye = ee, Ae = ie, re % 16 === 15)
            for (Z = 0; Z < 16; Z++)
              T = c[Z], M = v[Z], k = M & 65535, j = M >>> 16, D = T & 65535, z = T >>> 16, T = c[(Z + 9) % 16], M = v[(Z + 9) % 16], k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, J = c[(Z + 1) % 16], te = v[(Z + 1) % 16], T = (J >>> 1 | te << 32 - 1) ^ (J >>> 8 | te << 32 - 8) ^ J >>> 7, M = (te >>> 1 | J << 32 - 1) ^ (te >>> 8 | J << 32 - 8) ^ (te >>> 7 | J << 32 - 7), k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, J = c[(Z + 14) % 16], te = v[(Z + 14) % 16], T = (J >>> 19 | te << 32 - 19) ^ (te >>> 61 - 32 | J << 32 - (61 - 32)) ^ J >>> 6, M = (te >>> 19 | J << 32 - 19) ^ (J >>> 61 - 32 | te << 32 - (61 - 32)) ^ (te >>> 6 | J << 32 - 6), k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, j += k >>> 16, D += j >>> 16, z += D >>> 16, c[Z] = D & 65535 | z << 16, v[Z] = k & 65535 | j << 16;
        T = ce, M = Ae, k = M & 65535, j = M >>> 16, D = T & 65535, z = T >>> 16, T = a[0], M = d[0], k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, j += k >>> 16, D += j >>> 16, z += D >>> 16, a[0] = ce = D & 65535 | z << 16, d[0] = Ae = k & 65535 | j << 16, T = xe, M = Oe, k = M & 65535, j = M >>> 16, D = T & 65535, z = T >>> 16, T = a[1], M = d[1], k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, j += k >>> 16, D += j >>> 16, z += D >>> 16, a[1] = xe = D & 65535 | z << 16, d[1] = Oe = k & 65535 | j << 16, T = me, M = Ne, k = M & 65535, j = M >>> 16, D = T & 65535, z = T >>> 16, T = a[2], M = d[2], k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, j += k >>> 16, D += j >>> 16, z += D >>> 16, a[2] = me = D & 65535 | z << 16, d[2] = Ne = k & 65535 | j << 16, T = we, M = Ge, k = M & 65535, j = M >>> 16, D = T & 65535, z = T >>> 16, T = a[3], M = d[3], k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, j += k >>> 16, D += j >>> 16, z += D >>> 16, a[3] = we = D & 65535 | z << 16, d[3] = Ge = k & 65535 | j << 16, T = y, M = Pe, k = M & 65535, j = M >>> 16, D = T & 65535, z = T >>> 16, T = a[4], M = d[4], k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, j += k >>> 16, D += j >>> 16, z += D >>> 16, a[4] = y = D & 65535 | z << 16, d[4] = Pe = k & 65535 | j << 16, T = Te, M = We, k = M & 65535, j = M >>> 16, D = T & 65535, z = T >>> 16, T = a[5], M = d[5], k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, j += k >>> 16, D += j >>> 16, z += D >>> 16, a[5] = Te = D & 65535 | z << 16, d[5] = We = k & 65535 | j << 16, T = De, M = qe, k = M & 65535, j = M >>> 16, D = T & 65535, z = T >>> 16, T = a[6], M = d[6], k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, j += k >>> 16, D += j >>> 16, z += D >>> 16, a[6] = De = D & 65535 | z << 16, d[6] = qe = k & 65535 | j << 16, T = Le, M = Ye, k = M & 65535, j = M >>> 16, D = T & 65535, z = T >>> 16, T = a[7], M = d[7], k += M & 65535, j += M >>> 16, D += T & 65535, z += T >>> 16, j += k >>> 16, D += j >>> 16, z += D >>> 16, a[7] = Le = D & 65535 | z << 16, d[7] = Ye = k & 65535 | j << 16, He += 128, i -= 128;
      }
      return i;
    }
    function gt(a, d, u) {
      var i = new Int32Array(8), c = new Int32Array(8), v = new Uint8Array(256), x, I = u;
      for (i[0] = 1779033703, i[1] = 3144134277, i[2] = 1013904242, i[3] = 2773480762, i[4] = 1359893119, i[5] = 2600822924, i[6] = 528734635, i[7] = 1541459225, c[0] = 4089235720, c[1] = 2227873595, c[2] = 4271175723, c[3] = 1595750129, c[4] = 2917565137, c[5] = 725511199, c[6] = 4215389547, c[7] = 327033209, tn(i, c, d, u), u %= 128, x = 0; x < u; x++)
        v[x] = d[I - u + x];
      for (v[u] = 128, u = 256 - 128 * (u < 112 ? 1 : 0), v[u - 9] = 0, A(v, u - 8, I / 536870912 | 0, I << 3), tn(i, c, v, u), x = 0; x < 8; x++)
        A(a, 8 * x, i[x], c[x]);
      return 0;
    }
    function yr(a, d) {
      var u = r(), i = r(), c = r(), v = r(), x = r(), I = r(), U = r(), Q = r(), W = r();
      Fe(u, a[1], a[0]), Fe(W, d[1], d[0]), be(u, u, W), Re(i, a[0], a[1]), Re(W, d[0], d[1]), be(i, i, W), be(c, a[3], d[3]), be(c, c, b), be(v, a[2], d[2]), Re(v, v, v), Fe(x, i, u), Fe(I, v, c), Re(U, v, c), Re(Q, i, u), be(a[0], x, I), be(a[1], Q, U), be(a[2], U, I), be(a[3], x, Q);
    }
    function On(a, d, u) {
      var i;
      for (i = 0; i < 4; i++)
        se(a[i], d[i], u);
    }
    function gr(a, d) {
      var u = r(), i = r(), c = r();
      lt(c, d[2]), be(u, d[0], c), be(i, d[1], c), ae(a, i), a[31] ^= Se(u) << 7;
    }
    function $r(a, d, u) {
      var i, c;
      for (_(a[0], f), _(a[1], l), _(a[2], l), _(a[3], f), c = 255; c >= 0; --c)
        i = u[c / 8 | 0] >> (c & 7) & 1, On(a, d, i), yr(d, a), yr(a, a), On(a, d, i);
    }
    function vr(a, d) {
      var u = [r(), r(), r(), r()];
      _(u[0], g), _(u[1], E), _(u[2], l), be(u[3], g, E), $r(a, u, d);
    }
    function Nr(a, d, u) {
      var i = new Uint8Array(64), c = [r(), r(), r(), r()], v;
      for (u || n(d, 32), gt(i, d, 32), i[0] &= 248, i[31] &= 127, i[31] |= 64, vr(c, i), gr(a, c), v = 0; v < 32; v++)
        d[v + 32] = a[v];
      return 0;
    }
    var ar = new Float64Array([237, 211, 245, 92, 26, 99, 18, 88, 214, 156, 247, 162, 222, 249, 222, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16]);
    function Xt(a, d) {
      var u, i, c, v;
      for (i = 63; i >= 32; --i) {
        for (u = 0, c = i - 32, v = i - 12; c < v; ++c)
          d[c] += u - 16 * d[i] * ar[c - (i - 32)], u = Math.floor((d[c] + 128) / 256), d[c] -= u * 256;
        d[c] += u, d[i] = 0;
      }
      for (u = 0, c = 0; c < 32; c++)
        d[c] += u - (d[31] >> 4) * ar[c], u = d[c] >> 8, d[c] &= 255;
      for (c = 0; c < 32; c++)
        d[c] -= u * ar[c];
      for (i = 0; i < 32; i++)
        d[i + 1] += d[i] >> 8, a[i] = d[i] & 255;
    }
    function Wr(a) {
      var d = new Float64Array(64), u;
      for (u = 0; u < 64; u++)
        d[u] = a[u];
      for (u = 0; u < 64; u++)
        a[u] = 0;
      Xt(a, d);
    }
    function rn(a, d, u, i) {
      var c = new Uint8Array(64), v = new Uint8Array(64), x = new Uint8Array(64), I, U, Q = new Float64Array(64), W = [r(), r(), r(), r()];
      gt(c, i, 32), c[0] &= 248, c[31] &= 127, c[31] |= 64;
      var fe = u + 64;
      for (I = 0; I < u; I++)
        a[64 + I] = d[I];
      for (I = 0; I < 32; I++)
        a[32 + I] = c[32 + I];
      for (gt(x, a.subarray(32), u + 32), Wr(x), vr(W, x), gr(a, W), I = 32; I < 64; I++)
        a[I] = i[I];
      for (gt(v, a, u + 64), Wr(v), I = 0; I < 64; I++)
        Q[I] = 0;
      for (I = 0; I < 32; I++)
        Q[I] = x[I];
      for (I = 0; I < 32; I++)
        for (U = 0; U < 32; U++)
          Q[I + U] += v[I] * c[U];
      return Xt(a.subarray(32), Q), fe;
    }
    function Zn(a, d) {
      var u = r(), i = r(), c = r(), v = r(), x = r(), I = r(), U = r();
      return _(a[2], l), Be(a[1], d), $e(c, a[1]), be(v, c, p), Fe(c, c, a[2]), Re(v, a[2], v), $e(x, v), $e(I, x), be(U, I, x), be(u, U, c), be(u, u, v), St(u, u), be(u, u, c), be(u, u, v), be(u, u, v), be(a[0], u, v), $e(i, a[0]), be(i, i, v), Ee(i, c) && be(a[0], a[0], m), $e(i, a[0]), be(i, i, v), Ee(i, c) ? -1 : (Se(a[0]) === d[31] >> 7 && Fe(a[0], f, a[0]), be(a[3], a[0], a[1]), 0);
    }
    function br(a, d, u, i) {
      var c, v = new Uint8Array(32), x = new Uint8Array(64), I = [r(), r(), r(), r()], U = [r(), r(), r(), r()];
      if (u < 64 || Zn(U, i))
        return -1;
      for (c = 0; c < u; c++)
        a[c] = d[c];
      for (c = 0; c < 32; c++)
        a[c + 32] = i[c];
      if (gt(x, a, u), Wr(x), $r(I, U, x), vr(U, d.subarray(32)), yr(I, U), gr(v, I), u -= 64, N(d, 0, v, 0)) {
        for (c = 0; c < u; c++)
          a[c] = 0;
        return -1;
      }
      for (c = 0; c < u; c++)
        a[c] = d[c + 64];
      return u;
    }
    var qr = 32, xr = 24, Jt = 32, Bt = 16, er = 32, wr = 32, tr = 32, kt = 32, jr = 32, cr = xr, Nn = Jt, jn = Bt, ft = 64, Tt = 32, Nt = 64, Yr = 32, Dr = 64;
    t.lowlevel = {
      crypto_core_hsalsa20: R,
      crypto_stream_xor: ye,
      crypto_stream: Me,
      crypto_stream_salsa20_xor: Y,
      crypto_stream_salsa20: K,
      crypto_onetimeauth: G,
      crypto_onetimeauth_verify: X,
      crypto_verify_16: S,
      crypto_verify_32: N,
      crypto_secretbox: ge,
      crypto_secretbox_open: L,
      crypto_scalarmult: dt,
      crypto_scalarmult_base: ht,
      crypto_box_beforenm: ct,
      crypto_box_afternm: Qt,
      crypto_box: hr,
      crypto_box_open: pr,
      crypto_box_keypair: _r,
      crypto_hash: gt,
      crypto_sign: rn,
      crypto_sign_keypair: Nr,
      crypto_sign_open: br,
      crypto_secretbox_KEYBYTES: qr,
      crypto_secretbox_NONCEBYTES: xr,
      crypto_secretbox_ZEROBYTES: Jt,
      crypto_secretbox_BOXZEROBYTES: Bt,
      crypto_scalarmult_BYTES: er,
      crypto_scalarmult_SCALARBYTES: wr,
      crypto_box_PUBLICKEYBYTES: tr,
      crypto_box_SECRETKEYBYTES: kt,
      crypto_box_BEFORENMBYTES: jr,
      crypto_box_NONCEBYTES: cr,
      crypto_box_ZEROBYTES: Nn,
      crypto_box_BOXZEROBYTES: jn,
      crypto_sign_BYTES: ft,
      crypto_sign_PUBLICKEYBYTES: Tt,
      crypto_sign_SECRETKEYBYTES: Nt,
      crypto_sign_SEEDBYTES: Yr,
      crypto_hash_BYTES: Dr,
      gf: r,
      D: p,
      L: ar,
      pack25519: ae,
      unpack25519: Be,
      M: be,
      A: Re,
      S: $e,
      Z: Fe,
      pow2523: St,
      add: yr,
      set25519: _,
      modL: Xt,
      scalarmult: $r,
      scalarbase: vr
    };
    function nn(a, d) {
      if (a.length !== qr)
        throw new Error("bad key size");
      if (d.length !== xr)
        throw new Error("bad nonce size");
    }
    function gi(a, d) {
      if (a.length !== tr)
        throw new Error("bad public key size");
      if (d.length !== kt)
        throw new Error("bad secret key size");
    }
    function rt() {
      for (var a = 0; a < arguments.length; a++)
        if (!(arguments[a] instanceof Uint8Array))
          throw new TypeError("unexpected type, use Uint8Array");
    }
    function on(a) {
      for (var d = 0; d < a.length; d++)
        a[d] = 0;
    }
    t.randomBytes = function(a) {
      var d = new Uint8Array(a);
      return n(d, a), d;
    }, t.secretbox = function(a, d, u) {
      rt(a, d, u), nn(u, d);
      for (var i = new Uint8Array(Jt + a.length), c = new Uint8Array(i.length), v = 0; v < a.length; v++)
        i[v + Jt] = a[v];
      return ge(c, i, i.length, d, u), c.subarray(Bt);
    }, t.secretbox.open = function(a, d, u) {
      rt(a, d, u), nn(u, d);
      for (var i = new Uint8Array(Bt + a.length), c = new Uint8Array(i.length), v = 0; v < a.length; v++)
        i[v + Bt] = a[v];
      return i.length < 32 || L(c, i, i.length, d, u) !== 0 ? null : c.subarray(Jt);
    }, t.secretbox.keyLength = qr, t.secretbox.nonceLength = xr, t.secretbox.overheadLength = Bt, t.scalarMult = function(a, d) {
      if (rt(a, d), a.length !== wr)
        throw new Error("bad n size");
      if (d.length !== er)
        throw new Error("bad p size");
      var u = new Uint8Array(er);
      return dt(u, a, d), u;
    }, t.scalarMult.base = function(a) {
      if (rt(a), a.length !== wr)
        throw new Error("bad n size");
      var d = new Uint8Array(er);
      return ht(d, a), d;
    }, t.scalarMult.scalarLength = wr, t.scalarMult.groupElementLength = er, t.box = function(a, d, u, i) {
      var c = t.box.before(u, i);
      return t.secretbox(a, d, c);
    }, t.box.before = function(a, d) {
      rt(a, d), gi(a, d);
      var u = new Uint8Array(jr);
      return ct(u, a, d), u;
    }, t.box.after = t.secretbox, t.box.open = function(a, d, u, i) {
      var c = t.box.before(u, i);
      return t.secretbox.open(a, d, c);
    }, t.box.open.after = t.secretbox.open, t.box.keyPair = function() {
      var a = new Uint8Array(tr), d = new Uint8Array(kt);
      return _r(a, d), {
        publicKey: a,
        secretKey: d
      };
    }, t.box.keyPair.fromSecretKey = function(a) {
      if (rt(a), a.length !== kt)
        throw new Error("bad secret key size");
      var d = new Uint8Array(tr);
      return ht(d, a), {
        publicKey: d,
        secretKey: new Uint8Array(a)
      };
    }, t.box.publicKeyLength = tr, t.box.secretKeyLength = kt, t.box.sharedKeyLength = jr, t.box.nonceLength = cr, t.box.overheadLength = t.secretbox.overheadLength, t.sign = function(a, d) {
      if (rt(a, d), d.length !== Nt)
        throw new Error("bad secret key size");
      var u = new Uint8Array(ft + a.length);
      return rn(u, a, a.length, d), u;
    }, t.sign.open = function(a, d) {
      if (rt(a, d), d.length !== Tt)
        throw new Error("bad public key size");
      var u = new Uint8Array(a.length), i = br(u, a, a.length, d);
      if (i < 0)
        return null;
      for (var c = new Uint8Array(i), v = 0; v < c.length; v++)
        c[v] = u[v];
      return c;
    }, t.sign.detached = function(a, d) {
      for (var u = t.sign(a, d), i = new Uint8Array(ft), c = 0; c < i.length; c++)
        i[c] = u[c];
      return i;
    }, t.sign.detached.verify = function(a, d, u) {
      if (rt(a, d, u), d.length !== ft)
        throw new Error("bad signature size");
      if (u.length !== Tt)
        throw new Error("bad public key size");
      var i = new Uint8Array(ft + a.length), c = new Uint8Array(ft + a.length), v;
      for (v = 0; v < ft; v++)
        i[v] = d[v];
      for (v = 0; v < a.length; v++)
        i[v + ft] = a[v];
      return br(c, i, i.length, u) >= 0;
    }, t.sign.keyPair = function() {
      var a = new Uint8Array(Tt), d = new Uint8Array(Nt);
      return Nr(a, d), {
        publicKey: a,
        secretKey: d
      };
    }, t.sign.keyPair.fromSecretKey = function(a) {
      if (rt(a), a.length !== Nt)
        throw new Error("bad secret key size");
      for (var d = new Uint8Array(Tt), u = 0; u < d.length; u++)
        d[u] = a[32 + u];
      return {
        publicKey: d,
        secretKey: new Uint8Array(a)
      };
    }, t.sign.keyPair.fromSeed = function(a) {
      if (rt(a), a.length !== Yr)
        throw new Error("bad seed size");
      for (var d = new Uint8Array(Tt), u = new Uint8Array(Nt), i = 0; i < 32; i++)
        u[i] = a[i];
      return Nr(d, u, !0), {
        publicKey: d,
        secretKey: u
      };
    }, t.sign.publicKeyLength = Tt, t.sign.secretKeyLength = Nt, t.sign.seedLength = Yr, t.sign.signatureLength = ft, t.hash = function(a) {
      rt(a);
      var d = new Uint8Array(Dr);
      return gt(d, a, a.length), d;
    }, t.hash.hashLength = Dr, t.verify = function(a, d) {
      return rt(a, d), a.length === 0 || d.length === 0 || a.length !== d.length ? !1 : w(a, 0, d, 0, a.length) === 0;
    }, t.setPRNG = function(a) {
      n = a;
    }, function() {
      var a = typeof self < "u" ? self.crypto || self.msCrypto : null;
      if (a && a.getRandomValues) {
        var d = 65536;
        t.setPRNG(function(u, i) {
          var c, v = new Uint8Array(i);
          for (c = 0; c < i; c += d)
            a.getRandomValues(v.subarray(c, c + Math.min(i - c, d)));
          for (c = 0; c < i; c++)
            u[c] = v[c];
          on(v);
        });
      } else
        typeof Sx < "u" && (a = Ix, a && a.randomBytes && t.setPRNG(function(u, i) {
          var c, v = a.randomBytes(i);
          for (c = 0; c < i; c++)
            u[c] = v[c];
          on(v);
        }));
    }();
  })(e.exports ? e.exports : self.nacl = self.nacl || {});
})(d0);
function ga(e) {
  if (!Number.isSafeInteger(e) || e < 0)
    throw new Error(`Wrong positive integer: ${e}`);
}
function Cx(e) {
  if (typeof e != "boolean")
    throw new Error(`Expected boolean, not ${e}`);
}
function h0(e, ...t) {
  if (!(e instanceof Uint8Array))
    throw new TypeError("Expected Uint8Array");
  if (t.length > 0 && !t.includes(e.length))
    throw new TypeError(`Expected Uint8Array of length ${t}, not of length=${e.length}`);
}
function _x(e) {
  if (typeof e != "function" || typeof e.create != "function")
    throw new Error("Hash should be wrapped by utils.wrapConstructor");
  ga(e.outputLen), ga(e.blockLen);
}
function Ox(e, t = !0) {
  if (e.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (t && e.finished)
    throw new Error("Hash#digest() has already been called");
}
function Nx(e, t) {
  h0(e);
  const r = t.outputLen;
  if (e.length < r)
    throw new Error(`digestInto() expects output buffer of length at least ${r}`);
}
const ti = {
  number: ga,
  bool: Cx,
  bytes: h0,
  hash: _x,
  exists: Ox,
  output: Nx
};
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */
const zo = (e) => new Uint32Array(e.buffer, e.byteOffset, Math.floor(e.byteLength / 4)), jx = new Uint8Array(new Uint32Array([287454020]).buffer)[0] === 68;
if (!jx)
  throw new Error("Non little-endian hardware is not supported");
Array.from({
  length: 256
}, (e, t) => t.toString(16).padStart(2, "0"));
function Dx(e) {
  if (typeof e != "string")
    throw new TypeError(`utf8ToBytes expected string, got ${typeof e}`);
  return new TextEncoder().encode(e);
}
function Ti(e) {
  if (typeof e == "string" && (e = Dx(e)), !(e instanceof Uint8Array))
    throw new TypeError(`Expected input type is Uint8Array (got ${typeof e})`);
  return e;
}
class Lx {
  clone() {
    return this._cloneInto();
  }
}
function Rx(e) {
  const t = (n, o) => e(o).update(Ti(n)).digest(), r = e({});
  return t.outputLen = r.outputLen, t.blockLen = r.blockLen, t.create = (n) => e(n), t;
}
const Px = new Uint8Array([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 14, 10, 4, 8, 9, 15, 13, 6, 1, 12, 0, 2, 11, 7, 5, 3, 11, 8, 12, 0, 5, 2, 15, 13, 10, 14, 3, 6, 7, 1, 9, 4, 7, 9, 3, 1, 13, 12, 11, 14, 2, 6, 5, 10, 4, 0, 15, 8, 9, 0, 5, 7, 2, 4, 10, 15, 14, 1, 11, 12, 6, 8, 3, 13, 2, 12, 6, 10, 0, 11, 8, 3, 4, 13, 7, 5, 15, 14, 1, 9, 12, 5, 1, 15, 14, 13, 4, 10, 0, 7, 6, 3, 9, 2, 8, 11, 13, 11, 7, 14, 12, 1, 3, 9, 5, 0, 15, 4, 8, 6, 2, 10, 6, 15, 14, 9, 11, 3, 0, 8, 12, 2, 13, 7, 1, 4, 10, 5, 10, 2, 8, 4, 7, 6, 1, 5, 15, 11, 9, 14, 3, 12, 13, 0, 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 14, 10, 4, 8, 9, 15, 13, 6, 1, 12, 0, 2, 11, 7, 5, 3]);
class Ux extends Lx {
  constructor(t, r, n = {}, o, s, f) {
    if (super(), this.blockLen = t, this.outputLen = r, this.length = 0, this.pos = 0, this.finished = !1, this.destroyed = !1, ti.number(t), ti.number(r), ti.number(o), r < 0 || r > o)
      throw new Error("outputLen bigger than keyLen");
    if (n.key !== void 0 && (n.key.length < 1 || n.key.length > o))
      throw new Error(`key must be up 1..${o} byte long or undefined`);
    if (n.salt !== void 0 && n.salt.length !== s)
      throw new Error(`salt must be ${s} byte long or undefined`);
    if (n.personalization !== void 0 && n.personalization.length !== f)
      throw new Error(`personalization must be ${f} byte long or undefined`);
    this.buffer32 = zo(this.buffer = new Uint8Array(t));
  }
  update(t) {
    ti.exists(this);
    const {
      blockLen: r,
      buffer: n,
      buffer32: o
    } = this;
    t = Ti(t);
    const s = t.length;
    for (let f = 0; f < s; ) {
      this.pos === r && (this.compress(o, 0, !1), this.pos = 0);
      const l = Math.min(r - this.pos, s - f), h = t.byteOffset + f;
      if (l === r && !(h % 4) && f + l < s) {
        const p = new Uint32Array(t.buffer, h, Math.floor((s - f) / 4));
        for (let b = 0; f + r < s; b += o.length, f += r)
          this.length += r, this.compress(p, b, !1);
        continue;
      }
      n.set(t.subarray(f, f + l), this.pos), this.pos += l, this.length += l, f += l;
    }
    return this;
  }
  digestInto(t) {
    ti.exists(this), ti.output(t, this);
    const {
      pos: r,
      buffer32: n
    } = this;
    this.finished = !0, this.buffer.subarray(r).fill(0), this.compress(n, 0, !0);
    const o = zo(t);
    this.get().forEach((s, f) => o[f] = s);
  }
  digest() {
    const {
      buffer: t,
      outputLen: r
    } = this;
    this.digestInto(t);
    const n = t.slice(0, r);
    return this.destroy(), n;
  }
  _cloneInto(t) {
    const {
      buffer: r,
      length: n,
      finished: o,
      destroyed: s,
      outputLen: f,
      pos: l
    } = this;
    return t || (t = new this.constructor({
      dkLen: f
    })), t.set(...this.get()), t.length = n, t.finished = o, t.destroyed = s, t.outputLen = f, t.buffer.set(r), t.pos = l, t;
  }
}
const io = BigInt(2 ** 32 - 1), va = BigInt(32);
function p0(e, t = !1) {
  return t ? {
    h: Number(e & io),
    l: Number(e >> va & io)
  } : {
    h: Number(e >> va & io) | 0,
    l: Number(e & io) | 0
  };
}
function Bx(e, t = !1) {
  let r = new Uint32Array(e.length), n = new Uint32Array(e.length);
  for (let o = 0; o < e.length; o++) {
    const {
      h: s,
      l: f
    } = p0(e[o], t);
    [r[o], n[o]] = [s, f];
  }
  return [r, n];
}
const kx = (e, t) => BigInt(e >>> 0) << va | BigInt(t >>> 0), zx = (e, t, r) => e >>> r, Fx = (e, t, r) => e << 32 - r | t >>> r, $x = (e, t, r) => e >>> r | t << 32 - r, Wx = (e, t, r) => e << 32 - r | t >>> r, qx = (e, t, r) => e << 64 - r | t >>> r - 32, Yx = (e, t, r) => e >>> r - 32 | t << 64 - r, Gx = (e, t) => t, Qx = (e, t) => e, Vx = (e, t, r) => e << r | t >>> 32 - r, Hx = (e, t, r) => t << r | e >>> 32 - r, Zx = (e, t, r) => t << r - 32 | e >>> 64 - r, Kx = (e, t, r) => e << r - 32 | t >>> 64 - r;
function Xx(e, t, r, n) {
  const o = (t >>> 0) + (n >>> 0);
  return {
    h: e + r + (o / 2 ** 32 | 0) | 0,
    l: o | 0
  };
}
const Jx = (e, t, r) => (e >>> 0) + (t >>> 0) + (r >>> 0), e2 = (e, t, r, n) => t + r + n + (e / 2 ** 32 | 0) | 0, t2 = (e, t, r, n) => (e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0), r2 = (e, t, r, n, o) => t + r + n + o + (e / 2 ** 32 | 0) | 0, n2 = (e, t, r, n, o) => (e >>> 0) + (t >>> 0) + (r >>> 0) + (n >>> 0) + (o >>> 0), i2 = (e, t, r, n, o, s) => t + r + n + o + s + (e / 2 ** 32 | 0) | 0, $t = {
  fromBig: p0,
  split: Bx,
  toBig: kx,
  shrSH: zx,
  shrSL: Fx,
  rotrSH: $x,
  rotrSL: Wx,
  rotrBH: qx,
  rotrBL: Yx,
  rotr32H: Gx,
  rotr32L: Qx,
  rotlSH: Vx,
  rotlSL: Hx,
  rotlBH: Zx,
  rotlBL: Kx,
  add: Xx,
  add3L: Jx,
  add3H: e2,
  add4L: t2,
  add4H: r2,
  add5H: i2,
  add5L: n2
}, xt = new Uint32Array([4089235720, 1779033703, 2227873595, 3144134277, 4271175723, 1013904242, 1595750129, 2773480762, 2917565137, 1359893119, 725511199, 2600822924, 4215389547, 528734635, 327033209, 1541459225]), _e = new Uint32Array(32);
function pn(e, t, r, n, o, s) {
  const f = o[s], l = o[s + 1];
  let h = _e[2 * e], p = _e[2 * e + 1], b = _e[2 * t], g = _e[2 * t + 1], E = _e[2 * r], m = _e[2 * r + 1], A = _e[2 * n], w = _e[2 * n + 1], S = $t.add3L(h, b, f);
  p = $t.add3H(S, p, g, l), h = S | 0, {
    Dh: w,
    Dl: A
  } = {
    Dh: w ^ p,
    Dl: A ^ h
  }, {
    Dh: w,
    Dl: A
  } = {
    Dh: $t.rotr32H(w, A),
    Dl: $t.rotr32L(w, A)
  }, {
    h: m,
    l: E
  } = $t.add(m, E, w, A), {
    Bh: g,
    Bl: b
  } = {
    Bh: g ^ m,
    Bl: b ^ E
  }, {
    Bh: g,
    Bl: b
  } = {
    Bh: $t.rotrSH(g, b, 24),
    Bl: $t.rotrSL(g, b, 24)
  }, _e[2 * e] = h, _e[2 * e + 1] = p, _e[2 * t] = b, _e[2 * t + 1] = g, _e[2 * r] = E, _e[2 * r + 1] = m, _e[2 * n] = A, _e[2 * n + 1] = w;
}
function yn(e, t, r, n, o, s) {
  const f = o[s], l = o[s + 1];
  let h = _e[2 * e], p = _e[2 * e + 1], b = _e[2 * t], g = _e[2 * t + 1], E = _e[2 * r], m = _e[2 * r + 1], A = _e[2 * n], w = _e[2 * n + 1], S = $t.add3L(h, b, f);
  p = $t.add3H(S, p, g, l), h = S | 0, {
    Dh: w,
    Dl: A
  } = {
    Dh: w ^ p,
    Dl: A ^ h
  }, {
    Dh: w,
    Dl: A
  } = {
    Dh: $t.rotrSH(w, A, 16),
    Dl: $t.rotrSL(w, A, 16)
  }, {
    h: m,
    l: E
  } = $t.add(m, E, w, A), {
    Bh: g,
    Bl: b
  } = {
    Bh: g ^ m,
    Bl: b ^ E
  }, {
    Bh: g,
    Bl: b
  } = {
    Bh: $t.rotrBH(g, b, 63),
    Bl: $t.rotrBL(g, b, 63)
  }, _e[2 * e] = h, _e[2 * e + 1] = p, _e[2 * t] = b, _e[2 * t + 1] = g, _e[2 * r] = E, _e[2 * r + 1] = m, _e[2 * n] = A, _e[2 * n + 1] = w;
}
class o2 extends Ux {
  constructor(t = {}) {
    super(128, t.dkLen === void 0 ? 64 : t.dkLen, t, 64, 16, 16), this.v0l = xt[0] | 0, this.v0h = xt[1] | 0, this.v1l = xt[2] | 0, this.v1h = xt[3] | 0, this.v2l = xt[4] | 0, this.v2h = xt[5] | 0, this.v3l = xt[6] | 0, this.v3h = xt[7] | 0, this.v4l = xt[8] | 0, this.v4h = xt[9] | 0, this.v5l = xt[10] | 0, this.v5h = xt[11] | 0, this.v6l = xt[12] | 0, this.v6h = xt[13] | 0, this.v7l = xt[14] | 0, this.v7h = xt[15] | 0;
    const r = t.key ? t.key.length : 0;
    if (this.v0l ^= this.outputLen | r << 8 | 1 << 16 | 1 << 24, t.salt) {
      const n = zo(Ti(t.salt));
      this.v4l ^= n[0], this.v4h ^= n[1], this.v5l ^= n[2], this.v5h ^= n[3];
    }
    if (t.personalization) {
      const n = zo(Ti(t.personalization));
      this.v6l ^= n[0], this.v6h ^= n[1], this.v7l ^= n[2], this.v7h ^= n[3];
    }
    if (t.key) {
      const n = new Uint8Array(this.blockLen);
      n.set(Ti(t.key)), this.update(n);
    }
  }
  get() {
    let {
      v0l: t,
      v0h: r,
      v1l: n,
      v1h: o,
      v2l: s,
      v2h: f,
      v3l: l,
      v3h: h,
      v4l: p,
      v4h: b,
      v5l: g,
      v5h: E,
      v6l: m,
      v6h: A,
      v7l: w,
      v7h: S
    } = this;
    return [t, r, n, o, s, f, l, h, p, b, g, E, m, A, w, S];
  }
  set(t, r, n, o, s, f, l, h, p, b, g, E, m, A, w, S) {
    this.v0l = t | 0, this.v0h = r | 0, this.v1l = n | 0, this.v1h = o | 0, this.v2l = s | 0, this.v2h = f | 0, this.v3l = l | 0, this.v3h = h | 0, this.v4l = p | 0, this.v4h = b | 0, this.v5l = g | 0, this.v5h = E | 0, this.v6l = m | 0, this.v6h = A | 0, this.v7l = w | 0, this.v7h = S | 0;
  }
  compress(t, r, n) {
    this.get().forEach((h, p) => _e[p] = h), _e.set(xt, 16);
    let {
      h: o,
      l: s
    } = $t.fromBig(BigInt(this.length));
    _e[24] = xt[8] ^ s, _e[25] = xt[9] ^ o, n && (_e[28] = ~_e[28], _e[29] = ~_e[29]);
    let f = 0;
    const l = Px;
    for (let h = 0; h < 12; h++)
      pn(0, 4, 8, 12, t, r + 2 * l[f++]), yn(0, 4, 8, 12, t, r + 2 * l[f++]), pn(1, 5, 9, 13, t, r + 2 * l[f++]), yn(1, 5, 9, 13, t, r + 2 * l[f++]), pn(2, 6, 10, 14, t, r + 2 * l[f++]), yn(2, 6, 10, 14, t, r + 2 * l[f++]), pn(3, 7, 11, 15, t, r + 2 * l[f++]), yn(3, 7, 11, 15, t, r + 2 * l[f++]), pn(0, 5, 10, 15, t, r + 2 * l[f++]), yn(0, 5, 10, 15, t, r + 2 * l[f++]), pn(1, 6, 11, 12, t, r + 2 * l[f++]), yn(1, 6, 11, 12, t, r + 2 * l[f++]), pn(2, 7, 8, 13, t, r + 2 * l[f++]), yn(2, 7, 8, 13, t, r + 2 * l[f++]), pn(3, 4, 9, 14, t, r + 2 * l[f++]), yn(3, 4, 9, 14, t, r + 2 * l[f++]);
    this.v0l ^= _e[0] ^ _e[16], this.v0h ^= _e[1] ^ _e[17], this.v1l ^= _e[2] ^ _e[18], this.v1h ^= _e[3] ^ _e[19], this.v2l ^= _e[4] ^ _e[20], this.v2h ^= _e[5] ^ _e[21], this.v3l ^= _e[6] ^ _e[22], this.v3h ^= _e[7] ^ _e[23], this.v4l ^= _e[8] ^ _e[24], this.v4h ^= _e[9] ^ _e[25], this.v5l ^= _e[10] ^ _e[26], this.v5h ^= _e[11] ^ _e[27], this.v6l ^= _e[12] ^ _e[28], this.v6h ^= _e[13] ^ _e[29], this.v7l ^= _e[14] ^ _e[30], this.v7h ^= _e[15] ^ _e[31], _e.fill(0);
  }
  destroy() {
    this.destroyed = !0, this.buffer32.fill(0), this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
  }
}
const s2 = Rx((e) => new o2(e));
function a2(e) {
  const t = Nv(e.signature), r = Nb(Jl.PersonalMessage, Mr(e.messageBytes));
  return d0.exports.sign.detached.verify(s2(r, { dkLen: 32 }), t.signature, t.pubKey.toBytes());
}
function c2(e) {
  const t = Pi();
  return e ? Ur(() => t.chains.find((r) => r.id === e), [e, t.chains]) : t.chain;
}
function f2(e) {
  const t = Pi(), {
    address: r = t.address,
    typeArg: n = nc,
    chainId: o = t.chain?.id
  } = e || {}, s = c2(o), f = px(c0.COIN_BALANCE, {
    address: r,
    typeArg: n,
    chainId: o
  }), l = Ut(() => {
    if (!r || !s)
      return BigInt(0);
    const h = new vx(s.rpcUrl);
    return new gx(h, r).balance.get(n);
  }, [s, r]);
  return cx(f, l, {
    initialData: BigInt(0)
  });
}
function u2(e) {
  const {
    typeArg: t,
    chainId: r
  } = e || {}, n = f2({
    typeArg: t,
    chainId: r
  });
  return Object.assign(n, {
    balance: n.data,
    loading: n.isLoading
  });
}
function L6(e) {
  return Ur(() => new Xl(new pi({ fullnode: e })), [e]);
}
function Br(e) {
  return Array.isArray(e) && e.length > 0;
}
function jf(e) {
  return "standard:connect" in e.features && "standard:events" in e.features && "sui:signAndExecuteTransactionBlock" in e.features;
}
const l2 = (e) => {
  const {
    icon: t,
    alt: r = "icon"
  } = e;
  return /* @__PURE__ */ je("div", {
    onClick: e.onClick,
    className: e.className,
    style: e.style,
    children: typeof t == "string" ? /* @__PURE__ */ je("img", {
      src: t,
      alt: r,
      className: e.elClassName,
      style: e.elStyle
    }) : Wt.cloneElement(t)
  });
};
const d2 = () => /* @__PURE__ */ yt("div", {
  className: "wkit-dialog__header",
  children: [/* @__PURE__ */ je(Ii, {
    className: "wkit-dialog__title",
    children: "Connect Wallet"
  }), /* @__PURE__ */ je(sh, {
    style: {
      position: "absolute",
      right: "16px",
      top: "16px"
    },
    className: "wkit-dialog__close",
    children: /* @__PURE__ */ je(ch, {})
  })]
}), h2 = () => /* @__PURE__ */ yt("div", {
  className: "wkit-new-to-sui",
  children: [/* @__PURE__ */ je("span", {
    className: "wkit-new-to-sui__text",
    children: "New to sui? "
  }), /* @__PURE__ */ je("a", {
    className: "wkit-new-to-sui__link",
    href: "https://suiet.app/docs/getting-started",
    target: "_blank",
    children: "Learn More Here"
  })]
}), p2 = (e) => {
  const {
    wallet: t
  } = e, [r, n] = Zt("");
  return At(() => {
    !t.iconUrl || n(t.iconUrl);
  }, [t.iconUrl]), /* @__PURE__ */ yt("div", {
    className: "wkit-select-item",
    onClick: () => {
      e.onSelect?.(t);
    },
    children: [/* @__PURE__ */ je(l2, {
      icon: r,
      className: "wkit-select-item__icon",
      elClassName: "wkit-select-item__icon"
    }), t.label ?? t.name]
  }, t.name);
}, Df = (e) => Br(e.wallets) ? /* @__PURE__ */ yt("div", {
  className: "wkit-select__container",
  children: [/* @__PURE__ */ je("div", {
    className: "wkit-select__title",
    children: e.title
  }), Br(e.wallets) && e.wallets.map((t) => /* @__PURE__ */ je(p2, {
    wallet: t,
    onSelect: e.onSelect
  }, t.name))]
}) : null, y2 = (e) => {
  const {
    wallet: t
  } = e;
  return /* @__PURE__ */ yt("section", {
    children: [/* @__PURE__ */ yt("div", {
      className: "wkit-dialog__header",
      children: [/* @__PURE__ */ je(Ii, {
        className: "wkit-dialog__title",
        style: {
          margin: "-8px 12px -6px -8px"
        },
        children: /* @__PURE__ */ je("span", {
          className: "wkit-dialog__close",
          onClick: e.onNavBack,
          children: /* @__PURE__ */ je(fu, {})
        })
      }), /* @__PURE__ */ je(Ii, {
        className: "wkit-dialog__title",
        children: "Install Wallet"
      })]
    }), /* @__PURE__ */ yt("div", {
      className: "wkit-install",
      children: [/* @__PURE__ */ je("img", {
        className: "wkit-install__logo",
        src: t.iconUrl,
        alt: `${t.name} logo`
      }), /* @__PURE__ */ je("h1", {
        className: "wkit-install__title",
        children: "You haven\u2019t install this wallet"
      }), /* @__PURE__ */ je("p", {
        className: "wkit-install__description",
        children: "Install wallet via Chrome Extension Store"
      }), /* @__PURE__ */ je("button", {
        className: "wkit-button wkit-install__button",
        onClick: () => {
          if (!t.downloadUrl?.browserExtension)
            throw new zt(`no downloadUrl config on this wallet: ${t.name}`);
          window.open(t.downloadUrl.browserExtension, "_blank");
        },
        children: "Get Wallet"
      })]
    })]
  });
}, g2 = (e) => {
  const {
    wallet: t
  } = e;
  return /* @__PURE__ */ yt("section", {
    children: [/* @__PURE__ */ yt("div", {
      className: "wkit-dialog__header",
      children: [/* @__PURE__ */ je(Ii, {
        className: "wkit-dialog__title",
        style: {
          margin: "-6px 12px -6px -8px"
        },
        children: /* @__PURE__ */ je("span", {
          className: "wkit-dialog__close",
          onClick: e.onNavBack,
          children: /* @__PURE__ */ je(fu, {})
        })
      }), /* @__PURE__ */ je(Ii, {
        className: "wkit-dialog__title",
        children: "Connecting"
      })]
    }), /* @__PURE__ */ yt("div", {
      className: "wkit-connecting",
      children: [/* @__PURE__ */ je("img", {
        className: "wkit-connecting__logo",
        src: t.iconUrl,
        alt: `logo of ${t.name}`
      }), /* @__PURE__ */ yt("h1", {
        className: "wkit-connecting__title",
        children: ["Opening ", t.name]
      }), /* @__PURE__ */ je("p", {
        className: "wkit-connecting__description",
        children: "Confirm connection in the extension"
      })]
    })]
  });
}, v2 = (e) => {
  const {
    configuredWallets: t,
    detectedWallets: r,
    select: n,
    connecting: o
  } = Pi(), {
    onConnectSuccess: s = () => {
    },
    onConnectError: f = (g) => {
      throw g;
    }
  } = e, [l, h] = Zt(), p = Ut(async (g) => {
    if (h(g), g.installed) {
      try {
        await n(g.name);
      } catch (E) {
        f(E);
        return;
      }
      s(g.name);
    }
  }, [n]);
  function b() {
    if (l) {
      if (!l.installed)
        return /* @__PURE__ */ je(y2, {
          wallet: l,
          onNavBack: () => {
            h(void 0);
          }
        });
      if (o)
        return /* @__PURE__ */ je(g2, {
          wallet: l,
          onNavBack: () => {
            h(void 0);
          }
        });
    }
    return /* @__PURE__ */ yt("div", {
      children: [/* @__PURE__ */ je(d2, {}), /* @__PURE__ */ yt("div", {
        className: "wkit-select__scroll",
        children: [/* @__PURE__ */ je(Df, {
          title: "Popular",
          wallets: t,
          onSelect: p
        }), /* @__PURE__ */ je(Df, {
          title: "Others",
          wallets: r,
          onSelect: p
        })]
      }), /* @__PURE__ */ je("div", {
        style: {
          height: "41px",
          flexShrink: "0"
        }
      }), /* @__PURE__ */ je(h2, {})]
    });
  }
  return /* @__PURE__ */ je(ah, {
    open: e.open,
    onOpenChange: e.onOpenChange,
    trigger: e.children,
    contentProps: {
      onOpenAutoFocus: (g) => {
        g.preventDefault();
      }
    },
    children: b()
  });
};
function b2(e) {
  const {
    disconnect: t,
    account: r,
    chain: n,
    connected: o,
    name: s
  } = Pi(), {
    balance: f
  } = u2(), [l, h] = Zt(!1), p = Ut(() => !n || n.id === xo.id ? /* @__PURE__ */ je(To, {
    children: "Unknown Chain"
  }) : /* @__PURE__ */ yt(To, {
    children: [xx(f ?? 0), " SUI"]
  }), [f, n]);
  return o ? /* @__PURE__ */ yt("div", {
    className: So("wkit-connected-container"),
    children: [/* @__PURE__ */ yt("button", {
      className: So("wkit-connected-button"),
      onClick: () => {
        h(!l);
      },
      children: [/* @__PURE__ */ je("span", {
        className: "wkit-connected-button__balance",
        children: p()
      }), /* @__PURE__ */ je("div", {
        className: "wkit-connected-button__divider"
      }), /* @__PURE__ */ yt("div", {
        className: "wkit-address-select",
        children: [/* @__PURE__ */ je("span", {
          className: "wkit-address-select__address",
          children: Ex(r?.address)
        }), /* @__PURE__ */ je("span", {
          className: "wkit-address-select__right-arrow",
          children: /* @__PURE__ */ je(fh, {})
        })]
      })]
    }), l && /* @__PURE__ */ je("div", {
      className: "wkit-disconnect-button__container",
      children: /* @__PURE__ */ je("button", {
        className: "wkit-disconnect-button",
        onClick: async () => {
          h(!1);
          try {
            await t();
          } catch (b) {
            e?.onDisconnectError?.(b);
            return;
          }
          e?.onDisconnectSuccess?.(s);
        },
        children: "Disconnect"
      })
    })]
  }) : null;
}
const R6 = (e) => {
  const {
    label: t = "Connect Button"
  } = e, [r, n] = Zt(!1), {
    connected: o
  } = Pi();
  return At(() => {
    o && n(!1);
  }, [o]), /* @__PURE__ */ je(v2, {
    open: r,
    onOpenChange: (s) => {
      o || n(s);
    },
    onConnectSuccess: e.onConnectSuccess,
    onConnectError: e.onConnectError,
    children: /* @__PURE__ */ je("div", {
      children: o ? /* @__PURE__ */ je(b2, {
        onDisconnectSuccess: (s) => {
          n(!1), e?.onDisconnectSuccess?.(s);
        },
        onDisconnectError: e.onDisconnectError
      }) : /* @__PURE__ */ je("button", {
        className: So("wkit-button", e.className),
        style: e.style,
        children: e.children || t
      })
    })
  });
};
function Cr(e) {
  return Object.freeze(e);
}
var gn = /* @__PURE__ */ ((e) => (e.SUI_WALLET = "Sui Wallet", e.SUIET_WALLET = "Suiet", e.ETHOS_WALLET = "Ethos Wallet", e.SURF_WALLET = "Surf Wallet", e.GLASS_WALLET = "GlassWallet", e.MORPHIS_WALLET = "Morphis Wallet", e.MARTIAN_WALLET = "Martian Sui Wallet", e.ONEKEY_WALLET = "OneKey Wallet", e.SPACECY_WALLET = "Spacecy Sui Wallet", e.NIGHTLY_WALLET = "Nightly Wallet", e.ELLI_WALLET = "Elli", e))(gn || {});
const x2 = Cr({
  name: "Suiet",
  label: "Suiet Wallet",
  iconUrl: "data:image/svg+xml;base64,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",
  downloadUrl: {
    browserExtension: "https://chrome.google.com/webstore/detail/suiet/khpkpbbcccdmmclmpigdgddabeilkdpd"
  }
}), w2 = Cr({
  name: "Sui Wallet",
  label: "Sui Wallet",
  iconUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAIVBMVEUAAAD////////9/f39/f3+/v7x+Pz///95wfGj1PXI5fgEMJeQAAAAB3RSTlMAECNgmNr40ET05wAAAOBJREFUeNplUksOgjAQbYw38LdloQdw5VZJDGuNiWtXdGvUFjlAtT2AVC4AekrLvKKYvoTMm5fpfGGswWCdit2cfTFNZYO49YfSYwW/t2+FS0TCTH6x/Q/wISPZwcYJSVc4uxdg1wI2Yn0QbmCXbAKin7AHtiCbq6wicvI5syK/+azowlZSoxNGc4l7IWswhqKlagtD4Kl9CAWBAmspbGHwhJK+HDMlkiaIcJ9BWWqMu64yhcbGVMU5nKoc/XC2fGs/HMbPra78+MGCwhUGSw7OEB4qOKU7Nrki/p2/8zt8ABpiv63tyiOHAAAAAElFTkSuQmCC",
  downloadUrl: {
    browserExtension: "https://chrome.google.com/webstore/detail/sui-wallet/opcgpfmipidbgpenhmajoajpbobppdil"
  }
}), m2 = Cr({
  name: "Ethos Wallet",
  label: "Ethos Wallet",
  iconUrl: "data:image/svg+xml;base64,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",
  downloadUrl: {
    browserExtension: "https://chrome.google.com/webstore/detail/ethos-sui-wallet/mcbigmjiafegjnnogedioegffbooigli"
  }
}), E2 = Cr({
  name: "Martian Sui Wallet",
  label: "Martian Sui Wallet",
  iconUrl: "https://cdn.martianwallet.xyz/assets/icon.png",
  downloadUrl: {
    browserExtension: "https://chrome.google.com/webstore/detail/martian-wallet-aptos-sui/efbglgofoippbgcjepnhiblaibcnclgk"
  }
}), A2 = Cr({
  name: "Surf Wallet",
  label: "Surf Wallet",
  iconUrl: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTEyIiBoZWlnaHQ9IjUxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNDcwIDQwMGMtMTEgOC0yMyAxNC0zNSAxNS00NyA0LTEwNi00Mi0xNDQtNDdzLTYwIDIxLTY5IDM2Yy01IDktNiAyMi02IDMzIDAgNCAwIDkgMiAxNSAyIDExIDMwIDU1IDk0IDQ5IDY5LTYgMTA5LTQzIDE1MC05Mmw2LTYgMi0zeiIgZmlsbD0iIzU4QzVGMyIvPjxwYXRoIGQ9Ik0yNTQgMzI3YzExLTYgMjItMTEgMzMtMTEgNDIgMCA5MiA0NiAxMjUgNTMgMzQgNyA1Ni0xNSA2NC0yNyA3LTEyIDgtMjMgOC0zMWwtMS0xMmMtMi03LTIyLTUwLTc5LTUwLTYzIDAtMTAyIDMwLTE0MiA3MGwtNSA1LTMgM3oiIGZpbGw9IiM5REUyRkYiLz48cGF0aCBkPSJNMzMgMjk2djJjMCA1OCA0NyAxMDMgMTA0IDEwMyAyNCAwIDQ1LTcgNjMtMjFsMS0xIDEtMSAxLTF2LTFsMTEtMTAgNDAtMzkgMy0yIDUtNmM0MC00MCA3OS03MCAxNDEtNzAgNTggMCA3NyA0MyA4MCA1MS01LTk5LTc1LTE4MS0xNjgtMjA2bC0zLTFjLTEwLTItMzYtMTItMzYtMjdWMThzMi0xMy0xMi00Yy0zNiAyNC02NyA3Ni05NSA5MS02OSAzMC0xMjAgOTAtMTM0IDE2NmwtMiAxOXY2eiIgZmlsbD0iIzU4QzVGMyIvPjxwYXRoIGQ9Ik0yNTUgMjcxbC00MyAzNi00NCAzOGMtNiA2LTE1IDQtMTgtN3MzLTUyIDM0LTcyIDYyLTIwIDc0LTEzYzkgNyA2IDExIDQgMTNsLTcgNXoiIGZpbGw9IiNmZmYiLz48L3N2Zz4=",
  downloadUrl: {
    browserExtension: "https://chrome.google.com/webstore/detail/surf-sui-wallet/emeeapjkbcbpbpgaagfchmcgglmebnen"
  }
}), S2 = Cr({
  name: "GlassWallet",
  label: "Glass Wallet",
  iconUrl: "data:image/png;base64,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",
  downloadUrl: {
    browserExtension: "https://chrome.google.com/webstore/detail/glass-wallet-sui-wallet/loinekcabhlmhjjbocijdoimmejangoa"
  }
}), T2 = Cr({
  name: "Morphis Wallet",
  label: "Morphis Wallet",
  iconUrl: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiByeD0iNSIgZmlsbD0iI2ZmZiIvPjxwYXRoIGQ9Ik0xOS45NCA3LjRsLS4wMS0uMDhWNy4zYy0uMDEtLjAyLS4wMS0uMDQtLjAzLS4wNSAwLS4wMy0uMDItLjA1LS4wMy0uMDdsLS4wMS0uMDEtLjA2LS4wNS0uMDQtLjAyLTUuMDUtMy4wNWgtLjAxbC0uMDMtLjAxLS4wNC0uMDEtLjAzLS4wMi0uMDQtLjAxaC0uMDdsLS4wNC4wMS0uMDQuMDItLjAzLjAxLS4wNC4wMWgtLjAxTDkuMjkgNy4xIDQuMiAxMC4xM2wtLjA2LjAzLS4wMS4wMi0uMDUuMDUtLjAzLjA1LS4wMS4wMS0uMDMuMDYtLjAxLjA3djYuMTJjMCAuMTYuMDcuMjkuMi4zNmw1LjA1IDMuMDVjLjA1LjA0LjEzLjA1LjIuMDUuMDggMCAuMTQtLjAxLjIxLS4wNS4xMi0uMDguMi0uMjEuMi0uMzd2LTUuMzdsNC40NiAyLjY5Yy4wNi4wMy4xMy4wNC4yLjA0LjA4IDAgLjEzLS4wMS4yMS0uMDQuMTItLjA4LjItLjIyLjItLjM3di01LjM3bDQuNDYgMi42OGMuMDYuMDMuMTMuMDUuMjEuMDUuMDYgMCAuMTItLjAyLjItLjA1LjEyLS4wOC4yLS4yMi4yLS4zN1Y3LjM4Yy0uMDYuMDUtLjA2LjAyLS4wNi4wMnptLTEwLjUgNS42NEw1LjIgMTAuNDhsNC4yNC0yLjU3IDQuMjYgMi41Ny00LjI2IDIuNTZ6TTE0LjUgMTBsLTQuMjUtMi41NyA0LjI1LTIuNTYgNC4yNSAyLjU2TDE0LjUgMTB6bS01LjQ2IDguOUw0LjggMTYuMzNWMTEuMmw0LjI0IDIuNTZ2NS4xNHptMS4yMS01LjM3bDMuODUtMi4zM3Y0LjY1bC0zLjg1LTIuMzJ6bTUuMDUtMy4wM2wzLjg1LTIuMzR2NC42NGwtMy44NS0yLjN6IiBmaWxsPSIjMDAwIi8+PC9zdmc+",
  downloadUrl: {
    browserExtension: "https://chrome.google.com/webstore/detail/morphis-wallet/heefohaffomkkkphnlpohglngmbcclhi"
  }
}), M2 = Cr({
  name: "OneKey Wallet",
  label: "OneKey Wallet",
  iconUrl: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgdmlld0JveD0iMCAwIDEyOCAxMjgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxnIGNsaXAtcGF0aD0idXJsKCNjbGlwMF80NTkyMl84OCkiPgo8cGF0aCBkPSJNMTI3LjYxIDYzLjgwNDlDMTI3LjYxIDEwNy44NTMgMTA3Ljg1MyAxMjcuNjEgNjMuODA0OSAxMjcuNjFDMTkuNzU2OCAxMjcuNjEgMCAxMDcuODUzIDAgNjMuODA0OUMwIDE5Ljc1NjggMTkuNzU2OCAwIDYzLjgwNDkgMEMxMDcuODUzIDAgMTI3LjYxIDE5Ljc1NjggMTI3LjYxIDYzLjgwNDlaIiBmaWxsPSIjM0JEMjNEIi8+CjxwYXRoIGQ9Ik02OS41Njk5IDI3LjA1NTdMNTEuODE5NyAyNy4wNTU3TDQ4LjcwNTYgMzYuNDcxOUg1OC41NjQ1TDU4LjU2NDUgNTYuMzA2M0g2OS41Njk5VjI3LjA1NTdaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTg0LjA0ODYgODAuMzExMUM4NC4wNDg2IDkxLjQ5MTIgNzQuOTg1NCAxMDAuNTU0IDYzLjgwNTMgMTAwLjU1NEM1Mi42MjUzIDEwMC41NTQgNDMuNTYyMSA5MS40OTEyIDQzLjU2MjEgODAuMzExMUM0My41NjIxIDY5LjEzMTEgNTIuNjI1MyA2MC4wNjc4IDYzLjgwNTMgNjAuMDY3OEM3NC45ODU0IDYwLjA2NzggODQuMDQ4NiA2OS4xMzExIDg0LjA0ODYgODAuMzExMVpNNzQuODU4NCA4MC4zMTExQzc0Ljg1ODQgODYuNDE1NSA2OS45MDk3IDkxLjM2NDEgNjMuODA1MyA5MS4zNjQxQzU3LjcwMDggOTEuMzY0MSA1Mi43NTIyIDg2LjQxNTUgNTIuNzUyMiA4MC4zMTExQzUyLjc1MjIgNzQuMjA2NiA1Ny43MDA4IDY5LjI1OCA2My44MDUzIDY5LjI1OEM2OS45MDk3IDY5LjI1OCA3NC44NTg0IDc0LjIwNjYgNzQuODU4NCA4MC4zMTExWiIgZmlsbD0iYmxhY2siLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF80NTkyMl84OCI+CjxyZWN0IHdpZHRoPSIxMjgiIGhlaWdodD0iMTI4IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=",
  downloadUrl: {
    browserExtension: "https://chrome.google.com/webstore/detail/onekey/jnmbobjmhlngoefaiojfljckilhhlhcj"
  }
}), I2 = Cr({
  name: "Spacecy Sui Wallet",
  label: "Spacecy Sui Wallet",
  iconUrl: "https://spacecywallet.com/favicon.ico",
  downloadUrl: {
    browserExtension: "https://chrome.google.com/webstore/detail/spacecy-wallet/mkchoaaiifodcflmbaphdgeidocajadp?hl=en-US"
  }
}), C2 = Cr({
  name: "Nightly Wallet",
  label: "Nightly Wallet",
  iconUrl: "data:image/svg+xml;base64,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",
  downloadUrl: {
    browserExtension: "https://chrome.google.com/webstore/detail/nightly/fiikommddbeccaoicoejoniammnalkfa?hl=en&authuser=0"
  }
}), _2 = Cr({
  name: "Elli",
  label: "Elli Wallet",
  iconUrl: "data:image/png;base64,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",
  downloadUrl: {
    browserExtension: "https://chrome.google.com/webstore/detail/elli-sui-wallet/ocjdpmoallmgmjbbogfiiaofphbjgchh?utm_source=wallet-kit"
  }
}), O2 = [
  x2,
  w2,
  ...[
    m2,
    E2,
    A2,
    T2,
    S2,
    M2,
    I2,
    C2,
    _2
  ].sort((e, t) => e.name < t.name ? -1 : 1)
];
var N2 = typeof global == "object" && global && global.Object === Object && global;
const j2 = N2;
var D2 = typeof self == "object" && self && self.Object === Object && self, L2 = j2 || D2 || Function("return this")();
const hc = L2;
var R2 = hc.Symbol;
const fi = R2;
var y0 = Object.prototype, P2 = y0.hasOwnProperty, U2 = y0.toString, xi = fi ? fi.toStringTag : void 0;
function B2(e) {
  var t = P2.call(e, xi), r = e[xi];
  try {
    e[xi] = void 0;
    var n = !0;
  } catch {
  }
  var o = U2.call(e);
  return n && (t ? e[xi] = r : delete e[xi]), o;
}
var k2 = Object.prototype, z2 = k2.toString;
function F2(e) {
  return z2.call(e);
}
var $2 = "[object Null]", W2 = "[object Undefined]", Lf = fi ? fi.toStringTag : void 0;
function pc(e) {
  return e == null ? e === void 0 ? W2 : $2 : Lf && Lf in Object(e) ? B2(e) : F2(e);
}
function yc(e) {
  return e != null && typeof e == "object";
}
var q2 = "[object Symbol]";
function gc(e) {
  return typeof e == "symbol" || yc(e) && pc(e) == q2;
}
function Y2(e, t) {
  for (var r = -1, n = e == null ? 0 : e.length, o = Array(n); ++r < n; )
    o[r] = t(e[r], r, e);
  return o;
}
var G2 = Array.isArray;
const is = G2;
var Q2 = 1 / 0, Rf = fi ? fi.prototype : void 0, Pf = Rf ? Rf.toString : void 0;
function g0(e) {
  if (typeof e == "string")
    return e;
  if (is(e))
    return Y2(e, g0) + "";
  if (gc(e))
    return Pf ? Pf.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -Q2 ? "-0" : t;
}
function v0(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var V2 = "[object AsyncFunction]", H2 = "[object Function]", Z2 = "[object GeneratorFunction]", K2 = "[object Proxy]";
function X2(e) {
  if (!v0(e))
    return !1;
  var t = pc(e);
  return t == H2 || t == Z2 || t == V2 || t == K2;
}
var J2 = hc["__core-js_shared__"];
const Ys = J2;
var Uf = function() {
  var e = /[^.]+$/.exec(Ys && Ys.keys && Ys.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function ew(e) {
  return !!Uf && Uf in e;
}
var tw = Function.prototype, rw = tw.toString;
function nw(e) {
  if (e != null) {
    try {
      return rw.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var iw = /[\\^$.*+?()[\]{}|]/g, ow = /^\[object .+?Constructor\]$/, sw = Function.prototype, aw = Object.prototype, cw = sw.toString, fw = aw.hasOwnProperty, uw = RegExp(
  "^" + cw.call(fw).replace(iw, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function lw(e) {
  if (!v0(e) || ew(e))
    return !1;
  var t = X2(e) ? uw : ow;
  return t.test(nw(e));
}
function dw(e, t) {
  return e?.[t];
}
function b0(e, t) {
  var r = dw(e, t);
  return lw(r) ? r : void 0;
}
var hw = 9007199254740991, pw = /^(?:0|[1-9]\d*)$/;
function yw(e, t) {
  var r = typeof e;
  return t = t ?? hw, !!t && (r == "number" || r != "symbol" && pw.test(e)) && e > -1 && e % 1 == 0 && e < t;
}
function gw(e, t) {
  return e === t || e !== e && t !== t;
}
var vw = 9007199254740991;
function bw(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= vw;
}
var xw = "[object Arguments]";
function Bf(e) {
  return yc(e) && pc(e) == xw;
}
var x0 = Object.prototype, ww = x0.hasOwnProperty, mw = x0.propertyIsEnumerable, Ew = Bf(function() {
  return arguments;
}()) ? Bf : function(e) {
  return yc(e) && ww.call(e, "callee") && !mw.call(e, "callee");
};
const Aw = Ew;
var Sw = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Tw = /^\w*$/;
function Mw(e, t) {
  if (is(e))
    return !1;
  var r = typeof e;
  return r == "number" || r == "symbol" || r == "boolean" || e == null || gc(e) ? !0 : Tw.test(e) || !Sw.test(e) || t != null && e in Object(t);
}
var Iw = b0(Object, "create");
const Ri = Iw;
function Cw() {
  this.__data__ = Ri ? Ri(null) : {}, this.size = 0;
}
function _w(e) {
  var t = this.has(e) && delete this.__data__[e];
  return this.size -= t ? 1 : 0, t;
}
var Ow = "__lodash_hash_undefined__", Nw = Object.prototype, jw = Nw.hasOwnProperty;
function Dw(e) {
  var t = this.__data__;
  if (Ri) {
    var r = t[e];
    return r === Ow ? void 0 : r;
  }
  return jw.call(t, e) ? t[e] : void 0;
}
var Lw = Object.prototype, Rw = Lw.hasOwnProperty;
function Pw(e) {
  var t = this.__data__;
  return Ri ? t[e] !== void 0 : Rw.call(t, e);
}
var Uw = "__lodash_hash_undefined__";
function Bw(e, t) {
  var r = this.__data__;
  return this.size += this.has(e) ? 0 : 1, r[e] = Ri && t === void 0 ? Uw : t, this;
}
function Yn(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Yn.prototype.clear = Cw;
Yn.prototype.delete = _w;
Yn.prototype.get = Dw;
Yn.prototype.has = Pw;
Yn.prototype.set = Bw;
function kw() {
  this.__data__ = [], this.size = 0;
}
function os(e, t) {
  for (var r = e.length; r--; )
    if (gw(e[r][0], t))
      return r;
  return -1;
}
var zw = Array.prototype, Fw = zw.splice;
function $w(e) {
  var t = this.__data__, r = os(t, e);
  if (r < 0)
    return !1;
  var n = t.length - 1;
  return r == n ? t.pop() : Fw.call(t, r, 1), --this.size, !0;
}
function Ww(e) {
  var t = this.__data__, r = os(t, e);
  return r < 0 ? void 0 : t[r][1];
}
function qw(e) {
  return os(this.__data__, e) > -1;
}
function Yw(e, t) {
  var r = this.__data__, n = os(r, e);
  return n < 0 ? (++this.size, r.push([e, t])) : r[n][1] = t, this;
}
function yi(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
yi.prototype.clear = kw;
yi.prototype.delete = $w;
yi.prototype.get = Ww;
yi.prototype.has = qw;
yi.prototype.set = Yw;
var Gw = b0(hc, "Map");
const Qw = Gw;
function Vw() {
  this.size = 0, this.__data__ = {
    hash: new Yn(),
    map: new (Qw || yi)(),
    string: new Yn()
  };
}
function Hw(e) {
  var t = typeof e;
  return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
}
function ss(e, t) {
  var r = e.__data__;
  return Hw(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
}
function Zw(e) {
  var t = ss(this, e).delete(e);
  return this.size -= t ? 1 : 0, t;
}
function Kw(e) {
  return ss(this, e).get(e);
}
function Xw(e) {
  return ss(this, e).has(e);
}
function Jw(e, t) {
  var r = ss(this, e), n = r.size;
  return r.set(e, t), this.size += r.size == n ? 0 : 1, this;
}
function Hn(e) {
  var t = -1, r = e == null ? 0 : e.length;
  for (this.clear(); ++t < r; ) {
    var n = e[t];
    this.set(n[0], n[1]);
  }
}
Hn.prototype.clear = Vw;
Hn.prototype.delete = Zw;
Hn.prototype.get = Kw;
Hn.prototype.has = Xw;
Hn.prototype.set = Jw;
var e6 = "Expected a function";
function vc(e, t) {
  if (typeof e != "function" || t != null && typeof t != "function")
    throw new TypeError(e6);
  var r = function() {
    var n = arguments, o = t ? t.apply(this, n) : n[0], s = r.cache;
    if (s.has(o))
      return s.get(o);
    var f = e.apply(this, n);
    return r.cache = s.set(o, f) || s, f;
  };
  return r.cache = new (vc.Cache || Hn)(), r;
}
vc.Cache = Hn;
var t6 = 500;
function r6(e) {
  var t = vc(e, function(n) {
    return r.size === t6 && r.clear(), n;
  }), r = t.cache;
  return t;
}
var n6 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, i6 = /\\(\\)?/g, o6 = r6(function(e) {
  var t = [];
  return e.charCodeAt(0) === 46 && t.push(""), e.replace(n6, function(r, n, o, s) {
    t.push(o ? s.replace(i6, "$1") : n || r);
  }), t;
});
const s6 = o6;
function a6(e) {
  return e == null ? "" : g0(e);
}
function c6(e, t) {
  return is(e) ? e : Mw(e, t) ? [e] : s6(a6(e));
}
var f6 = 1 / 0;
function u6(e) {
  if (typeof e == "string" || gc(e))
    return e;
  var t = e + "";
  return t == "0" && 1 / e == -f6 ? "-0" : t;
}
function l6(e, t, r) {
  t = c6(t, e);
  for (var n = -1, o = t.length, s = !1; ++n < o; ) {
    var f = u6(t[n]);
    if (!(s = e != null && r(e, f)))
      break;
    e = e[f];
  }
  return s || ++n != o ? s : (o = e == null ? 0 : e.length, !!o && bw(o) && yw(f, o) && (is(e) || Aw(e)));
}
var d6 = Object.prototype, h6 = d6.hasOwnProperty;
function p6(e, t) {
  return e != null && h6.call(e, t);
}
function kf(e, t) {
  return e != null && l6(e, t, p6);
}
function y6(e, t) {
  let r = Sr.WALLET__CONNECT_ERROR, n = e.message;
  switch (t) {
    case gn.SUI_WALLET:
    case gn.ETHOS_WALLET:
    case gn.GLASS_WALLET:
    case gn.MORPHIS_WALLET:
      n.includes("Permission rejected") && (r = Sr.WALLET__CONNECT_ERROR__USER_REJECTED);
      break;
    case gn.SUIET_WALLET:
      n.includes("User rejects approval") && (r = Sr.WALLET__CONNECT_ERROR__USER_REJECTED);
      break;
    case gn.SPACECY_WALLET:
      r = Sr.WALLET__CONNECT_ERROR__USER_REJECTED;
      break;
    case gn.SURF_WALLET:
      n.includes("The user rejected the request") && (r = Sr.WALLET__CONNECT_ERROR__USER_REJECTED);
      break;
  }
  return {
    code: r,
    message: n,
    details: {
      wallet: t
    }
  };
}
var g6 = Object.defineProperty, v6 = (e, t, r) => t in e ? g6(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, b6 = (e, t, r) => (v6(e, typeof t != "symbol" ? t + "" : t, r), r), w0 = /* @__PURE__ */ ((e) => (e.STANDARD__CONNECT = "standard:connect", e.STANDARD__DISCONNECT = "standard:disconnect", e.STANDARD__EVENTS = "standard:events", e.SUI__SIGN_AND_EXECUTE_TRANSACTION_BLOCK = "sui:signAndExecuteTransactionBlock", e.SUI__SIGN_TRANSACTION_BLOCK = "sui:signTransactionBlock", e.SUI__SIGN_MESSAGE = "sui:signMessage", e))(w0 || {});
class zf {
  constructor(t) {
    b6(this, "standardWalletAdapter"), this.standardWalletAdapter = t;
  }
  get name() {
    return this.standardWalletAdapter.name;
  }
  get icon() {
    return this.standardWalletAdapter.icon;
  }
  get version() {
    return this.standardWalletAdapter.version;
  }
  get accounts() {
    return this.standardWalletAdapter.accounts;
  }
  get chains() {
    return this.standardWalletAdapter.chains;
  }
  get features() {
    return this.standardWalletAdapter.features;
  }
  async connect(t) {
    const r = this.getFeature(
      "standard:connect"
    );
    try {
      return await r.connect(t);
    } catch (n) {
      const { code: o, message: s, details: f } = y6(n, this.name);
      throw new Ln(s, o, f);
    }
  }
  async disconnect() {
    const t = this.getFeature(
      "standard:disconnect"
    );
    try {
      return await t.disconnect();
    } catch (r) {
      throw new Ln(r.message, Sr.WALLET__DISCONNECT_ERROR);
    }
  }
  on(t, r) {
    const n = this.getFeature(
      "standard:events"
    );
    try {
      return n.on(t, r);
    } catch (o) {
      throw new Ln(o.message, Sr.WALLET__LISTEN_TO_EVENT_ERROR);
    }
  }
  async signAndExecuteTransactionBlock(t) {
    const r = this.getFeature("sui:signAndExecuteTransactionBlock");
    try {
      return await r.signAndExecuteTransactionBlock(t);
    } catch (n) {
      throw new Ln(n.message, Sr.WALLET__SIGN_TX_ERROR);
    }
  }
  signTransactionBlock(t) {
    const r = this.getFeature("sui:signTransactionBlock");
    try {
      return r.signTransactionBlock(t);
    } catch (n) {
      throw new Ln(n.message, Sr.WALLET__SIGN_TX_ERROR);
    }
  }
  async signMessage(t) {
    const r = this.getFeature(
      "sui:signMessage"
    );
    try {
      return await r.signMessage(t);
    } catch (n) {
      throw new Ln(n.message, Sr.WALLET__SIGN_MSG_ERROR);
    }
  }
  hasFeature(t) {
    const { features: r } = this.standardWalletAdapter;
    return kf(r, t);
  }
  getFeature(t) {
    const { features: r } = this.standardWalletAdapter;
    if (!kf(r, t))
      throw new dh(t);
    return r[t];
  }
}
var x6 = globalThis && globalThis.__classPrivateFieldSet || function(e, t, r, n, o) {
  if (n === "m")
    throw new TypeError("Private method is not writable");
  if (n === "a" && !o)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof t == "function" ? e !== t || !o : !t.has(e))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return n === "a" ? o.call(e, r) : o ? o.value = r : t.set(e, r), r;
}, w6 = globalThis && globalThis.__classPrivateFieldGet || function(e, t, r, n) {
  if (r === "a" && !n)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof t == "function" ? e !== t || !n : !t.has(e))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? n : r === "a" ? n.call(e) : n ? n.value : t.get(e);
}, wo;
let wi;
const mo = /* @__PURE__ */ new Set(), ri = {};
function m6() {
  if (wi || (wi = Object.freeze({ register: Ff, get: E6, on: A6 }), typeof window > "u"))
    return wi;
  const e = Object.freeze({ register: Ff });
  try {
    window.addEventListener("wallet-standard:register-wallet", ({ detail: t }) => t(e));
  } catch (t) {
    console.error(`wallet-standard:register-wallet event listener could not be added
`, t);
  }
  try {
    window.dispatchEvent(new S6(e));
  } catch (t) {
    console.error(`wallet-standard:app-ready event could not be dispatched
`, t);
  }
  return wi;
}
function Ff(...e) {
  return e = e.filter((t) => !mo.has(t)), e.length ? (e.forEach((t) => mo.add(t)), ri.register?.forEach((t) => $f(() => t(...e))), function() {
    e.forEach((r) => mo.delete(r)), ri.unregister?.forEach((r) => $f(() => r(...e)));
  }) : () => {
  };
}
function E6() {
  return [...mo];
}
function A6(e, t) {
  return ri[e]?.push(t) || (ri[e] = [t]), function() {
    ri[e] = ri[e]?.filter((n) => t !== n);
  };
}
function $f(e) {
  try {
    e();
  } catch (t) {
    console.error(t);
  }
}
class S6 extends Event {
  constructor(t) {
    super("wallet-standard:app-ready", {
      bubbles: !1,
      cancelable: !1,
      composed: !1
    }), wo.set(this, void 0), x6(this, wo, t, "f");
  }
  get detail() {
    return w6(this, wo, "f");
  }
  get type() {
    return "wallet-standard:app-ready";
  }
  preventDefault() {
    throw new Error("preventDefault cannot be called");
  }
  stopImmediatePropagation() {
    throw new Error("stopImmediatePropagation cannot be called");
  }
  stopPropagation() {
    throw new Error("stopPropagation cannot be called");
  }
}
wo = /* @__PURE__ */ new WeakMap();
function T6() {
  const e = Et(), [t, r] = Zt([]);
  function n() {
    return e.current ? e.current.get().filter(jf) : [];
  }
  return At(() => {
    e.current = m6();
    const o = n();
    Br(o) && r(
      o.map((f) => new zf(f))
    );
    const s = e.current.on("register", (...f) => {
      if (!e.current)
        return;
      const h = [...n()];
      f.filter(jf).filter((p) => !h.find((b) => b.name === p.name)).forEach((p) => {
        h.push(p);
      }), r(h.map((p) => new zf(p)));
    });
    return () => {
      s();
    };
  }, []), {
    data: t
  };
}
const M6 = (e) => {
  const { data: t } = T6(), r = Ur(() => Br(e) ? Br(t) ? e.map((s) => {
    const f = t.find((l) => s.name === l.name);
    return f ? {
      ...s,
      adapter: f,
      installed: !0
    } : {
      ...s,
      adapter: void 0,
      installed: !1
    };
  }) : e.map((s) => ({
    ...s,
    adapter: void 0,
    installed: !1
  })) : [], [e, t]), n = Ur(() => Br(t) ? t.filter((s) => !e.find((f) => f.name === s.name)).map((s) => ({
    name: s.name,
    label: s.name,
    adapter: s,
    installed: !0,
    iconUrl: s.icon,
    downloadUrl: {
      browserExtension: ""
    }
  })) : [], [e, t]);
  return {
    allAvailableWallets: Ur(() => [
      ...r,
      ...n
    ].filter((s) => s.installed), [r, n]),
    configuredWallets: r,
    detectedWallets: n
  };
};
class ba {
  constructor() {
    if (!window)
      throw new Error("window not found: storage should be used in browser env");
  }
  get length() {
    return window.localStorage.length;
  }
  setItem(t, r) {
    try {
      let n = JSON.stringify(r);
      return window.localStorage.setItem(t, n);
    } catch (n) {
      throw new Error("stringify data failed when setItem: " + n.message);
    }
  }
  getItem(t) {
    const r = window.localStorage.getItem(t);
    if (!r)
      return r;
    try {
      return JSON.parse(r);
    } catch (n) {
      throw new Error("parse data failed when getItem: " + n.message);
    }
  }
  removeItem(t) {
    return window.localStorage.removeItem(t);
  }
  clear() {
    return window.localStorage.clear();
  }
}
var Fo = /* @__PURE__ */ ((e) => (e.LAST_CONNECT_WALLET_NAME = "WK__LAST_CONNECT_WALLET_NAME", e))(Fo || {});
function I6(e, t, r, n) {
  const o = Et(!1);
  At(() => {
    if (!n || o.current || !Br(r) || t !== Ar.DISCONNECTED)
      return;
    const f = new ba().getItem(Fo.LAST_CONNECT_WALLET_NAME);
    !f || r.find((l) => l.name == f) && e(f).then(() => {
      o.current = !0;
    }).catch((l) => {
    });
  }, [r]);
}
function C6(e) {
  return e?.accounts?.[0]?.chains?.[0] ? e.accounts[0].chains[0] : "sui:unknown";
}
const P6 = (e) => {
  const {
    defaultWallets: t = O2,
    chains: r = hx,
    autoConnect: n = !0,
    children: o
  } = e, {
    allAvailableWallets: s,
    configuredWallets: f,
    detectedWallets: l
  } = M6(t), [h, p] = Zt(), [b, g] = Zt(Ar.DISCONNECTED), [E, m] = Zt(() => Br(r) ? r[0] : xo), A = Et([]), w = (ye, $) => ye && $ === Ar.CONNECTED, S = Ur(() => {
    if (!!w(h, b))
      return h.accounts[0];
  }, [h, b]), N = (ye, $) => {
    if (!w(ye, $))
      throw new zt("Failed to call function, wallet not connected");
  }, P = Ut(async (ye, $) => {
    if (!ye)
      throw new zt("param adapter is missing");
    g(Ar.CONNECTING);
    try {
      const G = await ye.connect($);
      if (Br(G?.accounts)) {
        const ge = C6(G), L = r.find((_) => _.id === ge);
        m(L ?? xo);
      }
      return p(ye), g(Ar.CONNECTED), new ba().setItem(Fo.LAST_CONNECT_WALLET_NAME, ye.name), G;
    } catch (G) {
      throw p(void 0), g(Ar.DISCONNECTED), G;
    }
  }, []), C = Ut(async () => {
    N(h, b);
    const ye = h;
    Br(A.current) && (A.current.forEach((G) => {
      try {
        G();
      } catch (X) {
        console.error("error when clearing wallet listener", X.message);
      }
    }), A.current = []), new ba().removeItem(Fo.LAST_CONNECT_WALLET_NAME);
    try {
      ye.hasFeature(w0.STANDARD__DISCONNECT) && await ye.disconnect();
    } finally {
      p(void 0), g(Ar.DISCONNECTED), m(r?.[0] ?? xo);
    }
  }, [h, b]), B = Ut(async (ye) => {
    if (w(h, b)) {
      if (ye === h.name)
        return;
      await C();
    }
    const $ = s.find((G) => G.name === ye);
    if (!$) {
      const G = s.map((X) => X.name);
      throw new zt(`select failed: wallet ${ye} is not available, all wallets are listed here: [${G.join(", ")}]`);
    }
    await P($.adapter);
  }, [h, b, s]), R = Ut((ye, $) => {
    N(h, b);
    const X = h.on("change", (ge) => {
      if (ye === "change") {
        $(ge);
        return;
      }
      if (ge.accounts && ye === "accountChange") {
        $({
          account: ge.accounts?.[0]
        });
        return;
      }
      if (ge.features && ye === "featureChange") {
        $({
          features: ge.features
        });
        return;
      }
    });
    return A.current.push(X), X;
  }, [h, b]), F = Ut(() => (N(h, b), h.accounts), [h, b]), Y = Ut(async (ye) => {
    if (N(h, b), !S)
      throw new zt("no active account");
    return await h.signAndExecuteTransactionBlock({
      account: S,
      chain: E.id,
      ...ye
    });
  }, [h, b, E, S]), K = Ut(async (ye) => {
    if (N(h, b), !S)
      throw new zt("no active account");
    return await h.signTransactionBlock({
      account: S,
      chain: E.id,
      ...ye
    });
  }, [h, b, E, S]), Me = Ut(async (ye) => {
    if (N(h, b), !S)
      throw new zt("no active account");
    return await h.signMessage({
      account: S,
      message: ye.message
    });
  }, [h, S, b]);
  return I6(B, b, s, n), /* @__PURE__ */ je(lu.Provider, {
    value: {
      name: h?.name,
      chains: r,
      chain: E,
      allAvailableWallets: s,
      configuredWallets: f,
      detectedWallets: l,
      adapter: h,
      status: b,
      connecting: b === Ar.CONNECTING,
      connected: b === Ar.CONNECTED,
      select: B,
      disconnect: C,
      on: R,
      getAccounts: F,
      account: S,
      signAndExecuteTransactionBlock: Y,
      signMessage: Me,
      signTransactionBlock: K,
      verifySignedMessage: a2,
      address: S?.address
    },
    children: /* @__PURE__ */ je(rx, {
      client: new Zb(),
      children: o
    })
  });
};
function m0(e) {
  if (typeof e == "string") {
    console.warn(`[DEPRECATED] ${e}`);
    return;
  }
  const { name: t, message: r, migrationDoc: n } = e;
  console.warn(`[DEPRECATED] ${t} is no longer supported. ` + r + (n ? ` | Check migration doc: ${n}` : ""));
}
function U6() {
  return m0({
    name: "getDefaultWallets",
    message: "If you want to customize wallet list, use defaultWallets instead",
    migrationDoc: "https://kit.suiet.app/docs/migration/upgradeTo0.1.0"
  }), [];
}
function B6() {
  return m0({
    name: "getAllWallets",
    message: "If you want to customize wallet list, use defaultWallets instead",
    migrationDoc: "https://kit.suiet.app/docs/migration/upgradeTo0.1.0"
  }), [];
}
export {
  gx as Account,
  O2 as AllDefaultWallets,
  uu as BaseError,
  R6 as ConnectButton,
  v2 as ConnectModal,
  Ar as ConnectionStatus,
  hx as DefaultChains,
  _2 as ElliWallet,
  Sr as ErrorCode,
  m2 as EthosWallet,
  S2 as GlassWallet,
  zt as KitError,
  E2 as MartianWallet,
  T2 as MorphisWallet,
  C2 as NightlyWallet,
  M2 as OneKeyWallet,
  gn as PresetWallet,
  vx as Provider,
  D6 as SUI_SYSTEM_STATE_OBJECT_ID,
  I2 as SpacecyWallet,
  fx as SuiChainId,
  ux as SuiDevnetChain,
  dx as SuiMainnetChain,
  lx as SuiTestnetChain,
  w2 as SuiWallet,
  x2 as SuietWallet,
  A2 as SurfWallet,
  xo as UnknownChain,
  lu as WalletContext,
  Ln as WalletError,
  dh as WalletNotImplementError,
  P6 as WalletProvider,
  Ex as addressEllipsis,
  Cr as defineWallet,
  f0 as formatCurrency,
  xx as formatSUI,
  B6 as getAllWallets,
  U6 as getDefaultWallets,
  u2 as useAccountBalance,
  c2 as useChain,
  f2 as useCoinBalance,
  L6 as useSuiProvider,
  Pi as useWallet,
  a2 as verifySignedMessage
};
